//#region src/Constants.ts
var e = 65536, t = 65535, n = 255, r = "main.asm", i = 32, a = /* @__PURE__ */ function(e) {
	return e[e.BREAKPOINT = 0] = "BREAKPOINT", e[e.HALTED = 1] = "HALTED", e[e.WAITING_FOR_INTERRUPT = 2] = "WAITING_FOR_INTERRUPT", e[e.WAITING_FOR_INPUT = 3] = "WAITING_FOR_INPUT", e[e.T_STATES_EXHAUSTED = 4] = "T_STATES_EXHAUSTED", e[e.INSTRUCTIONS_EXHAUSTED = 5] = "INSTRUCTIONS_EXHAUSTED", e[e.RETURNED = 6] = "RETURNED", e[e.STEP_COMPLETE = 7] = "STEP_COMPLETE", e[e.PAUSED = 8] = "PAUSED", e;
}({});
function o(e) {
	return e === 1 || e === 6;
}
var s = -1;
function c(e) {
	return e.kind === "poke";
}
var l = class {
	constructor(e, t, n, r, i, a) {
		this.z80State = e, this.memory = t, this.tStateCount = n, this.stopReason = r, this.pendingInputPort = i, this.stackProvenance = a;
	}
}, u = /* @__PURE__ */ new Set([
	"a",
	"f",
	"b",
	"c",
	"d",
	"e",
	"h",
	"l",
	"ixh",
	"ixl",
	"iyh",
	"iyl",
	"i",
	"r"
]), ee = [
	"af",
	"bc",
	"de",
	"hl",
	"afPrime",
	"bcPrime",
	"dePrime",
	"hlPrime",
	"ix",
	"iy",
	"sp",
	"pc"
], d = new Set(ee), te = ee.map((e) => e.replace("Prime", "'")), ne = new Set(te), re = /* @__PURE__ */ new Set([
	"memptr",
	"i",
	"r",
	"iff1",
	"iff2",
	"im",
	"halted"
]);
function ie(e) {
	return ne.has(e.toLowerCase());
}
function ae(e) {
	return u.has(e.toLowerCase());
}
function oe(e) {
	return u.has(e) || d.has(e) || re.has(e);
}
//#endregion
//#region ../z80-base/src/Utils.ts
function f(e, t) {
	return e.toString(16).toUpperCase().padStart(t, "0");
}
function se(e) {
	return f(e, 2);
}
function p(e) {
	return f(e, 4);
}
function ce(e) {
	return e &= 4294967295, e < 0 && (e += 4294967296), f(e, 8);
}
function m(e) {
	return e >> 8 & 255;
}
function h(e) {
	return e & 255;
}
function g(e, t) {
	return (e & 255) << 8 | t & 255;
}
function _(e) {
	return x(e, 1);
}
function v(e) {
	return S(e, 1);
}
function y(e) {
	return le(e, 1);
}
function b(e) {
	return C(e, 1);
}
function x(e, t) {
	return e + t & 255;
}
function S(e, t) {
	return e + t & 65535;
}
function le(e, t) {
	return e - t & 255;
}
function C(e, t) {
	return e - t & 65535;
}
function w(e) {
	return e >= 128 ? e - 256 : e;
}
function ue(e) {
	throw Error("Unexpected value: " + e);
}
//#endregion
//#region ../z80-base/src/RegisterSet.ts
var de = class e {
	constructor() {
		this.af = 0, this.bc = 0, this.de = 0, this.hl = 0, this.afPrime = 0, this.bcPrime = 0, this.dePrime = 0, this.hlPrime = 0, this.ix = 0, this.iy = 0, this.sp = 0, this.pc = 0, this.memptr = 0, this.i = 0, this.r = 0, this.iff1 = 0, this.iff2 = 0, this.im = 0, this.halted = 0;
	}
	get a() {
		return m(this.af);
	}
	set a(e) {
		this.af = g(e, this.f);
	}
	get f() {
		return h(this.af);
	}
	set f(e) {
		this.af = g(this.a, e);
	}
	get b() {
		return m(this.bc);
	}
	set b(e) {
		this.bc = g(e, this.c);
	}
	get c() {
		return h(this.bc);
	}
	set c(e) {
		this.bc = g(this.b, e);
	}
	get d() {
		return m(this.de);
	}
	set d(e) {
		this.de = g(e, this.e);
	}
	get e() {
		return h(this.de);
	}
	set e(e) {
		this.de = g(this.d, e);
	}
	get h() {
		return m(this.hl);
	}
	set h(e) {
		this.hl = g(e, this.l);
	}
	get l() {
		return h(this.hl);
	}
	set l(e) {
		this.hl = g(this.h, e);
	}
	get ixh() {
		return m(this.ix);
	}
	set ixh(e) {
		this.ix = g(e, this.ixl);
	}
	get ixl() {
		return h(this.ix);
	}
	set ixl(e) {
		this.ix = g(this.ixh, e);
	}
	get iyh() {
		return m(this.iy);
	}
	set iyh(e) {
		this.iy = g(e, this.iyl);
	}
	get iyl() {
		return h(this.iy);
	}
	set iyl(e) {
		this.iy = g(this.iyh, e);
	}
	bumpR() {
		this.r = this.r & 128 | (this.r & 127) + 1 & 127;
	}
	getValue(e) {
		return this[e];
	}
	clone() {
		let t = new e();
		return t.bc = this.bc, t.de = this.de, t.hl = this.hl, t.af = this.af, t.afPrime = this.afPrime, t.bcPrime = this.bcPrime, t.dePrime = this.dePrime, t.hlPrime = this.hlPrime, t.ix = this.ix, t.iy = this.iy, t.sp = this.sp, t.pc = this.pc, t.memptr = this.memptr, t.i = this.i, t.r = this.r, t.iff1 = this.iff1, t.iff2 = this.iff2, t.im = this.im, t.halted = this.halted, t;
	}
}, fe = [
	"af",
	"bc",
	"de",
	"hl",
	"afPrime",
	"bcPrime",
	"dePrime",
	"hlPrime",
	"ix",
	"iy",
	"sp",
	"pc",
	"memptr",
	"i",
	"r",
	"iff1",
	"iff2",
	"im",
	"halted"
], T = /* @__PURE__ */ function(e) {
	return e[e.C = 1] = "C", e[e.N = 2] = "N", e[e.P = 4] = "P", e[e.V = 4] = "V", e[e.X3 = 8] = "X3", e[e.H = 16] = "H", e[e.X5 = 32] = "X5", e[e.Z = 64] = "Z", e[e.S = 128] = "S", e;
}({}), pe = [
	{
		name: "rst00",
		address: 0
	},
	{
		name: "rst08",
		address: 8
	},
	{
		name: "rst10",
		address: 16
	},
	{
		name: "rst18",
		address: 24
	},
	{
		name: "rst20",
		address: 32
	},
	{
		name: "rst28",
		address: 40
	},
	{
		name: "rst30",
		address: 48
	},
	{
		name: "rst38",
		address: 56
	}
], me = class {
	constructor(e, t) {
		this.minLevel = e, this.logSink = t;
	}
	isEnabled(e) {
		return e >= this.minLevel;
	}
	isTraceEnabled() {
		return this.isEnabled(0);
	}
	isInfoEnabled() {
		return this.isEnabled(1);
	}
	isWarnEnabled() {
		return this.isEnabled(2);
	}
	log(e, t) {
		this.isEnabled(e) && this.logSink(e, t);
	}
	trace(e) {
		this.log(0, e);
	}
	info(e) {
		this.log(1, e);
	}
	warn(e) {
		this.log(2, e);
	}
}, he = (e, t) => {
	switch (e) {
		case 0:
		case 1:
			console.log(t);
			break;
		case 2: console.warn(t);
	}
}, ge = 100;
function _e(e) {
	let t = 0, n = "", r = 0, i;
	function a() {
		if (r > 0) {
			let i = n;
			r > 1 && (i += " (x" + r + ")"), r = 0, e(t, i);
		}
	}
	return (e, o) => {
		clearTimeout(i), r > 0 && e === t && o === n ? r += 1 : (a(), t = e, n = o, r = 1), i = setTimeout(a, ge);
	};
}
var ve = new class {
	constructor(...e) {
		this.sink = (e, t) => {
			for (let n of this.delegatedSinks) n(e, t);
		}, this.delegatedSinks = [...e];
	}
}(_e(he));
new me(1, ve.sink), new me(1, ve.sink), new me(1, ve.sink);
var ye = new me(1, ve.sink), E = [
	0,
	T.H,
	T.H,
	T.H,
	0,
	0,
	0,
	T.H
], D = [
	0,
	0,
	T.H,
	0,
	T.H,
	0,
	T.H,
	T.H
], O = [
	0,
	0,
	0,
	T.V,
	T.V,
	0,
	0,
	0
], k = [
	0,
	T.V,
	0,
	0,
	0,
	0,
	T.V,
	0
], A = /* @__PURE__ */ new Map();
A.set(0, (e) => {}), A.set(1, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.bc = t;
}), A.set(2, (e) => {
	let t;
	t = e.regs.a, e.regs.memptr = g(e.regs.a, v(e.regs.bc)), e.writeByte(e.regs.bc, t);
}), A.set(3, (e) => {
	let t;
	t = e.regs.bc, e.incTStateCount(2), t = v(t), e.regs.bc = t;
}), A.set(4, (e) => {
	let t;
	t = e.regs.b, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.b = t;
}), A.set(5, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.b = t;
}), A.set(6, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.b = t;
}), A.set(7, (e) => {
	let t = e.regs.a;
	e.regs.a = (e.regs.a >> 7 | e.regs.a << 1) & 255, e.regs.f = e.regs.f & (T.P | T.Z | T.S) | e.regs.a & (T.X3 | T.X5) | (t & 128 ? T.C : 0);
}), A.set(8, (e) => {
	let t = e.regs.afPrime;
	e.regs.afPrime = e.regs.af, e.regs.af = t;
}), A.set(9, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.bc;
	let n = e.regs.hl + t, r = ((e.regs.hl & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), A.set(10, (e) => {
	let t;
	e.regs.memptr = v(e.regs.bc), t = e.readByte(e.regs.bc), e.regs.a = t;
}), A.set(11, (e) => {
	let t;
	t = e.regs.bc, e.incTStateCount(2), t = b(t), e.regs.bc = t;
}), A.set(12, (e) => {
	let t;
	t = e.regs.c, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.c = t;
}), A.set(13, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.c = t;
}), A.set(14, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.c = t;
}), A.set(15, (e) => {
	let t = e.regs.a;
	e.regs.a = (e.regs.a >> 1 | e.regs.a << 7) & 255, e.regs.f = e.regs.f & (T.P | T.Z | T.S) | e.regs.a & (T.X3 | T.X5) | (t & 1 ? T.C : 0);
}), A.set(16, (e) => {
	if (e.incTStateCount(1), e.regs.b = y(e.regs.b), e.regs.b !== 0) {
		let t = e.readByte(e.regs.pc);
		e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
	} else e.incTStateCount(3), e.regs.pc = v(e.regs.pc);
}), A.set(17, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.de = t;
}), A.set(18, (e) => {
	let t;
	t = e.regs.a, e.regs.memptr = g(e.regs.a, v(e.regs.de)), e.writeByte(e.regs.de, t);
}), A.set(19, (e) => {
	let t;
	t = e.regs.de, e.incTStateCount(2), t = v(t), e.regs.de = t;
}), A.set(20, (e) => {
	let t;
	t = e.regs.d, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.d = t;
}), A.set(21, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.d = t;
}), A.set(22, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.d = t;
}), A.set(23, (e) => {
	let t = e.regs.a;
	e.regs.a = (e.regs.a << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = e.regs.f & (T.P | T.Z | T.S) | e.regs.a & (T.X3 | T.X5) | (t & 128 ? T.C : 0);
}), A.set(24, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
}), A.set(25, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.de;
	let n = e.regs.hl + t, r = ((e.regs.hl & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), A.set(26, (e) => {
	let t;
	e.regs.memptr = v(e.regs.de), t = e.readByte(e.regs.de), e.regs.a = t;
}), A.set(27, (e) => {
	let t;
	t = e.regs.de, e.incTStateCount(2), t = b(t), e.regs.de = t;
}), A.set(28, (e) => {
	let t;
	t = e.regs.e, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.e = t;
}), A.set(29, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.e = t;
}), A.set(30, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.e = t;
}), A.set(31, (e) => {
	let t = e.regs.a;
	e.regs.a = e.regs.a >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = e.regs.f & (T.P | T.Z | T.S) | e.regs.a & (T.X3 | T.X5) | (t & 1 ? T.C : 0);
}), A.set(32, (e) => {
	if ((e.regs.f & T.Z) === 0) {
		let t = e.readByte(e.regs.pc);
		e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
	} else e.incTStateCount(3), e.regs.pc = v(e.regs.pc);
}), A.set(33, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.hl = t;
}), A.set(34, (e) => {
	let t;
	t = e.regs.hl;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), A.set(35, (e) => {
	let t;
	t = e.regs.hl, e.incTStateCount(2), t = v(t), e.regs.hl = t;
}), A.set(36, (e) => {
	let t;
	t = e.regs.h, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.h = t;
}), A.set(37, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.h = t;
}), A.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.h = t;
}), A.set(39, (e) => {
	let t = 0, n = e.regs.f & T.C;
	if (((e.regs.f & T.H) !== 0 || (e.regs.a & 15) > 9) && (t = 6), (n !== 0 || e.regs.a > 153) && (t |= 96), e.regs.a > 153 && (n = T.C), (e.regs.f & T.N) !== 0) {
		let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
		e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
	} else {
		let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
		e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
	}
	e.regs.f = e.regs.f & ~(T.C | T.P) | n | e.parityTable[e.regs.a];
}), A.set(40, (e) => {
	if ((e.regs.f & T.Z) !== 0) {
		let t = e.readByte(e.regs.pc);
		e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
	} else e.incTStateCount(3), e.regs.pc = v(e.regs.pc);
}), A.set(41, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.hl;
	let n = e.regs.hl + t, r = ((e.regs.hl & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), A.set(42, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.hl = t;
}), A.set(43, (e) => {
	let t;
	t = e.regs.hl, e.incTStateCount(2), t = b(t), e.regs.hl = t;
}), A.set(44, (e) => {
	let t;
	t = e.regs.l, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.l = t;
}), A.set(45, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.l = t;
}), A.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.l = t;
}), A.set(47, (e) => {
	e.regs.a ^= 255, e.regs.f = e.regs.f & (T.C | T.P | T.Z | T.S) | e.regs.a & (T.X3 | T.X5) | T.N | T.H;
}), A.set(48, (e) => {
	if ((e.regs.f & T.C) === 0) {
		let t = e.readByte(e.regs.pc);
		e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
	} else e.incTStateCount(3), e.regs.pc = v(e.regs.pc);
}), A.set(49, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.sp = t;
}), A.set(50, (e) => {
	let t;
	t = e.regs.a, t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.regs.a, v(t)), e.writeByte(t, e.regs.a);
}), A.set(51, (e) => {
	let t;
	t = e.regs.sp, e.incTStateCount(2), t = v(t), e.regs.sp = t;
}), A.set(52, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1), t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.writeByte(e.regs.hl, t);
}), A.set(53, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.writeByte(e.regs.hl, t);
}), A.set(54, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.writeByte(e.regs.hl, t);
}), A.set(55, (e) => {
	e.regs.f = e.regs.f & (T.P | T.Z | T.S) | T.C | (e.regs.f | e.regs.a) & (T.X3 | T.X5);
}), A.set(56, (e) => {
	if ((e.regs.f & T.C) !== 0) {
		let t = e.readByte(e.regs.pc);
		e.incTStateCount(5), e.regs.pc = S(e.regs.pc, w(t)), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.pc;
	} else e.incTStateCount(3), e.regs.pc = v(e.regs.pc);
}), A.set(57, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.sp;
	let n = e.regs.hl + t, r = ((e.regs.hl & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), A.set(58, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.memptr = v(t), t = e.readByte(t), e.regs.a = t;
}), A.set(59, (e) => {
	let t;
	t = e.regs.sp, e.incTStateCount(2), t = b(t), e.regs.sp = t;
}), A.set(60, (e) => {
	let t;
	t = e.regs.a, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.a = t;
}), A.set(61, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.a = t;
}), A.set(62, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.a = t;
}), A.set(63, (e) => {
	e.regs.f = e.regs.f & (T.P | T.Z | T.S) | ((e.regs.f & T.C) === 0 ? T.C : T.H) | (e.regs.f | e.regs.a) & (T.X3 | T.X5);
}), A.set(64, (e) => {
	let t;
	t = e.regs.b, e.regs.b = t;
}), A.set(65, (e) => {
	let t;
	t = e.regs.c, e.regs.b = t;
}), A.set(66, (e) => {
	let t;
	t = e.regs.d, e.regs.b = t;
}), A.set(67, (e) => {
	let t;
	t = e.regs.e, e.regs.b = t;
}), A.set(68, (e) => {
	let t;
	t = e.regs.h, e.regs.b = t;
}), A.set(69, (e) => {
	let t;
	t = e.regs.l, e.regs.b = t;
}), A.set(70, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.b = t;
}), A.set(71, (e) => {
	let t;
	t = e.regs.a, e.regs.b = t;
}), A.set(72, (e) => {
	let t;
	t = e.regs.b, e.regs.c = t;
}), A.set(73, (e) => {
	let t;
	t = e.regs.c, e.regs.c = t;
}), A.set(74, (e) => {
	let t;
	t = e.regs.d, e.regs.c = t;
}), A.set(75, (e) => {
	let t;
	t = e.regs.e, e.regs.c = t;
}), A.set(76, (e) => {
	let t;
	t = e.regs.h, e.regs.c = t;
}), A.set(77, (e) => {
	let t;
	t = e.regs.l, e.regs.c = t;
}), A.set(78, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.c = t;
}), A.set(79, (e) => {
	let t;
	t = e.regs.a, e.regs.c = t;
}), A.set(80, (e) => {
	let t;
	t = e.regs.b, e.regs.d = t;
}), A.set(81, (e) => {
	let t;
	t = e.regs.c, e.regs.d = t;
}), A.set(82, (e) => {
	let t;
	t = e.regs.d, e.regs.d = t;
}), A.set(83, (e) => {
	let t;
	t = e.regs.e, e.regs.d = t;
}), A.set(84, (e) => {
	let t;
	t = e.regs.h, e.regs.d = t;
}), A.set(85, (e) => {
	let t;
	t = e.regs.l, e.regs.d = t;
}), A.set(86, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.d = t;
}), A.set(87, (e) => {
	let t;
	t = e.regs.a, e.regs.d = t;
}), A.set(88, (e) => {
	let t;
	t = e.regs.b, e.regs.e = t;
}), A.set(89, (e) => {
	let t;
	t = e.regs.c, e.regs.e = t;
}), A.set(90, (e) => {
	let t;
	t = e.regs.d, e.regs.e = t;
}), A.set(91, (e) => {
	let t;
	t = e.regs.e, e.regs.e = t;
}), A.set(92, (e) => {
	let t;
	t = e.regs.h, e.regs.e = t;
}), A.set(93, (e) => {
	let t;
	t = e.regs.l, e.regs.e = t;
}), A.set(94, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.e = t;
}), A.set(95, (e) => {
	let t;
	t = e.regs.a, e.regs.e = t;
}), A.set(96, (e) => {
	let t;
	t = e.regs.b, e.regs.h = t;
}), A.set(97, (e) => {
	let t;
	t = e.regs.c, e.regs.h = t;
}), A.set(98, (e) => {
	let t;
	t = e.regs.d, e.regs.h = t;
}), A.set(99, (e) => {
	let t;
	t = e.regs.e, e.regs.h = t;
}), A.set(100, (e) => {
	let t;
	t = e.regs.h, e.regs.h = t;
}), A.set(101, (e) => {
	let t;
	t = e.regs.l, e.regs.h = t;
}), A.set(102, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.h = t;
}), A.set(103, (e) => {
	let t;
	t = e.regs.a, e.regs.h = t;
}), A.set(104, (e) => {
	let t;
	t = e.regs.b, e.regs.l = t;
}), A.set(105, (e) => {
	let t;
	t = e.regs.c, e.regs.l = t;
}), A.set(106, (e) => {
	let t;
	t = e.regs.d, e.regs.l = t;
}), A.set(107, (e) => {
	let t;
	t = e.regs.e, e.regs.l = t;
}), A.set(108, (e) => {
	let t;
	t = e.regs.h, e.regs.l = t;
}), A.set(109, (e) => {
	let t;
	t = e.regs.l, e.regs.l = t;
}), A.set(110, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.l = t;
}), A.set(111, (e) => {
	let t;
	t = e.regs.a, e.regs.l = t;
}), A.set(112, (e) => {
	let t;
	t = e.regs.b, e.writeByte(e.regs.hl, t);
}), A.set(113, (e) => {
	let t;
	t = e.regs.c, e.writeByte(e.regs.hl, t);
}), A.set(114, (e) => {
	let t;
	t = e.regs.d, e.writeByte(e.regs.hl, t);
}), A.set(115, (e) => {
	let t;
	t = e.regs.e, e.writeByte(e.regs.hl, t);
}), A.set(116, (e) => {
	let t;
	t = e.regs.h, e.writeByte(e.regs.hl, t);
}), A.set(117, (e) => {
	let t;
	t = e.regs.l, e.writeByte(e.regs.hl, t);
}), A.set(118, (e) => {
	e.regs.halted = 1, e.regs.pc = b(e.regs.pc);
}), A.set(119, (e) => {
	let t;
	t = e.regs.a, e.writeByte(e.regs.hl, t);
}), A.set(120, (e) => {
	let t;
	t = e.regs.b, e.regs.a = t;
}), A.set(121, (e) => {
	let t;
	t = e.regs.c, e.regs.a = t;
}), A.set(122, (e) => {
	let t;
	t = e.regs.d, e.regs.a = t;
}), A.set(123, (e) => {
	let t;
	t = e.regs.e, e.regs.a = t;
}), A.set(124, (e) => {
	let t;
	t = e.regs.h, e.regs.a = t;
}), A.set(125, (e) => {
	let t;
	t = e.regs.l, e.regs.a = t;
}), A.set(126, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.a = t;
}), A.set(127, (e) => {
	let t;
	t = e.regs.a, e.regs.a = t;
}), A.set(128, (e) => {
	let t;
	t = e.regs.b;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(129, (e) => {
	let t;
	t = e.regs.c;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(130, (e) => {
	let t;
	t = e.regs.d;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(131, (e) => {
	let t;
	t = e.regs.e;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(132, (e) => {
	let t;
	t = e.regs.h;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(133, (e) => {
	let t;
	t = e.regs.l;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(134, (e) => {
	let t;
	t = e.readByte(e.regs.hl);
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(135, (e) => {
	let t;
	t = e.regs.a;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(136, (e) => {
	let t;
	t = e.regs.b;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(137, (e) => {
	let t;
	t = e.regs.c;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(138, (e) => {
	let t;
	t = e.regs.d;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(139, (e) => {
	let t;
	t = e.regs.e;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(140, (e) => {
	let t;
	t = e.regs.h;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(141, (e) => {
	let t;
	t = e.regs.l;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(142, (e) => {
	let t;
	t = e.readByte(e.regs.hl);
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(143, (e) => {
	let t;
	t = e.regs.a;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(144, (e) => {
	let t;
	t = e.regs.b;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(145, (e) => {
	let t;
	t = e.regs.c;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(146, (e) => {
	let t;
	t = e.regs.d;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(147, (e) => {
	let t;
	t = e.regs.e;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(148, (e) => {
	let t;
	t = e.regs.h;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(149, (e) => {
	let t;
	t = e.regs.l;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(150, (e) => {
	let t;
	t = e.readByte(e.regs.hl);
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(151, (e) => {
	let t;
	t = e.regs.a;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(152, (e) => {
	let t;
	t = e.regs.b;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(153, (e) => {
	let t;
	t = e.regs.c;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(154, (e) => {
	let t;
	t = e.regs.d;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(155, (e) => {
	let t;
	t = e.regs.e;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(156, (e) => {
	let t;
	t = e.regs.h;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(157, (e) => {
	let t;
	t = e.regs.l;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(158, (e) => {
	let t;
	t = e.readByte(e.regs.hl);
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(159, (e) => {
	let t;
	t = e.regs.a;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(160, (e) => {
	let t;
	t = e.regs.b, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(161, (e) => {
	let t;
	t = e.regs.c, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(162, (e) => {
	let t;
	t = e.regs.d, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(163, (e) => {
	let t;
	t = e.regs.e, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(164, (e) => {
	let t;
	t = e.regs.h, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(165, (e) => {
	let t;
	t = e.regs.l, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(166, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(167, (e) => {
	let t;
	t = e.regs.a, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(168, (e) => {
	let t;
	t = e.regs.b, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(169, (e) => {
	let t;
	t = e.regs.c, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(170, (e) => {
	let t;
	t = e.regs.d, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(171, (e) => {
	let t;
	t = e.regs.e, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(172, (e) => {
	let t;
	t = e.regs.h, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(173, (e) => {
	let t;
	t = e.regs.l, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(174, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(175, (e) => {
	let t;
	t = e.regs.a, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(176, (e) => {
	let t;
	t = e.regs.b, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(177, (e) => {
	let t;
	t = e.regs.c, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(178, (e) => {
	let t;
	t = e.regs.d, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(179, (e) => {
	let t;
	t = e.regs.e, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(180, (e) => {
	let t;
	t = e.regs.h, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(181, (e) => {
	let t;
	t = e.regs.l, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(182, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(183, (e) => {
	let t;
	t = e.regs.a, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(184, (e) => {
	let t;
	t = e.regs.b;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(185, (e) => {
	let t;
	t = e.regs.c;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(186, (e) => {
	let t;
	t = e.regs.d;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(187, (e) => {
	let t;
	t = e.regs.e;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(188, (e) => {
	let t;
	t = e.regs.h;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(189, (e) => {
	let t;
	t = e.regs.l;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(190, (e) => {
	let t;
	t = e.readByte(e.regs.hl);
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(191, (e) => {
	let t;
	t = e.regs.a;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(192, (e) => {
	e.incTStateCount(1), (e.regs.f & T.Z) === 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(193, (e) => {
	e.regs.bc = e.popWord();
}), A.set(194, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.Z) === 0 && (e.regs.pc = e.regs.memptr);
}), A.set(195, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), e.regs.pc = e.regs.memptr;
}), A.set(196, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.Z) === 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(197, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.bc);
}), A.set(198, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc);
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(199, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 0, e.regs.memptr = e.regs.pc;
}), A.set(200, (e) => {
	e.incTStateCount(1), (e.regs.f & T.Z) !== 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(201, (e) => {
	e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc;
}), A.set(202, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.Z) !== 0 && (e.regs.pc = e.regs.memptr);
}), A.set(203, (e) => {
	xe(e);
}), A.set(204, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.Z) !== 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(205, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr;
}), A.set(206, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc);
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(207, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 8, e.regs.memptr = e.regs.pc;
}), A.set(208, (e) => {
	e.incTStateCount(1), (e.regs.f & T.C) === 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(209, (e) => {
	e.regs.de = e.popWord();
}), A.set(210, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.C) === 0 && (e.regs.pc = e.regs.memptr);
}), A.set(211, (e) => {
	let t = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.regs.a, _(t)), e.writePort(g(e.regs.a, t), e.regs.a);
}), A.set(212, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.C) === 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(213, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.de);
}), A.set(214, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc);
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(215, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 16, e.regs.memptr = e.regs.pc;
}), A.set(216, (e) => {
	e.incTStateCount(1), (e.regs.f & T.C) !== 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(217, (e) => {
	let t;
	t = e.regs.bc, e.regs.bc = e.regs.bcPrime, e.regs.bcPrime = t, t = e.regs.de, e.regs.de = e.regs.dePrime, e.regs.dePrime = t, t = e.regs.hl, e.regs.hl = e.regs.hlPrime, e.regs.hlPrime = t;
}), A.set(218, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.C) !== 0 && (e.regs.pc = e.regs.memptr);
}), A.set(219, (e) => {
	let t = g(e.regs.a, e.readByte(e.regs.pc));
	e.regs.pc = v(e.regs.pc), e.regs.a = e.readPort(t), e.regs.memptr = v(t);
}), A.set(220, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.C) !== 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(221, (e) => {
	Se(e);
}), A.set(222, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc);
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), A.set(223, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 24, e.regs.memptr = e.regs.pc;
}), A.set(224, (e) => {
	e.incTStateCount(1), (e.regs.f & T.P) === 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(225, (e) => {
	e.regs.hl = e.popWord();
}), A.set(226, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.P) === 0 && (e.regs.pc = e.regs.memptr);
}), A.set(227, (e) => {
	let t = e.regs.hl, n = e.readByte(e.regs.sp), r = e.readByte(v(e.regs.sp));
	e.incTStateCount(1), e.writeByte(v(e.regs.sp), m(t)), e.writeByte(e.regs.sp, h(t)), e.incTStateCount(2), e.regs.memptr = g(r, n), e.regs.hl = g(r, n);
}), A.set(228, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.P) === 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(229, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.hl);
}), A.set(230, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), A.set(231, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 32, e.regs.memptr = e.regs.pc;
}), A.set(232, (e) => {
	e.incTStateCount(1), (e.regs.f & T.P) !== 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(233, (e) => {
	e.regs.pc = e.regs.hl;
}), A.set(234, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.P) !== 0 && (e.regs.pc = e.regs.memptr);
}), A.set(235, (e) => {
	let t = e.regs.hl;
	e.regs.hl = e.regs.de, e.regs.de = t;
}), A.set(236, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.P) !== 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(237, (e) => {
	we(e);
}), A.set(238, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(239, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 40, e.regs.memptr = e.regs.pc;
}), A.set(240, (e) => {
	e.incTStateCount(1), (e.regs.f & T.S) === 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(241, (e) => {
	e.regs.af = e.popWord();
}), A.set(242, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.S) === 0 && (e.regs.pc = e.regs.memptr);
}), A.set(243, (e) => {
	e.regs.iff1 = 0, e.regs.iff2 = 0;
}), A.set(244, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.S) === 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(245, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.af);
}), A.set(246, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), A.set(247, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 48, e.regs.memptr = e.regs.pc;
}), A.set(248, (e) => {
	e.incTStateCount(1), (e.regs.f & T.S) !== 0 && (e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc);
}), A.set(249, (e) => {
	let t;
	t = e.regs.hl, e.incTStateCount(2), e.regs.sp = t;
}), A.set(250, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.S) !== 0 && (e.regs.pc = e.regs.memptr);
}), A.set(251, (e) => {
	e.regs.iff1 = 1, e.regs.iff2 = 1;
}), A.set(252, (e) => {
	e.regs.memptr = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.memptr = g(e.readByte(e.regs.pc), e.regs.memptr), e.regs.pc = v(e.regs.pc), (e.regs.f & T.S) !== 0 && (e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = e.regs.memptr);
}), A.set(253, (e) => {
	Te(e);
}), A.set(254, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc);
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), A.set(255, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.pc), e.regs.pc = 56, e.regs.memptr = e.regs.pc;
});
var j = /* @__PURE__ */ new Map();
j.set(0, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(1, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(2, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(3, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(4, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(5, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(6, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(7, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(8, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(9, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(10, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(11, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(12, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(13, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(14, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(15, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(16, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(17, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(18, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(19, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(20, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(21, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(22, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(23, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(24, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(25, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(26, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(27, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(28, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(29, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(30, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(31, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(32, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(33, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(34, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(35, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(36, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(37, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(39, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(40, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(41, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(42, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(43, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(44, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(45, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(47, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(48, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(49, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(50, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(51, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(52, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(53, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(54, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(55, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(56, (e) => {
	let t;
	t = e.regs.b;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
}), j.set(57, (e) => {
	let t;
	t = e.regs.c;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
}), j.set(58, (e) => {
	let t;
	t = e.regs.d;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
}), j.set(59, (e) => {
	let t;
	t = e.regs.e;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
}), j.set(60, (e) => {
	let t;
	t = e.regs.h;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
}), j.set(61, (e) => {
	let t;
	t = e.regs.l;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
}), j.set(62, (e) => {
	let t;
	t = e.readByte(e.regs.hl), e.incTStateCount(1);
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.hl, t);
}), j.set(63, (e) => {
	let t;
	t = e.regs.a;
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
}), j.set(64, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(65, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(66, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(67, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(68, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(69, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(70, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(71, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(72, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(73, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(74, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(75, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(76, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(77, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(78, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(79, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(80, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(81, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(82, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(83, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(84, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(85, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(86, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(87, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(88, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(89, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(90, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(91, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(92, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(93, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(94, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(95, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(96, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(97, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(98, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(99, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(100, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(101, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(102, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(103, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(104, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(105, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(106, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(107, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(108, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(109, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(110, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(111, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(112, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(113, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(114, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(115, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(116, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(117, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(118, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(119, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), j.set(120, (e) => {
	let t = e.regs.b, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(121, (e) => {
	let t = e.regs.c, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(122, (e) => {
	let t = e.regs.d, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(123, (e) => {
	let t = e.regs.e, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(124, (e) => {
	let t = e.regs.h, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(125, (e) => {
	let t = e.regs.l, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(126, (e) => {
	let t = e.readByte(e.regs.hl), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(127, (e) => {
	let t = e.regs.a, n = t, r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), j.set(128, (e) => {
	e.regs.b &= 254;
}), j.set(129, (e) => {
	e.regs.c &= 254;
}), j.set(130, (e) => {
	e.regs.d &= 254;
}), j.set(131, (e) => {
	e.regs.e &= 254;
}), j.set(132, (e) => {
	e.regs.h &= 254;
}), j.set(133, (e) => {
	e.regs.l &= 254;
}), j.set(134, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 254);
}), j.set(135, (e) => {
	e.regs.a &= 254;
}), j.set(136, (e) => {
	e.regs.b &= 253;
}), j.set(137, (e) => {
	e.regs.c &= 253;
}), j.set(138, (e) => {
	e.regs.d &= 253;
}), j.set(139, (e) => {
	e.regs.e &= 253;
}), j.set(140, (e) => {
	e.regs.h &= 253;
}), j.set(141, (e) => {
	e.regs.l &= 253;
}), j.set(142, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 253);
}), j.set(143, (e) => {
	e.regs.a &= 253;
}), j.set(144, (e) => {
	e.regs.b &= 251;
}), j.set(145, (e) => {
	e.regs.c &= 251;
}), j.set(146, (e) => {
	e.regs.d &= 251;
}), j.set(147, (e) => {
	e.regs.e &= 251;
}), j.set(148, (e) => {
	e.regs.h &= 251;
}), j.set(149, (e) => {
	e.regs.l &= 251;
}), j.set(150, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 251);
}), j.set(151, (e) => {
	e.regs.a &= 251;
}), j.set(152, (e) => {
	e.regs.b &= 247;
}), j.set(153, (e) => {
	e.regs.c &= 247;
}), j.set(154, (e) => {
	e.regs.d &= 247;
}), j.set(155, (e) => {
	e.regs.e &= 247;
}), j.set(156, (e) => {
	e.regs.h &= 247;
}), j.set(157, (e) => {
	e.regs.l &= 247;
}), j.set(158, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 247);
}), j.set(159, (e) => {
	e.regs.a &= 247;
}), j.set(160, (e) => {
	e.regs.b &= 239;
}), j.set(161, (e) => {
	e.regs.c &= 239;
}), j.set(162, (e) => {
	e.regs.d &= 239;
}), j.set(163, (e) => {
	e.regs.e &= 239;
}), j.set(164, (e) => {
	e.regs.h &= 239;
}), j.set(165, (e) => {
	e.regs.l &= 239;
}), j.set(166, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 239);
}), j.set(167, (e) => {
	e.regs.a &= 239;
}), j.set(168, (e) => {
	e.regs.b &= 223;
}), j.set(169, (e) => {
	e.regs.c &= 223;
}), j.set(170, (e) => {
	e.regs.d &= 223;
}), j.set(171, (e) => {
	e.regs.e &= 223;
}), j.set(172, (e) => {
	e.regs.h &= 223;
}), j.set(173, (e) => {
	e.regs.l &= 223;
}), j.set(174, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 223);
}), j.set(175, (e) => {
	e.regs.a &= 223;
}), j.set(176, (e) => {
	e.regs.b &= 191;
}), j.set(177, (e) => {
	e.regs.c &= 191;
}), j.set(178, (e) => {
	e.regs.d &= 191;
}), j.set(179, (e) => {
	e.regs.e &= 191;
}), j.set(180, (e) => {
	e.regs.h &= 191;
}), j.set(181, (e) => {
	e.regs.l &= 191;
}), j.set(182, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 191);
}), j.set(183, (e) => {
	e.regs.a &= 191;
}), j.set(184, (e) => {
	e.regs.b &= 127;
}), j.set(185, (e) => {
	e.regs.c &= 127;
}), j.set(186, (e) => {
	e.regs.d &= 127;
}), j.set(187, (e) => {
	e.regs.e &= 127;
}), j.set(188, (e) => {
	e.regs.h &= 127;
}), j.set(189, (e) => {
	e.regs.l &= 127;
}), j.set(190, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t & 127);
}), j.set(191, (e) => {
	e.regs.a &= 127;
}), j.set(192, (e) => {
	e.regs.b |= 1;
}), j.set(193, (e) => {
	e.regs.c |= 1;
}), j.set(194, (e) => {
	e.regs.d |= 1;
}), j.set(195, (e) => {
	e.regs.e |= 1;
}), j.set(196, (e) => {
	e.regs.h |= 1;
}), j.set(197, (e) => {
	e.regs.l |= 1;
}), j.set(198, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 1);
}), j.set(199, (e) => {
	e.regs.a |= 1;
}), j.set(200, (e) => {
	e.regs.b |= 2;
}), j.set(201, (e) => {
	e.regs.c |= 2;
}), j.set(202, (e) => {
	e.regs.d |= 2;
}), j.set(203, (e) => {
	e.regs.e |= 2;
}), j.set(204, (e) => {
	e.regs.h |= 2;
}), j.set(205, (e) => {
	e.regs.l |= 2;
}), j.set(206, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 2);
}), j.set(207, (e) => {
	e.regs.a |= 2;
}), j.set(208, (e) => {
	e.regs.b |= 4;
}), j.set(209, (e) => {
	e.regs.c |= 4;
}), j.set(210, (e) => {
	e.regs.d |= 4;
}), j.set(211, (e) => {
	e.regs.e |= 4;
}), j.set(212, (e) => {
	e.regs.h |= 4;
}), j.set(213, (e) => {
	e.regs.l |= 4;
}), j.set(214, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 4);
}), j.set(215, (e) => {
	e.regs.a |= 4;
}), j.set(216, (e) => {
	e.regs.b |= 8;
}), j.set(217, (e) => {
	e.regs.c |= 8;
}), j.set(218, (e) => {
	e.regs.d |= 8;
}), j.set(219, (e) => {
	e.regs.e |= 8;
}), j.set(220, (e) => {
	e.regs.h |= 8;
}), j.set(221, (e) => {
	e.regs.l |= 8;
}), j.set(222, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 8);
}), j.set(223, (e) => {
	e.regs.a |= 8;
}), j.set(224, (e) => {
	e.regs.b |= 16;
}), j.set(225, (e) => {
	e.regs.c |= 16;
}), j.set(226, (e) => {
	e.regs.d |= 16;
}), j.set(227, (e) => {
	e.regs.e |= 16;
}), j.set(228, (e) => {
	e.regs.h |= 16;
}), j.set(229, (e) => {
	e.regs.l |= 16;
}), j.set(230, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 16);
}), j.set(231, (e) => {
	e.regs.a |= 16;
}), j.set(232, (e) => {
	e.regs.b |= 32;
}), j.set(233, (e) => {
	e.regs.c |= 32;
}), j.set(234, (e) => {
	e.regs.d |= 32;
}), j.set(235, (e) => {
	e.regs.e |= 32;
}), j.set(236, (e) => {
	e.regs.h |= 32;
}), j.set(237, (e) => {
	e.regs.l |= 32;
}), j.set(238, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 32);
}), j.set(239, (e) => {
	e.regs.a |= 32;
}), j.set(240, (e) => {
	e.regs.b |= 64;
}), j.set(241, (e) => {
	e.regs.c |= 64;
}), j.set(242, (e) => {
	e.regs.d |= 64;
}), j.set(243, (e) => {
	e.regs.e |= 64;
}), j.set(244, (e) => {
	e.regs.h |= 64;
}), j.set(245, (e) => {
	e.regs.l |= 64;
}), j.set(246, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 64);
}), j.set(247, (e) => {
	e.regs.a |= 64;
}), j.set(248, (e) => {
	e.regs.b |= 128;
}), j.set(249, (e) => {
	e.regs.c |= 128;
}), j.set(250, (e) => {
	e.regs.d |= 128;
}), j.set(251, (e) => {
	e.regs.e |= 128;
}), j.set(252, (e) => {
	e.regs.h |= 128;
}), j.set(253, (e) => {
	e.regs.l |= 128;
}), j.set(254, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(1), e.writeByte(e.regs.hl, t | 128);
}), j.set(255, (e) => {
	e.regs.a |= 128;
});
var M = /* @__PURE__ */ new Map();
M.set(9, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.bc;
	let n = e.regs.ix + t, r = ((e.regs.ix & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.ix), e.regs.ix = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), M.set(25, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.de;
	let n = e.regs.ix + t, r = ((e.regs.ix & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.ix), e.regs.ix = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), M.set(33, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.ix = t;
}), M.set(34, (e) => {
	let t;
	t = e.regs.ix;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), M.set(35, (e) => {
	let t;
	t = e.regs.ix, e.incTStateCount(2), t = v(t), e.regs.ix = t;
}), M.set(36, (e) => {
	let t;
	t = e.regs.ixh, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.ixh = t;
}), M.set(37, (e) => {
	let t;
	t = e.regs.ixh;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.ixh = t;
}), M.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.ixh = t;
}), M.set(41, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.ix;
	let n = e.regs.ix + t, r = ((e.regs.ix & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.ix), e.regs.ix = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), M.set(42, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.ix = t;
}), M.set(43, (e) => {
	let t;
	t = e.regs.ix, e.incTStateCount(2), t = b(t), e.regs.ix = t;
}), M.set(44, (e) => {
	let t;
	t = e.regs.ixl, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.ixl = t;
}), M.set(45, (e) => {
	let t;
	t = e.regs.ixl;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.ixl = t;
}), M.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.ixl = t;
}), M.set(52, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = S(e.regs.ix, w(n)), t = e.readByte(e.regs.memptr), e.incTStateCount(1), t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.writeByte(e.regs.memptr, t);
}), M.set(53, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = S(e.regs.ix, w(n)), t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let r = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (r & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.writeByte(e.regs.memptr, t);
}), M.set(54, (e) => {
	let t = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc);
	let n;
	n = e.readByte(e.regs.pc), e.incTStateCount(2), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(57, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.sp;
	let n = e.regs.ix + t, r = ((e.regs.ix & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.ix), e.regs.ix = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), M.set(68, (e) => {
	let t;
	t = e.regs.ixh, e.regs.b = t;
}), M.set(69, (e) => {
	let t;
	t = e.regs.ixl, e.regs.b = t;
}), M.set(70, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.b = t;
}), M.set(76, (e) => {
	let t;
	t = e.regs.ixh, e.regs.c = t;
}), M.set(77, (e) => {
	let t;
	t = e.regs.ixl, e.regs.c = t;
}), M.set(78, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.c = t;
}), M.set(84, (e) => {
	let t;
	t = e.regs.ixh, e.regs.d = t;
}), M.set(85, (e) => {
	let t;
	t = e.regs.ixl, e.regs.d = t;
}), M.set(86, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.d = t;
}), M.set(92, (e) => {
	let t;
	t = e.regs.ixh, e.regs.e = t;
}), M.set(93, (e) => {
	let t;
	t = e.regs.ixl, e.regs.e = t;
}), M.set(94, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.e = t;
}), M.set(96, (e) => {
	let t;
	t = e.regs.b, e.regs.ixh = t;
}), M.set(97, (e) => {
	let t;
	t = e.regs.c, e.regs.ixh = t;
}), M.set(98, (e) => {
	let t;
	t = e.regs.d, e.regs.ixh = t;
}), M.set(99, (e) => {
	let t;
	t = e.regs.e, e.regs.ixh = t;
}), M.set(100, (e) => {
	let t;
	t = e.regs.ixh, e.regs.ixh = t;
}), M.set(101, (e) => {
	let t;
	t = e.regs.ixl, e.regs.ixh = t;
}), M.set(102, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.h = t;
}), M.set(103, (e) => {
	let t;
	t = e.regs.a, e.regs.ixh = t;
}), M.set(104, (e) => {
	let t;
	t = e.regs.b, e.regs.ixl = t;
}), M.set(105, (e) => {
	let t;
	t = e.regs.c, e.regs.ixl = t;
}), M.set(106, (e) => {
	let t;
	t = e.regs.d, e.regs.ixl = t;
}), M.set(107, (e) => {
	let t;
	t = e.regs.e, e.regs.ixl = t;
}), M.set(108, (e) => {
	let t;
	t = e.regs.ixh, e.regs.ixl = t;
}), M.set(109, (e) => {
	let t;
	t = e.regs.ixl, e.regs.ixl = t;
}), M.set(110, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.l = t;
}), M.set(111, (e) => {
	let t;
	t = e.regs.a, e.regs.ixl = t;
}), M.set(112, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.b, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(113, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.c, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(114, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.d, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(115, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.e, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(116, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.h, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(117, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.l, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(119, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.a, e.regs.memptr = e.regs.ix + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), M.set(124, (e) => {
	let t;
	t = e.regs.ixh, e.regs.a = t;
}), M.set(125, (e) => {
	let t;
	t = e.regs.ixl, e.regs.a = t;
}), M.set(126, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a = t;
}), M.set(132, (e) => {
	let t;
	t = e.regs.ixh;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(133, (e) => {
	let t;
	t = e.regs.ixl;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(134, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(140, (e) => {
	let t;
	t = e.regs.ixh;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(141, (e) => {
	let t;
	t = e.regs.ixl;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(142, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(148, (e) => {
	let t;
	t = e.regs.ixh;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(149, (e) => {
	let t;
	t = e.regs.ixl;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(150, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(156, (e) => {
	let t;
	t = e.regs.ixh;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(157, (e) => {
	let t;
	t = e.regs.ixl;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(158, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), M.set(164, (e) => {
	let t;
	t = e.regs.ixh, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), M.set(165, (e) => {
	let t;
	t = e.regs.ixl, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), M.set(166, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), M.set(172, (e) => {
	let t;
	t = e.regs.ixh, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(173, (e) => {
	let t;
	t = e.regs.ixl, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(174, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(180, (e) => {
	let t;
	t = e.regs.ixh, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(181, (e) => {
	let t;
	t = e.regs.ixl, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(182, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), M.set(188, (e) => {
	let t;
	t = e.regs.ixh;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), M.set(189, (e) => {
	let t;
	t = e.regs.ixl;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), M.set(190, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.ix + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), M.set(203, (e) => {
	Ce(e);
}), M.set(225, (e) => {
	e.regs.ix = e.popWord();
}), M.set(227, (e) => {
	let t = e.regs.ix, n = e.readByte(e.regs.sp), r = e.readByte(v(e.regs.sp));
	e.incTStateCount(1), e.writeByte(v(e.regs.sp), m(t)), e.writeByte(e.regs.sp, h(t)), e.incTStateCount(2), e.regs.memptr = g(r, n), e.regs.ix = g(r, n);
}), M.set(229, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.ix);
}), M.set(233, (e) => {
	e.regs.pc = e.regs.ix;
}), M.set(249, (e) => {
	let t;
	t = e.regs.ix, e.incTStateCount(2), e.regs.sp = t;
});
var N = /* @__PURE__ */ new Map();
N.set(0, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(1, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(2, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(3, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(4, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(5, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(6, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(7, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(8, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(9, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(10, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(11, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(12, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(13, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(14, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(15, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(16, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(17, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(18, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(19, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(20, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(21, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(22, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(23, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(24, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(25, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(26, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(27, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(28, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(29, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(30, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(31, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(32, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(33, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(34, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(35, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(36, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(37, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(39, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(40, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(41, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(42, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(43, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(44, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(45, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(47, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(48, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(49, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(50, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(51, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(52, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(53, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(54, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(55, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(56, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(57, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(58, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(59, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(60, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(61, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(62, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), N.set(63, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(70, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(78, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(86, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(94, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(102, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(110, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(118, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), N.set(126, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), N.set(128, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(129, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(130, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(131, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(132, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(133, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(134, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 254);
}), N.set(135, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(136, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(137, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(138, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(139, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(140, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(141, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(142, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 253);
}), N.set(143, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(144, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(145, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(146, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(147, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(148, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(149, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(150, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 251);
}), N.set(151, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(152, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(153, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(154, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(155, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(156, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(157, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(158, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 247);
}), N.set(159, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(160, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(161, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(162, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(163, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(164, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(165, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(166, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 239);
}), N.set(167, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(168, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(169, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(170, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(171, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(172, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(173, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(174, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 223);
}), N.set(175, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(176, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(177, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(178, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(179, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(180, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(181, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(182, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 191);
}), N.set(183, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(184, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(185, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(186, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(187, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(188, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(189, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(190, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 127);
}), N.set(191, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(192, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(193, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(194, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(195, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(196, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(197, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(198, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 1);
}), N.set(199, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(200, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(201, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(202, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(203, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(204, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(205, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(206, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 2);
}), N.set(207, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(208, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(209, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(210, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(211, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(212, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(213, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(214, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 4);
}), N.set(215, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(216, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(217, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(218, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(219, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(220, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(221, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(222, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 8);
}), N.set(223, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(224, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(225, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(226, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(227, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(228, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(229, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(230, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 16);
}), N.set(231, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(232, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(233, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(234, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(235, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(236, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(237, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(238, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 32);
}), N.set(239, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(240, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(241, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(242, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(243, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(244, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(245, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(246, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 64);
}), N.set(247, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), N.set(248, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), N.set(249, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), N.set(250, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), N.set(251, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), N.set(252, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), N.set(253, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), N.set(254, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 128);
}), N.set(255, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
});
var P = /* @__PURE__ */ new Map();
P.set(64, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.b = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.b];
}), P.set(65, (e) => {
	e.writePort(e.regs.bc, e.regs.b), e.regs.memptr = v(e.regs.bc);
}), P.set(66, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.bc;
	let n = e.regs.hl - t;
	(e.regs.f & T.C) !== 0 && --n;
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | T.N | k[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | D[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(67, (e) => {
	let t;
	t = e.regs.bc;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), P.set(68, (e) => {
	let t = e.regs.a;
	e.regs.a = 0;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n;
	let i = T.N;
	n & 256 && (i |= T.C), i |= D[r & 7], i |= k[r >> 4], i |= e.sz53Table[e.regs.a], e.regs.f = i;
}), P.set(69, (e) => {
	e.regs.iff1 = e.regs.iff2, e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc;
}), P.set(70, (e) => {
	e.regs.im = 0;
}), P.set(71, (e) => {
	let t;
	t = e.regs.a, e.incTStateCount(1), e.regs.i = t;
}), P.set(72, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.c = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.c];
}), P.set(73, (e) => {
	e.writePort(e.regs.bc, e.regs.c), e.regs.memptr = v(e.regs.bc);
}), P.set(74, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.bc;
	let n = e.regs.hl + t;
	(e.regs.f & T.C) !== 0 && (n += 1);
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | O[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | E[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(75, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.bc = t;
}), P.set(77, (e) => {
	e.regs.iff1 = e.regs.iff2, e.regs.pc = e.popWord(), e.regs.memptr = e.regs.pc;
}), P.set(79, (e) => {
	let t;
	t = e.regs.a, e.incTStateCount(1), e.regs.r = t;
}), P.set(80, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.d = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.d];
}), P.set(81, (e) => {
	e.writePort(e.regs.bc, e.regs.d), e.regs.memptr = v(e.regs.bc);
}), P.set(82, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.de;
	let n = e.regs.hl - t;
	(e.regs.f & T.C) !== 0 && --n;
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | T.N | k[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | D[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(83, (e) => {
	let t;
	t = e.regs.de;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), P.set(86, (e) => {
	e.regs.im = 1;
}), P.set(87, (e) => {
	let t;
	t = e.regs.i, e.incTStateCount(1), e.regs.a = t, e.regs.f = e.regs.f & T.C | e.sz53Table[e.regs.a] | (e.regs.iff2 ? T.V : 0);
}), P.set(88, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.e = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.e];
}), P.set(89, (e) => {
	e.writePort(e.regs.bc, e.regs.e), e.regs.memptr = v(e.regs.bc);
}), P.set(90, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.de;
	let n = e.regs.hl + t;
	(e.regs.f & T.C) !== 0 && (n += 1);
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | O[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | E[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(91, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.de = t;
}), P.set(94, (e) => {
	e.regs.im = 2;
}), P.set(95, (e) => {
	let t;
	t = e.regs.r, e.incTStateCount(1), e.regs.a = t, e.regs.f = e.regs.f & T.C | e.sz53Table[e.regs.a] | (e.regs.iff2 ? T.V : 0);
}), P.set(96, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.h = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.h];
}), P.set(97, (e) => {
	e.writePort(e.regs.bc, e.regs.h), e.regs.memptr = v(e.regs.bc);
}), P.set(98, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.hl;
	let n = e.regs.hl - t;
	(e.regs.f & T.C) !== 0 && --n;
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | T.N | k[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | D[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(103, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(4), e.writeByte(e.regs.hl, (e.regs.a << 4 | t >> 4) & 255), e.regs.a = e.regs.a & 240 | t & 15, e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.a], e.regs.memptr = v(e.regs.hl);
}), P.set(104, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.l = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.l];
}), P.set(105, (e) => {
	e.writePort(e.regs.bc, e.regs.l), e.regs.memptr = v(e.regs.bc);
}), P.set(106, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.hl;
	let n = e.regs.hl + t;
	(e.regs.f & T.C) !== 0 && (n += 1);
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | O[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | E[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(111, (e) => {
	let t = e.readByte(e.regs.hl);
	e.incTStateCount(4), e.writeByte(e.regs.hl, (t << 4 | e.regs.a & 15) & 255), e.regs.a = e.regs.a & 240 | t >> 4, e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.a], e.regs.memptr = v(e.regs.hl);
}), P.set(112, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.f = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.f];
}), P.set(113, (e) => {
	e.writePort(e.regs.bc, 0), e.regs.memptr = v(e.regs.bc);
}), P.set(114, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.sp;
	let n = e.regs.hl - t;
	(e.regs.f & T.C) !== 0 && --n;
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | T.N | k[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | D[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(115, (e) => {
	let t;
	t = e.regs.sp;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), P.set(120, (e) => {
	e.regs.memptr = v(e.regs.bc), e.regs.a = e.readPort(e.regs.bc), e.regs.f = e.regs.f & T.C | e.sz53pTable[e.regs.a];
}), P.set(121, (e) => {
	e.writePort(e.regs.bc, e.regs.a), e.regs.memptr = v(e.regs.bc);
}), P.set(122, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.sp;
	let n = e.regs.hl + t;
	(e.regs.f & T.C) !== 0 && (n += 1);
	let r = ((e.regs.hl & 34816) >> 11 | (t & 34816) >> 10 | (n & 34816) >> 9) & 255;
	e.regs.memptr = v(e.regs.hl), e.regs.hl = n & 65535, e.regs.f = (n & 65536 ? T.C : 0) | O[r >> 4] | n >> 8 & (T.X3 | T.X5 | T.S) | E[r & 7] | (n === 0 ? T.Z : 0);
}), P.set(123, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.sp = t;
}), P.set(160, (e) => {
	let t = e.readByte(e.regs.hl);
	e.writeByte(e.regs.de, t), e.incTStateCount(2), e.regs.bc = b(e.regs.bc), t = S(t, e.regs.a), e.regs.f = e.regs.f & (T.C | T.Z | T.S) | (e.regs.bc === 0 ? 0 : T.V) | t & T.X3 | (t & 2 ? T.X5 : 0), e.regs.hl = v(e.regs.hl), e.regs.de = v(e.regs.de);
}), P.set(161, (e) => {
	let t = e.readByte(e.regs.hl), n = e.regs.a - t & 255, r = (e.regs.a & 8) >> 3 | (t & 8) >> 2 | (n & 8) >> 1;
	e.incTStateCount(5), e.regs.bc = b(e.regs.bc), e.regs.f = e.regs.f & T.C | (e.regs.bc === 0 ? 0 : T.V) | T.N | D[r] | (n === 0 ? T.Z : 0) | n & T.S, (e.regs.f & T.H) !== 0 && (n = y(n)), e.regs.f |= n & T.X3 | (n & 2 ? T.X5 : 0), e.regs.memptr = v(e.regs.memptr), e.regs.hl = v(e.regs.hl);
}), P.set(162, (e) => {
	e.incTStateCount(1);
	let t = e.readPort(e.regs.bc);
	e.writeByte(e.regs.hl, t), e.regs.memptr = v(e.regs.bc), e.regs.b = y(e.regs.b);
	let n = _(x(t, e.regs.c));
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.hl = v(e.regs.hl);
}), P.set(163, (e) => {
	e.incTStateCount(1);
	let t = e.readByte(e.regs.hl);
	e.regs.b = y(e.regs.b), e.regs.memptr = v(e.regs.bc), e.writePort(e.regs.bc, t), e.regs.hl = v(e.regs.hl);
	let n = x(t, e.regs.l);
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b];
}), P.set(168, (e) => {
	let t = e.readByte(e.regs.hl);
	e.writeByte(e.regs.de, t), e.incTStateCount(2), e.regs.bc = b(e.regs.bc), t = S(t, e.regs.a), e.regs.f = e.regs.f & (T.C | T.Z | T.S) | (e.regs.bc === 0 ? 0 : T.V) | t & T.X3 | (t & 2 ? T.X5 : 0), e.regs.hl = b(e.regs.hl), e.regs.de = b(e.regs.de);
}), P.set(169, (e) => {
	let t = e.readByte(e.regs.hl), n = e.regs.a - t & 255, r = (e.regs.a & 8) >> 3 | (t & 8) >> 2 | (n & 8) >> 1;
	e.incTStateCount(5), e.regs.bc = b(e.regs.bc), e.regs.f = e.regs.f & T.C | (e.regs.bc === 0 ? 0 : T.V) | T.N | D[r] | (n === 0 ? T.Z : 0) | n & T.S, (e.regs.f & T.H) !== 0 && (n = y(n)), e.regs.f |= n & T.X3 | (n & 2 ? T.X5 : 0), e.regs.memptr = b(e.regs.memptr), e.regs.hl = b(e.regs.hl);
}), P.set(170, (e) => {
	e.incTStateCount(1);
	let t = e.readPort(e.regs.bc);
	e.writeByte(e.regs.hl, t), e.regs.memptr = b(e.regs.bc), e.regs.b = y(e.regs.b);
	let n = y(x(t, e.regs.c));
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.hl = b(e.regs.hl);
}), P.set(171, (e) => {
	e.incTStateCount(1);
	let t = e.readByte(e.regs.hl);
	e.regs.b = y(e.regs.b), e.regs.memptr = b(e.regs.bc), e.writePort(e.regs.bc, t), e.regs.hl = b(e.regs.hl);
	let n = x(t, e.regs.l);
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b];
}), P.set(176, (e) => {
	let t = e.readByte(e.regs.hl);
	e.writeByte(e.regs.de, t), e.incTStateCount(2), e.regs.bc = b(e.regs.bc), t = S(t, e.regs.a), e.regs.f = e.regs.f & (T.C | T.Z | T.S) | (e.regs.bc === 0 ? 0 : T.V) | t & T.X3 | (t & 2 ? T.X5 : 0), e.regs.bc !== 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2), e.regs.memptr = S(e.regs.pc, 1)), e.regs.hl = v(e.regs.hl), e.regs.de = v(e.regs.de);
}), P.set(177, (e) => {
	let t = e.readByte(e.regs.hl), n = e.regs.a - t & 255, r = (e.regs.a & 8) >> 3 | (t & 8) >> 2 | (n & 8) >> 1;
	e.incTStateCount(5), e.regs.bc = b(e.regs.bc), e.regs.f = e.regs.f & T.C | (e.regs.bc === 0 ? 0 : T.V) | T.N | D[r] | (n === 0 ? T.Z : 0) | n & T.S, (e.regs.f & T.H) !== 0 && (n = y(n)), e.regs.f |= n & T.X3 | (n & 2 ? T.X5 : 0), (e.regs.f & (T.V | T.Z)) === T.V ? (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2), e.regs.memptr = S(e.regs.pc, 1)) : e.regs.memptr = v(e.regs.memptr), e.regs.hl = v(e.regs.hl);
}), P.set(178, (e) => {
	e.incTStateCount(1);
	let t = e.readPort(e.regs.bc);
	e.writeByte(e.regs.hl, t), e.regs.memptr = v(e.regs.bc), e.regs.b = y(e.regs.b);
	let n = _(x(t, e.regs.c));
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.b > 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2)), e.regs.hl = v(e.regs.hl);
}), P.set(179, (e) => {
	e.incTStateCount(1);
	let t = e.readByte(e.regs.hl);
	e.regs.b = y(e.regs.b), e.regs.memptr = v(e.regs.bc), e.writePort(e.regs.bc, t), e.regs.hl = v(e.regs.hl);
	let n = x(t, e.regs.l);
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.b > 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2));
}), P.set(184, (e) => {
	let t = e.readByte(e.regs.hl);
	e.writeByte(e.regs.de, t), e.incTStateCount(2), e.regs.bc = b(e.regs.bc), t = S(t, e.regs.a), e.regs.f = e.regs.f & (T.C | T.Z | T.S) | (e.regs.bc === 0 ? 0 : T.V) | t & T.X3 | (t & 2 ? T.X5 : 0), e.regs.bc !== 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2), e.regs.memptr = S(e.regs.pc, 1)), e.regs.hl = b(e.regs.hl), e.regs.de = b(e.regs.de);
}), P.set(185, (e) => {
	let t = e.readByte(e.regs.hl), n = e.regs.a - t & 255, r = (e.regs.a & 8) >> 3 | (t & 8) >> 2 | (n & 8) >> 1;
	e.incTStateCount(5), e.regs.bc = b(e.regs.bc), e.regs.f = e.regs.f & T.C | (e.regs.bc === 0 ? 0 : T.V) | T.N | D[r] | (n === 0 ? T.Z : 0) | n & T.S, (e.regs.f & T.H) !== 0 && (n = y(n)), e.regs.f |= n & T.X3 | (n & 2 ? T.X5 : 0), (e.regs.f & (T.V | T.Z)) === T.V ? (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2), e.regs.memptr = S(e.regs.pc, 1)) : e.regs.memptr = b(e.regs.memptr), e.regs.hl = b(e.regs.hl);
}), P.set(186, (e) => {
	e.incTStateCount(1);
	let t = e.readPort(e.regs.bc);
	e.writeByte(e.regs.hl, t), e.regs.memptr = b(e.regs.bc), e.regs.b = y(e.regs.b);
	let n = y(x(t, e.regs.c));
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.b > 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2)), e.regs.hl = b(e.regs.hl);
}), P.set(187, (e) => {
	e.incTStateCount(1);
	let t = e.readByte(e.regs.hl);
	e.regs.b = y(e.regs.b), e.regs.memptr = b(e.regs.bc), e.writePort(e.regs.bc, t), e.regs.hl = b(e.regs.hl);
	let n = x(t, e.regs.l);
	e.regs.f = (t & 128 ? T.N : 0) | (n < t ? T.H | T.C : 0) | (e.parityTable[n & 7 ^ e.regs.b] ? T.P : 0) | e.sz53Table[e.regs.b], e.regs.b > 0 && (e.incTStateCount(5), e.regs.pc = S(e.regs.pc, -2));
});
var F = /* @__PURE__ */ new Map();
F.set(9, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.bc;
	let n = e.regs.iy + t, r = ((e.regs.iy & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.iy), e.regs.iy = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), F.set(25, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.de;
	let n = e.regs.iy + t, r = ((e.regs.iy & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.iy), e.regs.iy = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), F.set(33, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), t = g(e.readByte(e.regs.pc), t), e.regs.pc = v(e.regs.pc), e.regs.iy = t;
}), F.set(34, (e) => {
	let t;
	t = e.regs.iy;
	let n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), e.writeByte(n, h(t)), n = v(n), e.regs.memptr = n, e.writeByte(n, m(t));
}), F.set(35, (e) => {
	let t;
	t = e.regs.iy, e.incTStateCount(2), t = v(t), e.regs.iy = t;
}), F.set(36, (e) => {
	let t;
	t = e.regs.iyh, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.iyh = t;
}), F.set(37, (e) => {
	let t;
	t = e.regs.iyh;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.iyh = t;
}), F.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.iyh = t;
}), F.set(41, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.iy;
	let n = e.regs.iy + t, r = ((e.regs.iy & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.iy), e.regs.iy = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), F.set(42, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc), n = g(e.readByte(e.regs.pc), n), e.regs.pc = v(e.regs.pc), t = e.readByte(n), e.regs.memptr = v(n), t = g(e.readByte(e.regs.memptr), t), e.regs.iy = t;
}), F.set(43, (e) => {
	let t;
	t = e.regs.iy, e.incTStateCount(2), t = b(t), e.regs.iy = t;
}), F.set(44, (e) => {
	let t;
	t = e.regs.iyl, t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.regs.iyl = t;
}), F.set(45, (e) => {
	let t;
	t = e.regs.iyl;
	let n = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (n & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.regs.iyl = t;
}), F.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.regs.pc = v(e.regs.pc), e.regs.iyl = t;
}), F.set(52, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = S(e.regs.iy, w(n)), t = e.readByte(e.regs.memptr), e.incTStateCount(1), t = _(t), e.regs.f = e.regs.f & T.C | (t === 128 ? T.V : 0) | (t & 15 ? 0 : T.H) | e.sz53Table[t], e.writeByte(e.regs.memptr, t);
}), F.set(53, (e) => {
	let t, n = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = S(e.regs.iy, w(n)), t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let r = t;
	t = y(t), e.regs.f = e.regs.f & T.C | (t === 127 ? T.V : 0) | (r & 15 ? 0 : T.H) | T.N | e.sz53Table[t], e.writeByte(e.regs.memptr, t);
}), F.set(54, (e) => {
	let t = e.readByte(e.regs.pc);
	e.regs.pc = v(e.regs.pc);
	let n;
	n = e.readByte(e.regs.pc), e.incTStateCount(2), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(57, (e) => {
	let t;
	e.incTStateCount(7), t = e.regs.sp;
	let n = e.regs.iy + t, r = ((e.regs.iy & 2048) >> 11 | (t & 2048) >> 10 | (n & 2048) >> 9) & 255;
	e.regs.memptr = v(e.regs.iy), e.regs.iy = n & 65535, e.regs.f = e.regs.f & (T.V | T.Z | T.S) | (n & 65536 ? T.C : 0) | n >> 8 & (T.X3 | T.X5) | E[r];
}), F.set(68, (e) => {
	let t;
	t = e.regs.iyh, e.regs.b = t;
}), F.set(69, (e) => {
	let t;
	t = e.regs.iyl, e.regs.b = t;
}), F.set(70, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.b = t;
}), F.set(76, (e) => {
	let t;
	t = e.regs.iyh, e.regs.c = t;
}), F.set(77, (e) => {
	let t;
	t = e.regs.iyl, e.regs.c = t;
}), F.set(78, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.c = t;
}), F.set(84, (e) => {
	let t;
	t = e.regs.iyh, e.regs.d = t;
}), F.set(85, (e) => {
	let t;
	t = e.regs.iyl, e.regs.d = t;
}), F.set(86, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.d = t;
}), F.set(92, (e) => {
	let t;
	t = e.regs.iyh, e.regs.e = t;
}), F.set(93, (e) => {
	let t;
	t = e.regs.iyl, e.regs.e = t;
}), F.set(94, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.e = t;
}), F.set(96, (e) => {
	let t;
	t = e.regs.b, e.regs.iyh = t;
}), F.set(97, (e) => {
	let t;
	t = e.regs.c, e.regs.iyh = t;
}), F.set(98, (e) => {
	let t;
	t = e.regs.d, e.regs.iyh = t;
}), F.set(99, (e) => {
	let t;
	t = e.regs.e, e.regs.iyh = t;
}), F.set(100, (e) => {
	let t;
	t = e.regs.iyh, e.regs.iyh = t;
}), F.set(101, (e) => {
	let t;
	t = e.regs.iyl, e.regs.iyh = t;
}), F.set(102, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.h = t;
}), F.set(103, (e) => {
	let t;
	t = e.regs.a, e.regs.iyh = t;
}), F.set(104, (e) => {
	let t;
	t = e.regs.b, e.regs.iyl = t;
}), F.set(105, (e) => {
	let t;
	t = e.regs.c, e.regs.iyl = t;
}), F.set(106, (e) => {
	let t;
	t = e.regs.d, e.regs.iyl = t;
}), F.set(107, (e) => {
	let t;
	t = e.regs.e, e.regs.iyl = t;
}), F.set(108, (e) => {
	let t;
	t = e.regs.iyh, e.regs.iyl = t;
}), F.set(109, (e) => {
	let t;
	t = e.regs.iyl, e.regs.iyl = t;
}), F.set(110, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.l = t;
}), F.set(111, (e) => {
	let t;
	t = e.regs.a, e.regs.iyl = t;
}), F.set(112, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.b, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(113, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.c, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(114, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.d, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(115, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.e, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(116, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.h, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(117, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.l, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(119, (e) => {
	let t = e.readByte(e.regs.pc);
	e.incTStateCount(5), e.regs.pc = v(e.regs.pc);
	let n;
	n = e.regs.a, e.regs.memptr = e.regs.iy + w(t) & 65535, e.writeByte(e.regs.memptr, n);
}), F.set(124, (e) => {
	let t;
	t = e.regs.iyh, e.regs.a = t;
}), F.set(125, (e) => {
	let t;
	t = e.regs.iyl, e.regs.a = t;
}), F.set(126, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a = t;
}), F.set(132, (e) => {
	let t;
	t = e.regs.iyh;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(133, (e) => {
	let t;
	t = e.regs.iyl;
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(134, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = S(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(140, (e) => {
	let t;
	t = e.regs.iyh;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(141, (e) => {
	let t;
	t = e.regs.iyl;
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(142, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = S(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = v(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | E[r & 7] | O[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(148, (e) => {
	let t;
	t = e.regs.iyh;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(149, (e) => {
	let t;
	t = e.regs.iyl;
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(150, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = C(e.regs.a, t), r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(156, (e) => {
	let t;
	t = e.regs.iyh;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(157, (e) => {
	let t;
	t = e.regs.iyl;
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(158, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = C(e.regs.a, t);
	(e.regs.f & T.C) !== 0 && (n = b(n));
	let r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255;
	e.regs.a = n & 255, e.regs.f = (n & 256 ? T.C : 0) | T.N | D[r & 7] | k[r >> 4] | e.sz53Table[e.regs.a];
}), F.set(164, (e) => {
	let t;
	t = e.regs.iyh, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), F.set(165, (e) => {
	let t;
	t = e.regs.iyl, e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), F.set(166, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a &= t, e.regs.f = e.sz53pTable[e.regs.a], e.regs.f |= T.H;
}), F.set(172, (e) => {
	let t;
	t = e.regs.iyh, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(173, (e) => {
	let t;
	t = e.regs.iyl, e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(174, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a ^= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(180, (e) => {
	let t;
	t = e.regs.iyh, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(181, (e) => {
	let t;
	t = e.regs.iyl, e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(182, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr), e.regs.a |= t, e.regs.f = e.sz53pTable[e.regs.a];
}), F.set(188, (e) => {
	let t;
	t = e.regs.iyh;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), F.set(189, (e) => {
	let t;
	t = e.regs.iyl;
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), F.set(190, (e) => {
	let t;
	t = e.readByte(e.regs.pc), e.incTStateCount(5), e.regs.pc = v(e.regs.pc), e.regs.memptr = e.regs.iy + w(t) & 65535, t = e.readByte(e.regs.memptr);
	let n = e.regs.a - t & 65535, r = ((e.regs.a & 136) >> 3 | (t & 136) >> 2 | (n & 136) >> 1) & 255, i = T.N;
	n & 256 && (i |= T.C), n == 0 && (i |= T.Z), i |= D[r & 7], i |= k[r >> 4], i |= t & (T.X3 | T.X5), i |= n & T.S, e.regs.af = g(e.regs.a, i);
}), F.set(203, (e) => {
	Ee(e);
}), F.set(225, (e) => {
	e.regs.iy = e.popWord();
}), F.set(227, (e) => {
	let t = e.regs.iy, n = e.readByte(e.regs.sp), r = e.readByte(v(e.regs.sp));
	e.incTStateCount(1), e.writeByte(v(e.regs.sp), m(t)), e.writeByte(e.regs.sp, h(t)), e.incTStateCount(2), e.regs.memptr = g(r, n), e.regs.iy = g(r, n);
}), F.set(229, (e) => {
	e.incTStateCount(1), e.pushWord(e.regs.iy);
}), F.set(233, (e) => {
	e.regs.pc = e.regs.iy;
}), F.set(249, (e) => {
	let t;
	t = e.regs.iy, e.incTStateCount(2), e.regs.sp = t;
});
var I = /* @__PURE__ */ new Map();
I.set(0, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(1, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(2, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(3, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(4, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(5, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(6, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(7, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | t >> 7) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(8, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(9, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(10, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(11, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(12, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(13, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(14, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(15, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t >> 1 | t << 7) & 255, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(16, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(17, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(18, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(19, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(20, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(21, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(22, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(23, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | ((e.regs.f & T.C) === 0 ? 0 : 1)) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(24, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(25, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(26, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(27, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(28, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(29, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(30, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(31, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t >> 1 | ((e.regs.f & T.C) === 0 ? 0 : 128), e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(32, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(33, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(34, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(35, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(36, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(37, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(38, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(39, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t << 1 & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(40, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(41, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(42, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(43, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(44, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(45, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(46, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(47, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = t & 128 | t >> 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(48, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(49, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(50, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(51, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(52, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(53, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(54, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(55, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t = (t << 1 | 1) & 255, e.regs.f = (n & 128 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(56, (e) => {
	e.regs.b = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.b;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.b = t;
	}
	e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(57, (e) => {
	e.regs.c = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.c;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.c = t;
	}
	e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(58, (e) => {
	e.regs.d = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.d;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.d = t;
	}
	e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(59, (e) => {
	e.regs.e = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.e;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.e = t;
	}
	e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(60, (e) => {
	e.regs.h = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.h;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.h = t;
	}
	e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(61, (e) => {
	e.regs.l = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.l;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.l = t;
	}
	e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(62, (e) => {
	let t;
	t = e.readByte(e.regs.memptr), e.incTStateCount(1);
	let n = t;
	t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.writeByte(e.regs.memptr, t);
}), I.set(63, (e) => {
	e.regs.a = e.readByte(e.regs.memptr), e.incTStateCount(1);
	{
		let t;
		t = e.regs.a;
		let n = t;
		t >>= 1, e.regs.f = (n & 1 ? T.C : 0) | e.sz53pTable[t], e.regs.a = t;
	}
	e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(70, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 1 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(78, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 2 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(86, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 4 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(94, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 8 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(102, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 16 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(110, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 32 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(118, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 64 || (r |= T.P | T.Z), e.regs.f = r;
}), I.set(126, (e) => {
	let t = e.readByte(e.regs.memptr), n = m(e.regs.memptr);
	e.incTStateCount(1);
	let r = e.regs.f & T.C | T.H | n & (T.X3 | T.X5);
	t & 128 || (r |= T.P | T.Z), t & 128 && (r |= T.S), e.regs.f = r;
}), I.set(128, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(129, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(130, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(131, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(132, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(133, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(134, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 254);
}), I.set(135, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 254, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(136, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(137, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(138, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(139, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(140, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(141, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(142, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 253);
}), I.set(143, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 253, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(144, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(145, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(146, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(147, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(148, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(149, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(150, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 251);
}), I.set(151, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 251, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(152, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(153, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(154, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(155, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(156, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(157, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(158, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 247);
}), I.set(159, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 247, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(160, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(161, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(162, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(163, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(164, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(165, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(166, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 239);
}), I.set(167, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 239, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(168, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(169, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(170, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(171, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(172, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(173, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(174, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 223);
}), I.set(175, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 223, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(176, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(177, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(178, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(179, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(180, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(181, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(182, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 191);
}), I.set(183, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 191, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(184, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(185, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(186, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(187, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(188, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(189, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(190, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t & 127);
}), I.set(191, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) & 127, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(192, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(193, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(194, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(195, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(196, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(197, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(198, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 1);
}), I.set(199, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 1, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(200, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(201, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(202, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(203, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(204, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(205, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(206, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 2);
}), I.set(207, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 2, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(208, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(209, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(210, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(211, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(212, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(213, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(214, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 4);
}), I.set(215, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 4, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(216, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(217, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(218, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(219, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(220, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(221, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(222, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 8);
}), I.set(223, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 8, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(224, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(225, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(226, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(227, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(228, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(229, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(230, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 16);
}), I.set(231, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 16, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(232, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(233, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(234, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(235, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(236, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(237, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(238, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 32);
}), I.set(239, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 32, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(240, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(241, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(242, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(243, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(244, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(245, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(246, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 64);
}), I.set(247, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 64, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), I.set(248, (e) => {
	e.regs.b = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.b);
}), I.set(249, (e) => {
	e.regs.c = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.c);
}), I.set(250, (e) => {
	e.regs.d = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.d);
}), I.set(251, (e) => {
	e.regs.e = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.e);
}), I.set(252, (e) => {
	e.regs.h = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.h);
}), I.set(253, (e) => {
	e.regs.l = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.l);
}), I.set(254, (e) => {
	let t = e.readByte(e.regs.memptr);
	e.incTStateCount(1), e.writeByte(e.regs.memptr, t | 128);
}), I.set(255, (e) => {
	e.regs.a = e.readByte(e.regs.memptr) | 128, e.incTStateCount(1), e.writeByte(e.regs.memptr, e.regs.a);
}), M.set(4, A.get(4)), M.set(5, A.get(5)), M.set(6, A.get(6)), M.set(12, A.get(12)), M.set(13, A.get(13)), M.set(14, A.get(14)), M.set(20, A.get(20)), M.set(21, A.get(21)), M.set(22, A.get(22)), M.set(28, A.get(28)), M.set(29, A.get(29)), M.set(30, A.get(30)), M.set(60, A.get(60)), M.set(61, A.get(61)), M.set(62, A.get(62)), M.set(64, A.get(64)), M.set(65, A.get(65)), M.set(66, A.get(66)), M.set(67, A.get(67)), M.set(71, A.get(71)), M.set(72, A.get(72)), M.set(73, A.get(73)), M.set(74, A.get(74)), M.set(75, A.get(75)), M.set(79, A.get(79)), M.set(80, A.get(80)), M.set(81, A.get(81)), M.set(82, A.get(82)), M.set(83, A.get(83)), M.set(87, A.get(87)), M.set(88, A.get(88)), M.set(89, A.get(89)), M.set(90, A.get(90)), M.set(91, A.get(91)), M.set(95, A.get(95)), M.set(120, A.get(120)), M.set(121, A.get(121)), M.set(122, A.get(122)), M.set(123, A.get(123)), M.set(127, A.get(127)), M.set(128, A.get(128)), M.set(129, A.get(129)), M.set(130, A.get(130)), M.set(131, A.get(131)), M.set(135, A.get(135)), M.set(136, A.get(136)), M.set(137, A.get(137)), M.set(138, A.get(138)), M.set(139, A.get(139)), M.set(143, A.get(143)), M.set(144, A.get(144)), M.set(145, A.get(145)), M.set(146, A.get(146)), M.set(147, A.get(147)), M.set(151, A.get(151)), M.set(152, A.get(152)), M.set(153, A.get(153)), M.set(154, A.get(154)), M.set(155, A.get(155)), M.set(159, A.get(159)), M.set(160, A.get(160)), M.set(161, A.get(161)), M.set(162, A.get(162)), M.set(163, A.get(163)), M.set(167, A.get(167)), M.set(168, A.get(168)), M.set(169, A.get(169)), M.set(170, A.get(170)), M.set(171, A.get(171)), M.set(175, A.get(175)), M.set(176, A.get(176)), M.set(177, A.get(177)), M.set(178, A.get(178)), M.set(179, A.get(179)), M.set(183, A.get(183)), M.set(184, A.get(184)), M.set(185, A.get(185)), M.set(186, A.get(186)), M.set(187, A.get(187)), M.set(191, A.get(191)), N.set(64, N.get(70)), N.set(65, N.get(70)), N.set(66, N.get(70)), N.set(67, N.get(70)), N.set(68, N.get(70)), N.set(69, N.get(70)), N.set(71, N.get(70)), N.set(72, N.get(78)), N.set(73, N.get(78)), N.set(74, N.get(78)), N.set(75, N.get(78)), N.set(76, N.get(78)), N.set(77, N.get(78)), N.set(79, N.get(78)), N.set(80, N.get(86)), N.set(81, N.get(86)), N.set(82, N.get(86)), N.set(83, N.get(86)), N.set(84, N.get(86)), N.set(85, N.get(86)), N.set(87, N.get(86)), N.set(88, N.get(94)), N.set(89, N.get(94)), N.set(90, N.get(94)), N.set(91, N.get(94)), N.set(92, N.get(94)), N.set(93, N.get(94)), N.set(95, N.get(94)), N.set(96, N.get(102)), N.set(97, N.get(102)), N.set(98, N.get(102)), N.set(99, N.get(102)), N.set(100, N.get(102)), N.set(101, N.get(102)), N.set(103, N.get(102)), N.set(104, N.get(110)), N.set(105, N.get(110)), N.set(106, N.get(110)), N.set(107, N.get(110)), N.set(108, N.get(110)), N.set(109, N.get(110)), N.set(111, N.get(110)), N.set(112, N.get(118)), N.set(113, N.get(118)), N.set(114, N.get(118)), N.set(115, N.get(118)), N.set(116, N.get(118)), N.set(117, N.get(118)), N.set(119, N.get(118)), N.set(120, N.get(126)), N.set(121, N.get(126)), N.set(122, N.get(126)), N.set(123, N.get(126)), N.set(124, N.get(126)), N.set(125, N.get(126)), N.set(127, N.get(126)), P.set(76, P.get(68)), P.set(78, P.get(70)), P.set(84, P.get(68)), P.set(85, P.get(69)), P.set(92, P.get(68)), P.set(93, P.get(69)), P.set(99, A.get(34)), P.set(100, P.get(68)), P.set(101, P.get(69)), P.set(102, P.get(70)), P.set(107, A.get(42)), P.set(108, P.get(68)), P.set(109, P.get(69)), P.set(110, P.get(70)), P.set(116, P.get(68)), P.set(117, P.get(69)), P.set(118, P.get(86)), P.set(124, P.get(68)), P.set(125, P.get(69)), P.set(126, P.get(94)), F.set(4, A.get(4)), F.set(5, A.get(5)), F.set(6, A.get(6)), F.set(12, A.get(12)), F.set(13, A.get(13)), F.set(14, A.get(14)), F.set(20, A.get(20)), F.set(21, A.get(21)), F.set(22, A.get(22)), F.set(28, A.get(28)), F.set(29, A.get(29)), F.set(30, A.get(30)), F.set(60, A.get(60)), F.set(61, A.get(61)), F.set(62, A.get(62)), F.set(64, A.get(64)), F.set(65, A.get(65)), F.set(66, A.get(66)), F.set(67, A.get(67)), F.set(71, A.get(71)), F.set(72, A.get(72)), F.set(73, A.get(73)), F.set(74, A.get(74)), F.set(75, A.get(75)), F.set(79, A.get(79)), F.set(80, A.get(80)), F.set(81, A.get(81)), F.set(82, A.get(82)), F.set(83, A.get(83)), F.set(87, A.get(87)), F.set(88, A.get(88)), F.set(89, A.get(89)), F.set(90, A.get(90)), F.set(91, A.get(91)), F.set(95, A.get(95)), F.set(120, A.get(120)), F.set(121, A.get(121)), F.set(122, A.get(122)), F.set(123, A.get(123)), F.set(127, A.get(127)), F.set(128, A.get(128)), F.set(129, A.get(129)), F.set(130, A.get(130)), F.set(131, A.get(131)), F.set(135, A.get(135)), F.set(136, A.get(136)), F.set(137, A.get(137)), F.set(138, A.get(138)), F.set(139, A.get(139)), F.set(143, A.get(143)), F.set(144, A.get(144)), F.set(145, A.get(145)), F.set(146, A.get(146)), F.set(147, A.get(147)), F.set(151, A.get(151)), F.set(152, A.get(152)), F.set(153, A.get(153)), F.set(154, A.get(154)), F.set(155, A.get(155)), F.set(159, A.get(159)), F.set(160, A.get(160)), F.set(161, A.get(161)), F.set(162, A.get(162)), F.set(163, A.get(163)), F.set(167, A.get(167)), F.set(168, A.get(168)), F.set(169, A.get(169)), F.set(170, A.get(170)), F.set(171, A.get(171)), F.set(175, A.get(175)), F.set(176, A.get(176)), F.set(177, A.get(177)), F.set(178, A.get(178)), F.set(179, A.get(179)), F.set(183, A.get(183)), F.set(184, A.get(184)), F.set(185, A.get(185)), F.set(186, A.get(186)), F.set(187, A.get(187)), F.set(191, A.get(191)), I.set(64, I.get(70)), I.set(65, I.get(70)), I.set(66, I.get(70)), I.set(67, I.get(70)), I.set(68, I.get(70)), I.set(69, I.get(70)), I.set(71, I.get(70)), I.set(72, I.get(78)), I.set(73, I.get(78)), I.set(74, I.get(78)), I.set(75, I.get(78)), I.set(76, I.get(78)), I.set(77, I.get(78)), I.set(79, I.get(78)), I.set(80, I.get(86)), I.set(81, I.get(86)), I.set(82, I.get(86)), I.set(83, I.get(86)), I.set(84, I.get(86)), I.set(85, I.get(86)), I.set(87, I.get(86)), I.set(88, I.get(94)), I.set(89, I.get(94)), I.set(90, I.get(94)), I.set(91, I.get(94)), I.set(92, I.get(94)), I.set(93, I.get(94)), I.set(95, I.get(94)), I.set(96, I.get(102)), I.set(97, I.get(102)), I.set(98, I.get(102)), I.set(99, I.get(102)), I.set(100, I.get(102)), I.set(101, I.get(102)), I.set(103, I.get(102)), I.set(104, I.get(110)), I.set(105, I.get(110)), I.set(106, I.get(110)), I.set(107, I.get(110)), I.set(108, I.get(110)), I.set(109, I.get(110)), I.set(111, I.get(110)), I.set(112, I.get(118)), I.set(113, I.get(118)), I.set(114, I.get(118)), I.set(115, I.get(118)), I.set(116, I.get(118)), I.set(117, I.get(118)), I.set(119, I.get(118)), I.set(120, I.get(126)), I.set(121, I.get(126)), I.set(122, I.get(126)), I.set(123, I.get(126)), I.set(124, I.get(126)), I.set(125, I.get(126)), I.set(127, I.get(126));
function be(e) {
	e.incTStateCount(4);
	let t = e.readByteInternal(e.regs.pc);
	return e.regs.pc = v(e.regs.pc), e.regs.bumpR(), t;
}
function xe(e) {
	let t = be(e), n = j.get(t);
	n === void 0 ? e.warnUndefinedOpcode("CB " + f(t, 2)) : n(e);
}
function Se(e) {
	let t = be(e), n = M.get(t) ?? A.get(t);
	n === void 0 ? e.warnUndefinedOpcode("DD " + f(t, 2)) : n(e);
}
function Ce(e) {
	e.incTStateCount(3);
	let t = e.readByteInternal(e.regs.pc);
	e.regs.memptr = S(e.regs.ix, w(t)), e.regs.pc = v(e.regs.pc), e.incTStateCount(3);
	let n = e.readByteInternal(e.regs.pc);
	e.incTStateCount(2), e.regs.pc = v(e.regs.pc);
	let r = N.get(n);
	r === void 0 ? e.warnUndefinedOpcode("DD CB " + f(n, 2)) : r(e);
}
function we(e) {
	let t = be(e), n = P.get(t);
	n === void 0 ? e.warnUndefinedOpcode("ED " + f(t, 2)) : n(e);
}
function Te(e) {
	let t = be(e), n = F.get(t) ?? A.get(t);
	n === void 0 ? e.warnUndefinedOpcode("FD " + f(t, 2)) : n(e);
}
function Ee(e) {
	e.incTStateCount(3);
	let t = e.readByteInternal(e.regs.pc);
	e.regs.memptr = S(e.regs.iy, w(t)), e.regs.pc = v(e.regs.pc), e.incTStateCount(3);
	let n = e.readByteInternal(e.regs.pc);
	e.incTStateCount(2), e.regs.pc = v(e.regs.pc);
	let r = I.get(n);
	r === void 0 ? e.warnUndefinedOpcode("FD CB " + f(n, 2)) : r(e);
}
function De(e) {
	let t = be(e), n = A.get(t);
	n === void 0 ? e.warnUndefinedOpcode(f(t, 2)) : n(e);
}
//#endregion
//#region ../z80-emulator/src/Z80State.ts
var Oe = class {
	constructor(e) {
		this.regs = e;
	}
}, ke = class {
	constructor(e) {
		this.regs = new de(), this.instructionAddress = 0, this.pushInstructionAddress = /* @__PURE__ */ new Uint16Array(65536), this.sz53Table = [], this.parityTable = [], this.sz53pTable = [], this.warnedUndefinedOpcodes = /* @__PURE__ */ new Set(), this.hal = e, this.initTables();
	}
	save() {
		return new Oe(this.regs.clone());
	}
	restore(e) {
		this.regs = e.regs.clone();
	}
	reset() {
		this.regs = new de();
	}
	step() {
		this.instructionAddress = this.regs.pc, De(this);
	}
	warnUndefinedOpcode(e) {
		this.warnedUndefinedOpcodes.has(e) || (this.warnedUndefinedOpcodes.add(e), ye.warn("Undefined instruction " + e + " at 0x" + p(this.instructionAddress) + " executed as a NOP"));
	}
	incTStateCount(e) {
		this.hal.tStateCount += e;
	}
	maskableInterrupt() {
		this.regs.iff1 !== 0 && this.interrupt(!0);
	}
	nonMaskableInterrupt() {
		this.interrupt(!1);
	}
	readByte(e) {
		return this.incTStateCount(3), this.readByteInternal(e);
	}
	readWord(e) {
		let t = this.readByte(e);
		return g(this.readByte(e + 1), t);
	}
	readByteInternal(e) {
		return this.hal.readMemory(e);
	}
	writeByte(e, t) {
		this.incTStateCount(3), this.writeByteInternal(e, t);
	}
	writeByteInternal(e, t) {
		this.hal.writeMemory(e, t);
	}
	writePort(e, t) {
		this.incTStateCount(1), this.hal.writePort(e, t), this.incTStateCount(3);
	}
	readPort(e) {
		this.incTStateCount(1);
		let t = this.hal.readPort(e);
		return this.incTStateCount(3), t;
	}
	pushWord(e) {
		this.pushByte(m(e)), this.pushByte(h(e)), this.pushInstructionAddress[this.regs.sp] = this.instructionAddress;
	}
	pushByte(e) {
		this.regs.sp = this.regs.sp - 1 & 65535, this.writeByte(this.regs.sp, e);
	}
	popWord() {
		let e = this.popByte();
		return g(this.popByte(), e);
	}
	popByte() {
		let e = this.readByte(this.regs.sp);
		return this.regs.sp = v(this.regs.sp), e;
	}
	interrupt(e) {
		if (this.regs.halted && (this.regs.pc = this.regs.pc + 1 & 65535, this.regs.halted = 0), this.incTStateCount(7), this.regs.bumpR(), this.regs.iff1 = 0, e && (this.regs.iff2 = 0), this.pushWord(this.regs.pc), e) switch (this.regs.im) {
			case 0:
				this.regs.pc = 56;
				break;
			case 1:
				this.regs.pc = 56;
				break;
			case 2: {
				let e = g(this.regs.i, 255);
				this.regs.pc = this.readWord(e);
				break;
			}
			default: throw Error("Unknown im mode " + this.regs.im);
		}
		else this.regs.pc = 102;
	}
	initTables() {
		for (let e = 0; e < 256; e++) {
			this.sz53Table.push(e & (T.X3 | T.X5 | T.S));
			let t = e, n = 0;
			for (let e = 0; e < 8; e++) n ^= t & 1, t >>= 1;
			this.parityTable.push(n ? 0 : T.P), this.sz53pTable.push(this.sz53Table[e] | this.parityTable[e]);
		}
		this.sz53Table[0] |= T.Z, this.sz53pTable[0] |= T.Z;
	}
};
//#endregion
//#region ../z80-inst/src/OpcodesTypes.ts
function Ae(e) {
	return e === "nn" || e === "nnnn" || e === "dd" || e === "offset";
}
function je(e) {
	let t = [e.mnemonic, " "], n = !1;
	for (let r of e.tokens) {
		let e = r !== "(" && r !== ")" && r !== "," && r !== "+";
		n && e && t.push(" "), t.push(r), n = e;
	}
	return t.join("");
}
function Me(e) {
	return typeof e == "number" ? se(e) : e;
}
function Ne(e) {
	return e.opcodes.map(Me).join(" ");
}
//#endregion
//#region ../z80-inst/src/Opcodes.ts
var Pe = {
	mnemonic: "nop",
	params: [],
	tokens: [],
	opcodes: [0],
	isPseudo: !1,
	clr: {
		opcodes: "00",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "No operation is performed.",
		instruction: "nop"
	}
}, Fe = {
	mnemonic: "ld",
	params: ["bc", "nnnn"],
	tokens: [
		"bc",
		",",
		"nnnn"
	],
	opcodes: [1, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "01",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads <var>nnnn</var> into BC.",
		instruction: "ld bc,nnnn"
	}
}, Ie = {
	mnemonic: "ld",
	params: ["(bc)", "a"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"a"
	],
	opcodes: [2],
	isPseudo: !1,
	clr: {
		opcodes: "02",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Stores A into the memory location pointed to by BC.",
		instruction: "ld (bc),a"
	}
}, Le = {
	mnemonic: "inc",
	params: ["bc"],
	tokens: ["bc"],
	opcodes: [3],
	isPseudo: !1,
	clr: {
		opcodes: "03",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Adds one to BC.",
		instruction: "inc bc"
	}
}, Re = {
	mnemonic: "inc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [4],
	isPseudo: !1,
	clr: {
		opcodes: "04",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to B.",
		instruction: "inc b"
	}
}, ze = {
	mnemonic: "dec",
	params: ["b"],
	tokens: ["b"],
	opcodes: [5],
	isPseudo: !1,
	clr: {
		opcodes: "05",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from B.",
		instruction: "dec b"
	}
}, Be = {
	mnemonic: "ld",
	params: ["b", "nn"],
	tokens: [
		"b",
		",",
		"nn"
	],
	opcodes: [6, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "06",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into B.",
		instruction: "ld b,nn"
	}
}, Ve = {
	mnemonic: "rlca",
	params: [],
	tokens: [],
	opcodes: [7],
	isPseudo: !1,
	clr: {
		opcodes: "07",
		undocumented: !1,
		z180: !1,
		flags: "+0-0--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlca"
	}
}, He = {
	mnemonic: "ex",
	params: ["af", "af'"],
	tokens: [
		"af",
		",",
		"af'"
	],
	opcodes: [8],
	isPseudo: !1,
	clr: {
		opcodes: "08",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Exchanges the 16-bit contents of AF and AF'.",
		instruction: "ex af,af'"
	}
}, Ue = {
	mnemonic: "ex",
	params: ["af'", "af"],
	tokens: [
		"af'",
		",",
		"af"
	],
	opcodes: [8],
	isPseudo: !0,
	clr: {
		opcodes: "08",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Exchanges the 16-bit contents of AF and AF'.",
		instruction: "ex af,af'"
	}
}, We = {
	mnemonic: "add",
	params: ["hl", "bc"],
	tokens: [
		"hl",
		",",
		"bc"
	],
	opcodes: [9],
	isPseudo: !1,
	clr: {
		opcodes: "09",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of BC is added to HL.",
		instruction: "add hl,bc"
	}
}, Ge = {
	mnemonic: "ld",
	params: ["a", "(bc)"],
	tokens: [
		"a",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [10],
	isPseudo: !1,
	clr: {
		opcodes: "0A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads the value pointed to by BC into A.",
		instruction: "ld a,(bc)"
	}
}, Ke = {
	mnemonic: "dec",
	params: ["bc"],
	tokens: ["bc"],
	opcodes: [11],
	isPseudo: !1,
	clr: {
		opcodes: "0B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Subtracts one from BC.",
		instruction: "dec bc"
	}
}, qe = {
	mnemonic: "inc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [12],
	isPseudo: !1,
	clr: {
		opcodes: "0C",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to C.",
		instruction: "inc c"
	}
}, Je = {
	mnemonic: "dec",
	params: ["c"],
	tokens: ["c"],
	opcodes: [13],
	isPseudo: !1,
	clr: {
		opcodes: "0D",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from C.",
		instruction: "dec c"
	}
}, Ye = {
	mnemonic: "ld",
	params: ["c", "nn"],
	tokens: [
		"c",
		",",
		"nn"
	],
	opcodes: [14, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "0E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into C.",
		instruction: "ld c,nn"
	}
}, Xe = {
	mnemonic: "rrca",
	params: [],
	tokens: [],
	opcodes: [15],
	isPseudo: !1,
	clr: {
		opcodes: "0F",
		undocumented: !1,
		z180: !1,
		flags: "+0-0--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrca"
	}
}, Ze = {
	mnemonic: "djnz",
	params: ["offset"],
	tokens: ["offset"],
	opcodes: [16, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "10",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 13,
		without_jump_clock_count: 8,
		description: "The B register is decremented, and if not zero, the signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "djnz offset"
	}
}, Qe = {
	mnemonic: "ld",
	params: ["de", "nnnn"],
	tokens: [
		"de",
		",",
		"nnnn"
	],
	opcodes: [17, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "11",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads <var>nnnn</var> into DE.",
		instruction: "ld de,nnnn"
	}
}, $e = {
	mnemonic: "ld",
	params: ["(de)", "a"],
	tokens: [
		"(",
		"de",
		")",
		",",
		"a"
	],
	opcodes: [18],
	isPseudo: !1,
	clr: {
		opcodes: "12",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Stores A into the memory location pointed to by DE.",
		instruction: "ld (de),a"
	}
}, et = {
	mnemonic: "inc",
	params: ["de"],
	tokens: ["de"],
	opcodes: [19],
	isPseudo: !1,
	clr: {
		opcodes: "13",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Adds one to DE.",
		instruction: "inc de"
	}
}, tt = {
	mnemonic: "inc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [20],
	isPseudo: !1,
	clr: {
		opcodes: "14",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to D.",
		instruction: "inc d"
	}
}, nt = {
	mnemonic: "dec",
	params: ["d"],
	tokens: ["d"],
	opcodes: [21],
	isPseudo: !1,
	clr: {
		opcodes: "15",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from D.",
		instruction: "dec d"
	}
}, rt = {
	mnemonic: "ld",
	params: ["d", "nn"],
	tokens: [
		"d",
		",",
		"nn"
	],
	opcodes: [22, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "16",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into D.",
		instruction: "ld d,nn"
	}
}, it = {
	mnemonic: "rla",
	params: [],
	tokens: [],
	opcodes: [23],
	isPseudo: !1,
	clr: {
		opcodes: "17",
		undocumented: !1,
		z180: !1,
		flags: "+0-0--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rla"
	}
}, at = {
	mnemonic: "jr",
	params: ["offset"],
	tokens: ["offset"],
	opcodes: [24, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "18",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "jr offset"
	}
}, ot = {
	mnemonic: "add",
	params: ["hl", "de"],
	tokens: [
		"hl",
		",",
		"de"
	],
	opcodes: [25],
	isPseudo: !1,
	clr: {
		opcodes: "19",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of DE is added to HL.",
		instruction: "add hl,de"
	}
}, st = {
	mnemonic: "ld",
	params: ["a", "(de)"],
	tokens: [
		"a",
		",",
		"(",
		"de",
		")"
	],
	opcodes: [26],
	isPseudo: !1,
	clr: {
		opcodes: "1A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads the value pointed to by DE into A.",
		instruction: "ld a,(de)"
	}
}, ct = {
	mnemonic: "dec",
	params: ["de"],
	tokens: ["de"],
	opcodes: [27],
	isPseudo: !1,
	clr: {
		opcodes: "1B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Subtracts one from DE.",
		instruction: "dec de"
	}
}, lt = {
	mnemonic: "inc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [28],
	isPseudo: !1,
	clr: {
		opcodes: "1C",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to E.",
		instruction: "inc e"
	}
}, ut = {
	mnemonic: "dec",
	params: ["e"],
	tokens: ["e"],
	opcodes: [29],
	isPseudo: !1,
	clr: {
		opcodes: "1D",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from E.",
		instruction: "dec e"
	}
}, dt = {
	mnemonic: "ld",
	params: ["e", "nn"],
	tokens: [
		"e",
		",",
		"nn"
	],
	opcodes: [30, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "1E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into E.",
		instruction: "ld e,nn"
	}
}, ft = {
	mnemonic: "rra",
	params: [],
	tokens: [],
	opcodes: [31],
	isPseudo: !1,
	clr: {
		opcodes: "1F",
		undocumented: !1,
		z180: !1,
		flags: "+0-0--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rra"
	}
}, pt = {
	mnemonic: "jr",
	params: ["nz", "offset"],
	tokens: [
		"nz",
		",",
		"offset"
	],
	opcodes: [32, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "20",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 7,
		description: "If the zero flag is unset, the signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "jr nz,offset"
	}
}, mt = {
	mnemonic: "ld",
	params: ["hl", "nnnn"],
	tokens: [
		"hl",
		",",
		"nnnn"
	],
	opcodes: [33, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "21",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads <var>nnnn</var> into HL.",
		instruction: "ld hl,nnnn"
	}
}, ht = {
	mnemonic: "ld",
	params: ["(nnnn)", "hl"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"hl"
	],
	opcodes: [34, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "22",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Stores HL into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),hl"
	}
}, gt = {
	mnemonic: "inc",
	params: ["hl"],
	tokens: ["hl"],
	opcodes: [35],
	isPseudo: !1,
	clr: {
		opcodes: "23",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Adds one to HL.",
		instruction: "inc hl"
	}
}, _t = {
	mnemonic: "inc",
	params: ["h"],
	tokens: ["h"],
	opcodes: [36],
	isPseudo: !1,
	clr: {
		opcodes: "24",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to H.",
		instruction: "inc h"
	}
}, vt = {
	mnemonic: "dec",
	params: ["h"],
	tokens: ["h"],
	opcodes: [37],
	isPseudo: !1,
	clr: {
		opcodes: "25",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from H.",
		instruction: "dec h"
	}
}, yt = {
	mnemonic: "ld",
	params: ["h", "nn"],
	tokens: [
		"h",
		",",
		"nn"
	],
	opcodes: [38, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "26",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into H.",
		instruction: "ld h,nn"
	}
}, bt = {
	mnemonic: "daa",
	params: [],
	tokens: [],
	opcodes: [39],
	isPseudo: !1,
	clr: {
		opcodes: "27",
		undocumented: !1,
		z180: !1,
		flags: "*-P*++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adjusts A for BCD addition and subtraction operations.",
		instruction: "daa"
	}
}, xt = {
	mnemonic: "jr",
	params: ["z", "offset"],
	tokens: [
		"z",
		",",
		"offset"
	],
	opcodes: [40, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "28",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 7,
		description: "If the zero flag is set, the signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "jr z,offset"
	}
}, St = {
	mnemonic: "add",
	params: ["hl", "hl"],
	tokens: [
		"hl",
		",",
		"hl"
	],
	opcodes: [41],
	isPseudo: !1,
	clr: {
		opcodes: "29",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of HL is added to HL.",
		instruction: "add hl,hl"
	}
}, Ct = {
	mnemonic: "ld",
	params: ["hl", "(nnnn)"],
	tokens: [
		"hl",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [42, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "2A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Loads the value pointed to by <var>nnnn</var> into HL.",
		instruction: "ld hl,(nnnn)"
	}
}, wt = {
	mnemonic: "dec",
	params: ["hl"],
	tokens: ["hl"],
	opcodes: [43],
	isPseudo: !1,
	clr: {
		opcodes: "2B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Subtracts one from HL.",
		instruction: "dec hl"
	}
}, Tt = {
	mnemonic: "inc",
	params: ["l"],
	tokens: ["l"],
	opcodes: [44],
	isPseudo: !1,
	clr: {
		opcodes: "2C",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to L.",
		instruction: "inc l"
	}
}, Et = {
	mnemonic: "dec",
	params: ["l"],
	tokens: ["l"],
	opcodes: [45],
	isPseudo: !1,
	clr: {
		opcodes: "2D",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from L.",
		instruction: "dec l"
	}
}, Dt = {
	mnemonic: "ld",
	params: ["l", "nn"],
	tokens: [
		"l",
		",",
		"nn"
	],
	opcodes: [46, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "2E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into L.",
		instruction: "ld l,nn"
	}
}, Ot = {
	mnemonic: "cpl",
	params: [],
	tokens: [],
	opcodes: [47],
	isPseudo: !1,
	clr: {
		opcodes: "2F",
		undocumented: !1,
		z180: !1,
		flags: "-1-1--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are inverted (one's complement).",
		instruction: "cpl"
	}
}, kt = {
	mnemonic: "jr",
	params: ["nc", "offset"],
	tokens: [
		"nc",
		",",
		"offset"
	],
	opcodes: [48, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "30",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 7,
		description: "If the carry flag is unset, the signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "jr nc,offset"
	}
}, At = {
	mnemonic: "ld",
	params: ["sp", "nnnn"],
	tokens: [
		"sp",
		",",
		"nnnn"
	],
	opcodes: [49, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "31",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads <var>nnnn</var> into SP.",
		instruction: "ld sp,nnnn"
	}
}, jt = {
	mnemonic: "ld",
	params: ["(nnnn)", "a"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"a"
	],
	opcodes: [50, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "32",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 13,
		without_jump_clock_count: 13,
		description: "Stores A into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),a"
	}
}, Mt = {
	mnemonic: "inc",
	params: ["sp"],
	tokens: ["sp"],
	opcodes: [51],
	isPseudo: !1,
	clr: {
		opcodes: "33",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Adds one to SP.",
		instruction: "inc sp"
	}
}, Nt = {
	mnemonic: "inc",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [52],
	isPseudo: !1,
	clr: {
		opcodes: "34",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Adds one to (HL).",
		instruction: "inc (hl)"
	}
}, Pt = {
	mnemonic: "dec",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [53],
	isPseudo: !1,
	clr: {
		opcodes: "35",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Subtracts one from (HL).",
		instruction: "dec (hl)"
	}
}, Ft = {
	mnemonic: "ld",
	params: ["(hl)", "nn"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"nn"
	],
	opcodes: [54, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "36",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads <var>nn</var> into (HL).",
		instruction: "ld (hl),nn"
	}
}, It = {
	mnemonic: "scf",
	params: [],
	tokens: [],
	opcodes: [55],
	isPseudo: !1,
	clr: {
		opcodes: "37",
		undocumented: !1,
		z180: !1,
		flags: "10-0--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Sets the carry flag.",
		instruction: "scf"
	}
}, Lt = {
	mnemonic: "jr",
	params: ["c", "offset"],
	tokens: [
		"c",
		",",
		"offset"
	],
	opcodes: [56, "offset"],
	isPseudo: !1,
	clr: {
		opcodes: "38",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 7,
		description: "If the carry flag is set, the signed value <var>offset</var> is added to PC. The jump is measured from the start of the instruction opcode.",
		instruction: "jr c,offset"
	}
}, Rt = {
	mnemonic: "add",
	params: ["hl", "sp"],
	tokens: [
		"hl",
		",",
		"sp"
	],
	opcodes: [57],
	isPseudo: !1,
	clr: {
		opcodes: "39",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of SP is added to HL.",
		instruction: "add hl,sp"
	}
}, zt = {
	mnemonic: "ld",
	params: ["a", "(nnnn)"],
	tokens: [
		"a",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [58, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "3A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 13,
		without_jump_clock_count: 13,
		description: "Loads the value pointed to by <var>nnnn</var> into A.",
		instruction: "ld a,(nnnn)"
	}
}, Bt = {
	mnemonic: "dec",
	params: ["sp"],
	tokens: ["sp"],
	opcodes: [59],
	isPseudo: !1,
	clr: {
		opcodes: "3B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Subtracts one from SP.",
		instruction: "dec sp"
	}
}, Vt = {
	mnemonic: "inc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [60],
	isPseudo: !1,
	clr: {
		opcodes: "3C",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds one to A.",
		instruction: "inc a"
	}
}, Ht = {
	mnemonic: "dec",
	params: ["a"],
	tokens: ["a"],
	opcodes: [61],
	isPseudo: !1,
	clr: {
		opcodes: "3D",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts one from A.",
		instruction: "dec a"
	}
}, Ut = {
	mnemonic: "ld",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [62, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "3E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Loads <var>nn</var> into A.",
		instruction: "ld a,nn"
	}
}, Wt = {
	mnemonic: "ccf",
	params: [],
	tokens: [],
	opcodes: [63],
	isPseudo: !1,
	clr: {
		opcodes: "3F",
		undocumented: !1,
		z180: !1,
		flags: "*0-*--",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Inverts the carry flag.",
		instruction: "ccf"
	}
}, Gt = {
	mnemonic: "ld",
	params: ["b", "b"],
	tokens: [
		"b",
		",",
		"b"
	],
	opcodes: [64],
	isPseudo: !1,
	clr: {
		opcodes: "40",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into B.",
		instruction: "ld b,b"
	}
}, Kt = {
	mnemonic: "ld",
	params: ["b", "c"],
	tokens: [
		"b",
		",",
		"c"
	],
	opcodes: [65],
	isPseudo: !1,
	clr: {
		opcodes: "41",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into B.",
		instruction: "ld b,c"
	}
}, qt = {
	mnemonic: "ld",
	params: ["b", "d"],
	tokens: [
		"b",
		",",
		"d"
	],
	opcodes: [66],
	isPseudo: !1,
	clr: {
		opcodes: "42",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into B.",
		instruction: "ld b,d"
	}
}, Jt = {
	mnemonic: "ld",
	params: ["b", "e"],
	tokens: [
		"b",
		",",
		"e"
	],
	opcodes: [67],
	isPseudo: !1,
	clr: {
		opcodes: "43",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into B.",
		instruction: "ld b,e"
	}
}, Yt = {
	mnemonic: "ld",
	params: ["b", "h"],
	tokens: [
		"b",
		",",
		"h"
	],
	opcodes: [68],
	isPseudo: !1,
	clr: {
		opcodes: "44",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into B.",
		instruction: "ld b,h"
	}
}, Xt = {
	mnemonic: "ld",
	params: ["bc", "hl"],
	tokens: [
		"bc",
		",",
		"hl"
	],
	opcodes: [68, 77],
	isPseudo: !0,
	clr: {
		opcodes: "444D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of HL are loaded into BC.",
		instruction: "ld bc,hl"
	}
}, Zt = {
	mnemonic: "ld",
	params: ["b", "l"],
	tokens: [
		"b",
		",",
		"l"
	],
	opcodes: [69],
	isPseudo: !1,
	clr: {
		opcodes: "45",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into B.",
		instruction: "ld b,l"
	}
}, Qt = {
	mnemonic: "ld",
	params: ["b", "(hl)"],
	tokens: [
		"b",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [70],
	isPseudo: !1,
	clr: {
		opcodes: "46",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into B.",
		instruction: "ld b,(hl)"
	}
}, $t = {
	mnemonic: "ld",
	params: ["b", "a"],
	tokens: [
		"b",
		",",
		"a"
	],
	opcodes: [71],
	isPseudo: !1,
	clr: {
		opcodes: "47",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into B.",
		instruction: "ld b,a"
	}
}, en = {
	mnemonic: "ld",
	params: ["c", "b"],
	tokens: [
		"c",
		",",
		"b"
	],
	opcodes: [72],
	isPseudo: !1,
	clr: {
		opcodes: "48",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into C.",
		instruction: "ld c,b"
	}
}, tn = {
	mnemonic: "ld",
	params: ["c", "c"],
	tokens: [
		"c",
		",",
		"c"
	],
	opcodes: [73],
	isPseudo: !1,
	clr: {
		opcodes: "49",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into C.",
		instruction: "ld c,c"
	}
}, nn = {
	mnemonic: "ld",
	params: ["c", "d"],
	tokens: [
		"c",
		",",
		"d"
	],
	opcodes: [74],
	isPseudo: !1,
	clr: {
		opcodes: "4A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into C.",
		instruction: "ld c,d"
	}
}, rn = {
	mnemonic: "ld",
	params: ["c", "e"],
	tokens: [
		"c",
		",",
		"e"
	],
	opcodes: [75],
	isPseudo: !1,
	clr: {
		opcodes: "4B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into C.",
		instruction: "ld c,e"
	}
}, an = {
	mnemonic: "ld",
	params: ["c", "h"],
	tokens: [
		"c",
		",",
		"h"
	],
	opcodes: [76],
	isPseudo: !1,
	clr: {
		opcodes: "4C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into C.",
		instruction: "ld c,h"
	}
}, on = {
	mnemonic: "ld",
	params: ["c", "l"],
	tokens: [
		"c",
		",",
		"l"
	],
	opcodes: [77],
	isPseudo: !1,
	clr: {
		opcodes: "4D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into C.",
		instruction: "ld c,l"
	}
}, sn = {
	mnemonic: "ld",
	params: ["c", "(hl)"],
	tokens: [
		"c",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [78],
	isPseudo: !1,
	clr: {
		opcodes: "4E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into C.",
		instruction: "ld c,(hl)"
	}
}, cn = {
	mnemonic: "ld",
	params: ["bc", "(hl)"],
	tokens: [
		"bc",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [
		78,
		35,
		70,
		43
	],
	isPseudo: !0,
	clr: {
		opcodes: "4E23462B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 26,
		without_jump_clock_count: 26,
		description: "The contents of (HL) are loaded into BC.",
		instruction: "ld bc,(hl)"
	}
}, ln = {
	mnemonic: "ld",
	params: ["c", "a"],
	tokens: [
		"c",
		",",
		"a"
	],
	opcodes: [79],
	isPseudo: !1,
	clr: {
		opcodes: "4F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into C.",
		instruction: "ld c,a"
	}
}, un = {
	mnemonic: "ld",
	params: ["d", "b"],
	tokens: [
		"d",
		",",
		"b"
	],
	opcodes: [80],
	isPseudo: !1,
	clr: {
		opcodes: "50",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into D.",
		instruction: "ld d,b"
	}
}, dn = {
	mnemonic: "ld",
	params: ["de", "bc"],
	tokens: [
		"de",
		",",
		"bc"
	],
	opcodes: [80, 89],
	isPseudo: !0,
	clr: {
		opcodes: "5059",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of BC are loaded into DE.",
		instruction: "ld de,bc"
	}
}, fn = {
	mnemonic: "ld",
	params: ["d", "c"],
	tokens: [
		"d",
		",",
		"c"
	],
	opcodes: [81],
	isPseudo: !1,
	clr: {
		opcodes: "51",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into D.",
		instruction: "ld d,c"
	}
}, pn = {
	mnemonic: "ld",
	params: ["d", "d"],
	tokens: [
		"d",
		",",
		"d"
	],
	opcodes: [82],
	isPseudo: !1,
	clr: {
		opcodes: "52",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into D.",
		instruction: "ld d,d"
	}
}, mn = {
	mnemonic: "ld",
	params: ["d", "e"],
	tokens: [
		"d",
		",",
		"e"
	],
	opcodes: [83],
	isPseudo: !1,
	clr: {
		opcodes: "53",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into D.",
		instruction: "ld d,e"
	}
}, hn = {
	mnemonic: "ld",
	params: ["d", "h"],
	tokens: [
		"d",
		",",
		"h"
	],
	opcodes: [84],
	isPseudo: !1,
	clr: {
		opcodes: "54",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into D.",
		instruction: "ld d,h"
	}
}, gn = {
	mnemonic: "ld",
	params: ["de", "hl"],
	tokens: [
		"de",
		",",
		"hl"
	],
	opcodes: [84, 93],
	isPseudo: !0,
	clr: {
		opcodes: "545D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of HL are loaded into DE.",
		instruction: "ld de,hl"
	}
}, _n = {
	mnemonic: "ld",
	params: ["d", "l"],
	tokens: [
		"d",
		",",
		"l"
	],
	opcodes: [85],
	isPseudo: !1,
	clr: {
		opcodes: "55",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into D.",
		instruction: "ld d,l"
	}
}, vn = {
	mnemonic: "ld",
	params: ["d", "(hl)"],
	tokens: [
		"d",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [86],
	isPseudo: !1,
	clr: {
		opcodes: "56",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into D.",
		instruction: "ld d,(hl)"
	}
}, yn = {
	mnemonic: "ld",
	params: ["d", "a"],
	tokens: [
		"d",
		",",
		"a"
	],
	opcodes: [87],
	isPseudo: !1,
	clr: {
		opcodes: "57",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into D.",
		instruction: "ld d,a"
	}
}, bn = {
	mnemonic: "ld",
	params: ["e", "b"],
	tokens: [
		"e",
		",",
		"b"
	],
	opcodes: [88],
	isPseudo: !1,
	clr: {
		opcodes: "58",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into E.",
		instruction: "ld e,b"
	}
}, xn = {
	mnemonic: "ld",
	params: ["e", "c"],
	tokens: [
		"e",
		",",
		"c"
	],
	opcodes: [89],
	isPseudo: !1,
	clr: {
		opcodes: "59",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into E.",
		instruction: "ld e,c"
	}
}, Sn = {
	mnemonic: "ld",
	params: ["e", "d"],
	tokens: [
		"e",
		",",
		"d"
	],
	opcodes: [90],
	isPseudo: !1,
	clr: {
		opcodes: "5A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into E.",
		instruction: "ld e,d"
	}
}, Cn = {
	mnemonic: "ld",
	params: ["e", "e"],
	tokens: [
		"e",
		",",
		"e"
	],
	opcodes: [91],
	isPseudo: !1,
	clr: {
		opcodes: "5B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into E.",
		instruction: "ld e,e"
	}
}, wn = {
	mnemonic: "ld",
	params: ["e", "h"],
	tokens: [
		"e",
		",",
		"h"
	],
	opcodes: [92],
	isPseudo: !1,
	clr: {
		opcodes: "5C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into E.",
		instruction: "ld e,h"
	}
}, Tn = {
	mnemonic: "ld",
	params: ["e", "l"],
	tokens: [
		"e",
		",",
		"l"
	],
	opcodes: [93],
	isPseudo: !1,
	clr: {
		opcodes: "5D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into E.",
		instruction: "ld e,l"
	}
}, En = {
	mnemonic: "ld",
	params: ["e", "(hl)"],
	tokens: [
		"e",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [94],
	isPseudo: !1,
	clr: {
		opcodes: "5E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into E.",
		instruction: "ld e,(hl)"
	}
}, Dn = {
	mnemonic: "ld",
	params: ["e", "a"],
	tokens: [
		"e",
		",",
		"a"
	],
	opcodes: [95],
	isPseudo: !1,
	clr: {
		opcodes: "5F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into E.",
		instruction: "ld e,a"
	}
}, On = {
	mnemonic: "ld",
	params: ["h", "b"],
	tokens: [
		"h",
		",",
		"b"
	],
	opcodes: [96],
	isPseudo: !1,
	clr: {
		opcodes: "60",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into H.",
		instruction: "ld h,b"
	}
}, kn = {
	mnemonic: "ld",
	params: ["hl", "bc"],
	tokens: [
		"hl",
		",",
		"bc"
	],
	opcodes: [96, 105],
	isPseudo: !0,
	clr: {
		opcodes: "6069",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of BC are loaded into HL.",
		instruction: "ld hl,bc"
	}
}, An = {
	mnemonic: "ld",
	params: ["h", "c"],
	tokens: [
		"h",
		",",
		"c"
	],
	opcodes: [97],
	isPseudo: !1,
	clr: {
		opcodes: "61",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into H.",
		instruction: "ld h,c"
	}
}, jn = {
	mnemonic: "ld",
	params: ["h", "d"],
	tokens: [
		"h",
		",",
		"d"
	],
	opcodes: [98],
	isPseudo: !1,
	clr: {
		opcodes: "62",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into H.",
		instruction: "ld h,d"
	}
}, Mn = {
	mnemonic: "ld",
	params: ["hl", "de"],
	tokens: [
		"hl",
		",",
		"de"
	],
	opcodes: [98, 107],
	isPseudo: !0,
	clr: {
		opcodes: "626B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of DE are loaded into HL.",
		instruction: "ld hl,de"
	}
}, Nn = {
	mnemonic: "ld",
	params: ["h", "e"],
	tokens: [
		"h",
		",",
		"e"
	],
	opcodes: [99],
	isPseudo: !1,
	clr: {
		opcodes: "63",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into H.",
		instruction: "ld h,e"
	}
}, Pn = {
	mnemonic: "ld",
	params: ["h", "h"],
	tokens: [
		"h",
		",",
		"h"
	],
	opcodes: [100],
	isPseudo: !1,
	clr: {
		opcodes: "64",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into H.",
		instruction: "ld h,h"
	}
}, Fn = {
	mnemonic: "ld",
	params: ["h", "l"],
	tokens: [
		"h",
		",",
		"l"
	],
	opcodes: [101],
	isPseudo: !1,
	clr: {
		opcodes: "65",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into H.",
		instruction: "ld h,l"
	}
}, In = {
	mnemonic: "ld",
	params: ["h", "(hl)"],
	tokens: [
		"h",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [102],
	isPseudo: !1,
	clr: {
		opcodes: "66",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into H.",
		instruction: "ld h,(hl)"
	}
}, Ln = {
	mnemonic: "ld",
	params: ["h", "a"],
	tokens: [
		"h",
		",",
		"a"
	],
	opcodes: [103],
	isPseudo: !1,
	clr: {
		opcodes: "67",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into H.",
		instruction: "ld h,a"
	}
}, Rn = {
	mnemonic: "ld",
	params: ["l", "b"],
	tokens: [
		"l",
		",",
		"b"
	],
	opcodes: [104],
	isPseudo: !1,
	clr: {
		opcodes: "68",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into L.",
		instruction: "ld l,b"
	}
}, zn = {
	mnemonic: "ld",
	params: ["l", "c"],
	tokens: [
		"l",
		",",
		"c"
	],
	opcodes: [105],
	isPseudo: !1,
	clr: {
		opcodes: "69",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into L.",
		instruction: "ld l,c"
	}
}, Bn = {
	mnemonic: "ld",
	params: ["l", "d"],
	tokens: [
		"l",
		",",
		"d"
	],
	opcodes: [106],
	isPseudo: !1,
	clr: {
		opcodes: "6A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into L.",
		instruction: "ld l,d"
	}
}, Vn = {
	mnemonic: "ld",
	params: ["l", "e"],
	tokens: [
		"l",
		",",
		"e"
	],
	opcodes: [107],
	isPseudo: !1,
	clr: {
		opcodes: "6B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into L.",
		instruction: "ld l,e"
	}
}, Hn = {
	mnemonic: "ld",
	params: ["l", "h"],
	tokens: [
		"l",
		",",
		"h"
	],
	opcodes: [108],
	isPseudo: !1,
	clr: {
		opcodes: "6C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into L.",
		instruction: "ld l,h"
	}
}, Un = {
	mnemonic: "ld",
	params: ["l", "l"],
	tokens: [
		"l",
		",",
		"l"
	],
	opcodes: [109],
	isPseudo: !1,
	clr: {
		opcodes: "6D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into L.",
		instruction: "ld l,l"
	}
}, Wn = {
	mnemonic: "ld",
	params: ["l", "(hl)"],
	tokens: [
		"l",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [110],
	isPseudo: !1,
	clr: {
		opcodes: "6E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into L.",
		instruction: "ld l,(hl)"
	}
}, Gn = {
	mnemonic: "ld",
	params: ["l", "a"],
	tokens: [
		"l",
		",",
		"a"
	],
	opcodes: [111],
	isPseudo: !1,
	clr: {
		opcodes: "6F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into L.",
		instruction: "ld l,a"
	}
}, Kn = {
	mnemonic: "ld",
	params: ["(hl)", "b"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"b"
	],
	opcodes: [112],
	isPseudo: !1,
	clr: {
		opcodes: "70",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of B are loaded into (HL).",
		instruction: "ld (hl),b"
	}
}, qn = {
	mnemonic: "ld",
	params: ["(hl)", "c"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"c"
	],
	opcodes: [113],
	isPseudo: !1,
	clr: {
		opcodes: "71",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of C are loaded into (HL).",
		instruction: "ld (hl),c"
	}
}, Jn = {
	mnemonic: "ld",
	params: ["(hl)", "bc"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"bc"
	],
	opcodes: [
		113,
		35,
		112,
		43
	],
	isPseudo: !0,
	clr: {
		opcodes: "7123702B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 26,
		without_jump_clock_count: 26,
		description: "The contents of BC are loaded into (HL).",
		instruction: "ld (hl),bc"
	}
}, Yn = {
	mnemonic: "ld",
	params: ["(hl)", "d"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"d"
	],
	opcodes: [114],
	isPseudo: !1,
	clr: {
		opcodes: "72",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of D are loaded into (HL).",
		instruction: "ld (hl),d"
	}
}, Xn = {
	mnemonic: "ld",
	params: ["(hl)", "e"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"e"
	],
	opcodes: [115],
	isPseudo: !1,
	clr: {
		opcodes: "73",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of E are loaded into (HL).",
		instruction: "ld (hl),e"
	}
}, Zn = {
	mnemonic: "ld",
	params: ["(hl)", "de"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"de"
	],
	opcodes: [
		115,
		35,
		114,
		43
	],
	isPseudo: !0,
	clr: {
		opcodes: "7323722B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 26,
		without_jump_clock_count: 26,
		description: "The contents of DE are loaded into (HL).",
		instruction: "ld (hl),de"
	}
}, Qn = {
	mnemonic: "ld",
	params: ["(hl)", "h"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"h"
	],
	opcodes: [116],
	isPseudo: !1,
	clr: {
		opcodes: "74",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of H are loaded into (HL).",
		instruction: "ld (hl),h"
	}
}, $n = {
	mnemonic: "ld",
	params: ["(hl)", "l"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"l"
	],
	opcodes: [117],
	isPseudo: !1,
	clr: {
		opcodes: "75",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of L are loaded into (HL).",
		instruction: "ld (hl),l"
	}
}, er = {
	mnemonic: "halt",
	params: [],
	tokens: [],
	opcodes: [118],
	isPseudo: !1,
	clr: {
		opcodes: "76",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Suspends CPU operation until an interrupt or reset occurs.",
		instruction: "halt"
	}
}, tr = {
	mnemonic: "ld",
	params: ["(hl)", "a"],
	tokens: [
		"(",
		"hl",
		")",
		",",
		"a"
	],
	opcodes: [119],
	isPseudo: !1,
	clr: {
		opcodes: "77",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of A are loaded into (HL).",
		instruction: "ld (hl),a"
	}
}, nr = {
	mnemonic: "ld",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [120],
	isPseudo: !1,
	clr: {
		opcodes: "78",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of B are loaded into A.",
		instruction: "ld a,b"
	}
}, rr = {
	mnemonic: "ld",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [121],
	isPseudo: !1,
	clr: {
		opcodes: "79",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of C are loaded into A.",
		instruction: "ld a,c"
	}
}, ir = {
	mnemonic: "ld",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [122],
	isPseudo: !1,
	clr: {
		opcodes: "7A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of D are loaded into A.",
		instruction: "ld a,d"
	}
}, ar = {
	mnemonic: "ld",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [123],
	isPseudo: !1,
	clr: {
		opcodes: "7B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of E are loaded into A.",
		instruction: "ld a,e"
	}
}, or = {
	mnemonic: "ld",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [124],
	isPseudo: !1,
	clr: {
		opcodes: "7C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of H are loaded into A.",
		instruction: "ld a,h"
	}
}, sr = {
	mnemonic: "ld",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [125],
	isPseudo: !1,
	clr: {
		opcodes: "7D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of L are loaded into A.",
		instruction: "ld a,l"
	}
}, cr = {
	mnemonic: "ld",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [126],
	isPseudo: !1,
	clr: {
		opcodes: "7E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "The contents of (HL) are loaded into A.",
		instruction: "ld a,(hl)"
	}
}, lr = {
	mnemonic: "ld",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [127],
	isPseudo: !1,
	clr: {
		opcodes: "7F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "The contents of A are loaded into A.",
		instruction: "ld a,a"
	}
}, ur = {
	mnemonic: "add",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [128],
	isPseudo: !1,
	clr: {
		opcodes: "80",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds B to A.",
		instruction: "add a,b"
	}
}, dr = {
	mnemonic: "add",
	params: ["b"],
	tokens: ["b"],
	opcodes: [128],
	isPseudo: !0,
	clr: {
		opcodes: "80",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds B to A.",
		instruction: "add a,b"
	}
}, fr = {
	mnemonic: "add",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [129],
	isPseudo: !1,
	clr: {
		opcodes: "81",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds C to A.",
		instruction: "add a,c"
	}
}, pr = {
	mnemonic: "add",
	params: ["c"],
	tokens: ["c"],
	opcodes: [129],
	isPseudo: !0,
	clr: {
		opcodes: "81",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds C to A.",
		instruction: "add a,c"
	}
}, mr = {
	mnemonic: "add",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [130],
	isPseudo: !1,
	clr: {
		opcodes: "82",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds D to A.",
		instruction: "add a,d"
	}
}, hr = {
	mnemonic: "add",
	params: ["d"],
	tokens: ["d"],
	opcodes: [130],
	isPseudo: !0,
	clr: {
		opcodes: "82",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds D to A.",
		instruction: "add a,d"
	}
}, gr = {
	mnemonic: "add",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [131],
	isPseudo: !1,
	clr: {
		opcodes: "83",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds E to A.",
		instruction: "add a,e"
	}
}, _r = {
	mnemonic: "add",
	params: ["e"],
	tokens: ["e"],
	opcodes: [131],
	isPseudo: !0,
	clr: {
		opcodes: "83",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds E to A.",
		instruction: "add a,e"
	}
}, vr = {
	mnemonic: "add",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [132],
	isPseudo: !1,
	clr: {
		opcodes: "84",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds H to A.",
		instruction: "add a,h"
	}
}, yr = {
	mnemonic: "add",
	params: ["h"],
	tokens: ["h"],
	opcodes: [132],
	isPseudo: !0,
	clr: {
		opcodes: "84",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds H to A.",
		instruction: "add a,h"
	}
}, br = {
	mnemonic: "add",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [133],
	isPseudo: !1,
	clr: {
		opcodes: "85",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds L to A.",
		instruction: "add a,l"
	}
}, xr = {
	mnemonic: "add",
	params: ["l"],
	tokens: ["l"],
	opcodes: [133],
	isPseudo: !0,
	clr: {
		opcodes: "85",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds L to A.",
		instruction: "add a,l"
	}
}, Sr = {
	mnemonic: "add",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [134],
	isPseudo: !1,
	clr: {
		opcodes: "86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds (HL) to A.",
		instruction: "add a,(hl)"
	}
}, Cr = {
	mnemonic: "add",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [134],
	isPseudo: !0,
	clr: {
		opcodes: "86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds (HL) to A.",
		instruction: "add a,(hl)"
	}
}, wr = {
	mnemonic: "add",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [135],
	isPseudo: !1,
	clr: {
		opcodes: "87",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds A to A.",
		instruction: "add a,a"
	}
}, Tr = {
	mnemonic: "add",
	params: ["a"],
	tokens: ["a"],
	opcodes: [135],
	isPseudo: !0,
	clr: {
		opcodes: "87",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds A to A.",
		instruction: "add a,a"
	}
}, Er = {
	mnemonic: "adc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [136],
	isPseudo: !1,
	clr: {
		opcodes: "88",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds B and the carry flag to A.",
		instruction: "adc a,b"
	}
}, Dr = {
	mnemonic: "adc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [136],
	isPseudo: !0,
	clr: {
		opcodes: "88",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds B and the carry flag to A.",
		instruction: "adc a,b"
	}
}, Or = {
	mnemonic: "adc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [137],
	isPseudo: !1,
	clr: {
		opcodes: "89",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds C and the carry flag to A.",
		instruction: "adc a,c"
	}
}, kr = {
	mnemonic: "adc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [137],
	isPseudo: !0,
	clr: {
		opcodes: "89",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds C and the carry flag to A.",
		instruction: "adc a,c"
	}
}, Ar = {
	mnemonic: "adc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [138],
	isPseudo: !1,
	clr: {
		opcodes: "8A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds D and the carry flag to A.",
		instruction: "adc a,d"
	}
}, jr = {
	mnemonic: "adc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [138],
	isPseudo: !0,
	clr: {
		opcodes: "8A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds D and the carry flag to A.",
		instruction: "adc a,d"
	}
}, Mr = {
	mnemonic: "adc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [139],
	isPseudo: !1,
	clr: {
		opcodes: "8B",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds E and the carry flag to A.",
		instruction: "adc a,e"
	}
}, Nr = {
	mnemonic: "adc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [139],
	isPseudo: !0,
	clr: {
		opcodes: "8B",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds E and the carry flag to A.",
		instruction: "adc a,e"
	}
}, Pr = {
	mnemonic: "adc",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [140],
	isPseudo: !1,
	clr: {
		opcodes: "8C",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds H and the carry flag to A.",
		instruction: "adc a,h"
	}
}, Fr = {
	mnemonic: "adc",
	params: ["h"],
	tokens: ["h"],
	opcodes: [140],
	isPseudo: !0,
	clr: {
		opcodes: "8C",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds H and the carry flag to A.",
		instruction: "adc a,h"
	}
}, Ir = {
	mnemonic: "adc",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [141],
	isPseudo: !1,
	clr: {
		opcodes: "8D",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds L and the carry flag to A.",
		instruction: "adc a,l"
	}
}, Lr = {
	mnemonic: "adc",
	params: ["l"],
	tokens: ["l"],
	opcodes: [141],
	isPseudo: !0,
	clr: {
		opcodes: "8D",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds L and the carry flag to A.",
		instruction: "adc a,l"
	}
}, Rr = {
	mnemonic: "adc",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [142],
	isPseudo: !1,
	clr: {
		opcodes: "8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds (HL) and the carry flag to A.",
		instruction: "adc a,(hl)"
	}
}, zr = {
	mnemonic: "adc",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [142],
	isPseudo: !0,
	clr: {
		opcodes: "8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds (HL) and the carry flag to A.",
		instruction: "adc a,(hl)"
	}
}, Br = {
	mnemonic: "adc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [143],
	isPseudo: !1,
	clr: {
		opcodes: "8F",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds A and the carry flag to A.",
		instruction: "adc a,a"
	}
}, Vr = {
	mnemonic: "adc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [143],
	isPseudo: !0,
	clr: {
		opcodes: "8F",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Adds A and the carry flag to A.",
		instruction: "adc a,a"
	}
}, Hr = {
	mnemonic: "sub",
	params: ["b"],
	tokens: ["b"],
	opcodes: [144],
	isPseudo: !1,
	clr: {
		opcodes: "90",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B from A.",
		instruction: "sub b"
	}
}, Ur = {
	mnemonic: "sub",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [144],
	isPseudo: !0,
	clr: {
		opcodes: "90",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B from A.",
		instruction: "sub b"
	}
}, Wr = {
	mnemonic: "sub",
	params: ["c"],
	tokens: ["c"],
	opcodes: [145],
	isPseudo: !1,
	clr: {
		opcodes: "91",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C from A.",
		instruction: "sub c"
	}
}, Gr = {
	mnemonic: "sub",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [145],
	isPseudo: !0,
	clr: {
		opcodes: "91",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C from A.",
		instruction: "sub c"
	}
}, Kr = {
	mnemonic: "sub",
	params: ["d"],
	tokens: ["d"],
	opcodes: [146],
	isPseudo: !1,
	clr: {
		opcodes: "92",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D from A.",
		instruction: "sub d"
	}
}, qr = {
	mnemonic: "sub",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [146],
	isPseudo: !0,
	clr: {
		opcodes: "92",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D from A.",
		instruction: "sub d"
	}
}, Jr = {
	mnemonic: "sub",
	params: ["e"],
	tokens: ["e"],
	opcodes: [147],
	isPseudo: !1,
	clr: {
		opcodes: "93",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E from A.",
		instruction: "sub e"
	}
}, Yr = {
	mnemonic: "sub",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [147],
	isPseudo: !0,
	clr: {
		opcodes: "93",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E from A.",
		instruction: "sub e"
	}
}, Xr = {
	mnemonic: "sub",
	params: ["h"],
	tokens: ["h"],
	opcodes: [148],
	isPseudo: !1,
	clr: {
		opcodes: "94",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H from A.",
		instruction: "sub h"
	}
}, Zr = {
	mnemonic: "sub",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [148],
	isPseudo: !0,
	clr: {
		opcodes: "94",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H from A.",
		instruction: "sub h"
	}
}, Qr = {
	mnemonic: "sub",
	params: ["l"],
	tokens: ["l"],
	opcodes: [149],
	isPseudo: !1,
	clr: {
		opcodes: "95",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L from A.",
		instruction: "sub l"
	}
}, $r = {
	mnemonic: "sub",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [149],
	isPseudo: !0,
	clr: {
		opcodes: "95",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L from A.",
		instruction: "sub l"
	}
}, ei = {
	mnemonic: "sub",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [150],
	isPseudo: !1,
	clr: {
		opcodes: "96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) from A.",
		instruction: "sub (hl)"
	}
}, ti = {
	mnemonic: "sub",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [150],
	isPseudo: !0,
	clr: {
		opcodes: "96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) from A.",
		instruction: "sub (hl)"
	}
}, ni = {
	mnemonic: "sub",
	params: ["a"],
	tokens: ["a"],
	opcodes: [151],
	isPseudo: !1,
	clr: {
		opcodes: "97",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A from A.",
		instruction: "sub a"
	}
}, ri = {
	mnemonic: "sub",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [151],
	isPseudo: !0,
	clr: {
		opcodes: "97",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A from A.",
		instruction: "sub a"
	}
}, ii = {
	mnemonic: "sbc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [152],
	isPseudo: !1,
	clr: {
		opcodes: "98",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B and the carry flag from A.",
		instruction: "sbc a,b"
	}
}, ai = {
	mnemonic: "sbc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [152],
	isPseudo: !0,
	clr: {
		opcodes: "98",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B and the carry flag from A.",
		instruction: "sbc a,b"
	}
}, oi = {
	mnemonic: "sbc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [153],
	isPseudo: !1,
	clr: {
		opcodes: "99",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C and the carry flag from A.",
		instruction: "sbc a,c"
	}
}, si = {
	mnemonic: "sbc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [153],
	isPseudo: !0,
	clr: {
		opcodes: "99",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C and the carry flag from A.",
		instruction: "sbc a,c"
	}
}, ci = {
	mnemonic: "sbc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [154],
	isPseudo: !1,
	clr: {
		opcodes: "9A",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D and the carry flag from A.",
		instruction: "sbc a,d"
	}
}, li = {
	mnemonic: "sbc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [154],
	isPseudo: !0,
	clr: {
		opcodes: "9A",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D and the carry flag from A.",
		instruction: "sbc a,d"
	}
}, ui = {
	mnemonic: "sbc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [155],
	isPseudo: !1,
	clr: {
		opcodes: "9B",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E and the carry flag from A.",
		instruction: "sbc a,e"
	}
}, di = {
	mnemonic: "sbc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [155],
	isPseudo: !0,
	clr: {
		opcodes: "9B",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E and the carry flag from A.",
		instruction: "sbc a,e"
	}
}, fi = {
	mnemonic: "sbc",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [156],
	isPseudo: !1,
	clr: {
		opcodes: "9C",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H and the carry flag from A.",
		instruction: "sbc a,h"
	}
}, pi = {
	mnemonic: "sbc",
	params: ["h"],
	tokens: ["h"],
	opcodes: [156],
	isPseudo: !0,
	clr: {
		opcodes: "9C",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H and the carry flag from A.",
		instruction: "sbc a,h"
	}
}, mi = {
	mnemonic: "sbc",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [157],
	isPseudo: !1,
	clr: {
		opcodes: "9D",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L and the carry flag from A.",
		instruction: "sbc a,l"
	}
}, hi = {
	mnemonic: "sbc",
	params: ["l"],
	tokens: ["l"],
	opcodes: [157],
	isPseudo: !0,
	clr: {
		opcodes: "9D",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L and the carry flag from A.",
		instruction: "sbc a,l"
	}
}, gi = {
	mnemonic: "sbc",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [158],
	isPseudo: !1,
	clr: {
		opcodes: "9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) and the carry flag from A.",
		instruction: "sbc a,(hl)"
	}
}, _i = {
	mnemonic: "sbc",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [158],
	isPseudo: !0,
	clr: {
		opcodes: "9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) and the carry flag from A.",
		instruction: "sbc a,(hl)"
	}
}, vi = {
	mnemonic: "sbc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [159],
	isPseudo: !1,
	clr: {
		opcodes: "9F",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A and the carry flag from A.",
		instruction: "sbc a,a"
	}
}, yi = {
	mnemonic: "sbc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [159],
	isPseudo: !0,
	clr: {
		opcodes: "9F",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A and the carry flag from A.",
		instruction: "sbc a,a"
	}
}, bi = {
	mnemonic: "and",
	params: ["b"],
	tokens: ["b"],
	opcodes: [160],
	isPseudo: !1,
	clr: {
		opcodes: "A0",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with B.",
		instruction: "and b"
	}
}, xi = {
	mnemonic: "and",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [160],
	isPseudo: !0,
	clr: {
		opcodes: "A0",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with B.",
		instruction: "and b"
	}
}, Si = {
	mnemonic: "and",
	params: ["c"],
	tokens: ["c"],
	opcodes: [161],
	isPseudo: !1,
	clr: {
		opcodes: "A1",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with C.",
		instruction: "and c"
	}
}, Ci = {
	mnemonic: "and",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [161],
	isPseudo: !0,
	clr: {
		opcodes: "A1",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with C.",
		instruction: "and c"
	}
}, wi = {
	mnemonic: "and",
	params: ["d"],
	tokens: ["d"],
	opcodes: [162],
	isPseudo: !1,
	clr: {
		opcodes: "A2",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with D.",
		instruction: "and d"
	}
}, Ti = {
	mnemonic: "and",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [162],
	isPseudo: !0,
	clr: {
		opcodes: "A2",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with D.",
		instruction: "and d"
	}
}, Ei = {
	mnemonic: "and",
	params: ["e"],
	tokens: ["e"],
	opcodes: [163],
	isPseudo: !1,
	clr: {
		opcodes: "A3",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with E.",
		instruction: "and e"
	}
}, Di = {
	mnemonic: "and",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [163],
	isPseudo: !0,
	clr: {
		opcodes: "A3",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with E.",
		instruction: "and e"
	}
}, Oi = {
	mnemonic: "and",
	params: ["h"],
	tokens: ["h"],
	opcodes: [164],
	isPseudo: !1,
	clr: {
		opcodes: "A4",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with H.",
		instruction: "and h"
	}
}, ki = {
	mnemonic: "and",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [164],
	isPseudo: !0,
	clr: {
		opcodes: "A4",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with H.",
		instruction: "and h"
	}
}, Ai = {
	mnemonic: "and",
	params: ["l"],
	tokens: ["l"],
	opcodes: [165],
	isPseudo: !1,
	clr: {
		opcodes: "A5",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with L.",
		instruction: "and l"
	}
}, ji = {
	mnemonic: "and",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [165],
	isPseudo: !0,
	clr: {
		opcodes: "A5",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with L.",
		instruction: "and l"
	}
}, Mi = {
	mnemonic: "and",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [166],
	isPseudo: !1,
	clr: {
		opcodes: "A6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise AND on A with (HL).",
		instruction: "and (hl)"
	}
}, Ni = {
	mnemonic: "and",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [166],
	isPseudo: !0,
	clr: {
		opcodes: "A6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise AND on A with (HL).",
		instruction: "and (hl)"
	}
}, Pi = {
	mnemonic: "and",
	params: ["a"],
	tokens: ["a"],
	opcodes: [167],
	isPseudo: !1,
	clr: {
		opcodes: "A7",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with A.",
		instruction: "and a"
	}
}, Fi = {
	mnemonic: "and",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [167],
	isPseudo: !0,
	clr: {
		opcodes: "A7",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise AND on A with A.",
		instruction: "and a"
	}
}, Ii = {
	mnemonic: "xor",
	params: ["b"],
	tokens: ["b"],
	opcodes: [168],
	isPseudo: !1,
	clr: {
		opcodes: "A8",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with B.",
		instruction: "xor b"
	}
}, Li = {
	mnemonic: "xor",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [168],
	isPseudo: !0,
	clr: {
		opcodes: "A8",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with B.",
		instruction: "xor b"
	}
}, Ri = {
	mnemonic: "xor",
	params: ["c"],
	tokens: ["c"],
	opcodes: [169],
	isPseudo: !1,
	clr: {
		opcodes: "A9",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with C.",
		instruction: "xor c"
	}
}, zi = {
	mnemonic: "xor",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [169],
	isPseudo: !0,
	clr: {
		opcodes: "A9",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with C.",
		instruction: "xor c"
	}
}, Bi = {
	mnemonic: "xor",
	params: ["d"],
	tokens: ["d"],
	opcodes: [170],
	isPseudo: !1,
	clr: {
		opcodes: "AA",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with D.",
		instruction: "xor d"
	}
}, Vi = {
	mnemonic: "xor",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [170],
	isPseudo: !0,
	clr: {
		opcodes: "AA",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with D.",
		instruction: "xor d"
	}
}, Hi = {
	mnemonic: "xor",
	params: ["e"],
	tokens: ["e"],
	opcodes: [171],
	isPseudo: !1,
	clr: {
		opcodes: "AB",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with E.",
		instruction: "xor e"
	}
}, Ui = {
	mnemonic: "xor",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [171],
	isPseudo: !0,
	clr: {
		opcodes: "AB",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with E.",
		instruction: "xor e"
	}
}, Wi = {
	mnemonic: "xor",
	params: ["h"],
	tokens: ["h"],
	opcodes: [172],
	isPseudo: !1,
	clr: {
		opcodes: "AC",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with H.",
		instruction: "xor h"
	}
}, Gi = {
	mnemonic: "xor",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [172],
	isPseudo: !0,
	clr: {
		opcodes: "AC",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with H.",
		instruction: "xor h"
	}
}, Ki = {
	mnemonic: "xor",
	params: ["l"],
	tokens: ["l"],
	opcodes: [173],
	isPseudo: !1,
	clr: {
		opcodes: "AD",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with L.",
		instruction: "xor l"
	}
}, qi = {
	mnemonic: "xor",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [173],
	isPseudo: !0,
	clr: {
		opcodes: "AD",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with L.",
		instruction: "xor l"
	}
}, Ji = {
	mnemonic: "xor",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [174],
	isPseudo: !1,
	clr: {
		opcodes: "AE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise XOR on A with (HL).",
		instruction: "xor (hl)"
	}
}, Yi = {
	mnemonic: "xor",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [174],
	isPseudo: !0,
	clr: {
		opcodes: "AE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise XOR on A with (HL).",
		instruction: "xor (hl)"
	}
}, Xi = {
	mnemonic: "xor",
	params: ["a"],
	tokens: ["a"],
	opcodes: [175],
	isPseudo: !1,
	clr: {
		opcodes: "AF",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with A.",
		instruction: "xor a"
	}
}, Zi = {
	mnemonic: "xor",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [175],
	isPseudo: !0,
	clr: {
		opcodes: "AF",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise XOR on A with A.",
		instruction: "xor a"
	}
}, Qi = {
	mnemonic: "or",
	params: ["b"],
	tokens: ["b"],
	opcodes: [176],
	isPseudo: !1,
	clr: {
		opcodes: "B0",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with B.",
		instruction: "or b"
	}
}, $i = {
	mnemonic: "or",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [176],
	isPseudo: !0,
	clr: {
		opcodes: "B0",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with B.",
		instruction: "or b"
	}
}, ea = {
	mnemonic: "or",
	params: ["c"],
	tokens: ["c"],
	opcodes: [177],
	isPseudo: !1,
	clr: {
		opcodes: "B1",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with C.",
		instruction: "or c"
	}
}, ta = {
	mnemonic: "or",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [177],
	isPseudo: !0,
	clr: {
		opcodes: "B1",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with C.",
		instruction: "or c"
	}
}, na = {
	mnemonic: "or",
	params: ["d"],
	tokens: ["d"],
	opcodes: [178],
	isPseudo: !1,
	clr: {
		opcodes: "B2",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with D.",
		instruction: "or d"
	}
}, ra = {
	mnemonic: "or",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [178],
	isPseudo: !0,
	clr: {
		opcodes: "B2",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with D.",
		instruction: "or d"
	}
}, ia = {
	mnemonic: "or",
	params: ["e"],
	tokens: ["e"],
	opcodes: [179],
	isPseudo: !1,
	clr: {
		opcodes: "B3",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with E.",
		instruction: "or e"
	}
}, aa = {
	mnemonic: "or",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [179],
	isPseudo: !0,
	clr: {
		opcodes: "B3",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with E.",
		instruction: "or e"
	}
}, oa = {
	mnemonic: "or",
	params: ["h"],
	tokens: ["h"],
	opcodes: [180],
	isPseudo: !1,
	clr: {
		opcodes: "B4",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with H.",
		instruction: "or h"
	}
}, sa = {
	mnemonic: "or",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [180],
	isPseudo: !0,
	clr: {
		opcodes: "B4",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with H.",
		instruction: "or h"
	}
}, ca = {
	mnemonic: "or",
	params: ["l"],
	tokens: ["l"],
	opcodes: [181],
	isPseudo: !1,
	clr: {
		opcodes: "B5",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with L.",
		instruction: "or l"
	}
}, la = {
	mnemonic: "or",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [181],
	isPseudo: !0,
	clr: {
		opcodes: "B5",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with L.",
		instruction: "or l"
	}
}, ua = {
	mnemonic: "or",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [182],
	isPseudo: !1,
	clr: {
		opcodes: "B6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise OR on A with (HL).",
		instruction: "or (hl)"
	}
}, da = {
	mnemonic: "or",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [182],
	isPseudo: !0,
	clr: {
		opcodes: "B6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise OR on A with (HL).",
		instruction: "or (hl)"
	}
}, fa = {
	mnemonic: "or",
	params: ["a"],
	tokens: ["a"],
	opcodes: [183],
	isPseudo: !1,
	clr: {
		opcodes: "B7",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with A.",
		instruction: "or a"
	}
}, pa = {
	mnemonic: "or",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [183],
	isPseudo: !0,
	clr: {
		opcodes: "B7",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Bitwise OR on A with A.",
		instruction: "or a"
	}
}, ma = {
	mnemonic: "cp",
	params: ["b"],
	tokens: ["b"],
	opcodes: [184],
	isPseudo: !1,
	clr: {
		opcodes: "B8",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B from A and affects flags according to the result. A is not modified.",
		instruction: "cp b"
	}
}, ha = {
	mnemonic: "cp",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [184],
	isPseudo: !0,
	clr: {
		opcodes: "B8",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts B from A and affects flags according to the result. A is not modified.",
		instruction: "cp b"
	}
}, ga = {
	mnemonic: "cp",
	params: ["c"],
	tokens: ["c"],
	opcodes: [185],
	isPseudo: !1,
	clr: {
		opcodes: "B9",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C from A and affects flags according to the result. A is not modified.",
		instruction: "cp c"
	}
}, _a = {
	mnemonic: "cp",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [185],
	isPseudo: !0,
	clr: {
		opcodes: "B9",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts C from A and affects flags according to the result. A is not modified.",
		instruction: "cp c"
	}
}, va = {
	mnemonic: "cp",
	params: ["d"],
	tokens: ["d"],
	opcodes: [186],
	isPseudo: !1,
	clr: {
		opcodes: "BA",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D from A and affects flags according to the result. A is not modified.",
		instruction: "cp d"
	}
}, ya = {
	mnemonic: "cp",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [186],
	isPseudo: !0,
	clr: {
		opcodes: "BA",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts D from A and affects flags according to the result. A is not modified.",
		instruction: "cp d"
	}
}, ba = {
	mnemonic: "cp",
	params: ["e"],
	tokens: ["e"],
	opcodes: [187],
	isPseudo: !1,
	clr: {
		opcodes: "BB",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E from A and affects flags according to the result. A is not modified.",
		instruction: "cp e"
	}
}, xa = {
	mnemonic: "cp",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [187],
	isPseudo: !0,
	clr: {
		opcodes: "BB",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts E from A and affects flags according to the result. A is not modified.",
		instruction: "cp e"
	}
}, Sa = {
	mnemonic: "cp",
	params: ["h"],
	tokens: ["h"],
	opcodes: [188],
	isPseudo: !1,
	clr: {
		opcodes: "BC",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H from A and affects flags according to the result. A is not modified.",
		instruction: "cp h"
	}
}, Ca = {
	mnemonic: "cp",
	params: ["a", "h"],
	tokens: [
		"a",
		",",
		"h"
	],
	opcodes: [188],
	isPseudo: !0,
	clr: {
		opcodes: "BC",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts H from A and affects flags according to the result. A is not modified.",
		instruction: "cp h"
	}
}, wa = {
	mnemonic: "cp",
	params: ["l"],
	tokens: ["l"],
	opcodes: [189],
	isPseudo: !1,
	clr: {
		opcodes: "BD",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L from A and affects flags according to the result. A is not modified.",
		instruction: "cp l"
	}
}, Ta = {
	mnemonic: "cp",
	params: ["a", "l"],
	tokens: [
		"a",
		",",
		"l"
	],
	opcodes: [189],
	isPseudo: !0,
	clr: {
		opcodes: "BD",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts L from A and affects flags according to the result. A is not modified.",
		instruction: "cp l"
	}
}, Ea = {
	mnemonic: "cp",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [190],
	isPseudo: !1,
	clr: {
		opcodes: "BE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) from A and affects flags according to the result. A is not modified.",
		instruction: "cp (hl)"
	}
}, Da = {
	mnemonic: "cp",
	params: ["a", "(hl)"],
	tokens: [
		"a",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [190],
	isPseudo: !0,
	clr: {
		opcodes: "BE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts (HL) from A and affects flags according to the result. A is not modified.",
		instruction: "cp (hl)"
	}
}, Oa = {
	mnemonic: "cp",
	params: ["a"],
	tokens: ["a"],
	opcodes: [191],
	isPseudo: !1,
	clr: {
		opcodes: "BF",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A from A and affects flags according to the result. A is not modified.",
		instruction: "cp a"
	}
}, ka = {
	mnemonic: "cp",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [191],
	isPseudo: !0,
	clr: {
		opcodes: "BF",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Subtracts A from A and affects flags according to the result. A is not modified.",
		instruction: "cp a"
	}
}, Aa = {
	mnemonic: "ret",
	params: ["nz"],
	tokens: ["nz"],
	opcodes: [192],
	isPseudo: !1,
	clr: {
		opcodes: "C0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the zero flag is unset, the top stack entry is popped into PC.",
		instruction: "ret nz"
	}
}, ja = {
	mnemonic: "pop",
	params: ["bc"],
	tokens: ["bc"],
	opcodes: [193],
	isPseudo: !1,
	clr: {
		opcodes: "C1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "The memory location pointed to by SP is stored into C and SP is incremented. The memory location pointed to by SP is stored into B and SP is incremented again.",
		instruction: "pop bc"
	}
}, Ma = {
	mnemonic: "jp",
	params: ["nz", "nnnn"],
	tokens: [
		"nz",
		",",
		"nnnn"
	],
	opcodes: [194, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "C2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the zero flag is unset, <var>nnnn</var> is copied to PC.",
		instruction: "jp nz,nnnn"
	}
}, Na = {
	mnemonic: "jp",
	params: ["nnnn"],
	tokens: ["nnnn"],
	opcodes: [195, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "C3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "<var>nnnn</var> is copied to PC.",
		instruction: "jp nnnn"
	}
}, Pa = {
	mnemonic: "call",
	params: ["nz", "nnnn"],
	tokens: [
		"nz",
		",",
		"nnnn"
	],
	opcodes: [196, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "C4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the zero flag is unset, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call nz,nnnn"
	}
}, Fa = {
	mnemonic: "push",
	params: ["bc"],
	tokens: ["bc"],
	opcodes: [197],
	isPseudo: !1,
	clr: {
		opcodes: "C5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "SP is decremented and B is stored into the memory location pointed to by SP. SP is decremented again and C is stored into the memory location pointed to by SP.",
		instruction: "push bc"
	}
}, Ia = {
	mnemonic: "add",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [198, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "C6",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds <var>nn</var> to A.",
		instruction: "add a,nn"
	}
}, La = {
	mnemonic: "add",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [198, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "C6",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds <var>nn</var> to A.",
		instruction: "add a,nn"
	}
}, Ra = {
	mnemonic: "rst",
	params: ["00"],
	tokens: ["00"],
	opcodes: [199],
	isPseudo: !1,
	clr: {
		opcodes: "C7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 0.",
		instruction: "rst 00"
	}
}, za = {
	mnemonic: "ret",
	params: ["z"],
	tokens: ["z"],
	opcodes: [200],
	isPseudo: !1,
	clr: {
		opcodes: "C8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the zero flag is set, the top stack entry is popped into PC.",
		instruction: "ret z"
	}
}, Ba = {
	mnemonic: "ret",
	params: [],
	tokens: [],
	opcodes: [201],
	isPseudo: !1,
	clr: {
		opcodes: "C9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "The top stack entry is popped into PC.",
		instruction: "ret"
	}
}, Va = {
	mnemonic: "jp",
	params: ["z", "nnnn"],
	tokens: [
		"z",
		",",
		"nnnn"
	],
	opcodes: [202, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "CA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the zero flag is set, <var>nnnn</var> is copied to PC.",
		instruction: "jp z,nnnn"
	}
}, Ha = {
	mnemonic: "rlc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 0],
	isPseudo: !1,
	clr: {
		opcodes: "CB00",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc b"
	}
}, Ua = {
	mnemonic: "rlc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 1],
	isPseudo: !1,
	clr: {
		opcodes: "CB01",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc c"
	}
}, Wa = {
	mnemonic: "rlc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 2],
	isPseudo: !1,
	clr: {
		opcodes: "CB02",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc d"
	}
}, Ga = {
	mnemonic: "rlc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 3],
	isPseudo: !1,
	clr: {
		opcodes: "CB03",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc e"
	}
}, Ka = {
	mnemonic: "rlc",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 4],
	isPseudo: !1,
	clr: {
		opcodes: "CB04",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc h"
	}
}, qa = {
	mnemonic: "rlc",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 5],
	isPseudo: !1,
	clr: {
		opcodes: "CB05",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc l"
	}
}, Ja = {
	mnemonic: "rlc",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 6],
	isPseudo: !1,
	clr: {
		opcodes: "CB06",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc (hl)"
	}
}, Ya = {
	mnemonic: "rlc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 7],
	isPseudo: !1,
	clr: {
		opcodes: "CB07",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc a"
	}
}, Xa = {
	mnemonic: "rrc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 8],
	isPseudo: !1,
	clr: {
		opcodes: "CB08",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc b"
	}
}, Za = {
	mnemonic: "rrc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 9],
	isPseudo: !1,
	clr: {
		opcodes: "CB09",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc c"
	}
}, Qa = {
	mnemonic: "rrc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 10],
	isPseudo: !1,
	clr: {
		opcodes: "CB0A",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc d"
	}
}, $a = {
	mnemonic: "rrc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 11],
	isPseudo: !1,
	clr: {
		opcodes: "CB0B",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc e"
	}
}, eo = {
	mnemonic: "rrc",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 12],
	isPseudo: !1,
	clr: {
		opcodes: "CB0C",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc h"
	}
}, to = {
	mnemonic: "rrc",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 13],
	isPseudo: !1,
	clr: {
		opcodes: "CB0D",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc l"
	}
}, no = {
	mnemonic: "rrc",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 14],
	isPseudo: !1,
	clr: {
		opcodes: "CB0E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc (hl)"
	}
}, ro = {
	mnemonic: "rrc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 15],
	isPseudo: !1,
	clr: {
		opcodes: "CB0F",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc a"
	}
}, io = {
	mnemonic: "rl",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 16],
	isPseudo: !1,
	clr: {
		opcodes: "CB10",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl b"
	}
}, ao = {
	mnemonic: "rl",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 17],
	isPseudo: !1,
	clr: {
		opcodes: "CB11",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl c"
	}
}, oo = {
	mnemonic: "rl",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 18],
	isPseudo: !1,
	clr: {
		opcodes: "CB12",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl d"
	}
}, so = {
	mnemonic: "rl",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 19],
	isPseudo: !1,
	clr: {
		opcodes: "CB13",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl e"
	}
}, co = {
	mnemonic: "rl",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 20],
	isPseudo: !1,
	clr: {
		opcodes: "CB14",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl h"
	}
}, lo = {
	mnemonic: "rl",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 21],
	isPseudo: !1,
	clr: {
		opcodes: "CB15",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl l"
	}
}, uo = {
	mnemonic: "rl",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 22],
	isPseudo: !1,
	clr: {
		opcodes: "CB16",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl (hl)"
	}
}, fo = {
	mnemonic: "rl",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 23],
	isPseudo: !1,
	clr: {
		opcodes: "CB17",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl a"
	}
}, po = {
	mnemonic: "rr",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 24],
	isPseudo: !1,
	clr: {
		opcodes: "CB18",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr b"
	}
}, mo = {
	mnemonic: "rr",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 25],
	isPseudo: !1,
	clr: {
		opcodes: "CB19",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr c"
	}
}, ho = {
	mnemonic: "rr",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 26],
	isPseudo: !1,
	clr: {
		opcodes: "CB1A",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr d"
	}
}, go = {
	mnemonic: "rr",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 27],
	isPseudo: !1,
	clr: {
		opcodes: "CB1B",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr e"
	}
}, _o = {
	mnemonic: "rr",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 28],
	isPseudo: !1,
	clr: {
		opcodes: "CB1C",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr h"
	}
}, vo = {
	mnemonic: "rr",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 29],
	isPseudo: !1,
	clr: {
		opcodes: "CB1D",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr l"
	}
}, yo = {
	mnemonic: "rr",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 30],
	isPseudo: !1,
	clr: {
		opcodes: "CB1E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr (hl)"
	}
}, bo = {
	mnemonic: "rr",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 31],
	isPseudo: !1,
	clr: {
		opcodes: "CB1F",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr a"
	}
}, xo = {
	mnemonic: "sla",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 32],
	isPseudo: !1,
	clr: {
		opcodes: "CB20",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla b"
	}
}, So = {
	mnemonic: "sla",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 33],
	isPseudo: !1,
	clr: {
		opcodes: "CB21",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla c"
	}
}, Co = {
	mnemonic: "sla",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 34],
	isPseudo: !1,
	clr: {
		opcodes: "CB22",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla d"
	}
}, wo = {
	mnemonic: "sla",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 35],
	isPseudo: !1,
	clr: {
		opcodes: "CB23",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla e"
	}
}, To = {
	mnemonic: "sla",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 36],
	isPseudo: !1,
	clr: {
		opcodes: "CB24",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla h"
	}
}, Eo = {
	mnemonic: "sla",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 37],
	isPseudo: !1,
	clr: {
		opcodes: "CB25",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla l"
	}
}, Do = {
	mnemonic: "sla",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 38],
	isPseudo: !1,
	clr: {
		opcodes: "CB26",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla (hl)"
	}
}, Oo = {
	mnemonic: "sla",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 39],
	isPseudo: !1,
	clr: {
		opcodes: "CB27",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla a"
	}
}, ko = {
	mnemonic: "sra",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 40],
	isPseudo: !1,
	clr: {
		opcodes: "CB28",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra b"
	}
}, Ao = {
	mnemonic: "sra",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 41],
	isPseudo: !1,
	clr: {
		opcodes: "CB29",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra c"
	}
}, jo = {
	mnemonic: "sra",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 42],
	isPseudo: !1,
	clr: {
		opcodes: "CB2A",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra d"
	}
}, Mo = {
	mnemonic: "sra",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 43],
	isPseudo: !1,
	clr: {
		opcodes: "CB2B",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra e"
	}
}, No = {
	mnemonic: "sra",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 44],
	isPseudo: !1,
	clr: {
		opcodes: "CB2C",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra h"
	}
}, Po = {
	mnemonic: "sra",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 45],
	isPseudo: !1,
	clr: {
		opcodes: "CB2D",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra l"
	}
}, Fo = {
	mnemonic: "sra",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 46],
	isPseudo: !1,
	clr: {
		opcodes: "CB2E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra (hl)"
	}
}, Io = {
	mnemonic: "sra",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 47],
	isPseudo: !1,
	clr: {
		opcodes: "CB2F",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra a"
	}
}, Lo = {
	mnemonic: "sll",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 48],
	isPseudo: !1,
	clr: {
		opcodes: "CB30",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll b"
	}
}, Ro = {
	mnemonic: "sll",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 49],
	isPseudo: !1,
	clr: {
		opcodes: "CB31",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll c"
	}
}, zo = {
	mnemonic: "sll",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 50],
	isPseudo: !1,
	clr: {
		opcodes: "CB32",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll d"
	}
}, Bo = {
	mnemonic: "sll",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 51],
	isPseudo: !1,
	clr: {
		opcodes: "CB33",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll e"
	}
}, Vo = {
	mnemonic: "sll",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 52],
	isPseudo: !1,
	clr: {
		opcodes: "CB34",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll h"
	}
}, Ho = {
	mnemonic: "sll",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 53],
	isPseudo: !1,
	clr: {
		opcodes: "CB35",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll l"
	}
}, Uo = {
	mnemonic: "sll",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 54],
	isPseudo: !1,
	clr: {
		opcodes: "CB36",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll (hl)"
	}
}, Wo = {
	mnemonic: "sll",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 55],
	isPseudo: !1,
	clr: {
		opcodes: "CB37",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll a"
	}
}, Go = {
	mnemonic: "srl",
	params: ["b"],
	tokens: ["b"],
	opcodes: [203, 56],
	isPseudo: !1,
	clr: {
		opcodes: "CB38",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl b"
	}
}, Ko = {
	mnemonic: "srl",
	params: ["c"],
	tokens: ["c"],
	opcodes: [203, 57],
	isPseudo: !1,
	clr: {
		opcodes: "CB39",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl c"
	}
}, qo = {
	mnemonic: "srl",
	params: ["d"],
	tokens: ["d"],
	opcodes: [203, 58],
	isPseudo: !1,
	clr: {
		opcodes: "CB3A",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl d"
	}
}, Jo = {
	mnemonic: "srl",
	params: ["e"],
	tokens: ["e"],
	opcodes: [203, 59],
	isPseudo: !1,
	clr: {
		opcodes: "CB3B",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl e"
	}
}, Yo = {
	mnemonic: "srl",
	params: ["h"],
	tokens: ["h"],
	opcodes: [203, 60],
	isPseudo: !1,
	clr: {
		opcodes: "CB3C",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of H are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl h"
	}
}, Xo = {
	mnemonic: "srl",
	params: ["l"],
	tokens: ["l"],
	opcodes: [203, 61],
	isPseudo: !1,
	clr: {
		opcodes: "CB3D",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of L are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl l"
	}
}, Zo = {
	mnemonic: "srl",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [203, 62],
	isPseudo: !1,
	clr: {
		opcodes: "CB3E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The contents of (HL) are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl (hl)"
	}
}, Qo = {
	mnemonic: "srl",
	params: ["a"],
	tokens: ["a"],
	opcodes: [203, 63],
	isPseudo: !1,
	clr: {
		opcodes: "CB3F",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl a"
	}
}, $o = {
	mnemonic: "bit",
	params: ["0", "b"],
	tokens: [
		"0",
		",",
		"b"
	],
	opcodes: [203, 64],
	isPseudo: !1,
	clr: {
		opcodes: "CB40",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of B.",
		instruction: "bit 0,b"
	}
}, es = {
	mnemonic: "bit",
	params: ["0", "c"],
	tokens: [
		"0",
		",",
		"c"
	],
	opcodes: [203, 65],
	isPseudo: !1,
	clr: {
		opcodes: "CB41",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of C.",
		instruction: "bit 0,c"
	}
}, ts = {
	mnemonic: "bit",
	params: ["0", "d"],
	tokens: [
		"0",
		",",
		"d"
	],
	opcodes: [203, 66],
	isPseudo: !1,
	clr: {
		opcodes: "CB42",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of D.",
		instruction: "bit 0,d"
	}
}, ns = {
	mnemonic: "bit",
	params: ["0", "e"],
	tokens: [
		"0",
		",",
		"e"
	],
	opcodes: [203, 67],
	isPseudo: !1,
	clr: {
		opcodes: "CB43",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of E.",
		instruction: "bit 0,e"
	}
}, rs = {
	mnemonic: "bit",
	params: ["0", "h"],
	tokens: [
		"0",
		",",
		"h"
	],
	opcodes: [203, 68],
	isPseudo: !1,
	clr: {
		opcodes: "CB44",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of H.",
		instruction: "bit 0,h"
	}
}, is = {
	mnemonic: "bit",
	params: ["0", "l"],
	tokens: [
		"0",
		",",
		"l"
	],
	opcodes: [203, 69],
	isPseudo: !1,
	clr: {
		opcodes: "CB45",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of L.",
		instruction: "bit 0,l"
	}
}, as = {
	mnemonic: "bit",
	params: ["0", "(hl)"],
	tokens: [
		"0",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 70],
	isPseudo: !1,
	clr: {
		opcodes: "CB46",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 0 of (HL).",
		instruction: "bit 0,(hl)"
	}
}, os = {
	mnemonic: "bit",
	params: ["0", "a"],
	tokens: [
		"0",
		",",
		"a"
	],
	opcodes: [203, 71],
	isPseudo: !1,
	clr: {
		opcodes: "CB47",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 0 of A.",
		instruction: "bit 0,a"
	}
}, ss = {
	mnemonic: "bit",
	params: ["1", "b"],
	tokens: [
		"1",
		",",
		"b"
	],
	opcodes: [203, 72],
	isPseudo: !1,
	clr: {
		opcodes: "CB48",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of B.",
		instruction: "bit 1,b"
	}
}, cs = {
	mnemonic: "bit",
	params: ["1", "c"],
	tokens: [
		"1",
		",",
		"c"
	],
	opcodes: [203, 73],
	isPseudo: !1,
	clr: {
		opcodes: "CB49",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of C.",
		instruction: "bit 1,c"
	}
}, ls = {
	mnemonic: "bit",
	params: ["1", "d"],
	tokens: [
		"1",
		",",
		"d"
	],
	opcodes: [203, 74],
	isPseudo: !1,
	clr: {
		opcodes: "CB4A",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of D.",
		instruction: "bit 1,d"
	}
}, us = {
	mnemonic: "bit",
	params: ["1", "e"],
	tokens: [
		"1",
		",",
		"e"
	],
	opcodes: [203, 75],
	isPseudo: !1,
	clr: {
		opcodes: "CB4B",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of E.",
		instruction: "bit 1,e"
	}
}, ds = {
	mnemonic: "bit",
	params: ["1", "h"],
	tokens: [
		"1",
		",",
		"h"
	],
	opcodes: [203, 76],
	isPseudo: !1,
	clr: {
		opcodes: "CB4C",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of H.",
		instruction: "bit 1,h"
	}
}, fs = {
	mnemonic: "bit",
	params: ["1", "l"],
	tokens: [
		"1",
		",",
		"l"
	],
	opcodes: [203, 77],
	isPseudo: !1,
	clr: {
		opcodes: "CB4D",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of L.",
		instruction: "bit 1,l"
	}
}, ps = {
	mnemonic: "bit",
	params: ["1", "(hl)"],
	tokens: [
		"1",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 78],
	isPseudo: !1,
	clr: {
		opcodes: "CB4E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 1 of (HL).",
		instruction: "bit 1,(hl)"
	}
}, ms = {
	mnemonic: "bit",
	params: ["1", "a"],
	tokens: [
		"1",
		",",
		"a"
	],
	opcodes: [203, 79],
	isPseudo: !1,
	clr: {
		opcodes: "CB4F",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 1 of A.",
		instruction: "bit 1,a"
	}
}, hs = {
	mnemonic: "bit",
	params: ["2", "b"],
	tokens: [
		"2",
		",",
		"b"
	],
	opcodes: [203, 80],
	isPseudo: !1,
	clr: {
		opcodes: "CB50",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of B.",
		instruction: "bit 2,b"
	}
}, gs = {
	mnemonic: "bit",
	params: ["2", "c"],
	tokens: [
		"2",
		",",
		"c"
	],
	opcodes: [203, 81],
	isPseudo: !1,
	clr: {
		opcodes: "CB51",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of C.",
		instruction: "bit 2,c"
	}
}, _s = {
	mnemonic: "bit",
	params: ["2", "d"],
	tokens: [
		"2",
		",",
		"d"
	],
	opcodes: [203, 82],
	isPseudo: !1,
	clr: {
		opcodes: "CB52",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of D.",
		instruction: "bit 2,d"
	}
}, vs = {
	mnemonic: "bit",
	params: ["2", "e"],
	tokens: [
		"2",
		",",
		"e"
	],
	opcodes: [203, 83],
	isPseudo: !1,
	clr: {
		opcodes: "CB53",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of E.",
		instruction: "bit 2,e"
	}
}, ys = {
	mnemonic: "bit",
	params: ["2", "h"],
	tokens: [
		"2",
		",",
		"h"
	],
	opcodes: [203, 84],
	isPseudo: !1,
	clr: {
		opcodes: "CB54",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of H.",
		instruction: "bit 2,h"
	}
}, bs = {
	mnemonic: "bit",
	params: ["2", "l"],
	tokens: [
		"2",
		",",
		"l"
	],
	opcodes: [203, 85],
	isPseudo: !1,
	clr: {
		opcodes: "CB55",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of L.",
		instruction: "bit 2,l"
	}
}, xs = {
	mnemonic: "bit",
	params: ["2", "(hl)"],
	tokens: [
		"2",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 86],
	isPseudo: !1,
	clr: {
		opcodes: "CB56",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 2 of (HL).",
		instruction: "bit 2,(hl)"
	}
}, Ss = {
	mnemonic: "bit",
	params: ["2", "a"],
	tokens: [
		"2",
		",",
		"a"
	],
	opcodes: [203, 87],
	isPseudo: !1,
	clr: {
		opcodes: "CB57",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 2 of A.",
		instruction: "bit 2,a"
	}
}, Cs = {
	mnemonic: "bit",
	params: ["3", "b"],
	tokens: [
		"3",
		",",
		"b"
	],
	opcodes: [203, 88],
	isPseudo: !1,
	clr: {
		opcodes: "CB58",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of B.",
		instruction: "bit 3,b"
	}
}, ws = {
	mnemonic: "bit",
	params: ["3", "c"],
	tokens: [
		"3",
		",",
		"c"
	],
	opcodes: [203, 89],
	isPseudo: !1,
	clr: {
		opcodes: "CB59",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of C.",
		instruction: "bit 3,c"
	}
}, Ts = {
	mnemonic: "bit",
	params: ["3", "d"],
	tokens: [
		"3",
		",",
		"d"
	],
	opcodes: [203, 90],
	isPseudo: !1,
	clr: {
		opcodes: "CB5A",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of D.",
		instruction: "bit 3,d"
	}
}, Es = {
	mnemonic: "bit",
	params: ["3", "e"],
	tokens: [
		"3",
		",",
		"e"
	],
	opcodes: [203, 91],
	isPseudo: !1,
	clr: {
		opcodes: "CB5B",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of E.",
		instruction: "bit 3,e"
	}
}, Ds = {
	mnemonic: "bit",
	params: ["3", "h"],
	tokens: [
		"3",
		",",
		"h"
	],
	opcodes: [203, 92],
	isPseudo: !1,
	clr: {
		opcodes: "CB5C",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of H.",
		instruction: "bit 3,h"
	}
}, Os = {
	mnemonic: "bit",
	params: ["3", "l"],
	tokens: [
		"3",
		",",
		"l"
	],
	opcodes: [203, 93],
	isPseudo: !1,
	clr: {
		opcodes: "CB5D",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of L.",
		instruction: "bit 3,l"
	}
}, ks = {
	mnemonic: "bit",
	params: ["3", "(hl)"],
	tokens: [
		"3",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 94],
	isPseudo: !1,
	clr: {
		opcodes: "CB5E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 3 of (HL).",
		instruction: "bit 3,(hl)"
	}
}, As = {
	mnemonic: "bit",
	params: ["3", "a"],
	tokens: [
		"3",
		",",
		"a"
	],
	opcodes: [203, 95],
	isPseudo: !1,
	clr: {
		opcodes: "CB5F",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 3 of A.",
		instruction: "bit 3,a"
	}
}, js = {
	mnemonic: "bit",
	params: ["4", "b"],
	tokens: [
		"4",
		",",
		"b"
	],
	opcodes: [203, 96],
	isPseudo: !1,
	clr: {
		opcodes: "CB60",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of B.",
		instruction: "bit 4,b"
	}
}, Ms = {
	mnemonic: "bit",
	params: ["4", "c"],
	tokens: [
		"4",
		",",
		"c"
	],
	opcodes: [203, 97],
	isPseudo: !1,
	clr: {
		opcodes: "CB61",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of C.",
		instruction: "bit 4,c"
	}
}, Ns = {
	mnemonic: "bit",
	params: ["4", "d"],
	tokens: [
		"4",
		",",
		"d"
	],
	opcodes: [203, 98],
	isPseudo: !1,
	clr: {
		opcodes: "CB62",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of D.",
		instruction: "bit 4,d"
	}
}, Ps = {
	mnemonic: "bit",
	params: ["4", "e"],
	tokens: [
		"4",
		",",
		"e"
	],
	opcodes: [203, 99],
	isPseudo: !1,
	clr: {
		opcodes: "CB63",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of E.",
		instruction: "bit 4,e"
	}
}, Fs = {
	mnemonic: "bit",
	params: ["4", "h"],
	tokens: [
		"4",
		",",
		"h"
	],
	opcodes: [203, 100],
	isPseudo: !1,
	clr: {
		opcodes: "CB64",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of H.",
		instruction: "bit 4,h"
	}
}, Is = {
	mnemonic: "bit",
	params: ["4", "l"],
	tokens: [
		"4",
		",",
		"l"
	],
	opcodes: [203, 101],
	isPseudo: !1,
	clr: {
		opcodes: "CB65",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of L.",
		instruction: "bit 4,l"
	}
}, Ls = {
	mnemonic: "bit",
	params: ["4", "(hl)"],
	tokens: [
		"4",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 102],
	isPseudo: !1,
	clr: {
		opcodes: "CB66",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 4 of (HL).",
		instruction: "bit 4,(hl)"
	}
}, Rs = {
	mnemonic: "bit",
	params: ["4", "a"],
	tokens: [
		"4",
		",",
		"a"
	],
	opcodes: [203, 103],
	isPseudo: !1,
	clr: {
		opcodes: "CB67",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 4 of A.",
		instruction: "bit 4,a"
	}
}, zs = {
	mnemonic: "bit",
	params: ["5", "b"],
	tokens: [
		"5",
		",",
		"b"
	],
	opcodes: [203, 104],
	isPseudo: !1,
	clr: {
		opcodes: "CB68",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of B.",
		instruction: "bit 5,b"
	}
}, Bs = {
	mnemonic: "bit",
	params: ["5", "c"],
	tokens: [
		"5",
		",",
		"c"
	],
	opcodes: [203, 105],
	isPseudo: !1,
	clr: {
		opcodes: "CB69",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of C.",
		instruction: "bit 5,c"
	}
}, Vs = {
	mnemonic: "bit",
	params: ["5", "d"],
	tokens: [
		"5",
		",",
		"d"
	],
	opcodes: [203, 106],
	isPseudo: !1,
	clr: {
		opcodes: "CB6A",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of D.",
		instruction: "bit 5,d"
	}
}, Hs = {
	mnemonic: "bit",
	params: ["5", "e"],
	tokens: [
		"5",
		",",
		"e"
	],
	opcodes: [203, 107],
	isPseudo: !1,
	clr: {
		opcodes: "CB6B",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of E.",
		instruction: "bit 5,e"
	}
}, Us = {
	mnemonic: "bit",
	params: ["5", "h"],
	tokens: [
		"5",
		",",
		"h"
	],
	opcodes: [203, 108],
	isPseudo: !1,
	clr: {
		opcodes: "CB6C",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of H.",
		instruction: "bit 5,h"
	}
}, Ws = {
	mnemonic: "bit",
	params: ["5", "l"],
	tokens: [
		"5",
		",",
		"l"
	],
	opcodes: [203, 109],
	isPseudo: !1,
	clr: {
		opcodes: "CB6D",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of L.",
		instruction: "bit 5,l"
	}
}, Gs = {
	mnemonic: "bit",
	params: ["5", "(hl)"],
	tokens: [
		"5",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 110],
	isPseudo: !1,
	clr: {
		opcodes: "CB6E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 5 of (HL).",
		instruction: "bit 5,(hl)"
	}
}, Ks = {
	mnemonic: "bit",
	params: ["5", "a"],
	tokens: [
		"5",
		",",
		"a"
	],
	opcodes: [203, 111],
	isPseudo: !1,
	clr: {
		opcodes: "CB6F",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 5 of A.",
		instruction: "bit 5,a"
	}
}, qs = {
	mnemonic: "bit",
	params: ["6", "b"],
	tokens: [
		"6",
		",",
		"b"
	],
	opcodes: [203, 112],
	isPseudo: !1,
	clr: {
		opcodes: "CB70",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of B.",
		instruction: "bit 6,b"
	}
}, Js = {
	mnemonic: "bit",
	params: ["6", "c"],
	tokens: [
		"6",
		",",
		"c"
	],
	opcodes: [203, 113],
	isPseudo: !1,
	clr: {
		opcodes: "CB71",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of C.",
		instruction: "bit 6,c"
	}
}, Ys = {
	mnemonic: "bit",
	params: ["6", "d"],
	tokens: [
		"6",
		",",
		"d"
	],
	opcodes: [203, 114],
	isPseudo: !1,
	clr: {
		opcodes: "CB72",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of D.",
		instruction: "bit 6,d"
	}
}, Xs = {
	mnemonic: "bit",
	params: ["6", "e"],
	tokens: [
		"6",
		",",
		"e"
	],
	opcodes: [203, 115],
	isPseudo: !1,
	clr: {
		opcodes: "CB73",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of E.",
		instruction: "bit 6,e"
	}
}, Zs = {
	mnemonic: "bit",
	params: ["6", "h"],
	tokens: [
		"6",
		",",
		"h"
	],
	opcodes: [203, 116],
	isPseudo: !1,
	clr: {
		opcodes: "CB74",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of H.",
		instruction: "bit 6,h"
	}
}, Qs = {
	mnemonic: "bit",
	params: ["6", "l"],
	tokens: [
		"6",
		",",
		"l"
	],
	opcodes: [203, 117],
	isPseudo: !1,
	clr: {
		opcodes: "CB75",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of L.",
		instruction: "bit 6,l"
	}
}, $s = {
	mnemonic: "bit",
	params: ["6", "(hl)"],
	tokens: [
		"6",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 118],
	isPseudo: !1,
	clr: {
		opcodes: "CB76",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 6 of (HL).",
		instruction: "bit 6,(hl)"
	}
}, ec = {
	mnemonic: "bit",
	params: ["6", "a"],
	tokens: [
		"6",
		",",
		"a"
	],
	opcodes: [203, 119],
	isPseudo: !1,
	clr: {
		opcodes: "CB77",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 6 of A.",
		instruction: "bit 6,a"
	}
}, tc = {
	mnemonic: "bit",
	params: ["7", "b"],
	tokens: [
		"7",
		",",
		"b"
	],
	opcodes: [203, 120],
	isPseudo: !1,
	clr: {
		opcodes: "CB78",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of B.",
		instruction: "bit 7,b"
	}
}, nc = {
	mnemonic: "bit",
	params: ["7", "c"],
	tokens: [
		"7",
		",",
		"c"
	],
	opcodes: [203, 121],
	isPseudo: !1,
	clr: {
		opcodes: "CB79",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of C.",
		instruction: "bit 7,c"
	}
}, rc = {
	mnemonic: "bit",
	params: ["7", "d"],
	tokens: [
		"7",
		",",
		"d"
	],
	opcodes: [203, 122],
	isPseudo: !1,
	clr: {
		opcodes: "CB7A",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of D.",
		instruction: "bit 7,d"
	}
}, ic = {
	mnemonic: "bit",
	params: ["7", "e"],
	tokens: [
		"7",
		",",
		"e"
	],
	opcodes: [203, 123],
	isPseudo: !1,
	clr: {
		opcodes: "CB7B",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of E.",
		instruction: "bit 7,e"
	}
}, ac = {
	mnemonic: "bit",
	params: ["7", "h"],
	tokens: [
		"7",
		",",
		"h"
	],
	opcodes: [203, 124],
	isPseudo: !1,
	clr: {
		opcodes: "CB7C",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of H.",
		instruction: "bit 7,h"
	}
}, oc = {
	mnemonic: "bit",
	params: ["7", "l"],
	tokens: [
		"7",
		",",
		"l"
	],
	opcodes: [203, 125],
	isPseudo: !1,
	clr: {
		opcodes: "CB7D",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of L.",
		instruction: "bit 7,l"
	}
}, sc = {
	mnemonic: "bit",
	params: ["7", "(hl)"],
	tokens: [
		"7",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 126],
	isPseudo: !1,
	clr: {
		opcodes: "CB7E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Tests bit 7 of (HL).",
		instruction: "bit 7,(hl)"
	}
}, cc = {
	mnemonic: "bit",
	params: ["7", "a"],
	tokens: [
		"7",
		",",
		"a"
	],
	opcodes: [203, 127],
	isPseudo: !1,
	clr: {
		opcodes: "CB7F",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Tests bit 7 of A.",
		instruction: "bit 7,a"
	}
}, lc = {
	mnemonic: "res",
	params: ["0", "b"],
	tokens: [
		"0",
		",",
		"b"
	],
	opcodes: [203, 128],
	isPseudo: !1,
	clr: {
		opcodes: "CB80",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of B.",
		instruction: "res 0,b"
	}
}, uc = {
	mnemonic: "res",
	params: ["0", "c"],
	tokens: [
		"0",
		",",
		"c"
	],
	opcodes: [203, 129],
	isPseudo: !1,
	clr: {
		opcodes: "CB81",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of C.",
		instruction: "res 0,c"
	}
}, dc = {
	mnemonic: "res",
	params: ["0", "d"],
	tokens: [
		"0",
		",",
		"d"
	],
	opcodes: [203, 130],
	isPseudo: !1,
	clr: {
		opcodes: "CB82",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of D.",
		instruction: "res 0,d"
	}
}, fc = {
	mnemonic: "res",
	params: ["0", "e"],
	tokens: [
		"0",
		",",
		"e"
	],
	opcodes: [203, 131],
	isPseudo: !1,
	clr: {
		opcodes: "CB83",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of E.",
		instruction: "res 0,e"
	}
}, pc = {
	mnemonic: "res",
	params: ["0", "h"],
	tokens: [
		"0",
		",",
		"h"
	],
	opcodes: [203, 132],
	isPseudo: !1,
	clr: {
		opcodes: "CB84",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of H.",
		instruction: "res 0,h"
	}
}, mc = {
	mnemonic: "res",
	params: ["0", "l"],
	tokens: [
		"0",
		",",
		"l"
	],
	opcodes: [203, 133],
	isPseudo: !1,
	clr: {
		opcodes: "CB85",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of L.",
		instruction: "res 0,l"
	}
}, hc = {
	mnemonic: "res",
	params: ["0", "(hl)"],
	tokens: [
		"0",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 134],
	isPseudo: !1,
	clr: {
		opcodes: "CB86",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 0 of (HL).",
		instruction: "res 0,(hl)"
	}
}, gc = {
	mnemonic: "res",
	params: ["0", "a"],
	tokens: [
		"0",
		",",
		"a"
	],
	opcodes: [203, 135],
	isPseudo: !1,
	clr: {
		opcodes: "CB87",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 0 of A.",
		instruction: "res 0,a"
	}
}, _c = {
	mnemonic: "res",
	params: ["1", "b"],
	tokens: [
		"1",
		",",
		"b"
	],
	opcodes: [203, 136],
	isPseudo: !1,
	clr: {
		opcodes: "CB88",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of B.",
		instruction: "res 1,b"
	}
}, vc = {
	mnemonic: "res",
	params: ["1", "c"],
	tokens: [
		"1",
		",",
		"c"
	],
	opcodes: [203, 137],
	isPseudo: !1,
	clr: {
		opcodes: "CB89",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of C.",
		instruction: "res 1,c"
	}
}, yc = {
	mnemonic: "res",
	params: ["1", "d"],
	tokens: [
		"1",
		",",
		"d"
	],
	opcodes: [203, 138],
	isPseudo: !1,
	clr: {
		opcodes: "CB8A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of D.",
		instruction: "res 1,d"
	}
}, bc = {
	mnemonic: "res",
	params: ["1", "e"],
	tokens: [
		"1",
		",",
		"e"
	],
	opcodes: [203, 139],
	isPseudo: !1,
	clr: {
		opcodes: "CB8B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of E.",
		instruction: "res 1,e"
	}
}, xc = {
	mnemonic: "res",
	params: ["1", "h"],
	tokens: [
		"1",
		",",
		"h"
	],
	opcodes: [203, 140],
	isPseudo: !1,
	clr: {
		opcodes: "CB8C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of H.",
		instruction: "res 1,h"
	}
}, Sc = {
	mnemonic: "res",
	params: ["1", "l"],
	tokens: [
		"1",
		",",
		"l"
	],
	opcodes: [203, 141],
	isPseudo: !1,
	clr: {
		opcodes: "CB8D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of L.",
		instruction: "res 1,l"
	}
}, Cc = {
	mnemonic: "res",
	params: ["1", "(hl)"],
	tokens: [
		"1",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 142],
	isPseudo: !1,
	clr: {
		opcodes: "CB8E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 1 of (HL).",
		instruction: "res 1,(hl)"
	}
}, wc = {
	mnemonic: "res",
	params: ["1", "a"],
	tokens: [
		"1",
		",",
		"a"
	],
	opcodes: [203, 143],
	isPseudo: !1,
	clr: {
		opcodes: "CB8F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 1 of A.",
		instruction: "res 1,a"
	}
}, Tc = {
	mnemonic: "res",
	params: ["2", "b"],
	tokens: [
		"2",
		",",
		"b"
	],
	opcodes: [203, 144],
	isPseudo: !1,
	clr: {
		opcodes: "CB90",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of B.",
		instruction: "res 2,b"
	}
}, Ec = {
	mnemonic: "res",
	params: ["2", "c"],
	tokens: [
		"2",
		",",
		"c"
	],
	opcodes: [203, 145],
	isPseudo: !1,
	clr: {
		opcodes: "CB91",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of C.",
		instruction: "res 2,c"
	}
}, Dc = {
	mnemonic: "res",
	params: ["2", "d"],
	tokens: [
		"2",
		",",
		"d"
	],
	opcodes: [203, 146],
	isPseudo: !1,
	clr: {
		opcodes: "CB92",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of D.",
		instruction: "res 2,d"
	}
}, Oc = {
	mnemonic: "res",
	params: ["2", "e"],
	tokens: [
		"2",
		",",
		"e"
	],
	opcodes: [203, 147],
	isPseudo: !1,
	clr: {
		opcodes: "CB93",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of E.",
		instruction: "res 2,e"
	}
}, kc = {
	mnemonic: "res",
	params: ["2", "h"],
	tokens: [
		"2",
		",",
		"h"
	],
	opcodes: [203, 148],
	isPseudo: !1,
	clr: {
		opcodes: "CB94",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of H.",
		instruction: "res 2,h"
	}
}, Ac = {
	mnemonic: "res",
	params: ["2", "l"],
	tokens: [
		"2",
		",",
		"l"
	],
	opcodes: [203, 149],
	isPseudo: !1,
	clr: {
		opcodes: "CB95",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of L.",
		instruction: "res 2,l"
	}
}, jc = {
	mnemonic: "res",
	params: ["2", "(hl)"],
	tokens: [
		"2",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 150],
	isPseudo: !1,
	clr: {
		opcodes: "CB96",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 2 of (HL).",
		instruction: "res 2,(hl)"
	}
}, Mc = {
	mnemonic: "res",
	params: ["2", "a"],
	tokens: [
		"2",
		",",
		"a"
	],
	opcodes: [203, 151],
	isPseudo: !1,
	clr: {
		opcodes: "CB97",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 2 of A.",
		instruction: "res 2,a"
	}
}, Nc = {
	mnemonic: "res",
	params: ["3", "b"],
	tokens: [
		"3",
		",",
		"b"
	],
	opcodes: [203, 152],
	isPseudo: !1,
	clr: {
		opcodes: "CB98",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of B.",
		instruction: "res 3,b"
	}
}, Pc = {
	mnemonic: "res",
	params: ["3", "c"],
	tokens: [
		"3",
		",",
		"c"
	],
	opcodes: [203, 153],
	isPseudo: !1,
	clr: {
		opcodes: "CB99",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of C.",
		instruction: "res 3,c"
	}
}, Fc = {
	mnemonic: "res",
	params: ["3", "d"],
	tokens: [
		"3",
		",",
		"d"
	],
	opcodes: [203, 154],
	isPseudo: !1,
	clr: {
		opcodes: "CB9A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of D.",
		instruction: "res 3,d"
	}
}, Ic = {
	mnemonic: "res",
	params: ["3", "e"],
	tokens: [
		"3",
		",",
		"e"
	],
	opcodes: [203, 155],
	isPseudo: !1,
	clr: {
		opcodes: "CB9B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of E.",
		instruction: "res 3,e"
	}
}, Lc = {
	mnemonic: "res",
	params: ["3", "h"],
	tokens: [
		"3",
		",",
		"h"
	],
	opcodes: [203, 156],
	isPseudo: !1,
	clr: {
		opcodes: "CB9C",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of H.",
		instruction: "res 3,h"
	}
}, Rc = {
	mnemonic: "res",
	params: ["3", "l"],
	tokens: [
		"3",
		",",
		"l"
	],
	opcodes: [203, 157],
	isPseudo: !1,
	clr: {
		opcodes: "CB9D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of L.",
		instruction: "res 3,l"
	}
}, zc = {
	mnemonic: "res",
	params: ["3", "(hl)"],
	tokens: [
		"3",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 158],
	isPseudo: !1,
	clr: {
		opcodes: "CB9E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 3 of (HL).",
		instruction: "res 3,(hl)"
	}
}, Bc = {
	mnemonic: "res",
	params: ["3", "a"],
	tokens: [
		"3",
		",",
		"a"
	],
	opcodes: [203, 159],
	isPseudo: !1,
	clr: {
		opcodes: "CB9F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 3 of A.",
		instruction: "res 3,a"
	}
}, Vc = {
	mnemonic: "res",
	params: ["4", "b"],
	tokens: [
		"4",
		",",
		"b"
	],
	opcodes: [203, 160],
	isPseudo: !1,
	clr: {
		opcodes: "CBA0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of B.",
		instruction: "res 4,b"
	}
}, Hc = {
	mnemonic: "res",
	params: ["4", "c"],
	tokens: [
		"4",
		",",
		"c"
	],
	opcodes: [203, 161],
	isPseudo: !1,
	clr: {
		opcodes: "CBA1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of C.",
		instruction: "res 4,c"
	}
}, Uc = {
	mnemonic: "res",
	params: ["4", "d"],
	tokens: [
		"4",
		",",
		"d"
	],
	opcodes: [203, 162],
	isPseudo: !1,
	clr: {
		opcodes: "CBA2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of D.",
		instruction: "res 4,d"
	}
}, Wc = {
	mnemonic: "res",
	params: ["4", "e"],
	tokens: [
		"4",
		",",
		"e"
	],
	opcodes: [203, 163],
	isPseudo: !1,
	clr: {
		opcodes: "CBA3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of E.",
		instruction: "res 4,e"
	}
}, Gc = {
	mnemonic: "res",
	params: ["4", "h"],
	tokens: [
		"4",
		",",
		"h"
	],
	opcodes: [203, 164],
	isPseudo: !1,
	clr: {
		opcodes: "CBA4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of H.",
		instruction: "res 4,h"
	}
}, Kc = {
	mnemonic: "res",
	params: ["4", "l"],
	tokens: [
		"4",
		",",
		"l"
	],
	opcodes: [203, 165],
	isPseudo: !1,
	clr: {
		opcodes: "CBA5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of L.",
		instruction: "res 4,l"
	}
}, qc = {
	mnemonic: "res",
	params: ["4", "(hl)"],
	tokens: [
		"4",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 166],
	isPseudo: !1,
	clr: {
		opcodes: "CBA6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 4 of (HL).",
		instruction: "res 4,(hl)"
	}
}, Jc = {
	mnemonic: "res",
	params: ["4", "a"],
	tokens: [
		"4",
		",",
		"a"
	],
	opcodes: [203, 167],
	isPseudo: !1,
	clr: {
		opcodes: "CBA7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 4 of A.",
		instruction: "res 4,a"
	}
}, Yc = {
	mnemonic: "res",
	params: ["5", "b"],
	tokens: [
		"5",
		",",
		"b"
	],
	opcodes: [203, 168],
	isPseudo: !1,
	clr: {
		opcodes: "CBA8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of B.",
		instruction: "res 5,b"
	}
}, Xc = {
	mnemonic: "res",
	params: ["5", "c"],
	tokens: [
		"5",
		",",
		"c"
	],
	opcodes: [203, 169],
	isPseudo: !1,
	clr: {
		opcodes: "CBA9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of C.",
		instruction: "res 5,c"
	}
}, Zc = {
	mnemonic: "res",
	params: ["5", "d"],
	tokens: [
		"5",
		",",
		"d"
	],
	opcodes: [203, 170],
	isPseudo: !1,
	clr: {
		opcodes: "CBAA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of D.",
		instruction: "res 5,d"
	}
}, Qc = {
	mnemonic: "res",
	params: ["5", "e"],
	tokens: [
		"5",
		",",
		"e"
	],
	opcodes: [203, 171],
	isPseudo: !1,
	clr: {
		opcodes: "CBAB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of E.",
		instruction: "res 5,e"
	}
}, $c = {
	mnemonic: "res",
	params: ["5", "h"],
	tokens: [
		"5",
		",",
		"h"
	],
	opcodes: [203, 172],
	isPseudo: !1,
	clr: {
		opcodes: "CBAC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of H.",
		instruction: "res 5,h"
	}
}, el = {
	mnemonic: "res",
	params: ["5", "l"],
	tokens: [
		"5",
		",",
		"l"
	],
	opcodes: [203, 173],
	isPseudo: !1,
	clr: {
		opcodes: "CBAD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of L.",
		instruction: "res 5,l"
	}
}, tl = {
	mnemonic: "res",
	params: ["5", "(hl)"],
	tokens: [
		"5",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 174],
	isPseudo: !1,
	clr: {
		opcodes: "CBAE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 5 of (HL).",
		instruction: "res 5,(hl)"
	}
}, nl = {
	mnemonic: "res",
	params: ["5", "a"],
	tokens: [
		"5",
		",",
		"a"
	],
	opcodes: [203, 175],
	isPseudo: !1,
	clr: {
		opcodes: "CBAF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 5 of A.",
		instruction: "res 5,a"
	}
}, rl = {
	mnemonic: "res",
	params: ["6", "b"],
	tokens: [
		"6",
		",",
		"b"
	],
	opcodes: [203, 176],
	isPseudo: !1,
	clr: {
		opcodes: "CBB0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of B.",
		instruction: "res 6,b"
	}
}, il = {
	mnemonic: "res",
	params: ["6", "c"],
	tokens: [
		"6",
		",",
		"c"
	],
	opcodes: [203, 177],
	isPseudo: !1,
	clr: {
		opcodes: "CBB1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of C.",
		instruction: "res 6,c"
	}
}, al = {
	mnemonic: "res",
	params: ["6", "d"],
	tokens: [
		"6",
		",",
		"d"
	],
	opcodes: [203, 178],
	isPseudo: !1,
	clr: {
		opcodes: "CBB2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of D.",
		instruction: "res 6,d"
	}
}, ol = {
	mnemonic: "res",
	params: ["6", "e"],
	tokens: [
		"6",
		",",
		"e"
	],
	opcodes: [203, 179],
	isPseudo: !1,
	clr: {
		opcodes: "CBB3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of E.",
		instruction: "res 6,e"
	}
}, sl = {
	mnemonic: "res",
	params: ["6", "h"],
	tokens: [
		"6",
		",",
		"h"
	],
	opcodes: [203, 180],
	isPseudo: !1,
	clr: {
		opcodes: "CBB4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of H.",
		instruction: "res 6,h"
	}
}, cl = {
	mnemonic: "res",
	params: ["6", "l"],
	tokens: [
		"6",
		",",
		"l"
	],
	opcodes: [203, 181],
	isPseudo: !1,
	clr: {
		opcodes: "CBB5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of L.",
		instruction: "res 6,l"
	}
}, ll = {
	mnemonic: "res",
	params: ["6", "(hl)"],
	tokens: [
		"6",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 182],
	isPseudo: !1,
	clr: {
		opcodes: "CBB6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 6 of (HL).",
		instruction: "res 6,(hl)"
	}
}, ul = {
	mnemonic: "res",
	params: ["6", "a"],
	tokens: [
		"6",
		",",
		"a"
	],
	opcodes: [203, 183],
	isPseudo: !1,
	clr: {
		opcodes: "CBB7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 6 of A.",
		instruction: "res 6,a"
	}
}, dl = {
	mnemonic: "res",
	params: ["7", "b"],
	tokens: [
		"7",
		",",
		"b"
	],
	opcodes: [203, 184],
	isPseudo: !1,
	clr: {
		opcodes: "CBB8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of B.",
		instruction: "res 7,b"
	}
}, fl = {
	mnemonic: "res",
	params: ["7", "c"],
	tokens: [
		"7",
		",",
		"c"
	],
	opcodes: [203, 185],
	isPseudo: !1,
	clr: {
		opcodes: "CBB9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of C.",
		instruction: "res 7,c"
	}
}, pl = {
	mnemonic: "res",
	params: ["7", "d"],
	tokens: [
		"7",
		",",
		"d"
	],
	opcodes: [203, 186],
	isPseudo: !1,
	clr: {
		opcodes: "CBBA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of D.",
		instruction: "res 7,d"
	}
}, ml = {
	mnemonic: "res",
	params: ["7", "e"],
	tokens: [
		"7",
		",",
		"e"
	],
	opcodes: [203, 187],
	isPseudo: !1,
	clr: {
		opcodes: "CBBB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of E.",
		instruction: "res 7,e"
	}
}, hl = {
	mnemonic: "res",
	params: ["7", "h"],
	tokens: [
		"7",
		",",
		"h"
	],
	opcodes: [203, 188],
	isPseudo: !1,
	clr: {
		opcodes: "CBBC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of H.",
		instruction: "res 7,h"
	}
}, gl = {
	mnemonic: "res",
	params: ["7", "l"],
	tokens: [
		"7",
		",",
		"l"
	],
	opcodes: [203, 189],
	isPseudo: !1,
	clr: {
		opcodes: "CBBD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of L.",
		instruction: "res 7,l"
	}
}, _l = {
	mnemonic: "res",
	params: ["7", "(hl)"],
	tokens: [
		"7",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 190],
	isPseudo: !1,
	clr: {
		opcodes: "CBBE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Resets bit 7 of (HL).",
		instruction: "res 7,(hl)"
	}
}, vl = {
	mnemonic: "res",
	params: ["7", "a"],
	tokens: [
		"7",
		",",
		"a"
	],
	opcodes: [203, 191],
	isPseudo: !1,
	clr: {
		opcodes: "CBBF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Resets bit 7 of A.",
		instruction: "res 7,a"
	}
}, yl = {
	mnemonic: "set",
	params: ["0", "b"],
	tokens: [
		"0",
		",",
		"b"
	],
	opcodes: [203, 192],
	isPseudo: !1,
	clr: {
		opcodes: "CBC0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of B.",
		instruction: "set 0,b"
	}
}, bl = {
	mnemonic: "set",
	params: ["0", "c"],
	tokens: [
		"0",
		",",
		"c"
	],
	opcodes: [203, 193],
	isPseudo: !1,
	clr: {
		opcodes: "CBC1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of C.",
		instruction: "set 0,c"
	}
}, xl = {
	mnemonic: "set",
	params: ["0", "d"],
	tokens: [
		"0",
		",",
		"d"
	],
	opcodes: [203, 194],
	isPseudo: !1,
	clr: {
		opcodes: "CBC2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of D.",
		instruction: "set 0,d"
	}
}, Sl = {
	mnemonic: "set",
	params: ["0", "e"],
	tokens: [
		"0",
		",",
		"e"
	],
	opcodes: [203, 195],
	isPseudo: !1,
	clr: {
		opcodes: "CBC3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of E.",
		instruction: "set 0,e"
	}
}, Cl = {
	mnemonic: "set",
	params: ["0", "h"],
	tokens: [
		"0",
		",",
		"h"
	],
	opcodes: [203, 196],
	isPseudo: !1,
	clr: {
		opcodes: "CBC4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of H.",
		instruction: "set 0,h"
	}
}, wl = {
	mnemonic: "set",
	params: ["0", "l"],
	tokens: [
		"0",
		",",
		"l"
	],
	opcodes: [203, 197],
	isPseudo: !1,
	clr: {
		opcodes: "CBC5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of L.",
		instruction: "set 0,l"
	}
}, Tl = {
	mnemonic: "set",
	params: ["0", "(hl)"],
	tokens: [
		"0",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 198],
	isPseudo: !1,
	clr: {
		opcodes: "CBC6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 0 of (HL).",
		instruction: "set 0,(hl)"
	}
}, El = {
	mnemonic: "set",
	params: ["0", "a"],
	tokens: [
		"0",
		",",
		"a"
	],
	opcodes: [203, 199],
	isPseudo: !1,
	clr: {
		opcodes: "CBC7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 0 of A.",
		instruction: "set 0,a"
	}
}, Dl = {
	mnemonic: "set",
	params: ["1", "b"],
	tokens: [
		"1",
		",",
		"b"
	],
	opcodes: [203, 200],
	isPseudo: !1,
	clr: {
		opcodes: "CBC8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of B.",
		instruction: "set 1,b"
	}
}, Ol = {
	mnemonic: "set",
	params: ["1", "c"],
	tokens: [
		"1",
		",",
		"c"
	],
	opcodes: [203, 201],
	isPseudo: !1,
	clr: {
		opcodes: "CBC9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of C.",
		instruction: "set 1,c"
	}
}, kl = {
	mnemonic: "set",
	params: ["1", "d"],
	tokens: [
		"1",
		",",
		"d"
	],
	opcodes: [203, 202],
	isPseudo: !1,
	clr: {
		opcodes: "CBCA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of D.",
		instruction: "set 1,d"
	}
}, Al = {
	mnemonic: "set",
	params: ["1", "e"],
	tokens: [
		"1",
		",",
		"e"
	],
	opcodes: [203, 203],
	isPseudo: !1,
	clr: {
		opcodes: "CBCB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of E.",
		instruction: "set 1,e"
	}
}, jl = {
	mnemonic: "set",
	params: ["1", "h"],
	tokens: [
		"1",
		",",
		"h"
	],
	opcodes: [203, 204],
	isPseudo: !1,
	clr: {
		opcodes: "CBCC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of H.",
		instruction: "set 1,h"
	}
}, Ml = {
	mnemonic: "set",
	params: ["1", "l"],
	tokens: [
		"1",
		",",
		"l"
	],
	opcodes: [203, 205],
	isPseudo: !1,
	clr: {
		opcodes: "CBCD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of L.",
		instruction: "set 1,l"
	}
}, Nl = {
	mnemonic: "set",
	params: ["1", "(hl)"],
	tokens: [
		"1",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 206],
	isPseudo: !1,
	clr: {
		opcodes: "CBCE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 1 of (HL).",
		instruction: "set 1,(hl)"
	}
}, Pl = {
	mnemonic: "set",
	params: ["1", "a"],
	tokens: [
		"1",
		",",
		"a"
	],
	opcodes: [203, 207],
	isPseudo: !1,
	clr: {
		opcodes: "CBCF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 1 of A.",
		instruction: "set 1,a"
	}
}, Fl = {
	mnemonic: "set",
	params: ["2", "b"],
	tokens: [
		"2",
		",",
		"b"
	],
	opcodes: [203, 208],
	isPseudo: !1,
	clr: {
		opcodes: "CBD0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of B.",
		instruction: "set 2,b"
	}
}, Il = {
	mnemonic: "set",
	params: ["2", "c"],
	tokens: [
		"2",
		",",
		"c"
	],
	opcodes: [203, 209],
	isPseudo: !1,
	clr: {
		opcodes: "CBD1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of C.",
		instruction: "set 2,c"
	}
}, Ll = {
	mnemonic: "set",
	params: ["2", "d"],
	tokens: [
		"2",
		",",
		"d"
	],
	opcodes: [203, 210],
	isPseudo: !1,
	clr: {
		opcodes: "CBD2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of D.",
		instruction: "set 2,d"
	}
}, Rl = {
	mnemonic: "set",
	params: ["2", "e"],
	tokens: [
		"2",
		",",
		"e"
	],
	opcodes: [203, 211],
	isPseudo: !1,
	clr: {
		opcodes: "CBD3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of E.",
		instruction: "set 2,e"
	}
}, zl = {
	mnemonic: "set",
	params: ["2", "h"],
	tokens: [
		"2",
		",",
		"h"
	],
	opcodes: [203, 212],
	isPseudo: !1,
	clr: {
		opcodes: "CBD4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of H.",
		instruction: "set 2,h"
	}
}, Bl = {
	mnemonic: "set",
	params: ["2", "l"],
	tokens: [
		"2",
		",",
		"l"
	],
	opcodes: [203, 213],
	isPseudo: !1,
	clr: {
		opcodes: "CBD5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of L.",
		instruction: "set 2,l"
	}
}, Vl = {
	mnemonic: "set",
	params: ["2", "(hl)"],
	tokens: [
		"2",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 214],
	isPseudo: !1,
	clr: {
		opcodes: "CBD6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 2 of (HL).",
		instruction: "set 2,(hl)"
	}
}, Hl = {
	mnemonic: "set",
	params: ["2", "a"],
	tokens: [
		"2",
		",",
		"a"
	],
	opcodes: [203, 215],
	isPseudo: !1,
	clr: {
		opcodes: "CBD7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 2 of A.",
		instruction: "set 2,a"
	}
}, Ul = {
	mnemonic: "set",
	params: ["3", "b"],
	tokens: [
		"3",
		",",
		"b"
	],
	opcodes: [203, 216],
	isPseudo: !1,
	clr: {
		opcodes: "CBD8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of B.",
		instruction: "set 3,b"
	}
}, Wl = {
	mnemonic: "set",
	params: ["3", "c"],
	tokens: [
		"3",
		",",
		"c"
	],
	opcodes: [203, 217],
	isPseudo: !1,
	clr: {
		opcodes: "CBD9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of C.",
		instruction: "set 3,c"
	}
}, Gl = {
	mnemonic: "set",
	params: ["3", "d"],
	tokens: [
		"3",
		",",
		"d"
	],
	opcodes: [203, 218],
	isPseudo: !1,
	clr: {
		opcodes: "CBDA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of D.",
		instruction: "set 3,d"
	}
}, Kl = {
	mnemonic: "set",
	params: ["3", "e"],
	tokens: [
		"3",
		",",
		"e"
	],
	opcodes: [203, 219],
	isPseudo: !1,
	clr: {
		opcodes: "CBDB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of E.",
		instruction: "set 3,e"
	}
}, ql = {
	mnemonic: "set",
	params: ["3", "h"],
	tokens: [
		"3",
		",",
		"h"
	],
	opcodes: [203, 220],
	isPseudo: !1,
	clr: {
		opcodes: "CBDC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of H.",
		instruction: "set 3,h"
	}
}, Jl = {
	mnemonic: "set",
	params: ["3", "l"],
	tokens: [
		"3",
		",",
		"l"
	],
	opcodes: [203, 221],
	isPseudo: !1,
	clr: {
		opcodes: "CBDD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of L.",
		instruction: "set 3,l"
	}
}, Yl = {
	mnemonic: "set",
	params: ["3", "(hl)"],
	tokens: [
		"3",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 222],
	isPseudo: !1,
	clr: {
		opcodes: "CBDE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 3 of (HL).",
		instruction: "set 3,(hl)"
	}
}, Xl = {
	mnemonic: "set",
	params: ["3", "a"],
	tokens: [
		"3",
		",",
		"a"
	],
	opcodes: [203, 223],
	isPseudo: !1,
	clr: {
		opcodes: "CBDF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 3 of A.",
		instruction: "set 3,a"
	}
}, Zl = {
	mnemonic: "set",
	params: ["4", "b"],
	tokens: [
		"4",
		",",
		"b"
	],
	opcodes: [203, 224],
	isPseudo: !1,
	clr: {
		opcodes: "CBE0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of B.",
		instruction: "set 4,b"
	}
}, Ql = {
	mnemonic: "set",
	params: ["4", "c"],
	tokens: [
		"4",
		",",
		"c"
	],
	opcodes: [203, 225],
	isPseudo: !1,
	clr: {
		opcodes: "CBE1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of C.",
		instruction: "set 4,c"
	}
}, $l = {
	mnemonic: "set",
	params: ["4", "d"],
	tokens: [
		"4",
		",",
		"d"
	],
	opcodes: [203, 226],
	isPseudo: !1,
	clr: {
		opcodes: "CBE2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of D.",
		instruction: "set 4,d"
	}
}, eu = {
	mnemonic: "set",
	params: ["4", "e"],
	tokens: [
		"4",
		",",
		"e"
	],
	opcodes: [203, 227],
	isPseudo: !1,
	clr: {
		opcodes: "CBE3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of E.",
		instruction: "set 4,e"
	}
}, tu = {
	mnemonic: "set",
	params: ["4", "h"],
	tokens: [
		"4",
		",",
		"h"
	],
	opcodes: [203, 228],
	isPseudo: !1,
	clr: {
		opcodes: "CBE4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of H.",
		instruction: "set 4,h"
	}
}, nu = {
	mnemonic: "set",
	params: ["4", "l"],
	tokens: [
		"4",
		",",
		"l"
	],
	opcodes: [203, 229],
	isPseudo: !1,
	clr: {
		opcodes: "CBE5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of L.",
		instruction: "set 4,l"
	}
}, ru = {
	mnemonic: "set",
	params: ["4", "(hl)"],
	tokens: [
		"4",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 230],
	isPseudo: !1,
	clr: {
		opcodes: "CBE6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 4 of (HL).",
		instruction: "set 4,(hl)"
	}
}, iu = {
	mnemonic: "set",
	params: ["4", "a"],
	tokens: [
		"4",
		",",
		"a"
	],
	opcodes: [203, 231],
	isPseudo: !1,
	clr: {
		opcodes: "CBE7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 4 of A.",
		instruction: "set 4,a"
	}
}, au = {
	mnemonic: "set",
	params: ["5", "b"],
	tokens: [
		"5",
		",",
		"b"
	],
	opcodes: [203, 232],
	isPseudo: !1,
	clr: {
		opcodes: "CBE8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of B.",
		instruction: "set 5,b"
	}
}, ou = {
	mnemonic: "set",
	params: ["5", "c"],
	tokens: [
		"5",
		",",
		"c"
	],
	opcodes: [203, 233],
	isPseudo: !1,
	clr: {
		opcodes: "CBE9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of C.",
		instruction: "set 5,c"
	}
}, su = {
	mnemonic: "set",
	params: ["5", "d"],
	tokens: [
		"5",
		",",
		"d"
	],
	opcodes: [203, 234],
	isPseudo: !1,
	clr: {
		opcodes: "CBEA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of D.",
		instruction: "set 5,d"
	}
}, cu = {
	mnemonic: "set",
	params: ["5", "e"],
	tokens: [
		"5",
		",",
		"e"
	],
	opcodes: [203, 235],
	isPseudo: !1,
	clr: {
		opcodes: "CBEB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of E.",
		instruction: "set 5,e"
	}
}, lu = {
	mnemonic: "set",
	params: ["5", "h"],
	tokens: [
		"5",
		",",
		"h"
	],
	opcodes: [203, 236],
	isPseudo: !1,
	clr: {
		opcodes: "CBEC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of H.",
		instruction: "set 5,h"
	}
}, uu = {
	mnemonic: "set",
	params: ["5", "l"],
	tokens: [
		"5",
		",",
		"l"
	],
	opcodes: [203, 237],
	isPseudo: !1,
	clr: {
		opcodes: "CBED",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of L.",
		instruction: "set 5,l"
	}
}, du = {
	mnemonic: "set",
	params: ["5", "(hl)"],
	tokens: [
		"5",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 238],
	isPseudo: !1,
	clr: {
		opcodes: "CBEE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 5 of (HL).",
		instruction: "set 5,(hl)"
	}
}, fu = {
	mnemonic: "set",
	params: ["5", "a"],
	tokens: [
		"5",
		",",
		"a"
	],
	opcodes: [203, 239],
	isPseudo: !1,
	clr: {
		opcodes: "CBEF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 5 of A.",
		instruction: "set 5,a"
	}
}, pu = {
	mnemonic: "set",
	params: ["6", "b"],
	tokens: [
		"6",
		",",
		"b"
	],
	opcodes: [203, 240],
	isPseudo: !1,
	clr: {
		opcodes: "CBF0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of B.",
		instruction: "set 6,b"
	}
}, mu = {
	mnemonic: "set",
	params: ["6", "c"],
	tokens: [
		"6",
		",",
		"c"
	],
	opcodes: [203, 241],
	isPseudo: !1,
	clr: {
		opcodes: "CBF1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of C.",
		instruction: "set 6,c"
	}
}, hu = {
	mnemonic: "set",
	params: ["6", "d"],
	tokens: [
		"6",
		",",
		"d"
	],
	opcodes: [203, 242],
	isPseudo: !1,
	clr: {
		opcodes: "CBF2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of D.",
		instruction: "set 6,d"
	}
}, gu = {
	mnemonic: "set",
	params: ["6", "e"],
	tokens: [
		"6",
		",",
		"e"
	],
	opcodes: [203, 243],
	isPseudo: !1,
	clr: {
		opcodes: "CBF3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of E.",
		instruction: "set 6,e"
	}
}, _u = {
	mnemonic: "set",
	params: ["6", "h"],
	tokens: [
		"6",
		",",
		"h"
	],
	opcodes: [203, 244],
	isPseudo: !1,
	clr: {
		opcodes: "CBF4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of H.",
		instruction: "set 6,h"
	}
}, vu = {
	mnemonic: "set",
	params: ["6", "l"],
	tokens: [
		"6",
		",",
		"l"
	],
	opcodes: [203, 245],
	isPseudo: !1,
	clr: {
		opcodes: "CBF5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of L.",
		instruction: "set 6,l"
	}
}, yu = {
	mnemonic: "set",
	params: ["6", "(hl)"],
	tokens: [
		"6",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 246],
	isPseudo: !1,
	clr: {
		opcodes: "CBF6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 6 of (HL).",
		instruction: "set 6,(hl)"
	}
}, bu = {
	mnemonic: "set",
	params: ["6", "a"],
	tokens: [
		"6",
		",",
		"a"
	],
	opcodes: [203, 247],
	isPseudo: !1,
	clr: {
		opcodes: "CBF7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 6 of A.",
		instruction: "set 6,a"
	}
}, xu = {
	mnemonic: "set",
	params: ["7", "b"],
	tokens: [
		"7",
		",",
		"b"
	],
	opcodes: [203, 248],
	isPseudo: !1,
	clr: {
		opcodes: "CBF8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of B.",
		instruction: "set 7,b"
	}
}, Su = {
	mnemonic: "set",
	params: ["7", "c"],
	tokens: [
		"7",
		",",
		"c"
	],
	opcodes: [203, 249],
	isPseudo: !1,
	clr: {
		opcodes: "CBF9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of C.",
		instruction: "set 7,c"
	}
}, Cu = {
	mnemonic: "set",
	params: ["7", "d"],
	tokens: [
		"7",
		",",
		"d"
	],
	opcodes: [203, 250],
	isPseudo: !1,
	clr: {
		opcodes: "CBFA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of D.",
		instruction: "set 7,d"
	}
}, wu = {
	mnemonic: "set",
	params: ["7", "e"],
	tokens: [
		"7",
		",",
		"e"
	],
	opcodes: [203, 251],
	isPseudo: !1,
	clr: {
		opcodes: "CBFB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of E.",
		instruction: "set 7,e"
	}
}, Tu = {
	mnemonic: "set",
	params: ["7", "h"],
	tokens: [
		"7",
		",",
		"h"
	],
	opcodes: [203, 252],
	isPseudo: !1,
	clr: {
		opcodes: "CBFC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of H.",
		instruction: "set 7,h"
	}
}, Eu = {
	mnemonic: "set",
	params: ["7", "l"],
	tokens: [
		"7",
		",",
		"l"
	],
	opcodes: [203, 253],
	isPseudo: !1,
	clr: {
		opcodes: "CBFD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of L.",
		instruction: "set 7,l"
	}
}, Du = {
	mnemonic: "set",
	params: ["7", "(hl)"],
	tokens: [
		"7",
		",",
		"(",
		"hl",
		")"
	],
	opcodes: [203, 254],
	isPseudo: !1,
	clr: {
		opcodes: "CBFE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Sets bit 7 of (HL).",
		instruction: "set 7,(hl)"
	}
}, Ou = {
	mnemonic: "set",
	params: ["7", "a"],
	tokens: [
		"7",
		",",
		"a"
	],
	opcodes: [203, 255],
	isPseudo: !1,
	clr: {
		opcodes: "CBFF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets bit 7 of A.",
		instruction: "set 7,a"
	}
}, ku = {
	mnemonic: "call",
	params: ["z", "nnnn"],
	tokens: [
		"z",
		",",
		"nnnn"
	],
	opcodes: [204, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "CC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the zero flag is set, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call z,nnnn"
	}
}, Au = {
	mnemonic: "call",
	params: ["nnnn"],
	tokens: ["nnnn"],
	opcodes: [205, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "CD",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 17,
		description: "The current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call nnnn"
	}
}, ju = {
	mnemonic: "adc",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [206, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "CE",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds <var>nn</var> and the carry flag to A.",
		instruction: "adc a,nn"
	}
}, Mu = {
	mnemonic: "adc",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [206, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "CE",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Adds <var>nn</var> and the carry flag to A.",
		instruction: "adc a,nn"
	}
}, Nu = {
	mnemonic: "rst",
	params: ["08"],
	tokens: ["08"],
	opcodes: [207],
	isPseudo: !1,
	clr: {
		opcodes: "CF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 8.",
		instruction: "rst 08"
	}
}, Pu = {
	mnemonic: "ret",
	params: ["nc"],
	tokens: ["nc"],
	opcodes: [208],
	isPseudo: !1,
	clr: {
		opcodes: "D0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the carry flag is unset, the top stack entry is popped into PC.",
		instruction: "ret nc"
	}
}, Fu = {
	mnemonic: "pop",
	params: ["de"],
	tokens: ["de"],
	opcodes: [209],
	isPseudo: !1,
	clr: {
		opcodes: "D1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "The memory location pointed to by SP is stored into E and SP is incremented. The memory location pointed to by SP is stored into D and SP is incremented again.",
		instruction: "pop de"
	}
}, Iu = {
	mnemonic: "jp",
	params: ["nc", "nnnn"],
	tokens: [
		"nc",
		",",
		"nnnn"
	],
	opcodes: [210, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "D2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the carry flag is unset, <var>nnnn</var> is copied to PC.",
		instruction: "jp nc,nnnn"
	}
}, Lu = {
	mnemonic: "out",
	params: ["(nn)", "a"],
	tokens: [
		"(",
		"nn",
		")",
		",",
		"a"
	],
	opcodes: [211, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "D3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of A is written to the port whose address is formed by A in the high bits and <var>nn</var> in the low bits.",
		instruction: "out (nn),a"
	}
}, Ru = {
	mnemonic: "out",
	params: ["nn", "a"],
	tokens: [
		"nn",
		",",
		"a"
	],
	opcodes: [211, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "D3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The value of A is written to the port whose address is formed by A in the high bits and <var>nn</var> in the low bits.",
		instruction: "out (nn),a"
	}
}, zu = {
	mnemonic: "call",
	params: ["nc", "nnnn"],
	tokens: [
		"nc",
		",",
		"nnnn"
	],
	opcodes: [212, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "D4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the carry flag is unset, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call nc,nnnn"
	}
}, Bu = {
	mnemonic: "push",
	params: ["de"],
	tokens: ["de"],
	opcodes: [213],
	isPseudo: !1,
	clr: {
		opcodes: "D5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "SP is decremented and D is stored into the memory location pointed to by SP. SP is decremented again and E is stored into the memory location pointed to by SP.",
		instruction: "push de"
	}
}, Vu = {
	mnemonic: "sub",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [214, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "D6",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> from A.",
		instruction: "sub nn"
	}
}, Hu = {
	mnemonic: "sub",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [214, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "D6",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> from A.",
		instruction: "sub nn"
	}
}, Uu = {
	mnemonic: "rst",
	params: ["10"],
	tokens: ["10"],
	opcodes: [215],
	isPseudo: !1,
	clr: {
		opcodes: "D7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 16.",
		instruction: "rst 10"
	}
}, Wu = {
	mnemonic: "ret",
	params: ["c"],
	tokens: ["c"],
	opcodes: [216],
	isPseudo: !1,
	clr: {
		opcodes: "D8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the carry flag is set, the top stack entry is popped into PC.",
		instruction: "ret c"
	}
}, Gu = {
	mnemonic: "exx",
	params: [],
	tokens: [],
	opcodes: [217],
	isPseudo: !1,
	clr: {
		opcodes: "D9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Exchanges the 16-bit contents of BC, DE, and HL with BC', DE', and HL'.",
		instruction: "exx"
	}
}, Ku = {
	mnemonic: "jp",
	params: ["c", "nnnn"],
	tokens: [
		"c",
		",",
		"nnnn"
	],
	opcodes: [218, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "DA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the carry flag is set, <var>nnnn</var> is copied to PC.",
		instruction: "jp c,nnnn"
	}
}, qu = {
	mnemonic: "in",
	params: ["a", "(nn)"],
	tokens: [
		"a",
		",",
		"(",
		"nn",
		")"
	],
	opcodes: [219, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "DB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "A byte from the port whose address is formed by A in the high bits and <var>nn</var> in the low bits is written to A.",
		instruction: "in a,(nn)"
	}
}, Ju = {
	mnemonic: "in",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [219, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "DB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "A byte from the port whose address is formed by A in the high bits and <var>nn</var> in the low bits is written to A.",
		instruction: "in a,(nn)"
	}
}, Yu = {
	mnemonic: "call",
	params: ["c", "nnnn"],
	tokens: [
		"c",
		",",
		"nnnn"
	],
	opcodes: [220, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "DC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the carry flag is set, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call c,nnnn"
	}
}, Xu = {
	mnemonic: "add",
	params: ["ix", "bc"],
	tokens: [
		"ix",
		",",
		"bc"
	],
	opcodes: [221, 9],
	isPseudo: !1,
	clr: {
		opcodes: "DD09",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of BC is added to IX.",
		instruction: "add ix,bc"
	}
}, Zu = {
	mnemonic: "add",
	params: ["ix", "de"],
	tokens: [
		"ix",
		",",
		"de"
	],
	opcodes: [221, 25],
	isPseudo: !1,
	clr: {
		opcodes: "DD19",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of DE is added to IX.",
		instruction: "add ix,de"
	}
}, Qu = {
	mnemonic: "ld",
	params: ["ix", "nnnn"],
	tokens: [
		"ix",
		",",
		"nnnn"
	],
	opcodes: [
		221,
		33,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD21",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Loads <var>nnnn</var> into register IX.",
		instruction: "ld ix,nnnn"
	}
}, $u = {
	mnemonic: "ld",
	params: ["(nnnn)", "ix"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"ix"
	],
	opcodes: [
		221,
		34,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD22",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores IX into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),ix"
	}
}, ed = {
	mnemonic: "inc",
	params: ["ix"],
	tokens: ["ix"],
	opcodes: [221, 35],
	isPseudo: !1,
	clr: {
		opcodes: "DD23",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Adds one to IX.",
		instruction: "inc ix"
	}
}, td = {
	mnemonic: "inc",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 36],
	isPseudo: !1,
	clr: {
		opcodes: "DD24",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to IXH.",
		instruction: "inc ixh"
	}
}, nd = {
	mnemonic: "dec",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 37],
	isPseudo: !1,
	clr: {
		opcodes: "DD25",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from IXH.",
		instruction: "dec ixh"
	}
}, rd = {
	mnemonic: "ld",
	params: ["ixh", "nn"],
	tokens: [
		"ixh",
		",",
		"nn"
	],
	opcodes: [
		221,
		38,
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD26",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into IXH.",
		instruction: "ld ixh,nn"
	}
}, id = {
	mnemonic: "add",
	params: ["ix", "ix"],
	tokens: [
		"ix",
		",",
		"ix"
	],
	opcodes: [221, 41],
	isPseudo: !1,
	clr: {
		opcodes: "DD29",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of IX is added to IX.",
		instruction: "add ix,ix"
	}
}, ad = {
	mnemonic: "ld",
	params: ["ix", "(nnnn)"],
	tokens: [
		"ix",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		221,
		42,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD2A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into IX.",
		instruction: "ld ix,(nnnn)"
	}
}, od = {
	mnemonic: "dec",
	params: ["ix"],
	tokens: ["ix"],
	opcodes: [221, 43],
	isPseudo: !1,
	clr: {
		opcodes: "DD2B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Subtracts one from IX.",
		instruction: "dec ix"
	}
}, sd = {
	mnemonic: "inc",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 44],
	isPseudo: !1,
	clr: {
		opcodes: "DD2C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to IXL.",
		instruction: "inc ixl"
	}
}, cd = {
	mnemonic: "dec",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 45],
	isPseudo: !1,
	clr: {
		opcodes: "DD2D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from IXL.",
		instruction: "dec ixl"
	}
}, ld = {
	mnemonic: "ld",
	params: ["ixl", "nn"],
	tokens: [
		"ixl",
		",",
		"nn"
	],
	opcodes: [
		221,
		46,
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD2E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into IXL.",
		instruction: "ld ixl,nn"
	}
}, ud = {
	mnemonic: "inc",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		52,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD34",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 3,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Adds one to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "inc (ix+dd)"
	}
}, dd = {
	mnemonic: "dec",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		53,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD35",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 3,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Subtracts one from the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "dec (ix+dd)"
	}
}, fd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "nn"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"nn"
	],
	opcodes: [
		221,
		54,
		"dd",
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD36",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores <var>nn</var> to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),nn"
	}
}, pd = {
	mnemonic: "add",
	params: ["ix", "sp"],
	tokens: [
		"ix",
		",",
		"sp"
	],
	opcodes: [221, 57],
	isPseudo: !1,
	clr: {
		opcodes: "DD39",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of SP is added to IX.",
		instruction: "add ix,sp"
	}
}, md = {
	mnemonic: "ld",
	params: ["b", "ixh"],
	tokens: [
		"b",
		",",
		"ixh"
	],
	opcodes: [221, 68],
	isPseudo: !1,
	clr: {
		opcodes: "DD44",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into B.",
		instruction: "ld b,ixh"
	}
}, hd = {
	mnemonic: "ld",
	params: ["b", "ixl"],
	tokens: [
		"b",
		",",
		"ixl"
	],
	opcodes: [221, 69],
	isPseudo: !1,
	clr: {
		opcodes: "DD45",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into B.",
		instruction: "ld b,ixl"
	}
}, gd = {
	mnemonic: "ld",
	params: ["b", "(ix+dd)"],
	tokens: [
		"b",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		70,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD46",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into B.",
		instruction: "ld b,(ix+dd)"
	}
}, _d = {
	mnemonic: "ld",
	params: ["c", "ixh"],
	tokens: [
		"c",
		",",
		"ixh"
	],
	opcodes: [221, 76],
	isPseudo: !1,
	clr: {
		opcodes: "DD4C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into C.",
		instruction: "ld c,ixh"
	}
}, vd = {
	mnemonic: "ld",
	params: ["c", "ixl"],
	tokens: [
		"c",
		",",
		"ixl"
	],
	opcodes: [221, 77],
	isPseudo: !1,
	clr: {
		opcodes: "DD4D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into C.",
		instruction: "ld c,ixl"
	}
}, yd = {
	mnemonic: "ld",
	params: ["c", "(ix+dd)"],
	tokens: [
		"c",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		78,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD4E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into C.",
		instruction: "ld c,(ix+dd)"
	}
}, bd = {
	mnemonic: "ld",
	params: ["d", "ixh"],
	tokens: [
		"d",
		",",
		"ixh"
	],
	opcodes: [221, 84],
	isPseudo: !1,
	clr: {
		opcodes: "DD54",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into D.",
		instruction: "ld d,ixh"
	}
}, xd = {
	mnemonic: "ld",
	params: ["d", "ixl"],
	tokens: [
		"d",
		",",
		"ixl"
	],
	opcodes: [221, 85],
	isPseudo: !1,
	clr: {
		opcodes: "DD55",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into D.",
		instruction: "ld d,ixl"
	}
}, Sd = {
	mnemonic: "ld",
	params: ["d", "(ix+dd)"],
	tokens: [
		"d",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		86,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD56",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into D.",
		instruction: "ld d,(ix+dd)"
	}
}, Cd = {
	mnemonic: "ld",
	params: ["e", "ixh"],
	tokens: [
		"e",
		",",
		"ixh"
	],
	opcodes: [221, 92],
	isPseudo: !1,
	clr: {
		opcodes: "DD5C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into E.",
		instruction: "ld e,ixh"
	}
}, wd = {
	mnemonic: "ld",
	params: ["e", "ixl"],
	tokens: [
		"e",
		",",
		"ixl"
	],
	opcodes: [221, 93],
	isPseudo: !1,
	clr: {
		opcodes: "DD5D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into E.",
		instruction: "ld e,ixl"
	}
}, Td = {
	mnemonic: "ld",
	params: ["e", "(ix+dd)"],
	tokens: [
		"e",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		94,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD5E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into E.",
		instruction: "ld e,(ix+dd)"
	}
}, Ed = {
	mnemonic: "ld",
	params: ["ixh", "b"],
	tokens: [
		"ixh",
		",",
		"b"
	],
	opcodes: [221, 96],
	isPseudo: !1,
	clr: {
		opcodes: "DD60",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into IXH.",
		instruction: "ld ixh,b"
	}
}, Dd = {
	mnemonic: "ld",
	params: ["ixh", "c"],
	tokens: [
		"ixh",
		",",
		"c"
	],
	opcodes: [221, 97],
	isPseudo: !1,
	clr: {
		opcodes: "DD61",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into IXH.",
		instruction: "ld ixh,c"
	}
}, Od = {
	mnemonic: "ld",
	params: ["ixh", "d"],
	tokens: [
		"ixh",
		",",
		"d"
	],
	opcodes: [221, 98],
	isPseudo: !1,
	clr: {
		opcodes: "DD62",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into IXH.",
		instruction: "ld ixh,d"
	}
}, kd = {
	mnemonic: "ld",
	params: ["ixh", "e"],
	tokens: [
		"ixh",
		",",
		"e"
	],
	opcodes: [221, 99],
	isPseudo: !1,
	clr: {
		opcodes: "DD63",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into IXH.",
		instruction: "ld ixh,e"
	}
}, Ad = {
	mnemonic: "ld",
	params: ["ixh", "ixh"],
	tokens: [
		"ixh",
		",",
		"ixh"
	],
	opcodes: [221, 100],
	isPseudo: !1,
	clr: {
		opcodes: "DD64",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into IXH.",
		instruction: "ld ixh,ixh"
	}
}, jd = {
	mnemonic: "ld",
	params: ["ixh", "ixl"],
	tokens: [
		"ixh",
		",",
		"ixl"
	],
	opcodes: [221, 101],
	isPseudo: !1,
	clr: {
		opcodes: "DD65",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into IXH.",
		instruction: "ld ixh,ixl"
	}
}, Md = {
	mnemonic: "ld",
	params: ["h", "(ix+dd)"],
	tokens: [
		"h",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		102,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD66",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into H.",
		instruction: "ld h,(ix+dd)"
	}
}, Nd = {
	mnemonic: "ld",
	params: ["ixh", "a"],
	tokens: [
		"ixh",
		",",
		"a"
	],
	opcodes: [221, 103],
	isPseudo: !1,
	clr: {
		opcodes: "DD67",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into IXH.",
		instruction: "ld ixh,a"
	}
}, Pd = {
	mnemonic: "ld",
	params: ["ixl", "b"],
	tokens: [
		"ixl",
		",",
		"b"
	],
	opcodes: [221, 104],
	isPseudo: !1,
	clr: {
		opcodes: "DD68",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into IXL.",
		instruction: "ld ixl,b"
	}
}, Fd = {
	mnemonic: "ld",
	params: ["ixl", "c"],
	tokens: [
		"ixl",
		",",
		"c"
	],
	opcodes: [221, 105],
	isPseudo: !1,
	clr: {
		opcodes: "DD69",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into IXL.",
		instruction: "ld ixl,c"
	}
}, Id = {
	mnemonic: "ld",
	params: ["ixl", "d"],
	tokens: [
		"ixl",
		",",
		"d"
	],
	opcodes: [221, 106],
	isPseudo: !1,
	clr: {
		opcodes: "DD6A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into IXL.",
		instruction: "ld ixl,d"
	}
}, Ld = {
	mnemonic: "ld",
	params: ["ixl", "e"],
	tokens: [
		"ixl",
		",",
		"e"
	],
	opcodes: [221, 107],
	isPseudo: !1,
	clr: {
		opcodes: "DD6B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into IXL.",
		instruction: "ld ixl,e"
	}
}, Rd = {
	mnemonic: "ld",
	params: ["ixl", "ixh"],
	tokens: [
		"ixl",
		",",
		"ixh"
	],
	opcodes: [221, 108],
	isPseudo: !1,
	clr: {
		opcodes: "DD6C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into IXL.",
		instruction: "ld ixl,ixh"
	}
}, zd = {
	mnemonic: "ld",
	params: ["ixl", "ixl"],
	tokens: [
		"ixl",
		",",
		"ixl"
	],
	opcodes: [221, 109],
	isPseudo: !1,
	clr: {
		opcodes: "DD6D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into IXL.",
		instruction: "ld ixl,ixl"
	}
}, Bd = {
	mnemonic: "ld",
	params: ["l", "(ix+dd)"],
	tokens: [
		"l",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		110,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD6E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into L.",
		instruction: "ld l,(ix+dd)"
	}
}, Vd = {
	mnemonic: "ld",
	params: ["ixl", "a"],
	tokens: [
		"ixl",
		",",
		"a"
	],
	opcodes: [221, 111],
	isPseudo: !1,
	clr: {
		opcodes: "DD6F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into IXL.",
		instruction: "ld ixl,a"
	}
}, Hd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		112,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD70",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores B to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),b"
	}
}, Ud = {
	mnemonic: "ld",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		113,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD71",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores C to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),c"
	}
}, Wd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		114,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD72",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores D to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),d"
	}
}, Gd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		115,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD73",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores E to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),e"
	}
}, Kd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		116,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD74",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores H to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),h"
	}
}, qd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		117,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD75",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores L to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),l"
	}
}, Jd = {
	mnemonic: "ld",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		119,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD77",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores A to the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "ld (ix+dd),a"
	}
}, Yd = {
	mnemonic: "ld",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 124],
	isPseudo: !1,
	clr: {
		opcodes: "DD7C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXH are loaded into A.",
		instruction: "ld a,ixh"
	}
}, Xd = {
	mnemonic: "ld",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 125],
	isPseudo: !1,
	clr: {
		opcodes: "DD7D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IXL are loaded into A.",
		instruction: "ld a,ixl"
	}
}, Zd = {
	mnemonic: "ld",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		126,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD7E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IX plus <var>dd</var> into A.",
		instruction: "ld a,(ix+dd)"
	}
}, Qd = {
	mnemonic: "add",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 132],
	isPseudo: !1,
	clr: {
		opcodes: "DD84",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXH to A.",
		instruction: "add a,ixh"
	}
}, $d = {
	mnemonic: "add",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 132],
	isPseudo: !0,
	clr: {
		opcodes: "DD84",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXH to A.",
		instruction: "add a,ixh"
	}
}, ef = {
	mnemonic: "add",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 133],
	isPseudo: !1,
	clr: {
		opcodes: "DD85",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXL to A.",
		instruction: "add a,ixl"
	}
}, tf = {
	mnemonic: "add",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 133],
	isPseudo: !0,
	clr: {
		opcodes: "DD85",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXL to A.",
		instruction: "add a,ixl"
	}
}, nf = {
	mnemonic: "add",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		134,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IX plus <var>dd</var> to A.",
		instruction: "add a,(ix+dd)"
	}
}, rf = {
	mnemonic: "add",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		134,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DD86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IX plus <var>dd</var> to A.",
		instruction: "add a,(ix+dd)"
	}
}, af = {
	mnemonic: "adc",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 140],
	isPseudo: !1,
	clr: {
		opcodes: "DD8C",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXH and the carry flag to A.",
		instruction: "adc a,ixh"
	}
}, of = {
	mnemonic: "adc",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 140],
	isPseudo: !0,
	clr: {
		opcodes: "DD8C",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXH and the carry flag to A.",
		instruction: "adc a,ixh"
	}
}, sf = {
	mnemonic: "adc",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 141],
	isPseudo: !1,
	clr: {
		opcodes: "DD8D",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXL and the carry flag to A.",
		instruction: "adc a,ixl"
	}
}, cf = {
	mnemonic: "adc",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 141],
	isPseudo: !0,
	clr: {
		opcodes: "DD8D",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IXL and the carry flag to A.",
		instruction: "adc a,ixl"
	}
}, lf = {
	mnemonic: "adc",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		142,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IX plus <var>dd</var> and the carry flag to A.",
		instruction: "adc a,(ix+dd)"
	}
}, uf = {
	mnemonic: "adc",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		142,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DD8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IX plus <var>dd</var> and the carry flag to A.",
		instruction: "adc a,(ix+dd)"
	}
}, df = {
	mnemonic: "sub",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 148],
	isPseudo: !1,
	clr: {
		opcodes: "DD94",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH from A.",
		instruction: "sub ixh"
	}
}, ff = {
	mnemonic: "sub",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 148],
	isPseudo: !0,
	clr: {
		opcodes: "DD94",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH from A.",
		instruction: "sub ixh"
	}
}, pf = {
	mnemonic: "sub",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 149],
	isPseudo: !1,
	clr: {
		opcodes: "DD95",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL from A.",
		instruction: "sub ixl"
	}
}, mf = {
	mnemonic: "sub",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 149],
	isPseudo: !0,
	clr: {
		opcodes: "DD95",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL from A.",
		instruction: "sub ixl"
	}
}, hf = {
	mnemonic: "sub",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		150,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> from A.",
		instruction: "sub (ix+dd)"
	}
}, gf = {
	mnemonic: "sub",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		150,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DD96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> from A.",
		instruction: "sub (ix+dd)"
	}
}, _f = {
	mnemonic: "sbc",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 156],
	isPseudo: !1,
	clr: {
		opcodes: "DD9C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH and the carry flag from A.",
		instruction: "sbc a,ixh"
	}
}, vf = {
	mnemonic: "sbc",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 156],
	isPseudo: !0,
	clr: {
		opcodes: "DD9C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH and the carry flag from A.",
		instruction: "sbc a,ixh"
	}
}, yf = {
	mnemonic: "sbc",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 157],
	isPseudo: !1,
	clr: {
		opcodes: "DD9D",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL and the carry flag from A.",
		instruction: "sbc a,ixl"
	}
}, bf = {
	mnemonic: "sbc",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 157],
	isPseudo: !0,
	clr: {
		opcodes: "DD9D",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL and the carry flag from A.",
		instruction: "sbc a,ixl"
	}
}, xf = {
	mnemonic: "sbc",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		158,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DD9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> and the carry flag from A.",
		instruction: "sbc a,(ix+dd)"
	}
}, Sf = {
	mnemonic: "sbc",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		158,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DD9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> and the carry flag from A.",
		instruction: "sbc a,(ix+dd)"
	}
}, Cf = {
	mnemonic: "and",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 164],
	isPseudo: !1,
	clr: {
		opcodes: "DDA4",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IXH.",
		instruction: "and ixh"
	}
}, wf = {
	mnemonic: "and",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 164],
	isPseudo: !0,
	clr: {
		opcodes: "DDA4",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IXH.",
		instruction: "and ixh"
	}
}, Tf = {
	mnemonic: "and",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 165],
	isPseudo: !1,
	clr: {
		opcodes: "DDA5",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IXL.",
		instruction: "and ixl"
	}
}, Ef = {
	mnemonic: "and",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 165],
	isPseudo: !0,
	clr: {
		opcodes: "DDA5",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IXL.",
		instruction: "and ixl"
	}
}, Df = {
	mnemonic: "and",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		166,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDA6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise AND on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "and (ix+dd)"
	}
}, Of = {
	mnemonic: "and",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		166,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DDA6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise AND on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "and (ix+dd)"
	}
}, kf = {
	mnemonic: "xor",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 172],
	isPseudo: !1,
	clr: {
		opcodes: "DDAC",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IXH.",
		instruction: "xor ixh"
	}
}, Af = {
	mnemonic: "xor",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 172],
	isPseudo: !0,
	clr: {
		opcodes: "DDAC",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IXH.",
		instruction: "xor ixh"
	}
}, jf = {
	mnemonic: "xor",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 173],
	isPseudo: !1,
	clr: {
		opcodes: "DDAD",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IXL.",
		instruction: "xor ixl"
	}
}, Mf = {
	mnemonic: "xor",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 173],
	isPseudo: !0,
	clr: {
		opcodes: "DDAD",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IXL.",
		instruction: "xor ixl"
	}
}, Nf = {
	mnemonic: "xor",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		174,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDAE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise XOR on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "xor (ix+dd)"
	}
}, Pf = {
	mnemonic: "xor",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		174,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DDAE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise XOR on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "xor (ix+dd)"
	}
}, Ff = {
	mnemonic: "or",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 180],
	isPseudo: !1,
	clr: {
		opcodes: "DDB4",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IXH.",
		instruction: "or ixh"
	}
}, If = {
	mnemonic: "or",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 180],
	isPseudo: !0,
	clr: {
		opcodes: "DDB4",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IXH.",
		instruction: "or ixh"
	}
}, Lf = {
	mnemonic: "or",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 181],
	isPseudo: !1,
	clr: {
		opcodes: "DDB5",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IXL.",
		instruction: "or ixl"
	}
}, Rf = {
	mnemonic: "or",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 181],
	isPseudo: !0,
	clr: {
		opcodes: "DDB5",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IXL.",
		instruction: "or ixl"
	}
}, zf = {
	mnemonic: "or",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		182,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDB6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise OR on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "or (ix+dd)"
	}
}, Bf = {
	mnemonic: "or",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		182,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DDB6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise OR on A with the value pointed to by IX plus <var>dd</var>.",
		instruction: "or (ix+dd)"
	}
}, Vf = {
	mnemonic: "cp",
	params: ["ixh"],
	tokens: ["ixh"],
	opcodes: [221, 188],
	isPseudo: !1,
	clr: {
		opcodes: "DDBC",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH from A and affects flags according to the result. A is not modified.",
		instruction: "cp ixh"
	}
}, Hf = {
	mnemonic: "cp",
	params: ["a", "ixh"],
	tokens: [
		"a",
		",",
		"ixh"
	],
	opcodes: [221, 188],
	isPseudo: !0,
	clr: {
		opcodes: "DDBC",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXH from A and affects flags according to the result. A is not modified.",
		instruction: "cp ixh"
	}
}, Uf = {
	mnemonic: "cp",
	params: ["ixl"],
	tokens: ["ixl"],
	opcodes: [221, 189],
	isPseudo: !1,
	clr: {
		opcodes: "DDBD",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL from A and affects flags according to the result. A is not modified.",
		instruction: "cp ixl"
	}
}, Wf = {
	mnemonic: "cp",
	params: ["a", "ixl"],
	tokens: [
		"a",
		",",
		"ixl"
	],
	opcodes: [221, 189],
	isPseudo: !0,
	clr: {
		opcodes: "DDBD",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IXL from A and affects flags according to the result. A is not modified.",
		instruction: "cp ixl"
	}
}, Gf = {
	mnemonic: "cp",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		190,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDBE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp (ix+dd)"
	}
}, Kf = {
	mnemonic: "cp",
	params: ["a", "(ix+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		190,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "DDBE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IX plus <var>dd</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp (ix+dd)"
	}
}, qf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		0
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB00",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in B.",
		instruction: "rlc (ix+dd),b"
	}
}, Jf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		1
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB01",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in C.",
		instruction: "rlc (ix+dd),c"
	}
}, Yf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		2
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB02",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in D.",
		instruction: "rlc (ix+dd),d"
	}
}, Xf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		3
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB03",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in E.",
		instruction: "rlc (ix+dd),e"
	}
}, Zf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		4
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB04",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in H.",
		instruction: "rlc (ix+dd),h"
	}
}, Qf = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		5
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB05",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in L.",
		instruction: "rlc (ix+dd),l"
	}
}, $f = {
	mnemonic: "rlc",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		6
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB06",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc (ix+dd)"
	}
}, ep = {
	mnemonic: "rlc",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		7
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB07",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in A.",
		instruction: "rlc (ix+dd),a"
	}
}, tp = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		8
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB08",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in B.",
		instruction: "rrc (ix+dd),b"
	}
}, np = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		9
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB09",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in C.",
		instruction: "rrc (ix+dd),c"
	}
}, rp = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		10
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in D.",
		instruction: "rrc (ix+dd),d"
	}
}, ip = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		11
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in E.",
		instruction: "rrc (ix+dd),e"
	}
}, ap = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		12
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in H.",
		instruction: "rrc (ix+dd),h"
	}
}, op = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		13
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in L.",
		instruction: "rrc (ix+dd),l"
	}
}, sp = {
	mnemonic: "rrc",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		14
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc (ix+dd)"
	}
}, cp = {
	mnemonic: "rrc",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		15
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB0F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in A.",
		instruction: "rrc (ix+dd),a"
	}
}, lp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		16
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB10",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in B.",
		instruction: "rl (ix+dd),b"
	}
}, up = {
	mnemonic: "rl",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		17
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB11",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in C.",
		instruction: "rl (ix+dd),c"
	}
}, dp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		18
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB12",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in D.",
		instruction: "rl (ix+dd),d"
	}
}, fp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		19
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB13",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in E.",
		instruction: "rl (ix+dd),e"
	}
}, pp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		20
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB14",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in H.",
		instruction: "rl (ix+dd),h"
	}
}, mp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		21
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB15",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in L.",
		instruction: "rl (ix+dd),l"
	}
}, hp = {
	mnemonic: "rl",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		22
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB16",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl (ix+dd)"
	}
}, gp = {
	mnemonic: "rl",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		23
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB17",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in A.",
		instruction: "rl (ix+dd),a"
	}
}, _p = {
	mnemonic: "rr",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		24
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB18",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in B.",
		instruction: "rr (ix+dd),b"
	}
}, vp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		25
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB19",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in C.",
		instruction: "rr (ix+dd),c"
	}
}, yp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		26
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in D.",
		instruction: "rr (ix+dd),d"
	}
}, bp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		27
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in E.",
		instruction: "rr (ix+dd),e"
	}
}, xp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		28
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in H.",
		instruction: "rr (ix+dd),h"
	}
}, Sp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		29
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in L.",
		instruction: "rr (ix+dd),l"
	}
}, Cp = {
	mnemonic: "rr",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		30
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr (ix+dd)"
	}
}, wp = {
	mnemonic: "rr",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		31
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB1F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in A.",
		instruction: "rr (ix+dd),a"
	}
}, Tp = {
	mnemonic: "sla",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		32
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB20",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in B.",
		instruction: "sla (ix+dd),b"
	}
}, Ep = {
	mnemonic: "sla",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		33
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB21",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in C.",
		instruction: "sla (ix+dd),c"
	}
}, Dp = {
	mnemonic: "sla",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		34
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB22",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in D.",
		instruction: "sla (ix+dd),d"
	}
}, Op = {
	mnemonic: "sla",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		35
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB23",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in E.",
		instruction: "sla (ix+dd),e"
	}
}, kp = {
	mnemonic: "sla",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		36
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB24",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in H.",
		instruction: "sla (ix+dd),h"
	}
}, Ap = {
	mnemonic: "sla",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		37
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB25",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in L.",
		instruction: "sla (ix+dd),l"
	}
}, jp = {
	mnemonic: "sla",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		38
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB26",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla (ix+dd)"
	}
}, Mp = {
	mnemonic: "sla",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		39
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB27",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in A.",
		instruction: "sla (ix+dd),a"
	}
}, Np = {
	mnemonic: "sra",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		40
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB28",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in B.",
		instruction: "sra (ix+dd),b"
	}
}, Pp = {
	mnemonic: "sra",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		41
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB29",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in C.",
		instruction: "sra (ix+dd),c"
	}
}, Fp = {
	mnemonic: "sra",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		42
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in D.",
		instruction: "sra (ix+dd),d"
	}
}, Ip = {
	mnemonic: "sra",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		43
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in E.",
		instruction: "sra (ix+dd),e"
	}
}, Lp = {
	mnemonic: "sra",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		44
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in H.",
		instruction: "sra (ix+dd),h"
	}
}, Rp = {
	mnemonic: "sra",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		45
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in L.",
		instruction: "sra (ix+dd),l"
	}
}, zp = {
	mnemonic: "sra",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		46
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra (ix+dd)"
	}
}, Bp = {
	mnemonic: "sra",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		47
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB2F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in A.",
		instruction: "sra (ix+dd),a"
	}
}, Vp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		48
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB30",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in B.",
		instruction: "sll (ix+dd),b"
	}
}, Hp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		49
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB31",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in C.",
		instruction: "sll (ix+dd),c"
	}
}, Up = {
	mnemonic: "sll",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		50
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB32",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in D.",
		instruction: "sll (ix+dd),d"
	}
}, Wp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		51
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB33",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in E.",
		instruction: "sll (ix+dd),e"
	}
}, Gp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		52
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB34",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in H.",
		instruction: "sll (ix+dd),h"
	}
}, Kp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		53
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB35",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in L.",
		instruction: "sll (ix+dd),l"
	}
}, qp = {
	mnemonic: "sll",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		54
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB36",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll (ix+dd)"
	}
}, Jp = {
	mnemonic: "sll",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		55
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB37",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in A.",
		instruction: "sll (ix+dd),a"
	}
}, Yp = {
	mnemonic: "srl",
	params: ["(ix+dd)", "b"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		56
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB38",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in B.",
		instruction: "srl (ix+dd),b"
	}
}, Xp = {
	mnemonic: "srl",
	params: ["(ix+dd)", "c"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		57
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB39",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in C.",
		instruction: "srl (ix+dd),c"
	}
}, Zp = {
	mnemonic: "srl",
	params: ["(ix+dd)", "d"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		58
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in D.",
		instruction: "srl (ix+dd),d"
	}
}, Qp = {
	mnemonic: "srl",
	params: ["(ix+dd)", "e"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		59
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in E.",
		instruction: "srl (ix+dd),e"
	}
}, $p = {
	mnemonic: "srl",
	params: ["(ix+dd)", "h"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		60
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in H.",
		instruction: "srl (ix+dd),h"
	}
}, em = {
	mnemonic: "srl",
	params: ["(ix+dd)", "l"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		61
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in L.",
		instruction: "srl (ix+dd),l"
	}
}, tm = {
	mnemonic: "srl",
	params: ["(ix+dd)"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		62
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl (ix+dd)"
	}
}, nm = {
	mnemonic: "srl",
	params: ["(ix+dd)", "a"],
	tokens: [
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		63
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB3F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IX plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in A.",
		instruction: "srl (ix+dd),a"
	}
}, L = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		70
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB46",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, R = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		78
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB4E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, z = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		86
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB56",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, B = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		94
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB5E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, V = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		102
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB66",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, H = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		110
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB6E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, U = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		118
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB76",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, W = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		126
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB7E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, rm = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		128
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB80",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 0,(ix+dd),b"
	}
}, im = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		129
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB81",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 0,(ix+dd),c"
	}
}, am = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		130
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB82",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 0,(ix+dd),d"
	}
}, om = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		131
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB83",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 0,(ix+dd),e"
	}
}, sm = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		132
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB84",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 0,(ix+dd),h"
	}
}, cm = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		133
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB85",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 0,(ix+dd),l"
	}
}, lm = {
	mnemonic: "res",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		134
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB86",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 0,(ix+dd)"
	}
}, um = {
	mnemonic: "res",
	params: [
		"0",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		135
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB87",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 0,(ix+dd),a"
	}
}, dm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		136
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB88",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 1,(ix+dd),b"
	}
}, fm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		137
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB89",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 1,(ix+dd),c"
	}
}, pm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		138
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 1,(ix+dd),d"
	}
}, mm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		139
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 1,(ix+dd),e"
	}
}, hm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		140
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 1,(ix+dd),h"
	}
}, gm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		141
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 1,(ix+dd),l"
	}
}, _m = {
	mnemonic: "res",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		142
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 1,(ix+dd)"
	}
}, vm = {
	mnemonic: "res",
	params: [
		"1",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		143
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB8F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 1,(ix+dd),a"
	}
}, ym = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		144
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB90",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 2,(ix+dd),b"
	}
}, bm = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		145
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB91",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 2,(ix+dd),c"
	}
}, xm = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		146
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB92",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 2,(ix+dd),d"
	}
}, Sm = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		147
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB93",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 2,(ix+dd),e"
	}
}, Cm = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		148
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB94",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 2,(ix+dd),h"
	}
}, wm = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		149
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB95",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 2,(ix+dd),l"
	}
}, Tm = {
	mnemonic: "res",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		150
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB96",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 2,(ix+dd)"
	}
}, Em = {
	mnemonic: "res",
	params: [
		"2",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		151
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB97",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 2,(ix+dd),a"
	}
}, Dm = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		152
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB98",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 3,(ix+dd),b"
	}
}, Om = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		153
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB99",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 3,(ix+dd),c"
	}
}, km = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		154
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 3,(ix+dd),d"
	}
}, Am = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		155
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 3,(ix+dd),e"
	}
}, jm = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		156
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 3,(ix+dd),h"
	}
}, Mm = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		157
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 3,(ix+dd),l"
	}
}, Nm = {
	mnemonic: "res",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		158
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 3,(ix+dd)"
	}
}, Pm = {
	mnemonic: "res",
	params: [
		"3",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		159
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCB9F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 3,(ix+dd),a"
	}
}, Fm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		160
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 4,(ix+dd),b"
	}
}, Im = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		161
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 4,(ix+dd),c"
	}
}, Lm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		162
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 4,(ix+dd),d"
	}
}, Rm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		163
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 4,(ix+dd),e"
	}
}, zm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		164
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 4,(ix+dd),h"
	}
}, Bm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		165
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 4,(ix+dd),l"
	}
}, Vm = {
	mnemonic: "res",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		166
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 4,(ix+dd)"
	}
}, Hm = {
	mnemonic: "res",
	params: [
		"4",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		167
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 4,(ix+dd),a"
	}
}, Um = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		168
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 5,(ix+dd),b"
	}
}, Wm = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		169
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBA9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 5,(ix+dd),c"
	}
}, Gm = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		170
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 5,(ix+dd),d"
	}
}, Km = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		171
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 5,(ix+dd),e"
	}
}, qm = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		172
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 5,(ix+dd),h"
	}
}, Jm = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		173
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 5,(ix+dd),l"
	}
}, Ym = {
	mnemonic: "res",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		174
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 5,(ix+dd)"
	}
}, Xm = {
	mnemonic: "res",
	params: [
		"5",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		175
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBAF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 5,(ix+dd),a"
	}
}, Zm = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		176
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 6,(ix+dd),b"
	}
}, Qm = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		177
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 6,(ix+dd),c"
	}
}, $m = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		178
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 6,(ix+dd),d"
	}
}, eh = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		179
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 6,(ix+dd),e"
	}
}, th = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		180
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 6,(ix+dd),h"
	}
}, nh = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		181
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 6,(ix+dd),l"
	}
}, rh = {
	mnemonic: "res",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		182
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 6,(ix+dd)"
	}
}, ih = {
	mnemonic: "res",
	params: [
		"6",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		183
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 6,(ix+dd),a"
	}
}, ah = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		184
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 7,(ix+dd),b"
	}
}, oh = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		185
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBB9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 7,(ix+dd),c"
	}
}, sh = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		186
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 7,(ix+dd),d"
	}
}, ch = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		187
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 7,(ix+dd),e"
	}
}, lh = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		188
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 7,(ix+dd),h"
	}
}, uh = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		189
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 7,(ix+dd),l"
	}
}, dh = {
	mnemonic: "res",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		190
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "res 7,(ix+dd)"
	}
}, fh = {
	mnemonic: "res",
	params: [
		"7",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		191
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBBF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 7,(ix+dd),a"
	}
}, ph = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		192
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 0,(ix+dd),b"
	}
}, mh = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		193
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 0,(ix+dd),c"
	}
}, hh = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		194
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 0,(ix+dd),d"
	}
}, gh = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		195
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 0,(ix+dd),e"
	}
}, _h = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		196
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 0,(ix+dd),h"
	}
}, vh = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		197
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 0,(ix+dd),l"
	}
}, yh = {
	mnemonic: "set",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		198
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 0,(ix+dd)"
	}
}, bh = {
	mnemonic: "set",
	params: [
		"0",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		199
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 0,(ix+dd),a"
	}
}, xh = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		200
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 1,(ix+dd),b"
	}
}, Sh = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		201
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBC9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 1,(ix+dd),c"
	}
}, Ch = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		202
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 1,(ix+dd),d"
	}
}, wh = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		203
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 1,(ix+dd),e"
	}
}, Th = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		204
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 1,(ix+dd),h"
	}
}, Eh = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		205
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 1,(ix+dd),l"
	}
}, Dh = {
	mnemonic: "set",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		206
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 1,(ix+dd)"
	}
}, Oh = {
	mnemonic: "set",
	params: [
		"1",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		207
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBCF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 1,(ix+dd),a"
	}
}, kh = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		208
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 2,(ix+dd),b"
	}
}, Ah = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		209
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 2,(ix+dd),c"
	}
}, jh = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		210
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 2,(ix+dd),d"
	}
}, Mh = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		211
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 2,(ix+dd),e"
	}
}, Nh = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		212
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 2,(ix+dd),h"
	}
}, Ph = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		213
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 2,(ix+dd),l"
	}
}, Fh = {
	mnemonic: "set",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		214
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 2,(ix+dd)"
	}
}, Ih = {
	mnemonic: "set",
	params: [
		"2",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		215
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 2,(ix+dd),a"
	}
}, Lh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		216
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 3,(ix+dd),b"
	}
}, Rh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		217
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBD9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 3,(ix+dd),c"
	}
}, zh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		218
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 3,(ix+dd),d"
	}
}, Bh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		219
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 3,(ix+dd),e"
	}
}, Vh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		220
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 3,(ix+dd),h"
	}
}, Hh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		221
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 3,(ix+dd),l"
	}
}, Uh = {
	mnemonic: "set",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		222
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 3,(ix+dd)"
	}
}, Wh = {
	mnemonic: "set",
	params: [
		"3",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		223
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBDF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 3,(ix+dd),a"
	}
}, Gh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		224
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 4,(ix+dd),b"
	}
}, Kh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		225
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 4,(ix+dd),c"
	}
}, qh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		226
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 4,(ix+dd),d"
	}
}, Jh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		227
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 4,(ix+dd),e"
	}
}, Yh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		228
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 4,(ix+dd),h"
	}
}, Xh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		229
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 4,(ix+dd),l"
	}
}, Zh = {
	mnemonic: "set",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		230
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 4,(ix+dd)"
	}
}, Qh = {
	mnemonic: "set",
	params: [
		"4",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		231
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 4,(ix+dd),a"
	}
}, $h = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		232
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 5,(ix+dd),b"
	}
}, eg = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		233
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBE9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 5,(ix+dd),c"
	}
}, tg = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		234
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBEA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 5,(ix+dd),d"
	}
}, ng = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		235
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBEB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 5,(ix+dd),e"
	}
}, rg = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		236
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBEC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 5,(ix+dd),h"
	}
}, ig = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		237
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBED",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 5,(ix+dd),l"
	}
}, ag = {
	mnemonic: "set",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		238
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBEE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 5,(ix+dd)"
	}
}, og = {
	mnemonic: "set",
	params: [
		"5",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		239
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBEF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 5,(ix+dd),a"
	}
}, sg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		240
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 6,(ix+dd),b"
	}
}, cg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		241
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 6,(ix+dd),c"
	}
}, lg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		242
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 6,(ix+dd),d"
	}
}, ug = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		243
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 6,(ix+dd),e"
	}
}, dg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		244
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 6,(ix+dd),h"
	}
}, fg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		245
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 6,(ix+dd),l"
	}
}, pg = {
	mnemonic: "set",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		246
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 6,(ix+dd)"
	}
}, mg = {
	mnemonic: "set",
	params: [
		"6",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		247
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 6,(ix+dd),a"
	}
}, hg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"b"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		221,
		203,
		"dd",
		248
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 7,(ix+dd),b"
	}
}, gg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"c"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		221,
		203,
		"dd",
		249
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBF9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 7,(ix+dd),c"
	}
}, _g = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"d"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		221,
		203,
		"dd",
		250
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 7,(ix+dd),d"
	}
}, vg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"e"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		221,
		203,
		"dd",
		251
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 7,(ix+dd),e"
	}
}, yg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"h"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		221,
		203,
		"dd",
		252
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 7,(ix+dd),h"
	}
}, bg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"l"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		221,
		203,
		"dd",
		253
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 7,(ix+dd),l"
	}
}, xg = {
	mnemonic: "set",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		254
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "set 7,(ix+dd)"
	}
}, Sg = {
	mnemonic: "set",
	params: [
		"7",
		"(ix+dd)",
		"a"
	],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		221,
		203,
		"dd",
		255
	],
	isPseudo: !1,
	clr: {
		opcodes: "DDCBFF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IX plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 7,(ix+dd),a"
	}
}, Cg = {
	mnemonic: "pop",
	params: ["ix"],
	tokens: ["ix"],
	opcodes: [221, 225],
	isPseudo: !1,
	clr: {
		opcodes: "DDE1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "The memory location pointed to by SP is stored into IXL and SP is incremented. The memory location pointed to by SP is stored into IXH and SP is incremented again.",
		instruction: "pop ix"
	}
}, wg = {
	mnemonic: "ex",
	params: ["(sp)", "ix"],
	tokens: [
		"(",
		"sp",
		")",
		",",
		"ix"
	],
	opcodes: [221, 227],
	isPseudo: !1,
	clr: {
		opcodes: "DDE3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Exchanges (SP) with IXL, and (SP+1) with IXH.",
		instruction: "ex (sp),ix"
	}
}, Tg = {
	mnemonic: "ex",
	params: ["ix", "(sp)"],
	tokens: [
		"ix",
		",",
		"(",
		"sp",
		")"
	],
	opcodes: [221, 227],
	isPseudo: !0,
	clr: {
		opcodes: "DDE3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Exchanges (SP) with IXL, and (SP+1) with IXH.",
		instruction: "ex (sp),ix"
	}
}, Eg = {
	mnemonic: "push",
	params: ["ix"],
	tokens: ["ix"],
	opcodes: [221, 229],
	isPseudo: !1,
	clr: {
		opcodes: "DDE5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "SP is decremented and IXH is stored into the memory location pointed to by SP. SP is decremented again and IXL is stored into the memory location pointed to by SP.",
		instruction: "push ix"
	}
}, Dg = {
	mnemonic: "jp",
	params: ["(ix)"],
	tokens: [
		"(",
		"ix",
		")"
	],
	opcodes: [221, 233],
	isPseudo: !1,
	clr: {
		opcodes: "DDE9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Loads the value of IX into PC.",
		instruction: "jp (ix)"
	}
}, Og = {
	mnemonic: "jp",
	params: ["ix"],
	tokens: ["ix"],
	opcodes: [221, 233],
	isPseudo: !0,
	clr: {
		opcodes: "DDE9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Loads the value of IX into PC.",
		instruction: "jp (ix)"
	}
}, kg = {
	mnemonic: "ld",
	params: ["sp", "ix"],
	tokens: [
		"sp",
		",",
		"ix"
	],
	opcodes: [221, 249],
	isPseudo: !1,
	clr: {
		opcodes: "DDF9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads the value of IX into SP.",
		instruction: "ld sp,ix"
	}
}, Ag = {
	mnemonic: "sbc",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [222, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "DE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> and the carry flag from A.",
		instruction: "sbc a,nn"
	}
}, jg = {
	mnemonic: "sbc",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [222, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "DE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> and the carry flag from A.",
		instruction: "sbc a,nn"
	}
}, Mg = {
	mnemonic: "rst",
	params: ["18"],
	tokens: ["18"],
	opcodes: [223],
	isPseudo: !1,
	clr: {
		opcodes: "DF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 24.",
		instruction: "rst 18"
	}
}, Ng = {
	mnemonic: "ret",
	params: ["po"],
	tokens: ["po"],
	opcodes: [224],
	isPseudo: !1,
	clr: {
		opcodes: "E0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the parity/overflow flag is unset, the top stack entry is popped into PC.",
		instruction: "ret po"
	}
}, Pg = {
	mnemonic: "ret",
	params: ["nv"],
	tokens: ["nv"],
	opcodes: [224],
	isPseudo: !0,
	clr: {
		opcodes: "E0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the parity/overflow flag is unset, the top stack entry is popped into PC.",
		instruction: "ret po"
	}
}, Fg = {
	mnemonic: "pop",
	params: ["hl"],
	tokens: ["hl"],
	opcodes: [225],
	isPseudo: !1,
	clr: {
		opcodes: "E1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "The memory location pointed to by SP is stored into L and SP is incremented. The memory location pointed to by SP is stored into H and SP is incremented again.",
		instruction: "pop hl"
	}
}, Ig = {
	mnemonic: "jp",
	params: ["po", "nnnn"],
	tokens: [
		"po",
		",",
		"nnnn"
	],
	opcodes: [226, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "E2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is unset, <var>nnnn</var> is copied to PC.",
		instruction: "jp po,nnnn"
	}
}, Lg = {
	mnemonic: "jp",
	params: ["nv", "nnnn"],
	tokens: [
		"nv",
		",",
		"nnnn"
	],
	opcodes: [226, "nnnn"],
	isPseudo: !0,
	clr: {
		opcodes: "E2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is unset, <var>nnnn</var> is copied to PC.",
		instruction: "jp po,nnnn"
	}
}, Rg = {
	mnemonic: "ex",
	params: ["(sp)", "hl"],
	tokens: [
		"(",
		"sp",
		")",
		",",
		"hl"
	],
	opcodes: [227],
	isPseudo: !1,
	clr: {
		opcodes: "E3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Exchanges (SP) with L, and (SP+1) with H.",
		instruction: "ex (sp),hl"
	}
}, zg = {
	mnemonic: "ex",
	params: ["hl", "(sp)"],
	tokens: [
		"hl",
		",",
		"(",
		"sp",
		")"
	],
	opcodes: [227],
	isPseudo: !0,
	clr: {
		opcodes: "E3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Exchanges (SP) with L, and (SP+1) with H.",
		instruction: "ex (sp),hl"
	}
}, Bg = {
	mnemonic: "call",
	params: ["po", "nnnn"],
	tokens: [
		"po",
		",",
		"nnnn"
	],
	opcodes: [228, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "E4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is unset, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call po,nnnn"
	}
}, Vg = {
	mnemonic: "call",
	params: ["nv", "nnnn"],
	tokens: [
		"nv",
		",",
		"nnnn"
	],
	opcodes: [228, "nnnn"],
	isPseudo: !0,
	clr: {
		opcodes: "E4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is unset, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call po,nnnn"
	}
}, Hg = {
	mnemonic: "push",
	params: ["hl"],
	tokens: ["hl"],
	opcodes: [229],
	isPseudo: !1,
	clr: {
		opcodes: "E5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "SP is decremented and H is stored into the memory location pointed to by SP. SP is decremented again and L is stored into the memory location pointed to by SP.",
		instruction: "push hl"
	}
}, Ug = {
	mnemonic: "and",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [230, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "E6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise AND on A with <var>nn</var>.",
		instruction: "and nn"
	}
}, Wg = {
	mnemonic: "and",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [230, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "E6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise AND on A with <var>nn</var>.",
		instruction: "and nn"
	}
}, Gg = {
	mnemonic: "rst",
	params: ["20"],
	tokens: ["20"],
	opcodes: [231],
	isPseudo: !1,
	clr: {
		opcodes: "E7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 32.",
		instruction: "rst 20"
	}
}, Kg = {
	mnemonic: "ret",
	params: ["pe"],
	tokens: ["pe"],
	opcodes: [232],
	isPseudo: !1,
	clr: {
		opcodes: "E8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the parity/overflow flag is set, the top stack entry is popped into PC.",
		instruction: "ret pe"
	}
}, qg = {
	mnemonic: "ret",
	params: ["v"],
	tokens: ["v"],
	opcodes: [232],
	isPseudo: !0,
	clr: {
		opcodes: "E8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the parity/overflow flag is set, the top stack entry is popped into PC.",
		instruction: "ret pe"
	}
}, Jg = {
	mnemonic: "jp",
	params: ["(hl)"],
	tokens: [
		"(",
		"hl",
		")"
	],
	opcodes: [233],
	isPseudo: !1,
	clr: {
		opcodes: "E9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Loads the value of HL into PC.",
		instruction: "jp (hl)"
	}
}, Yg = {
	mnemonic: "jp",
	params: ["hl"],
	tokens: ["hl"],
	opcodes: [233],
	isPseudo: !0,
	clr: {
		opcodes: "E9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Loads the value of HL into PC.",
		instruction: "jp (hl)"
	}
}, Xg = {
	mnemonic: "jp",
	params: ["pe", "nnnn"],
	tokens: [
		"pe",
		",",
		"nnnn"
	],
	opcodes: [234, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "EA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is set, <var>nnnn</var> is copied to PC.",
		instruction: "jp pe,nnnn"
	}
}, Zg = {
	mnemonic: "jp",
	params: ["v", "nnnn"],
	tokens: [
		"v",
		",",
		"nnnn"
	],
	opcodes: [234, "nnnn"],
	isPseudo: !0,
	clr: {
		opcodes: "EA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is set, <var>nnnn</var> is copied to PC.",
		instruction: "jp pe,nnnn"
	}
}, Qg = {
	mnemonic: "ex",
	params: ["de", "hl"],
	tokens: [
		"de",
		",",
		"hl"
	],
	opcodes: [235],
	isPseudo: !1,
	clr: {
		opcodes: "EB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Exchanges the 16-bit contents of DE and HL.",
		instruction: "ex de,hl"
	}
}, $g = {
	mnemonic: "ex",
	params: ["hl", "de"],
	tokens: [
		"hl",
		",",
		"de"
	],
	opcodes: [235],
	isPseudo: !0,
	clr: {
		opcodes: "EB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Exchanges the 16-bit contents of DE and HL.",
		instruction: "ex de,hl"
	}
}, e_ = {
	mnemonic: "call",
	params: ["pe", "nnnn"],
	tokens: [
		"pe",
		",",
		"nnnn"
	],
	opcodes: [236, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "EC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is set, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call pe,nnnn"
	}
}, t_ = {
	mnemonic: "call",
	params: ["v", "nnnn"],
	tokens: [
		"v",
		",",
		"nnnn"
	],
	opcodes: [236, "nnnn"],
	isPseudo: !0,
	clr: {
		opcodes: "EC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the parity/overflow flag is set, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call pe,nnnn"
	}
}, n_ = {
	mnemonic: "in",
	params: ["b", "(c)"],
	tokens: [
		"b",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 64],
	isPseudo: !1,
	clr: {
		opcodes: "ED40",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to B.",
		instruction: "in b,(c)"
	}
}, r_ = {
	mnemonic: "in",
	params: ["b", "(bc)"],
	tokens: [
		"b",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 64],
	isPseudo: !0,
	clr: {
		opcodes: "ED40",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to B.",
		instruction: "in b,(c)"
	}
}, i_ = {
	mnemonic: "out",
	params: ["(c)", "b"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"b"
	],
	opcodes: [237, 65],
	isPseudo: !1,
	clr: {
		opcodes: "ED41",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of B is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),b"
	}
}, a_ = {
	mnemonic: "out",
	params: ["(bc)", "b"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"b"
	],
	opcodes: [237, 65],
	isPseudo: !0,
	clr: {
		opcodes: "ED41",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of B is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),b"
	}
}, o_ = {
	mnemonic: "sbc",
	params: ["hl", "bc"],
	tokens: [
		"hl",
		",",
		"bc"
	],
	opcodes: [237, 66],
	isPseudo: !1,
	clr: {
		opcodes: "ED42",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Subtracts BC and the carry flag from HL.",
		instruction: "sbc hl,bc"
	}
}, s_ = {
	mnemonic: "ld",
	params: ["(nnnn)", "bc"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"bc"
	],
	opcodes: [
		237,
		67,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED43",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores BC into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),bc"
	}
}, G = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 68],
	isPseudo: !1,
	clr: {
		opcodes: "ED44",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, c_ = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 69],
	isPseudo: !1,
	clr: {
		opcodes: "ED45",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, l_ = {
	mnemonic: "im",
	params: ["0"],
	tokens: ["0"],
	opcodes: [237, 70],
	isPseudo: !1,
	clr: {
		opcodes: "ED46",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 0.",
		instruction: "im 0"
	}
}, u_ = {
	mnemonic: "ld",
	params: ["i", "a"],
	tokens: [
		"i",
		",",
		"a"
	],
	opcodes: [237, 71],
	isPseudo: !1,
	clr: {
		opcodes: "ED47",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 9,
		without_jump_clock_count: 9,
		description: "Stores the value of A into register I.",
		instruction: "ld i,a"
	}
}, d_ = {
	mnemonic: "in",
	params: ["c", "(c)"],
	tokens: [
		"c",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 72],
	isPseudo: !1,
	clr: {
		opcodes: "ED48",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to C.",
		instruction: "in c,(c)"
	}
}, f_ = {
	mnemonic: "in",
	params: ["c", "(bc)"],
	tokens: [
		"bc",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 72],
	isPseudo: !0,
	clr: {
		opcodes: "ED48",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to C.",
		instruction: "in c,(c)"
	}
}, p_ = {
	mnemonic: "out",
	params: ["(c)", "c"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"c"
	],
	opcodes: [237, 73],
	isPseudo: !1,
	clr: {
		opcodes: "ED49",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of C is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),c"
	}
}, m_ = {
	mnemonic: "out",
	params: ["(bc)", "c"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"bc"
	],
	opcodes: [237, 73],
	isPseudo: !0,
	clr: {
		opcodes: "ED49",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of C is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),c"
	}
}, h_ = {
	mnemonic: "adc",
	params: ["hl", "bc"],
	tokens: [
		"hl",
		",",
		"bc"
	],
	opcodes: [237, 74],
	isPseudo: !1,
	clr: {
		opcodes: "ED4A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Adds BC and the carry flag to HL.",
		instruction: "adc hl,bc"
	}
}, g_ = {
	mnemonic: "ld",
	params: ["bc", "(nnnn)"],
	tokens: [
		"bc",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		237,
		75,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED4B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into BC.",
		instruction: "ld bc,(nnnn)"
	}
}, __ = {
	mnemonic: "reti",
	params: [],
	tokens: [],
	opcodes: [237, 77],
	isPseudo: !1,
	clr: {
		opcodes: "ED4D",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a maskable interrupt service routine. The top stack entry is popped into PC, and signals an I/O device that the interrupt has finished, allowing nested interrupts (not a consideration on the TI).",
		instruction: "reti"
	}
}, v_ = {
	mnemonic: "ld",
	params: ["r", "a"],
	tokens: [
		"r",
		",",
		"a"
	],
	opcodes: [237, 79],
	isPseudo: !1,
	clr: {
		opcodes: "ED4F",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 9,
		without_jump_clock_count: 9,
		description: "Stores the value of A into register R.",
		instruction: "ld r,a"
	}
}, y_ = {
	mnemonic: "in",
	params: ["d", "(c)"],
	tokens: [
		"d",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 80],
	isPseudo: !1,
	clr: {
		opcodes: "ED50",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to D.",
		instruction: "in d,(c)"
	}
}, b_ = {
	mnemonic: "in",
	params: ["d", "(bc)"],
	tokens: [
		"d",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 80],
	isPseudo: !0,
	clr: {
		opcodes: "ED50",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to D.",
		instruction: "in d,(c)"
	}
}, x_ = {
	mnemonic: "out",
	params: ["(c)", "d"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"d"
	],
	opcodes: [237, 81],
	isPseudo: !1,
	clr: {
		opcodes: "ED51",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of D is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),d"
	}
}, S_ = {
	mnemonic: "out",
	params: ["(bc)", "d"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"d"
	],
	opcodes: [237, 81],
	isPseudo: !0,
	clr: {
		opcodes: "ED51",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of D is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),d"
	}
}, C_ = {
	mnemonic: "sbc",
	params: ["hl", "de"],
	tokens: [
		"hl",
		",",
		"de"
	],
	opcodes: [237, 82],
	isPseudo: !1,
	clr: {
		opcodes: "ED52",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Subtracts DE and the carry flag from HL.",
		instruction: "sbc hl,de"
	}
}, w_ = {
	mnemonic: "ld",
	params: ["(nnnn)", "de"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"de"
	],
	opcodes: [
		237,
		83,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED53",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores DE into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),de"
	}
}, T_ = {
	mnemonic: "im",
	params: ["1"],
	tokens: ["1"],
	opcodes: [237, 86],
	isPseudo: !1,
	clr: {
		opcodes: "ED56",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 1.",
		instruction: "im 1"
	}
}, E_ = {
	mnemonic: "ld",
	params: ["a", "i"],
	tokens: [
		"a",
		",",
		"i"
	],
	opcodes: [237, 87],
	isPseudo: !1,
	clr: {
		opcodes: "ED57",
		undocumented: !1,
		z180: !1,
		flags: "-0*0++",
		byte_count: 2,
		with_jump_clock_count: 9,
		without_jump_clock_count: 9,
		description: "Stores the value of register I into A.",
		instruction: "ld a,i"
	}
}, D_ = {
	mnemonic: "in",
	params: ["e", "(c)"],
	tokens: [
		"e",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 88],
	isPseudo: !1,
	clr: {
		opcodes: "ED58",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to E.",
		instruction: "in e,(c)"
	}
}, O_ = {
	mnemonic: "in",
	params: ["e", "(bc)"],
	tokens: [
		"e",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 88],
	isPseudo: !0,
	clr: {
		opcodes: "ED58",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to E.",
		instruction: "in e,(c)"
	}
}, k_ = {
	mnemonic: "out",
	params: ["(c)", "e"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"e"
	],
	opcodes: [237, 89],
	isPseudo: !1,
	clr: {
		opcodes: "ED59",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of E is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),e"
	}
}, A_ = {
	mnemonic: "out",
	params: ["(bc)", "e"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"e"
	],
	opcodes: [237, 89],
	isPseudo: !0,
	clr: {
		opcodes: "ED59",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of E is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),e"
	}
}, j_ = {
	mnemonic: "adc",
	params: ["hl", "de"],
	tokens: [
		"hl",
		",",
		"de"
	],
	opcodes: [237, 90],
	isPseudo: !1,
	clr: {
		opcodes: "ED5A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Adds DE and the carry flag to HL.",
		instruction: "adc hl,de"
	}
}, M_ = {
	mnemonic: "ld",
	params: ["de", "(nnnn)"],
	tokens: [
		"de",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		237,
		91,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED5B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into DE.",
		instruction: "ld de,(nnnn)"
	}
}, N_ = {
	mnemonic: "im",
	params: ["2"],
	tokens: ["2"],
	opcodes: [237, 94],
	isPseudo: !1,
	clr: {
		opcodes: "ED5E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 2.",
		instruction: "im 2"
	}
}, P_ = {
	mnemonic: "ld",
	params: ["a", "r"],
	tokens: [
		"a",
		",",
		"r"
	],
	opcodes: [237, 95],
	isPseudo: !1,
	clr: {
		opcodes: "ED5F",
		undocumented: !1,
		z180: !1,
		flags: "-0*0++",
		byte_count: 2,
		with_jump_clock_count: 9,
		without_jump_clock_count: 9,
		description: "Stores the value of register R into A.",
		instruction: "ld a,r"
	}
}, F_ = {
	mnemonic: "in",
	params: ["h", "(c)"],
	tokens: [
		"h",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 96],
	isPseudo: !1,
	clr: {
		opcodes: "ED60",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to H.",
		instruction: "in h,(c)"
	}
}, I_ = {
	mnemonic: "in",
	params: ["h", "(bc)"],
	tokens: [
		"h",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 96],
	isPseudo: !0,
	clr: {
		opcodes: "ED60",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to H.",
		instruction: "in h,(c)"
	}
}, L_ = {
	mnemonic: "out",
	params: ["(c)", "h"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"h"
	],
	opcodes: [237, 97],
	isPseudo: !1,
	clr: {
		opcodes: "ED61",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of H is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),h"
	}
}, R_ = {
	mnemonic: "out",
	params: ["(bc)", "h"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"h"
	],
	opcodes: [237, 97],
	isPseudo: !0,
	clr: {
		opcodes: "ED61",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of H is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),h"
	}
}, z_ = {
	mnemonic: "sbc",
	params: ["hl", "hl"],
	tokens: [
		"hl",
		",",
		"hl"
	],
	opcodes: [237, 98],
	isPseudo: !1,
	clr: {
		opcodes: "ED62",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Subtracts HL and the carry flag from HL.",
		instruction: "sbc hl,hl"
	}
}, B_ = {
	mnemonic: "rrd",
	params: [],
	tokens: [],
	opcodes: [237, 103],
	isPseudo: !1,
	clr: {
		opcodes: "ED67",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 18,
		without_jump_clock_count: 18,
		description: "The contents of the low-order nibble of (HL) are copied to the low-order nibble of A. The previous contents are copied to the high-order nibble of (HL). The previous contents are copied to the low-order nibble of (HL).",
		instruction: "rrd"
	}
}, V_ = {
	mnemonic: "in",
	params: ["l", "(c)"],
	tokens: [
		"l",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 104],
	isPseudo: !1,
	clr: {
		opcodes: "ED68",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to L.",
		instruction: "in l,(c)"
	}
}, H_ = {
	mnemonic: "in",
	params: ["l", "(bc)"],
	tokens: [
		"l",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 104],
	isPseudo: !0,
	clr: {
		opcodes: "ED68",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to L.",
		instruction: "in l,(c)"
	}
}, U_ = {
	mnemonic: "out",
	params: ["(c)", "l"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"l"
	],
	opcodes: [237, 105],
	isPseudo: !1,
	clr: {
		opcodes: "ED69",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of L is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),l"
	}
}, W_ = {
	mnemonic: "out",
	params: ["(bc)", "l"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"l"
	],
	opcodes: [237, 105],
	isPseudo: !0,
	clr: {
		opcodes: "ED69",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of L is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),l"
	}
}, G_ = {
	mnemonic: "adc",
	params: ["hl", "hl"],
	tokens: [
		"hl",
		",",
		"hl"
	],
	opcodes: [237, 106],
	isPseudo: !1,
	clr: {
		opcodes: "ED6A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Adds HL and the carry flag to HL.",
		instruction: "adc hl,hl"
	}
}, K_ = {
	mnemonic: "rld",
	params: [],
	tokens: [],
	opcodes: [237, 111],
	isPseudo: !1,
	clr: {
		opcodes: "ED6F",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 18,
		without_jump_clock_count: 18,
		description: "The contents of the low-order nibble of (HL) are copied to the high-order nibble of (HL). The previous contents are copied to the low-order nibble of A. The previous contents are copied to the low-order nibble of (HL).",
		instruction: "rld"
	}
}, q_ = {
	mnemonic: "in",
	params: ["(c)"],
	tokens: [
		"(",
		"c",
		")"
	],
	opcodes: [237, 112],
	isPseudo: !1,
	clr: {
		opcodes: "ED70",
		undocumented: !0,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Inputs a byte from the port at the 16-bit address contained in the BC register pair and affects flags only.",
		instruction: "in (c)"
	}
}, J_ = {
	mnemonic: "in",
	params: ["(bc)"],
	tokens: [
		"(",
		"bc",
		")"
	],
	opcodes: [237, 112],
	isPseudo: !0,
	clr: {
		opcodes: "ED70",
		undocumented: !0,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Inputs a byte from the port at the 16-bit address contained in the BC register pair and affects flags only.",
		instruction: "in (c)"
	}
}, Y_ = {
	mnemonic: "out",
	params: ["(c)", "0"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"0"
	],
	opcodes: [237, 113],
	isPseudo: !1,
	clr: {
		opcodes: "ED71",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Outputs a zero (on NMOS Z80s) or 255 (on CMOS Z80s) to the port at the 16-bit address contained in the BC register pair.   <a href=\"https://worldofspectrum.org/z88forever/dn327/z80undoc.htm\">Read More</a>",
		instruction: "out (c),0"
	}
}, X_ = {
	mnemonic: "out",
	params: ["(bc)", "0"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"0"
	],
	opcodes: [237, 113],
	isPseudo: !0,
	clr: {
		opcodes: "ED71",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "Outputs a zero (on NMOS Z80s) or 255 (on CMOS Z80s) to the port at the 16-bit address contained in the BC register pair.   <a href=\"https://worldofspectrum.org/z88forever/dn327/z80undoc.htm\">Read More</a>",
		instruction: "out (c),0"
	}
}, Z_ = {
	mnemonic: "sbc",
	params: ["hl", "sp"],
	tokens: [
		"hl",
		",",
		"sp"
	],
	opcodes: [237, 114],
	isPseudo: !1,
	clr: {
		opcodes: "ED72",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Subtracts SP and the carry flag from HL.",
		instruction: "sbc hl,sp"
	}
}, Q_ = {
	mnemonic: "ld",
	params: ["(nnnn)", "sp"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"sp"
	],
	opcodes: [
		237,
		115,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED73",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores SP into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),sp"
	}
}, $_ = {
	mnemonic: "in",
	params: ["a", "(c)"],
	tokens: [
		"a",
		",",
		"(",
		"c",
		")"
	],
	opcodes: [237, 120],
	isPseudo: !1,
	clr: {
		opcodes: "ED78",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to A.",
		instruction: "in a,(c)"
	}
}, ev = {
	mnemonic: "in",
	params: ["a", "(bc)"],
	tokens: [
		"a",
		",",
		"(",
		"bc",
		")"
	],
	opcodes: [237, 120],
	isPseudo: !0,
	clr: {
		opcodes: "ED78",
		undocumented: !1,
		z180: !1,
		flags: "-0P0++",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to A.",
		instruction: "in a,(c)"
	}
}, tv = {
	mnemonic: "out",
	params: ["(c)", "a"],
	tokens: [
		"(",
		"c",
		")",
		",",
		"a"
	],
	opcodes: [237, 121],
	isPseudo: !1,
	clr: {
		opcodes: "ED79",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of A is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),a"
	}
}, nv = {
	mnemonic: "out",
	params: ["(bc)", "a"],
	tokens: [
		"(",
		"bc",
		")",
		",",
		"a"
	],
	opcodes: [237, 121],
	isPseudo: !0,
	clr: {
		opcodes: "ED79",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 12,
		without_jump_clock_count: 12,
		description: "The value of A is written to the port at the 16-bit address contained in the BC register pair.",
		instruction: "out (c),a"
	}
}, rv = {
	mnemonic: "adc",
	params: ["hl", "sp"],
	tokens: [
		"hl",
		",",
		"sp"
	],
	opcodes: [237, 122],
	isPseudo: !1,
	clr: {
		opcodes: "ED7A",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "Adds SP and the carry flag to HL.",
		instruction: "adc hl,sp"
	}
}, iv = {
	mnemonic: "ld",
	params: ["sp", "(nnnn)"],
	tokens: [
		"sp",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		237,
		123,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "ED7B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into SP.",
		instruction: "ld sp,(nnnn)"
	}
}, av = {
	mnemonic: "ldi",
	params: [],
	tokens: [],
	opcodes: [237, 160],
	isPseudo: !1,
	clr: {
		opcodes: "EDA0",
		undocumented: !1,
		z180: !1,
		flags: "-0*0--",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Transfers a byte of data from the memory location pointed to by HL to the memory location pointed to by DE. Then HL and DE are incremented and BC is decremented. p/v is reset if BC becomes zero and set otherwise.",
		instruction: "ldi"
	}
}, ov = {
	mnemonic: "cpi",
	params: [],
	tokens: [],
	opcodes: [237, 161],
	isPseudo: !1,
	clr: {
		opcodes: "EDA1",
		undocumented: !1,
		z180: !1,
		flags: "-1*+++",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Compares the value of the memory location pointed to by HL with A. Then HL is incremented and BC is decremented. p/v is reset if BC becomes zero and set otherwise.",
		instruction: "cpi"
	}
}, sv = {
	mnemonic: "ini",
	params: [],
	tokens: [],
	opcodes: [237, 162],
	isPseudo: !1,
	clr: {
		opcodes: "EDA2",
		undocumented: !1,
		z180: !1,
		flags: " 1  * ",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to the memory location pointed to by HL. Then HL is incremented and B is decremented. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "ini"
	}
}, cv = {
	mnemonic: "outi",
	params: [],
	tokens: [],
	opcodes: [237, 163],
	isPseudo: !1,
	clr: {
		opcodes: "EDA3",
		undocumented: !1,
		z180: !1,
		flags: " 1  * ",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "B is decremented. A byte from the memory location pointed to by HL is written to the port at the 16-bit address contained in the BC register pair. Then HL is incremented. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "outi"
	}
}, lv = {
	mnemonic: "ldd",
	params: [],
	tokens: [],
	opcodes: [237, 168],
	isPseudo: !1,
	clr: {
		opcodes: "EDA8",
		undocumented: !1,
		z180: !1,
		flags: "-0*0--",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Transfers a byte of data from the memory location pointed to by HL to the memory location pointed to by DE. Then HL, DE, and BC are decremented. p/v is reset if BC becomes zero and set otherwise.",
		instruction: "ldd"
	}
}, uv = {
	mnemonic: "cpd",
	params: [],
	tokens: [],
	opcodes: [237, 169],
	isPseudo: !1,
	clr: {
		opcodes: "EDA9",
		undocumented: !1,
		z180: !1,
		flags: "-1*+++",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "Compares the value of the memory location pointed to by HL with A. Then HL and BC are decremented. p/v is reset if BC becomes zero and set otherwise.",
		instruction: "cpd"
	}
}, dv = {
	mnemonic: "ind",
	params: [],
	tokens: [],
	opcodes: [237, 170],
	isPseudo: !1,
	clr: {
		opcodes: "EDAA",
		undocumented: !1,
		z180: !1,
		flags: " 1  * ",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to the memory location pointed to by HL. Then HL and B are decremented. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "ind"
	}
}, fv = {
	mnemonic: "outd",
	params: [],
	tokens: [],
	opcodes: [237, 171],
	isPseudo: !1,
	clr: {
		opcodes: "EDAB",
		undocumented: !1,
		z180: !1,
		flags: " 1  * ",
		byte_count: 2,
		with_jump_clock_count: 16,
		without_jump_clock_count: 16,
		description: "B is decremented. A byte from the memory location pointed to by HL is written to the port at the 16-bit address contained in the BC register pair. Then HL is decremented. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "outd"
	}
}, pv = {
	mnemonic: "ldir",
	params: [],
	tokens: [],
	opcodes: [237, 176],
	isPseudo: !1,
	clr: {
		opcodes: "EDB0",
		undocumented: !1,
		z180: !1,
		flags: "-000--",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "Transfers a byte of data from the memory location pointed to by HL to the memory location pointed to by DE. Then HL and DE are incremented and BC is decremented. If BC is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing.",
		instruction: "ldir"
	}
}, mv = {
	mnemonic: "cpir",
	params: [],
	tokens: [],
	opcodes: [237, 177],
	isPseudo: !1,
	clr: {
		opcodes: "EDB1",
		undocumented: !1,
		z180: !1,
		flags: "-1*+++",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "Compares the value of the memory location pointed to by HL with A. Then HL is incremented and BC is decremented. If BC is not zero and z is not set, this operation is repeated. p/v is reset if BC becomes zero and set otherwise, acting as an indicator that HL reached a memory location whose value equalled A before the counter went to zero. Interrupts can trigger while this instruction is processing.",
		instruction: "cpir"
	}
}, hv = {
	mnemonic: "inir",
	params: [],
	tokens: [],
	opcodes: [237, 178],
	isPseudo: !1,
	clr: {
		opcodes: "EDB2",
		undocumented: !1,
		z180: !1,
		flags: " 1  1 ",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to the memory location pointed to by HL. Then HL is incremented and B is decremented. If B is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "inir"
	}
}, gv = {
	mnemonic: "otir",
	params: [],
	tokens: [],
	opcodes: [237, 179],
	isPseudo: !1,
	clr: {
		opcodes: "EDB3",
		undocumented: !1,
		z180: !1,
		flags: " 1  1 ",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "B is decremented. A byte from the memory location pointed to by HL is written to the port at the 16-bit address contained in the BC register pair. Then HL is incremented. If B is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "otir"
	}
}, _v = {
	mnemonic: "lddr",
	params: [],
	tokens: [],
	opcodes: [237, 184],
	isPseudo: !1,
	clr: {
		opcodes: "EDB8",
		undocumented: !1,
		z180: !1,
		flags: "-000--",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "Transfers a byte of data from the memory location pointed to by HL to the memory location pointed to by DE. Then HL, DE, and BC are decremented. If BC is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing.",
		instruction: "lddr"
	}
}, vv = {
	mnemonic: "cpdr",
	params: [],
	tokens: [],
	opcodes: [237, 185],
	isPseudo: !1,
	clr: {
		opcodes: "EDB9",
		undocumented: !1,
		z180: !1,
		flags: "-1*+++",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "Compares the value of the memory location pointed to by HL with A. Then HL and BC are decremented. If BC is not zero and z is not set, this operation is repeated. p/v is reset if BC becomes zero and set otherwise, acting as an indicator that HL reached a memory location whose value equalled A before the counter went to zero. Interrupts can trigger while this instruction is processing.",
		instruction: "cpdr"
	}
}, yv = {
	mnemonic: "indr",
	params: [],
	tokens: [],
	opcodes: [237, 186],
	isPseudo: !1,
	clr: {
		opcodes: "EDBA",
		undocumented: !1,
		z180: !1,
		flags: " 1  1 ",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "A byte from the port at the 16-bit address contained in the BC register pair is written to the memory location pointed to by HL. Then HL and B are decremented. If B is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "indr"
	}
}, bv = {
	mnemonic: "otdr",
	params: [],
	tokens: [],
	opcodes: [237, 187],
	isPseudo: !1,
	clr: {
		opcodes: "EDBB",
		undocumented: !1,
		z180: !1,
		flags: " 1  1 ",
		byte_count: 2,
		with_jump_clock_count: 21,
		without_jump_clock_count: 16,
		description: "B is decremented. A byte from the memory location pointed to by HL is written to the port at the 16-bit address contained in the BC register pair. Then HL is decremented. If B is not zero, this operation is repeated. Interrupts can trigger while this instruction is processing. Note that the carry flag may be affected, contrary to documentation.   <a href=\"http://z80.info/z80undoc3.txt\">Read More</a>",
		instruction: "otdr"
	}
}, xv = {
	mnemonic: "xor",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [238, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "EE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise XOR on A with <var>nn</var>.",
		instruction: "xor nn"
	}
}, Sv = {
	mnemonic: "xor",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [238, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "EE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise XOR on A with <var>nn</var>.",
		instruction: "xor nn"
	}
}, Cv = {
	mnemonic: "rst",
	params: ["28"],
	tokens: ["28"],
	opcodes: [239],
	isPseudo: !1,
	clr: {
		opcodes: "EF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 40.",
		instruction: "rst 28"
	}
}, wv = {
	mnemonic: "ret",
	params: ["p"],
	tokens: ["p"],
	opcodes: [240],
	isPseudo: !1,
	clr: {
		opcodes: "F0",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the sign flag is unset, the top stack entry is popped into PC.",
		instruction: "ret p"
	}
}, Tv = {
	mnemonic: "pop",
	params: ["af"],
	tokens: ["af"],
	opcodes: [241],
	isPseudo: !1,
	clr: {
		opcodes: "F1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "The memory location pointed to by SP is stored into F and SP is incremented. The memory location pointed to by SP is stored into A and SP is incremented again.",
		instruction: "pop af"
	}
}, Ev = {
	mnemonic: "jp",
	params: ["p", "nnnn"],
	tokens: [
		"p",
		",",
		"nnnn"
	],
	opcodes: [242, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "F2",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the sign flag is unset, <var>nnnn</var> is copied to PC.",
		instruction: "jp p,nnnn"
	}
}, Dv = {
	mnemonic: "di",
	params: [],
	tokens: [],
	opcodes: [243],
	isPseudo: !1,
	clr: {
		opcodes: "F3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Resets both interrupt flip-flops, thus preventing maskable interrupts from triggering.",
		instruction: "di"
	}
}, Ov = {
	mnemonic: "call",
	params: ["p", "nnnn"],
	tokens: [
		"p",
		",",
		"nnnn"
	],
	opcodes: [244, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "F4",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the sign flag is unset, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call p,nnnn"
	}
}, kv = {
	mnemonic: "push",
	params: ["af"],
	tokens: ["af"],
	opcodes: [245],
	isPseudo: !1,
	clr: {
		opcodes: "F5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "SP is decremented and A is stored into the memory location pointed to by SP. SP is decremented again and F is stored into the memory location pointed to by SP.",
		instruction: "push af"
	}
}, Av = {
	mnemonic: "or",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [246, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "F6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise OR on A with <var>nn</var>.",
		instruction: "or nn"
	}
}, jv = {
	mnemonic: "or",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [246, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "F6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Bitwise OR on A with <var>nn</var>.",
		instruction: "or nn"
	}
}, Mv = {
	mnemonic: "rst",
	params: ["30"],
	tokens: ["30"],
	opcodes: [247],
	isPseudo: !1,
	clr: {
		opcodes: "F7",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 48.",
		instruction: "rst 30"
	}
}, Nv = {
	mnemonic: "ret",
	params: ["m"],
	tokens: ["m"],
	opcodes: [248],
	isPseudo: !1,
	clr: {
		opcodes: "F8",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 5,
		description: "If the sign flag is set, the top stack entry is popped into PC.",
		instruction: "ret m"
	}
}, Pv = {
	mnemonic: "ld",
	params: ["sp", "hl"],
	tokens: [
		"sp",
		",",
		"hl"
	],
	opcodes: [249],
	isPseudo: !1,
	clr: {
		opcodes: "F9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 6,
		without_jump_clock_count: 6,
		description: "Loads the value of HL into SP.",
		instruction: "ld sp,hl"
	}
}, Fv = {
	mnemonic: "jp",
	params: ["m", "nnnn"],
	tokens: [
		"m",
		",",
		"nnnn"
	],
	opcodes: [250, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "FA",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "If the sign flag is set, <var>nnnn</var> is copied to PC.",
		instruction: "jp m,nnnn"
	}
}, Iv = {
	mnemonic: "ei",
	params: [],
	tokens: [],
	opcodes: [251],
	isPseudo: !1,
	clr: {
		opcodes: "FB",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 4,
		without_jump_clock_count: 4,
		description: "Sets both interrupt flip-flops, thus allowing maskable interrupts to occur. An interrupt will not occur until after the immediately following instruction.",
		instruction: "ei"
	}
}, Lv = {
	mnemonic: "call",
	params: ["m", "nnnn"],
	tokens: [
		"m",
		",",
		"nnnn"
	],
	opcodes: [252, "nnnn"],
	isPseudo: !1,
	clr: {
		opcodes: "FC",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 17,
		without_jump_clock_count: 10,
		description: "If the sign flag is set, the current PC value plus three is pushed onto the stack, then is loaded with <var>nnnn</var>.",
		instruction: "call m,nnnn"
	}
}, Rv = {
	mnemonic: "add",
	params: ["iy", "bc"],
	tokens: [
		"iy",
		",",
		"bc"
	],
	opcodes: [253, 9],
	isPseudo: !1,
	clr: {
		opcodes: "FD09",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of BC is added to IY.",
		instruction: "add iy,bc"
	}
}, zv = {
	mnemonic: "add",
	params: ["iy", "de"],
	tokens: [
		"iy",
		",",
		"de"
	],
	opcodes: [253, 25],
	isPseudo: !1,
	clr: {
		opcodes: "FD19",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of DE is added to IY.",
		instruction: "add iy,de"
	}
}, Bv = {
	mnemonic: "ld",
	params: ["iy", "nnnn"],
	tokens: [
		"iy",
		",",
		"nnnn"
	],
	opcodes: [
		253,
		33,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD21",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Loads <var>nnnn</var> into register IY.",
		instruction: "ld iy,nnnn"
	}
}, Vv = {
	mnemonic: "ld",
	params: ["(nnnn)", "iy"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"iy"
	],
	opcodes: [
		253,
		34,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD22",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores IY into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),iy"
	}
}, Hv = {
	mnemonic: "inc",
	params: ["iy"],
	tokens: ["iy"],
	opcodes: [253, 35],
	isPseudo: !1,
	clr: {
		opcodes: "FD23",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Adds one to IY.",
		instruction: "inc iy"
	}
}, Uv = {
	mnemonic: "inc",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 36],
	isPseudo: !1,
	clr: {
		opcodes: "FD24",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to IYH.",
		instruction: "inc iyh"
	}
}, Wv = {
	mnemonic: "dec",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 37],
	isPseudo: !1,
	clr: {
		opcodes: "FD25",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from IYH.",
		instruction: "dec iyh"
	}
}, Gv = {
	mnemonic: "ld",
	params: ["iyh", "nn"],
	tokens: [
		"iyh",
		",",
		"nn"
	],
	opcodes: [
		253,
		38,
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD26",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into IYH.",
		instruction: "ld iyh,nn"
	}
}, Kv = {
	mnemonic: "add",
	params: ["iy", "iy"],
	tokens: [
		"iy",
		",",
		"iy"
	],
	opcodes: [253, 41],
	isPseudo: !1,
	clr: {
		opcodes: "FD29",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of IY is added to IY.",
		instruction: "add iy,iy"
	}
}, qv = {
	mnemonic: "ld",
	params: ["iy", "(nnnn)"],
	tokens: [
		"iy",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		253,
		42,
		"nnnn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD2A",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into IY.",
		instruction: "ld iy,(nnnn)"
	}
}, Jv = {
	mnemonic: "dec",
	params: ["iy"],
	tokens: ["iy"],
	opcodes: [253, 43],
	isPseudo: !1,
	clr: {
		opcodes: "FD2B",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Subtracts one from IY.",
		instruction: "dec iy"
	}
}, Yv = {
	mnemonic: "inc",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 44],
	isPseudo: !1,
	clr: {
		opcodes: "FD2C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to IYL.",
		instruction: "inc iyl"
	}
}, Xv = {
	mnemonic: "dec",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 45],
	isPseudo: !1,
	clr: {
		opcodes: "FD2D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from IYL.",
		instruction: "dec iyl"
	}
}, Zv = {
	mnemonic: "ld",
	params: ["iyl", "nn"],
	tokens: [
		"iyl",
		",",
		"nn"
	],
	opcodes: [
		253,
		46,
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD2E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into IYL.",
		instruction: "ld iyl,nn"
	}
}, Qv = {
	mnemonic: "inc",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		52,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD34",
		undocumented: !1,
		z180: !1,
		flags: "-0V+++",
		byte_count: 3,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Adds one to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "inc (iy+dd)"
	}
}, $v = {
	mnemonic: "dec",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		53,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD35",
		undocumented: !1,
		z180: !1,
		flags: "-1V+++",
		byte_count: 3,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Subtracts one from the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "dec (iy+dd)"
	}
}, ey = {
	mnemonic: "ld",
	params: ["(iy+dd)", "nn"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"nn"
	],
	opcodes: [
		253,
		54,
		"dd",
		"nn"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD36",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores <var>nn</var> to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),nn"
	}
}, ty = {
	mnemonic: "add",
	params: ["iy", "sp"],
	tokens: [
		"iy",
		",",
		"sp"
	],
	opcodes: [253, 57],
	isPseudo: !1,
	clr: {
		opcodes: "FD39",
		undocumented: !1,
		z180: !1,
		flags: "+0-+--",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "The value of SP is added to IY.",
		instruction: "add iy,sp"
	}
}, ny = {
	mnemonic: "ld",
	params: ["b", "iyh"],
	tokens: [
		"b",
		",",
		"iyh"
	],
	opcodes: [253, 68],
	isPseudo: !1,
	clr: {
		opcodes: "FD44",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into B.",
		instruction: "ld b,iyh"
	}
}, ry = {
	mnemonic: "ld",
	params: ["b", "iyl"],
	tokens: [
		"b",
		",",
		"iyl"
	],
	opcodes: [253, 69],
	isPseudo: !1,
	clr: {
		opcodes: "FD45",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into B.",
		instruction: "ld b,iyl"
	}
}, iy = {
	mnemonic: "ld",
	params: ["b", "(iy+dd)"],
	tokens: [
		"b",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		70,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD46",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into B.",
		instruction: "ld b,(iy+dd)"
	}
}, ay = {
	mnemonic: "ld",
	params: ["c", "iyh"],
	tokens: [
		"c",
		",",
		"iyh"
	],
	opcodes: [253, 76],
	isPseudo: !1,
	clr: {
		opcodes: "FD4C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into C.",
		instruction: "ld c,iyh"
	}
}, oy = {
	mnemonic: "ld",
	params: ["c", "iyl"],
	tokens: [
		"c",
		",",
		"iyl"
	],
	opcodes: [253, 77],
	isPseudo: !1,
	clr: {
		opcodes: "FD4D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into C.",
		instruction: "ld c,iyl"
	}
}, sy = {
	mnemonic: "ld",
	params: ["c", "(iy+dd)"],
	tokens: [
		"c",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		78,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD4E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into C.",
		instruction: "ld c,(iy+dd)"
	}
}, cy = {
	mnemonic: "ld",
	params: ["d", "iyh"],
	tokens: [
		"d",
		",",
		"iyh"
	],
	opcodes: [253, 84],
	isPseudo: !1,
	clr: {
		opcodes: "FD54",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into D.",
		instruction: "ld d,iyh"
	}
}, ly = {
	mnemonic: "ld",
	params: ["d", "iyl"],
	tokens: [
		"d",
		",",
		"iyl"
	],
	opcodes: [253, 85],
	isPseudo: !1,
	clr: {
		opcodes: "FD55",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into D.",
		instruction: "ld d,iyl"
	}
}, uy = {
	mnemonic: "ld",
	params: ["d", "(iy+dd)"],
	tokens: [
		"d",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		86,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD56",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into D.",
		instruction: "ld d,(iy+dd)"
	}
}, dy = {
	mnemonic: "ld",
	params: ["e", "iyh"],
	tokens: [
		"e",
		",",
		"iyh"
	],
	opcodes: [253, 92],
	isPseudo: !1,
	clr: {
		opcodes: "FD5C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into E.",
		instruction: "ld e,iyh"
	}
}, fy = {
	mnemonic: "ld",
	params: ["e", "iyl"],
	tokens: [
		"e",
		",",
		"iyl"
	],
	opcodes: [253, 93],
	isPseudo: !1,
	clr: {
		opcodes: "FD5D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into E.",
		instruction: "ld e,iyl"
	}
}, py = {
	mnemonic: "ld",
	params: ["e", "(iy+dd)"],
	tokens: [
		"e",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		94,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD5E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into E.",
		instruction: "ld e,(iy+dd)"
	}
}, my = {
	mnemonic: "ld",
	params: ["iyh", "b"],
	tokens: [
		"iyh",
		",",
		"b"
	],
	opcodes: [253, 96],
	isPseudo: !1,
	clr: {
		opcodes: "FD60",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into IYH.",
		instruction: "ld iyh,b"
	}
}, hy = {
	mnemonic: "ld",
	params: ["iyh", "c"],
	tokens: [
		"iyh",
		",",
		"c"
	],
	opcodes: [253, 97],
	isPseudo: !1,
	clr: {
		opcodes: "FD61",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into IYH.",
		instruction: "ld iyh,c"
	}
}, gy = {
	mnemonic: "ld",
	params: ["iyh", "d"],
	tokens: [
		"iyh",
		",",
		"d"
	],
	opcodes: [253, 98],
	isPseudo: !1,
	clr: {
		opcodes: "FD62",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into IYH.",
		instruction: "ld iyh,d"
	}
}, _y = {
	mnemonic: "ld",
	params: ["iyh", "e"],
	tokens: [
		"iyh",
		",",
		"e"
	],
	opcodes: [253, 99],
	isPseudo: !1,
	clr: {
		opcodes: "FD63",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into IYH.",
		instruction: "ld iyh,e"
	}
}, vy = {
	mnemonic: "ld",
	params: ["iyh", "iyh"],
	tokens: [
		"iyh",
		",",
		"iyh"
	],
	opcodes: [253, 100],
	isPseudo: !1,
	clr: {
		opcodes: "FD64",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into IYH.",
		instruction: "ld iyh,iyh"
	}
}, yy = {
	mnemonic: "ld",
	params: ["iyh", "iyl"],
	tokens: [
		"iyh",
		",",
		"iyl"
	],
	opcodes: [253, 101],
	isPseudo: !1,
	clr: {
		opcodes: "FD65",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into IYH.",
		instruction: "ld iyh,iyl"
	}
}, by = {
	mnemonic: "ld",
	params: ["h", "(iy+dd)"],
	tokens: [
		"h",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		102,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD66",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into H.",
		instruction: "ld h,(iy+dd)"
	}
}, xy = {
	mnemonic: "ld",
	params: ["iyh", "a"],
	tokens: [
		"iyh",
		",",
		"a"
	],
	opcodes: [253, 103],
	isPseudo: !1,
	clr: {
		opcodes: "FD67",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into IYH.",
		instruction: "ld iyh,a"
	}
}, Sy = {
	mnemonic: "ld",
	params: ["iyl", "b"],
	tokens: [
		"iyl",
		",",
		"b"
	],
	opcodes: [253, 104],
	isPseudo: !1,
	clr: {
		opcodes: "FD68",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into IYL.",
		instruction: "ld iyl,b"
	}
}, Cy = {
	mnemonic: "ld",
	params: ["iyl", "c"],
	tokens: [
		"iyl",
		",",
		"c"
	],
	opcodes: [253, 105],
	isPseudo: !1,
	clr: {
		opcodes: "FD69",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into IYL.",
		instruction: "ld iyl,c"
	}
}, wy = {
	mnemonic: "ld",
	params: ["iyl", "d"],
	tokens: [
		"iyl",
		",",
		"d"
	],
	opcodes: [253, 106],
	isPseudo: !1,
	clr: {
		opcodes: "FD6A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into IYL.",
		instruction: "ld iyl,d"
	}
}, Ty = {
	mnemonic: "ld",
	params: ["iyl", "e"],
	tokens: [
		"iyl",
		",",
		"e"
	],
	opcodes: [253, 107],
	isPseudo: !1,
	clr: {
		opcodes: "FD6B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into IYL.",
		instruction: "ld iyl,e"
	}
}, Ey = {
	mnemonic: "ld",
	params: ["iyl", "iyh"],
	tokens: [
		"iyl",
		",",
		"iyh"
	],
	opcodes: [253, 108],
	isPseudo: !1,
	clr: {
		opcodes: "FD6C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into IYL.",
		instruction: "ld iyl,iyh"
	}
}, Dy = {
	mnemonic: "ld",
	params: ["iyl", "iyl"],
	tokens: [
		"iyl",
		",",
		"iyl"
	],
	opcodes: [253, 109],
	isPseudo: !1,
	clr: {
		opcodes: "FD6D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into IYL.",
		instruction: "ld iyl,iyl"
	}
}, Oy = {
	mnemonic: "ld",
	params: ["l", "(iy+dd)"],
	tokens: [
		"l",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		110,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD6E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into L.",
		instruction: "ld l,(iy+dd)"
	}
}, ky = {
	mnemonic: "ld",
	params: ["iyl", "a"],
	tokens: [
		"iyl",
		",",
		"a"
	],
	opcodes: [253, 111],
	isPseudo: !1,
	clr: {
		opcodes: "FD6F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into IYL.",
		instruction: "ld iyl,a"
	}
}, Ay = {
	mnemonic: "ld",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		112,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD70",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores B to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),b"
	}
}, jy = {
	mnemonic: "ld",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		113,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD71",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores C to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),c"
	}
}, My = {
	mnemonic: "ld",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		114,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD72",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores D to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),d"
	}
}, Ny = {
	mnemonic: "ld",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		115,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD73",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores E to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),e"
	}
}, Py = {
	mnemonic: "ld",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		116,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD74",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores H to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),h"
	}
}, Fy = {
	mnemonic: "ld",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		117,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD75",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores L to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),l"
	}
}, Iy = {
	mnemonic: "ld",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		119,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD77",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Stores A to the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "ld (iy+dd),a"
	}
}, Ly = {
	mnemonic: "ld",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 124],
	isPseudo: !1,
	clr: {
		opcodes: "FD7C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYH are loaded into A.",
		instruction: "ld a,iyh"
	}
}, Ry = {
	mnemonic: "ld",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 125],
	isPseudo: !1,
	clr: {
		opcodes: "FD7D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of IYL are loaded into A.",
		instruction: "ld a,iyl"
	}
}, zy = {
	mnemonic: "ld",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		126,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD7E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Loads the value pointed to by IY plus <var>dd</var> into A.",
		instruction: "ld a,(iy+dd)"
	}
}, By = {
	mnemonic: "add",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 132],
	isPseudo: !1,
	clr: {
		opcodes: "FD84",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYH to A.",
		instruction: "add a,iyh"
	}
}, Vy = {
	mnemonic: "add",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 132],
	isPseudo: !0,
	clr: {
		opcodes: "FD84",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYH to A.",
		instruction: "add a,iyh"
	}
}, Hy = {
	mnemonic: "add",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 133],
	isPseudo: !1,
	clr: {
		opcodes: "FD85",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYL to A.",
		instruction: "add a,iyl"
	}
}, Uy = {
	mnemonic: "add",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 133],
	isPseudo: !0,
	clr: {
		opcodes: "FD85",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYL to A.",
		instruction: "add a,iyl"
	}
}, Wy = {
	mnemonic: "add",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		134,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IY plus <var>dd</var> to A.",
		instruction: "add a,(iy+dd)"
	}
}, Gy = {
	mnemonic: "add",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		134,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FD86",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IY plus <var>dd</var> to A.",
		instruction: "add a,(iy+dd)"
	}
}, Ky = {
	mnemonic: "adc",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 140],
	isPseudo: !1,
	clr: {
		opcodes: "FD8C",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYH and the carry flag to A.",
		instruction: "adc a,iyh"
	}
}, qy = {
	mnemonic: "adc",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 140],
	isPseudo: !0,
	clr: {
		opcodes: "FD8C",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYH and the carry flag to A.",
		instruction: "adc a,iyh"
	}
}, Jy = {
	mnemonic: "adc",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 141],
	isPseudo: !1,
	clr: {
		opcodes: "FD8D",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYL and the carry flag to A.",
		instruction: "adc a,iyl"
	}
}, Yy = {
	mnemonic: "adc",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 141],
	isPseudo: !0,
	clr: {
		opcodes: "FD8D",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds IYL and the carry flag to A.",
		instruction: "adc a,iyl"
	}
}, Xy = {
	mnemonic: "adc",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		142,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IY plus <var>dd</var> and the carry flag to A.",
		instruction: "adc a,(iy+dd)"
	}
}, Zy = {
	mnemonic: "adc",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		142,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FD8E",
		undocumented: !1,
		z180: !1,
		flags: "+0V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Adds the value pointed to by IY plus <var>dd</var> and the carry flag to A.",
		instruction: "adc a,(iy+dd)"
	}
}, Qy = {
	mnemonic: "sub",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 148],
	isPseudo: !1,
	clr: {
		opcodes: "FD94",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH from A.",
		instruction: "sub iyh"
	}
}, $y = {
	mnemonic: "sub",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 148],
	isPseudo: !0,
	clr: {
		opcodes: "FD94",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH from A.",
		instruction: "sub iyh"
	}
}, eb = {
	mnemonic: "sub",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 149],
	isPseudo: !1,
	clr: {
		opcodes: "FD95",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL from A.",
		instruction: "sub iyl"
	}
}, tb = {
	mnemonic: "sub",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 149],
	isPseudo: !0,
	clr: {
		opcodes: "FD95",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL from A.",
		instruction: "sub iyl"
	}
}, nb = {
	mnemonic: "sub",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		150,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> from A.",
		instruction: "sub (iy+dd)"
	}
}, rb = {
	mnemonic: "sub",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		150,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FD96",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> from A.",
		instruction: "sub (iy+dd)"
	}
}, ib = {
	mnemonic: "sbc",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 156],
	isPseudo: !1,
	clr: {
		opcodes: "FD9C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH and the carry flag from A.",
		instruction: "sbc a,iyh"
	}
}, ab = {
	mnemonic: "sbc",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 156],
	isPseudo: !0,
	clr: {
		opcodes: "FD9C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH and the carry flag from A.",
		instruction: "sbc a,iyh"
	}
}, ob = {
	mnemonic: "sbc",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 157],
	isPseudo: !1,
	clr: {
		opcodes: "FD9D",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL and the carry flag from A.",
		instruction: "sbc a,iyl"
	}
}, sb = {
	mnemonic: "sbc",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 157],
	isPseudo: !0,
	clr: {
		opcodes: "FD9D",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL and the carry flag from A.",
		instruction: "sbc a,iyl"
	}
}, cb = {
	mnemonic: "sbc",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		158,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FD9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> and the carry flag from A.",
		instruction: "sbc a,(iy+dd)"
	}
}, lb = {
	mnemonic: "sbc",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		158,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FD9E",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> and the carry flag from A.",
		instruction: "sbc a,(iy+dd)"
	}
}, ub = {
	mnemonic: "and",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 164],
	isPseudo: !1,
	clr: {
		opcodes: "FDA4",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IYH.",
		instruction: "and iyh"
	}
}, db = {
	mnemonic: "and",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 164],
	isPseudo: !0,
	clr: {
		opcodes: "FDA4",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IYH.",
		instruction: "and iyh"
	}
}, fb = {
	mnemonic: "and",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 165],
	isPseudo: !1,
	clr: {
		opcodes: "FDA5",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IYL.",
		instruction: "and iyl"
	}
}, pb = {
	mnemonic: "and",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 165],
	isPseudo: !0,
	clr: {
		opcodes: "FDA5",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with IYL.",
		instruction: "and iyl"
	}
}, mb = {
	mnemonic: "and",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		166,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDA6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise AND on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "and (iy+dd)"
	}
}, hb = {
	mnemonic: "and",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		166,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FDA6",
		undocumented: !1,
		z180: !1,
		flags: "00P1++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise AND on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "and (iy+dd)"
	}
}, gb = {
	mnemonic: "xor",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 172],
	isPseudo: !1,
	clr: {
		opcodes: "FDAC",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IYH.",
		instruction: "xor iyh"
	}
}, _b = {
	mnemonic: "xor",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 172],
	isPseudo: !0,
	clr: {
		opcodes: "FDAC",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IYH.",
		instruction: "xor iyh"
	}
}, vb = {
	mnemonic: "xor",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 173],
	isPseudo: !1,
	clr: {
		opcodes: "FDAD",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IYL.",
		instruction: "xor iyl"
	}
}, yb = {
	mnemonic: "xor",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 173],
	isPseudo: !0,
	clr: {
		opcodes: "FDAD",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with IYL.",
		instruction: "xor iyl"
	}
}, bb = {
	mnemonic: "xor",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		174,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDAE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise XOR on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "xor (iy+dd)"
	}
}, xb = {
	mnemonic: "xor",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		174,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FDAE",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise XOR on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "xor (iy+dd)"
	}
}, Sb = {
	mnemonic: "or",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 180],
	isPseudo: !1,
	clr: {
		opcodes: "FDB4",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IYH.",
		instruction: "or iyh"
	}
}, Cb = {
	mnemonic: "or",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 180],
	isPseudo: !0,
	clr: {
		opcodes: "FDB4",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IYH.",
		instruction: "or iyh"
	}
}, wb = {
	mnemonic: "or",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 181],
	isPseudo: !1,
	clr: {
		opcodes: "FDB5",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IYL.",
		instruction: "or iyl"
	}
}, Tb = {
	mnemonic: "or",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 181],
	isPseudo: !0,
	clr: {
		opcodes: "FDB5",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with IYL.",
		instruction: "or iyl"
	}
}, Eb = {
	mnemonic: "or",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		182,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDB6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise OR on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "or (iy+dd)"
	}
}, Db = {
	mnemonic: "or",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		182,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FDB6",
		undocumented: !1,
		z180: !1,
		flags: "00P0++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Bitwise OR on A with the value pointed to by IY plus <var>dd</var>.",
		instruction: "or (iy+dd)"
	}
}, Ob = {
	mnemonic: "cp",
	params: ["iyh"],
	tokens: ["iyh"],
	opcodes: [253, 188],
	isPseudo: !1,
	clr: {
		opcodes: "FDBC",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH from A and affects flags according to the result. A is not modified.",
		instruction: "cp iyh"
	}
}, kb = {
	mnemonic: "cp",
	params: ["a", "iyh"],
	tokens: [
		"a",
		",",
		"iyh"
	],
	opcodes: [253, 188],
	isPseudo: !0,
	clr: {
		opcodes: "FDBC",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYH from A and affects flags according to the result. A is not modified.",
		instruction: "cp iyh"
	}
}, Ab = {
	mnemonic: "cp",
	params: ["iyl"],
	tokens: ["iyl"],
	opcodes: [253, 189],
	isPseudo: !1,
	clr: {
		opcodes: "FDBD",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL from A and affects flags according to the result. A is not modified.",
		instruction: "cp iyl"
	}
}, jb = {
	mnemonic: "cp",
	params: ["a", "iyl"],
	tokens: [
		"a",
		",",
		"iyl"
	],
	opcodes: [253, 189],
	isPseudo: !0,
	clr: {
		opcodes: "FDBD",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts IYL from A and affects flags according to the result. A is not modified.",
		instruction: "cp iyl"
	}
}, Mb = {
	mnemonic: "cp",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		190,
		"dd"
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDBE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp (iy+dd)"
	}
}, Nb = {
	mnemonic: "cp",
	params: ["a", "(iy+dd)"],
	tokens: [
		"a",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		190,
		"dd"
	],
	isPseudo: !0,
	clr: {
		opcodes: "FDBE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 3,
		with_jump_clock_count: 19,
		without_jump_clock_count: 19,
		description: "Subtracts the value pointed to by IY plus <var>dd</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp (iy+dd)"
	}
}, Pb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		0
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB00",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in B.",
		instruction: "rlc (iy+dd),b"
	}
}, Fb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		1
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB01",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in C.",
		instruction: "rlc (iy+dd),c"
	}
}, Ib = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		2
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB02",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in D.",
		instruction: "rlc (iy+dd),d"
	}
}, Lb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		3
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB03",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in E.",
		instruction: "rlc (iy+dd),e"
	}
}, Rb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		4
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB04",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in H.",
		instruction: "rlc (iy+dd),h"
	}
}, zb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		5
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB05",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in L.",
		instruction: "rlc (iy+dd),l"
	}
}, Bb = {
	mnemonic: "rlc",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		6
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB06",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0.",
		instruction: "rlc (iy+dd)"
	}
}, Vb = {
	mnemonic: "rlc",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		7
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB07",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and bit 0. The result is then stored in A.",
		instruction: "rlc (iy+dd),a"
	}
}, Hb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		8
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB08",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in B.",
		instruction: "rrc (iy+dd),b"
	}
}, Ub = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		9
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB09",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in C.",
		instruction: "rrc (iy+dd),c"
	}
}, Wb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		10
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in D.",
		instruction: "rrc (iy+dd),d"
	}
}, Gb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		11
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in E.",
		instruction: "rrc (iy+dd),e"
	}
}, Kb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		12
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in H.",
		instruction: "rrc (iy+dd),h"
	}
}, qb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		13
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in L.",
		instruction: "rrc (iy+dd),l"
	}
}, Jb = {
	mnemonic: "rrc",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		14
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7.",
		instruction: "rrc (iy+dd)"
	}
}, Yb = {
	mnemonic: "rrc",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		15
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB0F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and bit 7. The result is then stored in A.",
		instruction: "rrc (iy+dd),a"
	}
}, Xb = {
	mnemonic: "rl",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		16
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB10",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in B.",
		instruction: "rl (iy+dd),b"
	}
}, Zb = {
	mnemonic: "rl",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		17
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB11",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in C.",
		instruction: "rl (iy+dd),c"
	}
}, Qb = {
	mnemonic: "rl",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		18
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB12",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in D.",
		instruction: "rl (iy+dd),d"
	}
}, $b = {
	mnemonic: "rl",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		19
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB13",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in E.",
		instruction: "rl (iy+dd),e"
	}
}, ex = {
	mnemonic: "rl",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		20
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB14",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in H.",
		instruction: "rl (iy+dd),h"
	}
}, tx = {
	mnemonic: "rl",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		21
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB15",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in L.",
		instruction: "rl (iy+dd),l"
	}
}, nx = {
	mnemonic: "rl",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		22
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB16",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0.",
		instruction: "rl (iy+dd)"
	}
}, rx = {
	mnemonic: "rl",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		23
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB17",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated left one bit position. The contents of bit 7 are copied to the carry flag and the previous contents of the carry flag are copied to bit 0. The result is then stored in A.",
		instruction: "rl (iy+dd),a"
	}
}, ix = {
	mnemonic: "rr",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		24
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB18",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in B.",
		instruction: "rr (iy+dd),b"
	}
}, ax = {
	mnemonic: "rr",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		25
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB19",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in C.",
		instruction: "rr (iy+dd),c"
	}
}, ox = {
	mnemonic: "rr",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		26
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in D.",
		instruction: "rr (iy+dd),d"
	}
}, sx = {
	mnemonic: "rr",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		27
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in E.",
		instruction: "rr (iy+dd),e"
	}
}, cx = {
	mnemonic: "rr",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		28
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in H.",
		instruction: "rr (iy+dd),h"
	}
}, lx = {
	mnemonic: "rr",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		29
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in L.",
		instruction: "rr (iy+dd),l"
	}
}, ux = {
	mnemonic: "rr",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		30
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7.",
		instruction: "rr (iy+dd)"
	}
}, dx = {
	mnemonic: "rr",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		31
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB1F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are rotated right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of the carry flag are copied to bit 7. The result is then stored in A.",
		instruction: "rr (iy+dd),a"
	}
}, fx = {
	mnemonic: "sla",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		32
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB20",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in B.",
		instruction: "sla (iy+dd),b"
	}
}, px = {
	mnemonic: "sla",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		33
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB21",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in C.",
		instruction: "sla (iy+dd),c"
	}
}, mx = {
	mnemonic: "sla",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		34
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB22",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in D.",
		instruction: "sla (iy+dd),d"
	}
}, hx = {
	mnemonic: "sla",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		35
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB23",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in E.",
		instruction: "sla (iy+dd),e"
	}
}, gx = {
	mnemonic: "sla",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		36
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB24",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in H.",
		instruction: "sla (iy+dd),h"
	}
}, _x = {
	mnemonic: "sla",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		37
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB25",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in L.",
		instruction: "sla (iy+dd),l"
	}
}, vx = {
	mnemonic: "sla",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		38
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB26",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0.",
		instruction: "sla (iy+dd)"
	}
}, yx = {
	mnemonic: "sla",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		39
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB27",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are copied to the carry flag and a zero is put into bit 0. The result is then stored in A.",
		instruction: "sla (iy+dd),a"
	}
}, bx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		40
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB28",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in B.",
		instruction: "sra (iy+dd),b"
	}
}, xx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		41
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB29",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in C.",
		instruction: "sra (iy+dd),c"
	}
}, Sx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		42
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in D.",
		instruction: "sra (iy+dd),d"
	}
}, Cx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		43
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in E.",
		instruction: "sra (iy+dd),e"
	}
}, wx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		44
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in H.",
		instruction: "sra (iy+dd),h"
	}
}, Tx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		45
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in L.",
		instruction: "sra (iy+dd),l"
	}
}, Ex = {
	mnemonic: "sra",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		46
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged.",
		instruction: "sra (iy+dd)"
	}
}, Dx = {
	mnemonic: "sra",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		47
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB2F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and the previous contents of bit 7 are unchanged. The result is then stored in A.",
		instruction: "sra (iy+dd),a"
	}
}, Ox = {
	mnemonic: "sll",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		48
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB30",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in B.",
		instruction: "sll (iy+dd),b"
	}
}, kx = {
	mnemonic: "sll",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		49
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB31",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in C.",
		instruction: "sll (iy+dd),c"
	}
}, Ax = {
	mnemonic: "sll",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		50
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB32",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in D.",
		instruction: "sll (iy+dd),d"
	}
}, jx = {
	mnemonic: "sll",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		51
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB33",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in E.",
		instruction: "sll (iy+dd),e"
	}
}, Mx = {
	mnemonic: "sll",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		52
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB34",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in H.",
		instruction: "sll (iy+dd),h"
	}
}, Nx = {
	mnemonic: "sll",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		53
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB35",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in L.",
		instruction: "sll (iy+dd),l"
	}
}, Px = {
	mnemonic: "sll",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		54
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB36",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0.",
		instruction: "sll (iy+dd)"
	}
}, Fx = {
	mnemonic: "sll",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		55
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB37",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted left one bit position. The contents of bit 7 are put into the carry flag and a one is put into bit 0. The result is then stored in A.",
		instruction: "sll (iy+dd),a"
	}
}, Ix = {
	mnemonic: "srl",
	params: ["(iy+dd)", "b"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		56
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB38",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in B.",
		instruction: "srl (iy+dd),b"
	}
}, Lx = {
	mnemonic: "srl",
	params: ["(iy+dd)", "c"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		57
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB39",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in C.",
		instruction: "srl (iy+dd),c"
	}
}, Rx = {
	mnemonic: "srl",
	params: ["(iy+dd)", "d"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		58
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3A",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in D.",
		instruction: "srl (iy+dd),d"
	}
}, zx = {
	mnemonic: "srl",
	params: ["(iy+dd)", "e"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		59
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3B",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in E.",
		instruction: "srl (iy+dd),e"
	}
}, Bx = {
	mnemonic: "srl",
	params: ["(iy+dd)", "h"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		60
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3C",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in H.",
		instruction: "srl (iy+dd),h"
	}
}, Vx = {
	mnemonic: "srl",
	params: ["(iy+dd)", "l"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		61
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3D",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in L.",
		instruction: "srl (iy+dd),l"
	}
}, Hx = {
	mnemonic: "srl",
	params: ["(iy+dd)"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		62
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3E",
		undocumented: !1,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7.",
		instruction: "srl (iy+dd)"
	}
}, Ux = {
	mnemonic: "srl",
	params: ["(iy+dd)", "a"],
	tokens: [
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		63
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB3F",
		undocumented: !0,
		z180: !1,
		flags: "+0P0++",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "The contents of the memory location pointed to by IY plus <var>dd</var> are shifted right one bit position. The contents of bit 0 are copied to the carry flag and a zero is put into bit 7. The result is then stored in A.",
		instruction: "srl (iy+dd),a"
	}
}, K = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		70
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB46",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, q = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		78
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB4E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, J = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		86
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB56",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, Y = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		94
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB5E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, X = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		102
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB66",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, Z = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		110
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB6E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Wx = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		118
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB76",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Gx = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		126
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB7E",
		undocumented: !1,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Kx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		128
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB80",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 0,(iy+dd),b"
	}
}, qx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		129
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB81",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 0,(iy+dd),c"
	}
}, Jx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		130
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB82",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 0,(iy+dd),d"
	}
}, Yx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		131
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB83",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 0,(iy+dd),e"
	}
}, Xx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		132
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB84",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 0,(iy+dd),h"
	}
}, Zx = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		133
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB85",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 0,(iy+dd),l"
	}
}, Qx = {
	mnemonic: "res",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		134
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB86",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 0,(iy+dd)"
	}
}, $x = {
	mnemonic: "res",
	params: [
		"0",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		135
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB87",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 0,(iy+dd),a"
	}
}, eS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		136
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB88",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 1,(iy+dd),b"
	}
}, tS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		137
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB89",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 1,(iy+dd),c"
	}
}, nS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		138
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 1,(iy+dd),d"
	}
}, rS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		139
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 1,(iy+dd),e"
	}
}, iS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		140
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 1,(iy+dd),h"
	}
}, aS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		141
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 1,(iy+dd),l"
	}
}, oS = {
	mnemonic: "res",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		142
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 1,(iy+dd)"
	}
}, sS = {
	mnemonic: "res",
	params: [
		"1",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		143
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB8F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 1,(iy+dd),a"
	}
}, cS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		144
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB90",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 2,(iy+dd),b"
	}
}, lS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		145
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB91",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 2,(iy+dd),c"
	}
}, uS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		146
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB92",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 2,(iy+dd),d"
	}
}, dS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		147
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB93",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 2,(iy+dd),e"
	}
}, fS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		148
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB94",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 2,(iy+dd),h"
	}
}, pS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		149
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB95",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 2,(iy+dd),l"
	}
}, mS = {
	mnemonic: "res",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		150
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB96",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 2,(iy+dd)"
	}
}, hS = {
	mnemonic: "res",
	params: [
		"2",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		151
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB97",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 2,(iy+dd),a"
	}
}, gS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		152
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB98",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 3,(iy+dd),b"
	}
}, _S = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		153
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB99",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 3,(iy+dd),c"
	}
}, vS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		154
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 3,(iy+dd),d"
	}
}, yS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		155
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 3,(iy+dd),e"
	}
}, bS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		156
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9C",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 3,(iy+dd),h"
	}
}, xS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		157
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 3,(iy+dd),l"
	}
}, SS = {
	mnemonic: "res",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		158
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9E",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 3,(iy+dd)"
	}
}, CS = {
	mnemonic: "res",
	params: [
		"3",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		159
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCB9F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 3,(iy+dd),a"
	}
}, wS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		160
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 4,(iy+dd),b"
	}
}, TS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		161
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 4,(iy+dd),c"
	}
}, ES = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		162
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 4,(iy+dd),d"
	}
}, DS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		163
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 4,(iy+dd),e"
	}
}, OS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		164
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 4,(iy+dd),h"
	}
}, kS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		165
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 4,(iy+dd),l"
	}
}, AS = {
	mnemonic: "res",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		166
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 4,(iy+dd)"
	}
}, jS = {
	mnemonic: "res",
	params: [
		"4",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		167
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 4,(iy+dd),a"
	}
}, MS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		168
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 5,(iy+dd),b"
	}
}, NS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		169
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBA9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 5,(iy+dd),c"
	}
}, PS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		170
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 5,(iy+dd),d"
	}
}, FS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		171
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 5,(iy+dd),e"
	}
}, IS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		172
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 5,(iy+dd),h"
	}
}, LS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		173
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 5,(iy+dd),l"
	}
}, RS = {
	mnemonic: "res",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		174
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 5,(iy+dd)"
	}
}, zS = {
	mnemonic: "res",
	params: [
		"5",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		175
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBAF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 5,(iy+dd),a"
	}
}, BS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		176
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 6,(iy+dd),b"
	}
}, VS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		177
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 6,(iy+dd),c"
	}
}, HS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		178
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 6,(iy+dd),d"
	}
}, US = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		179
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 6,(iy+dd),e"
	}
}, WS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		180
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 6,(iy+dd),h"
	}
}, GS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		181
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 6,(iy+dd),l"
	}
}, KS = {
	mnemonic: "res",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		182
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 6,(iy+dd)"
	}
}, qS = {
	mnemonic: "res",
	params: [
		"6",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		183
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 6,(iy+dd),a"
	}
}, JS = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		184
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "res 7,(iy+dd),b"
	}
}, YS = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		185
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBB9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "res 7,(iy+dd),c"
	}
}, XS = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		186
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "res 7,(iy+dd),d"
	}
}, ZS = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		187
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "res 7,(iy+dd),e"
	}
}, QS = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		188
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "res 7,(iy+dd),h"
	}
}, $S = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		189
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "res 7,(iy+dd),l"
	}
}, eC = {
	mnemonic: "res",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		190
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "res 7,(iy+dd)"
	}
}, tC = {
	mnemonic: "res",
	params: [
		"7",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		191
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBBF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Resets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "res 7,(iy+dd),a"
	}
}, nC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		192
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 0,(iy+dd),b"
	}
}, rC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		193
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 0,(iy+dd),c"
	}
}, iC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		194
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 0,(iy+dd),d"
	}
}, aC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		195
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 0,(iy+dd),e"
	}
}, oC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		196
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 0,(iy+dd),h"
	}
}, sC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		197
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 0,(iy+dd),l"
	}
}, cC = {
	mnemonic: "set",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		198
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 0,(iy+dd)"
	}
}, lC = {
	mnemonic: "set",
	params: [
		"0",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		199
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 0 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 0,(iy+dd),a"
	}
}, uC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		200
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 1,(iy+dd),b"
	}
}, dC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		201
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBC9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 1,(iy+dd),c"
	}
}, fC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		202
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 1,(iy+dd),d"
	}
}, pC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		203
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 1,(iy+dd),e"
	}
}, mC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		204
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 1,(iy+dd),h"
	}
}, hC = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		205
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 1,(iy+dd),l"
	}
}, gC = {
	mnemonic: "set",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		206
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 1,(iy+dd)"
	}
}, _C = {
	mnemonic: "set",
	params: [
		"1",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		207
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBCF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 1 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 1,(iy+dd),a"
	}
}, vC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		208
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 2,(iy+dd),b"
	}
}, yC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		209
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 2,(iy+dd),c"
	}
}, bC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		210
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 2,(iy+dd),d"
	}
}, xC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		211
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 2,(iy+dd),e"
	}
}, SC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		212
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 2,(iy+dd),h"
	}
}, CC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		213
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 2,(iy+dd),l"
	}
}, wC = {
	mnemonic: "set",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		214
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 2,(iy+dd)"
	}
}, TC = {
	mnemonic: "set",
	params: [
		"2",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		215
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 2 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 2,(iy+dd),a"
	}
}, EC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		216
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 3,(iy+dd),b"
	}
}, DC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		217
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBD9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 3,(iy+dd),c"
	}
}, OC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		218
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 3,(iy+dd),d"
	}
}, kC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		219
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 3,(iy+dd),e"
	}
}, AC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		220
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 3,(iy+dd),h"
	}
}, jC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		221
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 3,(iy+dd),l"
	}
}, MC = {
	mnemonic: "set",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		222
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 3,(iy+dd)"
	}
}, NC = {
	mnemonic: "set",
	params: [
		"3",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		223
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBDF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 3 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 3,(iy+dd),a"
	}
}, PC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		224
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 4,(iy+dd),b"
	}
}, FC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		225
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 4,(iy+dd),c"
	}
}, IC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		226
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 4,(iy+dd),d"
	}
}, LC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		227
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 4,(iy+dd),e"
	}
}, RC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		228
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 4,(iy+dd),h"
	}
}, zC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		229
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 4,(iy+dd),l"
	}
}, BC = {
	mnemonic: "set",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		230
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 4,(iy+dd)"
	}
}, VC = {
	mnemonic: "set",
	params: [
		"4",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		231
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 4 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 4,(iy+dd),a"
	}
}, HC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		232
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 5,(iy+dd),b"
	}
}, UC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		233
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBE9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 5,(iy+dd),c"
	}
}, WC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		234
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBEA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 5,(iy+dd),d"
	}
}, GC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		235
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBEB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 5,(iy+dd),e"
	}
}, KC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		236
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBEC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 5,(iy+dd),h"
	}
}, qC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		237
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBED",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 5,(iy+dd),l"
	}
}, JC = {
	mnemonic: "set",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		238
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBEE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 5,(iy+dd)"
	}
}, YC = {
	mnemonic: "set",
	params: [
		"5",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		239
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBEF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 5 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 5,(iy+dd),a"
	}
}, XC = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		240
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF0",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 6,(iy+dd),b"
	}
}, ZC = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		241
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF1",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 6,(iy+dd),c"
	}
}, QC = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		242
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF2",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 6,(iy+dd),d"
	}
}, $C = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		243
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF3",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 6,(iy+dd),e"
	}
}, ew = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		244
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF4",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 6,(iy+dd),h"
	}
}, tw = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		245
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF5",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 6,(iy+dd),l"
	}
}, nw = {
	mnemonic: "set",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		246
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF6",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 6,(iy+dd)"
	}
}, rw = {
	mnemonic: "set",
	params: [
		"6",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		247
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF7",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 6 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 6,(iy+dd),a"
	}
}, iw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"b"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"b"
	],
	opcodes: [
		253,
		203,
		"dd",
		248
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF8",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in B.",
		instruction: "set 7,(iy+dd),b"
	}
}, aw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"c"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"c"
	],
	opcodes: [
		253,
		203,
		"dd",
		249
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBF9",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in C.",
		instruction: "set 7,(iy+dd),c"
	}
}, ow = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"d"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"d"
	],
	opcodes: [
		253,
		203,
		"dd",
		250
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFA",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in D.",
		instruction: "set 7,(iy+dd),d"
	}
}, sw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"e"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"e"
	],
	opcodes: [
		253,
		203,
		"dd",
		251
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFB",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in E.",
		instruction: "set 7,(iy+dd),e"
	}
}, cw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"h"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"h"
	],
	opcodes: [
		253,
		203,
		"dd",
		252
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFC",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in H.",
		instruction: "set 7,(iy+dd),h"
	}
}, lw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"l"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"l"
	],
	opcodes: [
		253,
		203,
		"dd",
		253
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFD",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in L.",
		instruction: "set 7,(iy+dd),l"
	}
}, uw = {
	mnemonic: "set",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		254
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFE",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "set 7,(iy+dd)"
	}
}, dw = {
	mnemonic: "set",
	params: [
		"7",
		"(iy+dd)",
		"a"
	],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")",
		",",
		"a"
	],
	opcodes: [
		253,
		203,
		"dd",
		255
	],
	isPseudo: !1,
	clr: {
		opcodes: "FDCBFF",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Sets bit 7 of the memory location pointed to by IY plus <var>dd</var>. The result is then stored in A.",
		instruction: "set 7,(iy+dd),a"
	}
}, fw = {
	mnemonic: "pop",
	params: ["iy"],
	tokens: ["iy"],
	opcodes: [253, 225],
	isPseudo: !1,
	clr: {
		opcodes: "FDE1",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "The memory location pointed to by SP is stored into IYL and SP is incremented. The memory location pointed to by SP is stored into IYH and SP is incremented again.",
		instruction: "pop iy"
	}
}, pw = {
	mnemonic: "ex",
	params: ["(sp)", "iy"],
	tokens: [
		"(",
		"sp",
		")",
		",",
		"iy"
	],
	opcodes: [253, 227],
	isPseudo: !1,
	clr: {
		opcodes: "FDE3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Exchanges (SP) with IYL, and (SP+1) with IYH.",
		instruction: "ex (sp),iy"
	}
}, mw = {
	mnemonic: "ex",
	params: ["iy", "(sp)"],
	tokens: [
		"iy",
		",",
		"(",
		"sp",
		")"
	],
	opcodes: [253, 227],
	isPseudo: !0,
	clr: {
		opcodes: "FDE3",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 23,
		without_jump_clock_count: 23,
		description: "Exchanges (SP) with IYL, and (SP+1) with IYH.",
		instruction: "ex (sp),iy"
	}
}, hw = {
	mnemonic: "push",
	params: ["iy"],
	tokens: ["iy"],
	opcodes: [253, 229],
	isPseudo: !1,
	clr: {
		opcodes: "FDE5",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 15,
		without_jump_clock_count: 15,
		description: "SP is decremented and IYH is stored into the memory location pointed to by SP. SP is decremented again and IYL is stored into the memory location pointed to by SP.",
		instruction: "push iy"
	}
}, gw = {
	mnemonic: "jp",
	params: ["(iy)"],
	tokens: [
		"(",
		"iy",
		")"
	],
	opcodes: [253, 233],
	isPseudo: !1,
	clr: {
		opcodes: "FDE9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Loads the value of IY into PC.",
		instruction: "jp (iy)"
	}
}, _w = {
	mnemonic: "jp",
	params: ["iy"],
	tokens: ["iy"],
	opcodes: [253, 233],
	isPseudo: !0,
	clr: {
		opcodes: "FDE9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Loads the value of IY into PC.",
		instruction: "jp (iy)"
	}
}, vw = {
	mnemonic: "ld",
	params: ["sp", "iy"],
	tokens: [
		"sp",
		",",
		"iy"
	],
	opcodes: [253, 249],
	isPseudo: !1,
	clr: {
		opcodes: "FDF9",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 10,
		without_jump_clock_count: 10,
		description: "Loads the value of IY into SP.",
		instruction: "ld sp,iy"
	}
}, yw = {
	mnemonic: "cp",
	params: ["nn"],
	tokens: ["nn"],
	opcodes: [254, "nn"],
	isPseudo: !1,
	clr: {
		opcodes: "FE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp nn"
	}
}, bw = {
	mnemonic: "cp",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [254, "nn"],
	isPseudo: !0,
	clr: {
		opcodes: "FE",
		undocumented: !1,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 7,
		without_jump_clock_count: 7,
		description: "Subtracts <var>nn</var> from A and affects flags according to the result. A is not modified.",
		instruction: "cp nn"
	}
}, xw = {
	mnemonic: "rst",
	params: ["38"],
	tokens: ["38"],
	opcodes: [255],
	isPseudo: !1,
	clr: {
		opcodes: "FF",
		undocumented: !1,
		z180: !1,
		flags: "------",
		byte_count: 1,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "The current PC value plus one is pushed onto the stack, then is loaded with 56.",
		instruction: "rst 38"
	}
}, Sw = {
	mnemonic: "inc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 4],
	isPseudo: !1,
	aliasOf: Re,
	clr: {
		opcodes: "DD04",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to B.",
		instruction: "inc b"
	}
}, Cw = {
	mnemonic: "dec",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 5],
	isPseudo: !1,
	aliasOf: ze,
	clr: {
		opcodes: "DD05",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from B.",
		instruction: "dec b"
	}
}, ww = {
	mnemonic: "ld",
	params: ["b", "nn"],
	tokens: [
		"b",
		",",
		"nn"
	],
	opcodes: [
		221,
		6,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Be,
	clr: {
		opcodes: "DD06",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into B.",
		instruction: "ld b,nn"
	}
}, Tw = {
	mnemonic: "inc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 12],
	isPseudo: !1,
	aliasOf: qe,
	clr: {
		opcodes: "DD0C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to C.",
		instruction: "inc c"
	}
}, Ew = {
	mnemonic: "dec",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 13],
	isPseudo: !1,
	aliasOf: Je,
	clr: {
		opcodes: "DD0D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from C.",
		instruction: "dec c"
	}
}, Dw = {
	mnemonic: "ld",
	params: ["c", "nn"],
	tokens: [
		"c",
		",",
		"nn"
	],
	opcodes: [
		221,
		14,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Ye,
	clr: {
		opcodes: "DD0E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into C.",
		instruction: "ld c,nn"
	}
}, Ow = {
	mnemonic: "inc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 20],
	isPseudo: !1,
	aliasOf: tt,
	clr: {
		opcodes: "DD14",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to D.",
		instruction: "inc d"
	}
}, kw = {
	mnemonic: "dec",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 21],
	isPseudo: !1,
	aliasOf: nt,
	clr: {
		opcodes: "DD15",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from D.",
		instruction: "dec d"
	}
}, Aw = {
	mnemonic: "ld",
	params: ["d", "nn"],
	tokens: [
		"d",
		",",
		"nn"
	],
	opcodes: [
		221,
		22,
		"nn"
	],
	isPseudo: !1,
	aliasOf: rt,
	clr: {
		opcodes: "DD16",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into D.",
		instruction: "ld d,nn"
	}
}, jw = {
	mnemonic: "inc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 28],
	isPseudo: !1,
	aliasOf: lt,
	clr: {
		opcodes: "DD1C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to E.",
		instruction: "inc e"
	}
}, Mw = {
	mnemonic: "dec",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 29],
	isPseudo: !1,
	aliasOf: ut,
	clr: {
		opcodes: "DD1D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from E.",
		instruction: "dec e"
	}
}, Nw = {
	mnemonic: "ld",
	params: ["e", "nn"],
	tokens: [
		"e",
		",",
		"nn"
	],
	opcodes: [
		221,
		30,
		"nn"
	],
	isPseudo: !1,
	aliasOf: dt,
	clr: {
		opcodes: "DD1E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into E.",
		instruction: "ld e,nn"
	}
}, Pw = {
	mnemonic: "inc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 60],
	isPseudo: !1,
	aliasOf: Vt,
	clr: {
		opcodes: "DD3C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to A.",
		instruction: "inc a"
	}
}, Fw = {
	mnemonic: "dec",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 61],
	isPseudo: !1,
	aliasOf: Ht,
	clr: {
		opcodes: "DD3D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from A.",
		instruction: "dec a"
	}
}, Iw = {
	mnemonic: "ld",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [
		221,
		62,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Ut,
	clr: {
		opcodes: "DD3E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into A.",
		instruction: "ld a,nn"
	}
}, Lw = {
	mnemonic: "ld",
	params: ["b", "b"],
	tokens: [
		"b",
		",",
		"b"
	],
	opcodes: [221, 64],
	isPseudo: !1,
	aliasOf: Gt,
	clr: {
		opcodes: "DD40",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into B.",
		instruction: "ld b,b"
	}
}, Rw = {
	mnemonic: "ld",
	params: ["b", "c"],
	tokens: [
		"b",
		",",
		"c"
	],
	opcodes: [221, 65],
	isPseudo: !1,
	aliasOf: Kt,
	clr: {
		opcodes: "DD41",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into B.",
		instruction: "ld b,c"
	}
}, zw = {
	mnemonic: "ld",
	params: ["b", "d"],
	tokens: [
		"b",
		",",
		"d"
	],
	opcodes: [221, 66],
	isPseudo: !1,
	aliasOf: qt,
	clr: {
		opcodes: "DD42",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into B.",
		instruction: "ld b,d"
	}
}, Bw = {
	mnemonic: "ld",
	params: ["b", "e"],
	tokens: [
		"b",
		",",
		"e"
	],
	opcodes: [221, 67],
	isPseudo: !1,
	aliasOf: Jt,
	clr: {
		opcodes: "DD43",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into B.",
		instruction: "ld b,e"
	}
}, Vw = {
	mnemonic: "ld",
	params: ["b", "a"],
	tokens: [
		"b",
		",",
		"a"
	],
	opcodes: [221, 71],
	isPseudo: !1,
	aliasOf: $t,
	clr: {
		opcodes: "DD47",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into B.",
		instruction: "ld b,a"
	}
}, Hw = {
	mnemonic: "ld",
	params: ["c", "b"],
	tokens: [
		"c",
		",",
		"b"
	],
	opcodes: [221, 72],
	isPseudo: !1,
	aliasOf: en,
	clr: {
		opcodes: "DD48",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into C.",
		instruction: "ld c,b"
	}
}, Uw = {
	mnemonic: "ld",
	params: ["c", "c"],
	tokens: [
		"c",
		",",
		"c"
	],
	opcodes: [221, 73],
	isPseudo: !1,
	aliasOf: tn,
	clr: {
		opcodes: "DD49",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into C.",
		instruction: "ld c,c"
	}
}, Ww = {
	mnemonic: "ld",
	params: ["c", "d"],
	tokens: [
		"c",
		",",
		"d"
	],
	opcodes: [221, 74],
	isPseudo: !1,
	aliasOf: nn,
	clr: {
		opcodes: "DD4A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into C.",
		instruction: "ld c,d"
	}
}, Gw = {
	mnemonic: "ld",
	params: ["c", "e"],
	tokens: [
		"c",
		",",
		"e"
	],
	opcodes: [221, 75],
	isPseudo: !1,
	aliasOf: rn,
	clr: {
		opcodes: "DD4B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into C.",
		instruction: "ld c,e"
	}
}, Kw = {
	mnemonic: "ld",
	params: ["c", "a"],
	tokens: [
		"c",
		",",
		"a"
	],
	opcodes: [221, 79],
	isPseudo: !1,
	aliasOf: ln,
	clr: {
		opcodes: "DD4F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into C.",
		instruction: "ld c,a"
	}
}, qw = {
	mnemonic: "ld",
	params: ["d", "b"],
	tokens: [
		"d",
		",",
		"b"
	],
	opcodes: [221, 80],
	isPseudo: !1,
	aliasOf: un,
	clr: {
		opcodes: "DD50",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into D.",
		instruction: "ld d,b"
	}
}, Jw = {
	mnemonic: "ld",
	params: ["d", "c"],
	tokens: [
		"d",
		",",
		"c"
	],
	opcodes: [221, 81],
	isPseudo: !1,
	aliasOf: fn,
	clr: {
		opcodes: "DD51",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into D.",
		instruction: "ld d,c"
	}
}, Yw = {
	mnemonic: "ld",
	params: ["d", "d"],
	tokens: [
		"d",
		",",
		"d"
	],
	opcodes: [221, 82],
	isPseudo: !1,
	aliasOf: pn,
	clr: {
		opcodes: "DD52",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into D.",
		instruction: "ld d,d"
	}
}, Xw = {
	mnemonic: "ld",
	params: ["d", "e"],
	tokens: [
		"d",
		",",
		"e"
	],
	opcodes: [221, 83],
	isPseudo: !1,
	aliasOf: mn,
	clr: {
		opcodes: "DD53",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into D.",
		instruction: "ld d,e"
	}
}, Zw = {
	mnemonic: "ld",
	params: ["d", "a"],
	tokens: [
		"d",
		",",
		"a"
	],
	opcodes: [221, 87],
	isPseudo: !1,
	aliasOf: yn,
	clr: {
		opcodes: "DD57",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into D.",
		instruction: "ld d,a"
	}
}, Qw = {
	mnemonic: "ld",
	params: ["e", "b"],
	tokens: [
		"e",
		",",
		"b"
	],
	opcodes: [221, 88],
	isPseudo: !1,
	aliasOf: bn,
	clr: {
		opcodes: "DD58",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into E.",
		instruction: "ld e,b"
	}
}, $w = {
	mnemonic: "ld",
	params: ["e", "c"],
	tokens: [
		"e",
		",",
		"c"
	],
	opcodes: [221, 89],
	isPseudo: !1,
	aliasOf: xn,
	clr: {
		opcodes: "DD59",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into E.",
		instruction: "ld e,c"
	}
}, eT = {
	mnemonic: "ld",
	params: ["e", "d"],
	tokens: [
		"e",
		",",
		"d"
	],
	opcodes: [221, 90],
	isPseudo: !1,
	aliasOf: Sn,
	clr: {
		opcodes: "DD5A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into E.",
		instruction: "ld e,d"
	}
}, tT = {
	mnemonic: "ld",
	params: ["e", "e"],
	tokens: [
		"e",
		",",
		"e"
	],
	opcodes: [221, 91],
	isPseudo: !1,
	aliasOf: Cn,
	clr: {
		opcodes: "DD5B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into E.",
		instruction: "ld e,e"
	}
}, nT = {
	mnemonic: "ld",
	params: ["e", "a"],
	tokens: [
		"e",
		",",
		"a"
	],
	opcodes: [221, 95],
	isPseudo: !1,
	aliasOf: Dn,
	clr: {
		opcodes: "DD5F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into E.",
		instruction: "ld e,a"
	}
}, rT = {
	mnemonic: "ld",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [221, 120],
	isPseudo: !1,
	aliasOf: nr,
	clr: {
		opcodes: "DD78",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into A.",
		instruction: "ld a,b"
	}
}, iT = {
	mnemonic: "ld",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [221, 121],
	isPseudo: !1,
	aliasOf: rr,
	clr: {
		opcodes: "DD79",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into A.",
		instruction: "ld a,c"
	}
}, aT = {
	mnemonic: "ld",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [221, 122],
	isPseudo: !1,
	aliasOf: ir,
	clr: {
		opcodes: "DD7A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into A.",
		instruction: "ld a,d"
	}
}, oT = {
	mnemonic: "ld",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [221, 123],
	isPseudo: !1,
	aliasOf: ar,
	clr: {
		opcodes: "DD7B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into A.",
		instruction: "ld a,e"
	}
}, sT = {
	mnemonic: "ld",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [221, 127],
	isPseudo: !1,
	aliasOf: lr,
	clr: {
		opcodes: "DD7F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into A.",
		instruction: "ld a,a"
	}
}, cT = {
	mnemonic: "add",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [221, 128],
	isPseudo: !1,
	aliasOf: ur,
	clr: {
		opcodes: "DD80",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds B to A.",
		instruction: "add a,b"
	}
}, lT = {
	mnemonic: "add",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [221, 129],
	isPseudo: !1,
	aliasOf: fr,
	clr: {
		opcodes: "DD81",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds C to A.",
		instruction: "add a,c"
	}
}, uT = {
	mnemonic: "add",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [221, 130],
	isPseudo: !1,
	aliasOf: mr,
	clr: {
		opcodes: "DD82",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds D to A.",
		instruction: "add a,d"
	}
}, dT = {
	mnemonic: "add",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [221, 131],
	isPseudo: !1,
	aliasOf: gr,
	clr: {
		opcodes: "DD83",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds E to A.",
		instruction: "add a,e"
	}
}, fT = {
	mnemonic: "add",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [221, 135],
	isPseudo: !1,
	aliasOf: wr,
	clr: {
		opcodes: "DD87",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds A to A.",
		instruction: "add a,a"
	}
}, pT = {
	mnemonic: "adc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [221, 136],
	isPseudo: !1,
	aliasOf: Er,
	clr: {
		opcodes: "DD88",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds B and the carry flag to A.",
		instruction: "adc a,b"
	}
}, mT = {
	mnemonic: "adc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [221, 137],
	isPseudo: !1,
	aliasOf: Or,
	clr: {
		opcodes: "DD89",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds C and the carry flag to A.",
		instruction: "adc a,c"
	}
}, hT = {
	mnemonic: "adc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [221, 138],
	isPseudo: !1,
	aliasOf: Ar,
	clr: {
		opcodes: "DD8A",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds D and the carry flag to A.",
		instruction: "adc a,d"
	}
}, gT = {
	mnemonic: "adc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [221, 139],
	isPseudo: !1,
	aliasOf: Mr,
	clr: {
		opcodes: "DD8B",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds E and the carry flag to A.",
		instruction: "adc a,e"
	}
}, _T = {
	mnemonic: "adc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [221, 143],
	isPseudo: !1,
	aliasOf: Br,
	clr: {
		opcodes: "DD8F",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds A and the carry flag to A.",
		instruction: "adc a,a"
	}
}, vT = {
	mnemonic: "sub",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 144],
	isPseudo: !1,
	aliasOf: Hr,
	clr: {
		opcodes: "DD90",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B from A.",
		instruction: "sub b"
	}
}, yT = {
	mnemonic: "sub",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 145],
	isPseudo: !1,
	aliasOf: Wr,
	clr: {
		opcodes: "DD91",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C from A.",
		instruction: "sub c"
	}
}, bT = {
	mnemonic: "sub",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 146],
	isPseudo: !1,
	aliasOf: Kr,
	clr: {
		opcodes: "DD92",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D from A.",
		instruction: "sub d"
	}
}, xT = {
	mnemonic: "sub",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 147],
	isPseudo: !1,
	aliasOf: Jr,
	clr: {
		opcodes: "DD93",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E from A.",
		instruction: "sub e"
	}
}, ST = {
	mnemonic: "sub",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 151],
	isPseudo: !1,
	aliasOf: ni,
	clr: {
		opcodes: "DD97",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A from A.",
		instruction: "sub a"
	}
}, CT = {
	mnemonic: "sbc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [221, 152],
	isPseudo: !1,
	aliasOf: ii,
	clr: {
		opcodes: "DD98",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B and the carry flag from A.",
		instruction: "sbc a,b"
	}
}, wT = {
	mnemonic: "sbc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [221, 153],
	isPseudo: !1,
	aliasOf: oi,
	clr: {
		opcodes: "DD99",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C and the carry flag from A.",
		instruction: "sbc a,c"
	}
}, TT = {
	mnemonic: "sbc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [221, 154],
	isPseudo: !1,
	aliasOf: ci,
	clr: {
		opcodes: "DD9A",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D and the carry flag from A.",
		instruction: "sbc a,d"
	}
}, ET = {
	mnemonic: "sbc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [221, 155],
	isPseudo: !1,
	aliasOf: ui,
	clr: {
		opcodes: "DD9B",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E and the carry flag from A.",
		instruction: "sbc a,e"
	}
}, DT = {
	mnemonic: "sbc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [221, 159],
	isPseudo: !1,
	aliasOf: vi,
	clr: {
		opcodes: "DD9F",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A and the carry flag from A.",
		instruction: "sbc a,a"
	}
}, OT = {
	mnemonic: "and",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 160],
	isPseudo: !1,
	aliasOf: bi,
	clr: {
		opcodes: "DDA0",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with B.",
		instruction: "and b"
	}
}, kT = {
	mnemonic: "and",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 161],
	isPseudo: !1,
	aliasOf: Si,
	clr: {
		opcodes: "DDA1",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with C.",
		instruction: "and c"
	}
}, AT = {
	mnemonic: "and",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 162],
	isPseudo: !1,
	aliasOf: wi,
	clr: {
		opcodes: "DDA2",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with D.",
		instruction: "and d"
	}
}, jT = {
	mnemonic: "and",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 163],
	isPseudo: !1,
	aliasOf: Ei,
	clr: {
		opcodes: "DDA3",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with E.",
		instruction: "and e"
	}
}, MT = {
	mnemonic: "and",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 167],
	isPseudo: !1,
	aliasOf: Pi,
	clr: {
		opcodes: "DDA7",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with A.",
		instruction: "and a"
	}
}, NT = {
	mnemonic: "xor",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 168],
	isPseudo: !1,
	aliasOf: Ii,
	clr: {
		opcodes: "DDA8",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with B.",
		instruction: "xor b"
	}
}, PT = {
	mnemonic: "xor",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 169],
	isPseudo: !1,
	aliasOf: Ri,
	clr: {
		opcodes: "DDA9",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with C.",
		instruction: "xor c"
	}
}, FT = {
	mnemonic: "xor",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 170],
	isPseudo: !1,
	aliasOf: Bi,
	clr: {
		opcodes: "DDAA",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with D.",
		instruction: "xor d"
	}
}, IT = {
	mnemonic: "xor",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 171],
	isPseudo: !1,
	aliasOf: Hi,
	clr: {
		opcodes: "DDAB",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with E.",
		instruction: "xor e"
	}
}, LT = {
	mnemonic: "xor",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 175],
	isPseudo: !1,
	aliasOf: Xi,
	clr: {
		opcodes: "DDAF",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with A.",
		instruction: "xor a"
	}
}, RT = {
	mnemonic: "or",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 176],
	isPseudo: !1,
	aliasOf: Qi,
	clr: {
		opcodes: "DDB0",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with B.",
		instruction: "or b"
	}
}, zT = {
	mnemonic: "or",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 177],
	isPseudo: !1,
	aliasOf: ea,
	clr: {
		opcodes: "DDB1",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with C.",
		instruction: "or c"
	}
}, BT = {
	mnemonic: "or",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 178],
	isPseudo: !1,
	aliasOf: na,
	clr: {
		opcodes: "DDB2",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with D.",
		instruction: "or d"
	}
}, VT = {
	mnemonic: "or",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 179],
	isPseudo: !1,
	aliasOf: ia,
	clr: {
		opcodes: "DDB3",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with E.",
		instruction: "or e"
	}
}, HT = {
	mnemonic: "or",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 183],
	isPseudo: !1,
	aliasOf: fa,
	clr: {
		opcodes: "DDB7",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with A.",
		instruction: "or a"
	}
}, UT = {
	mnemonic: "cp",
	params: ["b"],
	tokens: ["b"],
	opcodes: [221, 184],
	isPseudo: !1,
	aliasOf: ma,
	clr: {
		opcodes: "DDB8",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B from A and affects flags according to the result. A is not modified.",
		instruction: "cp b"
	}
}, WT = {
	mnemonic: "cp",
	params: ["c"],
	tokens: ["c"],
	opcodes: [221, 185],
	isPseudo: !1,
	aliasOf: ga,
	clr: {
		opcodes: "DDB9",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C from A and affects flags according to the result. A is not modified.",
		instruction: "cp c"
	}
}, GT = {
	mnemonic: "cp",
	params: ["d"],
	tokens: ["d"],
	opcodes: [221, 186],
	isPseudo: !1,
	aliasOf: va,
	clr: {
		opcodes: "DDBA",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D from A and affects flags according to the result. A is not modified.",
		instruction: "cp d"
	}
}, KT = {
	mnemonic: "cp",
	params: ["e"],
	tokens: ["e"],
	opcodes: [221, 187],
	isPseudo: !1,
	aliasOf: ba,
	clr: {
		opcodes: "DDBB",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E from A and affects flags according to the result. A is not modified.",
		instruction: "cp e"
	}
}, qT = {
	mnemonic: "cp",
	params: ["a"],
	tokens: ["a"],
	opcodes: [221, 191],
	isPseudo: !1,
	aliasOf: Oa,
	clr: {
		opcodes: "DDBF",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A from A and affects flags according to the result. A is not modified.",
		instruction: "cp a"
	}
}, JT = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		64
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB40",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, YT = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		65
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB41",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, XT = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		66
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB42",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, ZT = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		67
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB43",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, QT = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		68
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB44",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, $T = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		69
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB45",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, eE = {
	mnemonic: "bit",
	params: ["0", "(ix+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		71
	],
	isPseudo: !1,
	aliasOf: L,
	clr: {
		opcodes: "DDCB47",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 0,(ix+dd)"
	}
}, tE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		72
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB48",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, nE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		73
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB49",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, rE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		74
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB4A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, iE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		75
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB4B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, aE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		76
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB4C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, oE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		77
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB4D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, sE = {
	mnemonic: "bit",
	params: ["1", "(ix+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		79
	],
	isPseudo: !1,
	aliasOf: R,
	clr: {
		opcodes: "DDCB4F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 1,(ix+dd)"
	}
}, cE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		80
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB50",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, lE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		81
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB51",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, uE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		82
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB52",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, dE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		83
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB53",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, fE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		84
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB54",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, pE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		85
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB55",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, mE = {
	mnemonic: "bit",
	params: ["2", "(ix+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		87
	],
	isPseudo: !1,
	aliasOf: z,
	clr: {
		opcodes: "DDCB57",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 2,(ix+dd)"
	}
}, hE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		88
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB58",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, gE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		89
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB59",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, _E = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		90
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB5A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, vE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		91
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB5B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, yE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		92
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB5C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, bE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		93
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB5D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, xE = {
	mnemonic: "bit",
	params: ["3", "(ix+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		95
	],
	isPseudo: !1,
	aliasOf: B,
	clr: {
		opcodes: "DDCB5F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 3,(ix+dd)"
	}
}, SE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		96
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB60",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, CE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		97
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB61",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, wE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		98
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB62",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, TE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		99
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB63",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, EE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		100
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB64",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, DE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		101
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB65",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, OE = {
	mnemonic: "bit",
	params: ["4", "(ix+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		103
	],
	isPseudo: !1,
	aliasOf: V,
	clr: {
		opcodes: "DDCB67",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 4,(ix+dd)"
	}
}, kE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		104
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB68",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, AE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		105
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB69",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, jE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		106
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB6A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, ME = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		107
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB6B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, NE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		108
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB6C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, PE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		109
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB6D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, FE = {
	mnemonic: "bit",
	params: ["5", "(ix+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		111
	],
	isPseudo: !1,
	aliasOf: H,
	clr: {
		opcodes: "DDCB6F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 5,(ix+dd)"
	}
}, IE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		112
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB70",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, LE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		113
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB71",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, RE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		114
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB72",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, zE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		115
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB73",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, BE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		116
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB74",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, VE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		117
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB75",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, HE = {
	mnemonic: "bit",
	params: ["6", "(ix+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		119
	],
	isPseudo: !1,
	aliasOf: U,
	clr: {
		opcodes: "DDCB77",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 6,(ix+dd)"
	}
}, UE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		120
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB78",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, WE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		121
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB79",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, GE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		122
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB7A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, KE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		123
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB7B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, qE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		124
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB7C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, JE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		125
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB7D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, YE = {
	mnemonic: "bit",
	params: ["7", "(ix+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"ix",
		"+",
		"dd",
		")"
	],
	opcodes: [
		221,
		203,
		"dd",
		127
	],
	isPseudo: !1,
	aliasOf: W,
	clr: {
		opcodes: "DDCB7F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IX plus <var>dd</var>.",
		instruction: "bit 7,(ix+dd)"
	}
}, XE = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 76],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED4C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, ZE = {
	mnemonic: "im",
	params: ["0"],
	tokens: ["0"],
	opcodes: [237, 78],
	isPseudo: !1,
	aliasOf: l_,
	clr: {
		opcodes: "ED4E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 0.",
		instruction: "im 0"
	}
}, QE = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 84],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED54",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, $E = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 85],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED55",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, eD = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 92],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED5C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, tD = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 93],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED5D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, nD = {
	mnemonic: "ld",
	params: ["(nnnn)", "hl"],
	tokens: [
		"(",
		"nnnn",
		")",
		",",
		"hl"
	],
	opcodes: [
		237,
		99,
		"nnnn"
	],
	isPseudo: !1,
	aliasOf: ht,
	clr: {
		opcodes: "ED63",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Stores HL into the memory location pointed to by <var>nnnn</var>.",
		instruction: "ld (nnnn),hl"
	}
}, rD = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 100],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED64",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, iD = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 101],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED65",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, aD = {
	mnemonic: "im",
	params: ["0"],
	tokens: ["0"],
	opcodes: [237, 102],
	isPseudo: !1,
	aliasOf: l_,
	clr: {
		opcodes: "ED66",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 0.",
		instruction: "im 0"
	}
}, oD = {
	mnemonic: "ld",
	params: ["hl", "(nnnn)"],
	tokens: [
		"hl",
		",",
		"(",
		"nnnn",
		")"
	],
	opcodes: [
		237,
		107,
		"nnnn"
	],
	isPseudo: !1,
	aliasOf: Ct,
	clr: {
		opcodes: "ED6B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Loads the value pointed to by <var>nnnn</var> into HL.",
		instruction: "ld hl,(nnnn)"
	}
}, sD = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 108],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED6C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, cD = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 109],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED6D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, lD = {
	mnemonic: "im",
	params: ["0"],
	tokens: ["0"],
	opcodes: [237, 110],
	isPseudo: !1,
	aliasOf: l_,
	clr: {
		opcodes: "ED6E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 0.",
		instruction: "im 0"
	}
}, uD = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 116],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED74",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, dD = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 117],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED75",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, fD = {
	mnemonic: "im",
	params: ["1"],
	tokens: ["1"],
	opcodes: [237, 118],
	isPseudo: !1,
	aliasOf: T_,
	clr: {
		opcodes: "ED76",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 1.",
		instruction: "im 1"
	}
}, pD = {
	mnemonic: "neg",
	params: [],
	tokens: [],
	opcodes: [237, 124],
	isPseudo: !1,
	aliasOf: G,
	clr: {
		opcodes: "ED7C",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are negated (two's complement). Operation is the same as subtracting A from zero.",
		instruction: "neg"
	}
}, mD = {
	mnemonic: "retn",
	params: [],
	tokens: [],
	opcodes: [237, 125],
	isPseudo: !1,
	aliasOf: c_,
	clr: {
		opcodes: "ED7D",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 14,
		without_jump_clock_count: 14,
		description: "Used at the end of a non-maskable interrupt service routine (located at 0066h) to pop the top stack entry into PC. The value of IFF2 is copied to IFF1 so that maskable interrupts are allowed to continue as before. NMIs are not enabled on the TI.",
		instruction: "retn"
	}
}, hD = {
	mnemonic: "im",
	params: ["2"],
	tokens: ["2"],
	opcodes: [237, 126],
	isPseudo: !1,
	aliasOf: N_,
	clr: {
		opcodes: "ED7E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Sets interrupt mode 2.",
		instruction: "im 2"
	}
}, gD = {
	mnemonic: "inc",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 4],
	isPseudo: !1,
	aliasOf: Re,
	clr: {
		opcodes: "FD04",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to B.",
		instruction: "inc b"
	}
}, _D = {
	mnemonic: "dec",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 5],
	isPseudo: !1,
	aliasOf: ze,
	clr: {
		opcodes: "FD05",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from B.",
		instruction: "dec b"
	}
}, vD = {
	mnemonic: "ld",
	params: ["b", "nn"],
	tokens: [
		"b",
		",",
		"nn"
	],
	opcodes: [
		253,
		6,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Be,
	clr: {
		opcodes: "FD06",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into B.",
		instruction: "ld b,nn"
	}
}, yD = {
	mnemonic: "inc",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 12],
	isPseudo: !1,
	aliasOf: qe,
	clr: {
		opcodes: "FD0C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to C.",
		instruction: "inc c"
	}
}, bD = {
	mnemonic: "dec",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 13],
	isPseudo: !1,
	aliasOf: Je,
	clr: {
		opcodes: "FD0D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from C.",
		instruction: "dec c"
	}
}, xD = {
	mnemonic: "ld",
	params: ["c", "nn"],
	tokens: [
		"c",
		",",
		"nn"
	],
	opcodes: [
		253,
		14,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Ye,
	clr: {
		opcodes: "FD0E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into C.",
		instruction: "ld c,nn"
	}
}, SD = {
	mnemonic: "inc",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 20],
	isPseudo: !1,
	aliasOf: tt,
	clr: {
		opcodes: "FD14",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to D.",
		instruction: "inc d"
	}
}, CD = {
	mnemonic: "dec",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 21],
	isPseudo: !1,
	aliasOf: nt,
	clr: {
		opcodes: "FD15",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from D.",
		instruction: "dec d"
	}
}, wD = {
	mnemonic: "ld",
	params: ["d", "nn"],
	tokens: [
		"d",
		",",
		"nn"
	],
	opcodes: [
		253,
		22,
		"nn"
	],
	isPseudo: !1,
	aliasOf: rt,
	clr: {
		opcodes: "FD16",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into D.",
		instruction: "ld d,nn"
	}
}, TD = {
	mnemonic: "inc",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 28],
	isPseudo: !1,
	aliasOf: lt,
	clr: {
		opcodes: "FD1C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to E.",
		instruction: "inc e"
	}
}, ED = {
	mnemonic: "dec",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 29],
	isPseudo: !1,
	aliasOf: ut,
	clr: {
		opcodes: "FD1D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from E.",
		instruction: "dec e"
	}
}, DD = {
	mnemonic: "ld",
	params: ["e", "nn"],
	tokens: [
		"e",
		",",
		"nn"
	],
	opcodes: [
		253,
		30,
		"nn"
	],
	isPseudo: !1,
	aliasOf: dt,
	clr: {
		opcodes: "FD1E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into E.",
		instruction: "ld e,nn"
	}
}, OD = {
	mnemonic: "inc",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 60],
	isPseudo: !1,
	aliasOf: Vt,
	clr: {
		opcodes: "FD3C",
		undocumented: !0,
		z180: !1,
		flags: "-0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds one to A.",
		instruction: "inc a"
	}
}, kD = {
	mnemonic: "dec",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 61],
	isPseudo: !1,
	aliasOf: Ht,
	clr: {
		opcodes: "FD3D",
		undocumented: !0,
		z180: !1,
		flags: "-1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts one from A.",
		instruction: "dec a"
	}
}, AD = {
	mnemonic: "ld",
	params: ["a", "nn"],
	tokens: [
		"a",
		",",
		"nn"
	],
	opcodes: [
		253,
		62,
		"nn"
	],
	isPseudo: !1,
	aliasOf: Ut,
	clr: {
		opcodes: "FD3E",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 3,
		with_jump_clock_count: 11,
		without_jump_clock_count: 11,
		description: "Loads <var>nn</var> into A.",
		instruction: "ld a,nn"
	}
}, jD = {
	mnemonic: "ld",
	params: ["b", "b"],
	tokens: [
		"b",
		",",
		"b"
	],
	opcodes: [253, 64],
	isPseudo: !1,
	aliasOf: Gt,
	clr: {
		opcodes: "FD40",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into B.",
		instruction: "ld b,b"
	}
}, MD = {
	mnemonic: "ld",
	params: ["b", "c"],
	tokens: [
		"b",
		",",
		"c"
	],
	opcodes: [253, 65],
	isPseudo: !1,
	aliasOf: Kt,
	clr: {
		opcodes: "FD41",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into B.",
		instruction: "ld b,c"
	}
}, ND = {
	mnemonic: "ld",
	params: ["b", "d"],
	tokens: [
		"b",
		",",
		"d"
	],
	opcodes: [253, 66],
	isPseudo: !1,
	aliasOf: qt,
	clr: {
		opcodes: "FD42",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into B.",
		instruction: "ld b,d"
	}
}, PD = {
	mnemonic: "ld",
	params: ["b", "e"],
	tokens: [
		"b",
		",",
		"e"
	],
	opcodes: [253, 67],
	isPseudo: !1,
	aliasOf: Jt,
	clr: {
		opcodes: "FD43",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into B.",
		instruction: "ld b,e"
	}
}, FD = {
	mnemonic: "ld",
	params: ["b", "a"],
	tokens: [
		"b",
		",",
		"a"
	],
	opcodes: [253, 71],
	isPseudo: !1,
	aliasOf: $t,
	clr: {
		opcodes: "FD47",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into B.",
		instruction: "ld b,a"
	}
}, ID = {
	mnemonic: "ld",
	params: ["c", "b"],
	tokens: [
		"c",
		",",
		"b"
	],
	opcodes: [253, 72],
	isPseudo: !1,
	aliasOf: en,
	clr: {
		opcodes: "FD48",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into C.",
		instruction: "ld c,b"
	}
}, LD = {
	mnemonic: "ld",
	params: ["c", "c"],
	tokens: [
		"c",
		",",
		"c"
	],
	opcodes: [253, 73],
	isPseudo: !1,
	aliasOf: tn,
	clr: {
		opcodes: "FD49",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into C.",
		instruction: "ld c,c"
	}
}, RD = {
	mnemonic: "ld",
	params: ["c", "d"],
	tokens: [
		"c",
		",",
		"d"
	],
	opcodes: [253, 74],
	isPseudo: !1,
	aliasOf: nn,
	clr: {
		opcodes: "FD4A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into C.",
		instruction: "ld c,d"
	}
}, zD = {
	mnemonic: "ld",
	params: ["c", "e"],
	tokens: [
		"c",
		",",
		"e"
	],
	opcodes: [253, 75],
	isPseudo: !1,
	aliasOf: rn,
	clr: {
		opcodes: "FD4B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into C.",
		instruction: "ld c,e"
	}
}, BD = {
	mnemonic: "ld",
	params: ["c", "a"],
	tokens: [
		"c",
		",",
		"a"
	],
	opcodes: [253, 79],
	isPseudo: !1,
	aliasOf: ln,
	clr: {
		opcodes: "FD4F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into C.",
		instruction: "ld c,a"
	}
}, VD = {
	mnemonic: "ld",
	params: ["d", "b"],
	tokens: [
		"d",
		",",
		"b"
	],
	opcodes: [253, 80],
	isPseudo: !1,
	aliasOf: un,
	clr: {
		opcodes: "FD50",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into D.",
		instruction: "ld d,b"
	}
}, HD = {
	mnemonic: "ld",
	params: ["d", "c"],
	tokens: [
		"d",
		",",
		"c"
	],
	opcodes: [253, 81],
	isPseudo: !1,
	aliasOf: fn,
	clr: {
		opcodes: "FD51",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into D.",
		instruction: "ld d,c"
	}
}, UD = {
	mnemonic: "ld",
	params: ["d", "d"],
	tokens: [
		"d",
		",",
		"d"
	],
	opcodes: [253, 82],
	isPseudo: !1,
	aliasOf: pn,
	clr: {
		opcodes: "FD52",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into D.",
		instruction: "ld d,d"
	}
}, WD = {
	mnemonic: "ld",
	params: ["d", "e"],
	tokens: [
		"d",
		",",
		"e"
	],
	opcodes: [253, 83],
	isPseudo: !1,
	aliasOf: mn,
	clr: {
		opcodes: "FD53",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into D.",
		instruction: "ld d,e"
	}
}, GD = {
	mnemonic: "ld",
	params: ["d", "a"],
	tokens: [
		"d",
		",",
		"a"
	],
	opcodes: [253, 87],
	isPseudo: !1,
	aliasOf: yn,
	clr: {
		opcodes: "FD57",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into D.",
		instruction: "ld d,a"
	}
}, KD = {
	mnemonic: "ld",
	params: ["e", "b"],
	tokens: [
		"e",
		",",
		"b"
	],
	opcodes: [253, 88],
	isPseudo: !1,
	aliasOf: bn,
	clr: {
		opcodes: "FD58",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into E.",
		instruction: "ld e,b"
	}
}, qD = {
	mnemonic: "ld",
	params: ["e", "c"],
	tokens: [
		"e",
		",",
		"c"
	],
	opcodes: [253, 89],
	isPseudo: !1,
	aliasOf: xn,
	clr: {
		opcodes: "FD59",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into E.",
		instruction: "ld e,c"
	}
}, JD = {
	mnemonic: "ld",
	params: ["e", "d"],
	tokens: [
		"e",
		",",
		"d"
	],
	opcodes: [253, 90],
	isPseudo: !1,
	aliasOf: Sn,
	clr: {
		opcodes: "FD5A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into E.",
		instruction: "ld e,d"
	}
}, YD = {
	mnemonic: "ld",
	params: ["e", "e"],
	tokens: [
		"e",
		",",
		"e"
	],
	opcodes: [253, 91],
	isPseudo: !1,
	aliasOf: Cn,
	clr: {
		opcodes: "FD5B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into E.",
		instruction: "ld e,e"
	}
}, XD = {
	mnemonic: "ld",
	params: ["e", "a"],
	tokens: [
		"e",
		",",
		"a"
	],
	opcodes: [253, 95],
	isPseudo: !1,
	aliasOf: Dn,
	clr: {
		opcodes: "FD5F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into E.",
		instruction: "ld e,a"
	}
}, ZD = {
	mnemonic: "ld",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [253, 120],
	isPseudo: !1,
	aliasOf: nr,
	clr: {
		opcodes: "FD78",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of B are loaded into A.",
		instruction: "ld a,b"
	}
}, QD = {
	mnemonic: "ld",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [253, 121],
	isPseudo: !1,
	aliasOf: rr,
	clr: {
		opcodes: "FD79",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of C are loaded into A.",
		instruction: "ld a,c"
	}
}, $D = {
	mnemonic: "ld",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [253, 122],
	isPseudo: !1,
	aliasOf: ir,
	clr: {
		opcodes: "FD7A",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of D are loaded into A.",
		instruction: "ld a,d"
	}
}, eO = {
	mnemonic: "ld",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [253, 123],
	isPseudo: !1,
	aliasOf: ar,
	clr: {
		opcodes: "FD7B",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of E are loaded into A.",
		instruction: "ld a,e"
	}
}, tO = {
	mnemonic: "ld",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [253, 127],
	isPseudo: !1,
	aliasOf: lr,
	clr: {
		opcodes: "FD7F",
		undocumented: !0,
		z180: !1,
		flags: "------",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "The contents of A are loaded into A.",
		instruction: "ld a,a"
	}
}, nO = {
	mnemonic: "add",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [253, 128],
	isPseudo: !1,
	aliasOf: ur,
	clr: {
		opcodes: "FD80",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds B to A.",
		instruction: "add a,b"
	}
}, rO = {
	mnemonic: "add",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [253, 129],
	isPseudo: !1,
	aliasOf: fr,
	clr: {
		opcodes: "FD81",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds C to A.",
		instruction: "add a,c"
	}
}, iO = {
	mnemonic: "add",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [253, 130],
	isPseudo: !1,
	aliasOf: mr,
	clr: {
		opcodes: "FD82",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds D to A.",
		instruction: "add a,d"
	}
}, aO = {
	mnemonic: "add",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [253, 131],
	isPseudo: !1,
	aliasOf: gr,
	clr: {
		opcodes: "FD83",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds E to A.",
		instruction: "add a,e"
	}
}, oO = {
	mnemonic: "add",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [253, 135],
	isPseudo: !1,
	aliasOf: wr,
	clr: {
		opcodes: "FD87",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds A to A.",
		instruction: "add a,a"
	}
}, sO = {
	mnemonic: "adc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [253, 136],
	isPseudo: !1,
	aliasOf: Er,
	clr: {
		opcodes: "FD88",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds B and the carry flag to A.",
		instruction: "adc a,b"
	}
}, cO = {
	mnemonic: "adc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [253, 137],
	isPseudo: !1,
	aliasOf: Or,
	clr: {
		opcodes: "FD89",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds C and the carry flag to A.",
		instruction: "adc a,c"
	}
}, lO = {
	mnemonic: "adc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [253, 138],
	isPseudo: !1,
	aliasOf: Ar,
	clr: {
		opcodes: "FD8A",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds D and the carry flag to A.",
		instruction: "adc a,d"
	}
}, uO = {
	mnemonic: "adc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [253, 139],
	isPseudo: !1,
	aliasOf: Mr,
	clr: {
		opcodes: "FD8B",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds E and the carry flag to A.",
		instruction: "adc a,e"
	}
}, dO = {
	mnemonic: "adc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [253, 143],
	isPseudo: !1,
	aliasOf: Br,
	clr: {
		opcodes: "FD8F",
		undocumented: !0,
		z180: !1,
		flags: "+0V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Adds A and the carry flag to A.",
		instruction: "adc a,a"
	}
}, fO = {
	mnemonic: "sub",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 144],
	isPseudo: !1,
	aliasOf: Hr,
	clr: {
		opcodes: "FD90",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B from A.",
		instruction: "sub b"
	}
}, pO = {
	mnemonic: "sub",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 145],
	isPseudo: !1,
	aliasOf: Wr,
	clr: {
		opcodes: "FD91",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C from A.",
		instruction: "sub c"
	}
}, mO = {
	mnemonic: "sub",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 146],
	isPseudo: !1,
	aliasOf: Kr,
	clr: {
		opcodes: "FD92",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D from A.",
		instruction: "sub d"
	}
}, hO = {
	mnemonic: "sub",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 147],
	isPseudo: !1,
	aliasOf: Jr,
	clr: {
		opcodes: "FD93",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E from A.",
		instruction: "sub e"
	}
}, gO = {
	mnemonic: "sub",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 151],
	isPseudo: !1,
	aliasOf: ni,
	clr: {
		opcodes: "FD97",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A from A.",
		instruction: "sub a"
	}
}, _O = {
	mnemonic: "sbc",
	params: ["a", "b"],
	tokens: [
		"a",
		",",
		"b"
	],
	opcodes: [253, 152],
	isPseudo: !1,
	aliasOf: ii,
	clr: {
		opcodes: "FD98",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B and the carry flag from A.",
		instruction: "sbc a,b"
	}
}, vO = {
	mnemonic: "sbc",
	params: ["a", "c"],
	tokens: [
		"a",
		",",
		"c"
	],
	opcodes: [253, 153],
	isPseudo: !1,
	aliasOf: oi,
	clr: {
		opcodes: "FD99",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C and the carry flag from A.",
		instruction: "sbc a,c"
	}
}, yO = {
	mnemonic: "sbc",
	params: ["a", "d"],
	tokens: [
		"a",
		",",
		"d"
	],
	opcodes: [253, 154],
	isPseudo: !1,
	aliasOf: ci,
	clr: {
		opcodes: "FD9A",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D and the carry flag from A.",
		instruction: "sbc a,d"
	}
}, bO = {
	mnemonic: "sbc",
	params: ["a", "e"],
	tokens: [
		"a",
		",",
		"e"
	],
	opcodes: [253, 155],
	isPseudo: !1,
	aliasOf: ui,
	clr: {
		opcodes: "FD9B",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E and the carry flag from A.",
		instruction: "sbc a,e"
	}
}, xO = {
	mnemonic: "sbc",
	params: ["a", "a"],
	tokens: [
		"a",
		",",
		"a"
	],
	opcodes: [253, 159],
	isPseudo: !1,
	aliasOf: vi,
	clr: {
		opcodes: "FD9F",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A and the carry flag from A.",
		instruction: "sbc a,a"
	}
}, SO = {
	mnemonic: "and",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 160],
	isPseudo: !1,
	aliasOf: bi,
	clr: {
		opcodes: "FDA0",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with B.",
		instruction: "and b"
	}
}, CO = {
	mnemonic: "and",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 161],
	isPseudo: !1,
	aliasOf: Si,
	clr: {
		opcodes: "FDA1",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with C.",
		instruction: "and c"
	}
}, wO = {
	mnemonic: "and",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 162],
	isPseudo: !1,
	aliasOf: wi,
	clr: {
		opcodes: "FDA2",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with D.",
		instruction: "and d"
	}
}, TO = {
	mnemonic: "and",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 163],
	isPseudo: !1,
	aliasOf: Ei,
	clr: {
		opcodes: "FDA3",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with E.",
		instruction: "and e"
	}
}, EO = {
	mnemonic: "and",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 167],
	isPseudo: !1,
	aliasOf: Pi,
	clr: {
		opcodes: "FDA7",
		undocumented: !0,
		z180: !1,
		flags: "00P1++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise AND on A with A.",
		instruction: "and a"
	}
}, DO = {
	mnemonic: "xor",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 168],
	isPseudo: !1,
	aliasOf: Ii,
	clr: {
		opcodes: "FDA8",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with B.",
		instruction: "xor b"
	}
}, OO = {
	mnemonic: "xor",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 169],
	isPseudo: !1,
	aliasOf: Ri,
	clr: {
		opcodes: "FDA9",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with C.",
		instruction: "xor c"
	}
}, kO = {
	mnemonic: "xor",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 170],
	isPseudo: !1,
	aliasOf: Bi,
	clr: {
		opcodes: "FDAA",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with D.",
		instruction: "xor d"
	}
}, AO = {
	mnemonic: "xor",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 171],
	isPseudo: !1,
	aliasOf: Hi,
	clr: {
		opcodes: "FDAB",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with E.",
		instruction: "xor e"
	}
}, jO = {
	mnemonic: "xor",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 175],
	isPseudo: !1,
	aliasOf: Xi,
	clr: {
		opcodes: "FDAF",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise XOR on A with A.",
		instruction: "xor a"
	}
}, MO = {
	mnemonic: "or",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 176],
	isPseudo: !1,
	aliasOf: Qi,
	clr: {
		opcodes: "FDB0",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with B.",
		instruction: "or b"
	}
}, NO = {
	mnemonic: "or",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 177],
	isPseudo: !1,
	aliasOf: ea,
	clr: {
		opcodes: "FDB1",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with C.",
		instruction: "or c"
	}
}, PO = {
	mnemonic: "or",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 178],
	isPseudo: !1,
	aliasOf: na,
	clr: {
		opcodes: "FDB2",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with D.",
		instruction: "or d"
	}
}, FO = {
	mnemonic: "or",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 179],
	isPseudo: !1,
	aliasOf: ia,
	clr: {
		opcodes: "FDB3",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with E.",
		instruction: "or e"
	}
}, IO = {
	mnemonic: "or",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 183],
	isPseudo: !1,
	aliasOf: fa,
	clr: {
		opcodes: "FDB7",
		undocumented: !0,
		z180: !1,
		flags: "00P0++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Bitwise OR on A with A.",
		instruction: "or a"
	}
}, LO = {
	mnemonic: "cp",
	params: ["b"],
	tokens: ["b"],
	opcodes: [253, 184],
	isPseudo: !1,
	aliasOf: ma,
	clr: {
		opcodes: "FDB8",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts B from A and affects flags according to the result. A is not modified.",
		instruction: "cp b"
	}
}, RO = {
	mnemonic: "cp",
	params: ["c"],
	tokens: ["c"],
	opcodes: [253, 185],
	isPseudo: !1,
	aliasOf: ga,
	clr: {
		opcodes: "FDB9",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts C from A and affects flags according to the result. A is not modified.",
		instruction: "cp c"
	}
}, zO = {
	mnemonic: "cp",
	params: ["d"],
	tokens: ["d"],
	opcodes: [253, 186],
	isPseudo: !1,
	aliasOf: va,
	clr: {
		opcodes: "FDBA",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts D from A and affects flags according to the result. A is not modified.",
		instruction: "cp d"
	}
}, BO = {
	mnemonic: "cp",
	params: ["e"],
	tokens: ["e"],
	opcodes: [253, 187],
	isPseudo: !1,
	aliasOf: ba,
	clr: {
		opcodes: "FDBB",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts E from A and affects flags according to the result. A is not modified.",
		instruction: "cp e"
	}
}, VO = {
	mnemonic: "cp",
	params: ["a"],
	tokens: ["a"],
	opcodes: [253, 191],
	isPseudo: !1,
	aliasOf: Oa,
	clr: {
		opcodes: "FDBF",
		undocumented: !0,
		z180: !1,
		flags: "+1V+++",
		byte_count: 2,
		with_jump_clock_count: 8,
		without_jump_clock_count: 8,
		description: "Subtracts A from A and affects flags according to the result. A is not modified.",
		instruction: "cp a"
	}
}, HO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		64
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB40",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, UO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		65
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB41",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, WO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		66
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB42",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, GO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		67
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB43",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, KO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		68
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB44",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, qO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		69
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB45",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, JO = {
	mnemonic: "bit",
	params: ["0", "(iy+dd)"],
	tokens: [
		"0",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		71
	],
	isPseudo: !1,
	aliasOf: K,
	clr: {
		opcodes: "FDCB47",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 0 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 0,(iy+dd)"
	}
}, YO = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		72
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB48",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, XO = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		73
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB49",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, ZO = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		74
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB4A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, QO = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		75
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB4B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, $O = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		76
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB4C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, ek = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		77
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB4D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, tk = {
	mnemonic: "bit",
	params: ["1", "(iy+dd)"],
	tokens: [
		"1",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		79
	],
	isPseudo: !1,
	aliasOf: q,
	clr: {
		opcodes: "FDCB4F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 1 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 1,(iy+dd)"
	}
}, nk = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		80
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB50",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, rk = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		81
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB51",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, ik = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		82
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB52",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, ak = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		83
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB53",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, ok = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		84
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB54",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, sk = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		85
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB55",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, ck = {
	mnemonic: "bit",
	params: ["2", "(iy+dd)"],
	tokens: [
		"2",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		87
	],
	isPseudo: !1,
	aliasOf: J,
	clr: {
		opcodes: "FDCB57",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 2 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 2,(iy+dd)"
	}
}, lk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		88
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB58",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, uk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		89
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB59",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, dk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		90
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB5A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, fk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		91
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB5B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, pk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		92
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB5C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, mk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		93
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB5D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, hk = {
	mnemonic: "bit",
	params: ["3", "(iy+dd)"],
	tokens: [
		"3",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		95
	],
	isPseudo: !1,
	aliasOf: Y,
	clr: {
		opcodes: "FDCB5F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 3 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 3,(iy+dd)"
	}
}, gk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		96
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB60",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, _k = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		97
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB61",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, vk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		98
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB62",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, yk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		99
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB63",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, bk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		100
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB64",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, xk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		101
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB65",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, Sk = {
	mnemonic: "bit",
	params: ["4", "(iy+dd)"],
	tokens: [
		"4",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		103
	],
	isPseudo: !1,
	aliasOf: X,
	clr: {
		opcodes: "FDCB67",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 4 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 4,(iy+dd)"
	}
}, Ck = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		104
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB68",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, wk = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		105
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB69",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Tk = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		106
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB6A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Ek = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		107
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB6B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Dk = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		108
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB6C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Ok = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		109
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB6D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, kk = {
	mnemonic: "bit",
	params: ["5", "(iy+dd)"],
	tokens: [
		"5",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		111
	],
	isPseudo: !1,
	aliasOf: Z,
	clr: {
		opcodes: "FDCB6F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 5 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 5,(iy+dd)"
	}
}, Ak = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		112
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB70",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, jk = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		113
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB71",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Mk = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		114
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB72",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Nk = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		115
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB73",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Pk = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		116
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB74",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Fk = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		117
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB75",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Ik = {
	mnemonic: "bit",
	params: ["6", "(iy+dd)"],
	tokens: [
		"6",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		119
	],
	isPseudo: !1,
	aliasOf: Wx,
	clr: {
		opcodes: "FDCB77",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 6 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 6,(iy+dd)"
	}
}, Lk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		120
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB78",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Rk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		121
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB79",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, zk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		122
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB7A",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Bk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		123
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB7B",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Vk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		124
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB7C",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Hk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		125
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB7D",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Uk = {
	mnemonic: "bit",
	params: ["7", "(iy+dd)"],
	tokens: [
		"7",
		",",
		"(",
		"iy",
		"+",
		"dd",
		")"
	],
	opcodes: [
		253,
		203,
		"dd",
		127
	],
	isPseudo: !1,
	aliasOf: Gx,
	clr: {
		opcodes: "FDCB7F",
		undocumented: !0,
		z180: !1,
		flags: "-0 1+ ",
		byte_count: 4,
		with_jump_clock_count: 20,
		without_jump_clock_count: 20,
		description: "Tests bit 7 of the memory location pointed to by IY plus <var>dd</var>.",
		instruction: "bit 7,(iy+dd)"
	}
}, Wk = /* @__PURE__ */ new Map([
	["adc", [
		Er,
		Dr,
		Or,
		kr,
		Ar,
		jr,
		Mr,
		Nr,
		Pr,
		Fr,
		Ir,
		Lr,
		Rr,
		zr,
		Br,
		Vr,
		ju,
		Mu,
		af,
		of,
		sf,
		cf,
		lf,
		uf,
		h_,
		j_,
		G_,
		rv,
		Ky,
		qy,
		Jy,
		Yy,
		Xy,
		Zy
	]],
	["add", [
		We,
		ot,
		St,
		Rt,
		ur,
		dr,
		fr,
		pr,
		mr,
		hr,
		gr,
		_r,
		vr,
		yr,
		br,
		xr,
		Sr,
		Cr,
		wr,
		Tr,
		Ia,
		La,
		Xu,
		Zu,
		id,
		pd,
		Qd,
		$d,
		ef,
		tf,
		nf,
		rf,
		Rv,
		zv,
		Kv,
		ty,
		By,
		Vy,
		Hy,
		Uy,
		Wy,
		Gy
	]],
	["and", [
		bi,
		xi,
		Si,
		Ci,
		wi,
		Ti,
		Ei,
		Di,
		Oi,
		ki,
		Ai,
		ji,
		Mi,
		Ni,
		Pi,
		Fi,
		Cf,
		wf,
		Tf,
		Ef,
		Df,
		Of,
		Ug,
		Wg,
		ub,
		db,
		fb,
		pb,
		mb,
		hb
	]],
	["bit", [
		$o,
		es,
		ts,
		ns,
		rs,
		is,
		as,
		os,
		ss,
		cs,
		ls,
		us,
		ds,
		fs,
		ps,
		ms,
		hs,
		gs,
		_s,
		vs,
		ys,
		bs,
		xs,
		Ss,
		Cs,
		ws,
		Ts,
		Es,
		Ds,
		Os,
		ks,
		As,
		js,
		Ms,
		Ns,
		Ps,
		Fs,
		Is,
		Ls,
		Rs,
		zs,
		Bs,
		Vs,
		Hs,
		Us,
		Ws,
		Gs,
		Ks,
		qs,
		Js,
		Ys,
		Xs,
		Zs,
		Qs,
		$s,
		ec,
		tc,
		nc,
		rc,
		ic,
		ac,
		oc,
		sc,
		cc,
		L,
		R,
		z,
		B,
		V,
		H,
		U,
		W,
		K,
		q,
		J,
		Y,
		X,
		Z,
		Wx,
		Gx
	]],
	["call", [
		Pa,
		ku,
		Au,
		zu,
		Yu,
		Bg,
		Vg,
		e_,
		t_,
		Ov,
		Lv
	]],
	["ccf", [Wt]],
	["cp", [
		ma,
		ha,
		ga,
		_a,
		va,
		ya,
		ba,
		xa,
		Sa,
		Ca,
		wa,
		Ta,
		Ea,
		Da,
		Oa,
		ka,
		Vf,
		Hf,
		Uf,
		Wf,
		Gf,
		Kf,
		Ob,
		kb,
		Ab,
		jb,
		Mb,
		Nb,
		yw,
		bw
	]],
	["cpd", [uv]],
	["cpdr", [vv]],
	["cpi", [ov]],
	["cpir", [mv]],
	["cpl", [Ot]],
	["daa", [bt]],
	["dec", [
		ze,
		Ke,
		Je,
		nt,
		ct,
		ut,
		vt,
		wt,
		Et,
		Pt,
		Bt,
		Ht,
		nd,
		od,
		cd,
		dd,
		Wv,
		Jv,
		Xv,
		$v
	]],
	["di", [Dv]],
	["djnz", [Ze]],
	["ei", [Iv]],
	["ex", [
		He,
		Ue,
		wg,
		Tg,
		Rg,
		zg,
		Qg,
		$g,
		pw,
		mw
	]],
	["exx", [Gu]],
	["halt", [er]],
	["im", [
		l_,
		T_,
		N_
	]],
	["in", [
		qu,
		Ju,
		n_,
		r_,
		d_,
		f_,
		y_,
		b_,
		D_,
		O_,
		F_,
		I_,
		V_,
		H_,
		q_,
		J_,
		$_,
		ev
	]],
	["inc", [
		Le,
		Re,
		qe,
		et,
		tt,
		lt,
		gt,
		_t,
		Tt,
		Mt,
		Nt,
		Vt,
		ed,
		td,
		sd,
		ud,
		Hv,
		Uv,
		Yv,
		Qv
	]],
	["ind", [dv]],
	["indr", [yv]],
	["ini", [sv]],
	["inir", [hv]],
	["jp", [
		Ma,
		Na,
		Va,
		Iu,
		Ku,
		Dg,
		Og,
		Ig,
		Lg,
		Jg,
		Yg,
		Xg,
		Zg,
		Ev,
		Fv,
		gw,
		_w
	]],
	["jr", [
		at,
		pt,
		xt,
		kt,
		Lt
	]],
	["ld", [
		Fe,
		Ie,
		Be,
		Ge,
		Ye,
		Qe,
		$e,
		rt,
		st,
		dt,
		mt,
		ht,
		yt,
		Ct,
		Dt,
		At,
		jt,
		Ft,
		zt,
		Ut,
		Gt,
		Kt,
		qt,
		Jt,
		Yt,
		Xt,
		Zt,
		Qt,
		$t,
		en,
		tn,
		nn,
		rn,
		an,
		on,
		sn,
		cn,
		ln,
		un,
		dn,
		fn,
		pn,
		mn,
		hn,
		gn,
		_n,
		vn,
		yn,
		bn,
		xn,
		Sn,
		Cn,
		wn,
		Tn,
		En,
		Dn,
		On,
		kn,
		An,
		jn,
		Mn,
		Nn,
		Pn,
		Fn,
		In,
		Ln,
		Rn,
		zn,
		Bn,
		Vn,
		Hn,
		Un,
		Wn,
		Gn,
		Kn,
		qn,
		Jn,
		Yn,
		Xn,
		Zn,
		Qn,
		$n,
		tr,
		nr,
		rr,
		ir,
		ar,
		or,
		sr,
		cr,
		lr,
		Qu,
		$u,
		rd,
		ad,
		ld,
		fd,
		md,
		hd,
		gd,
		_d,
		vd,
		yd,
		bd,
		xd,
		Sd,
		Cd,
		wd,
		Td,
		Ed,
		Dd,
		Od,
		kd,
		Ad,
		jd,
		Md,
		Nd,
		Pd,
		Fd,
		Id,
		Ld,
		Rd,
		zd,
		Bd,
		Vd,
		Hd,
		Ud,
		Wd,
		Gd,
		Kd,
		qd,
		Jd,
		Yd,
		Xd,
		Zd,
		kg,
		s_,
		u_,
		g_,
		v_,
		w_,
		E_,
		M_,
		P_,
		Q_,
		iv,
		Pv,
		Bv,
		Vv,
		Gv,
		qv,
		Zv,
		ey,
		ny,
		ry,
		iy,
		ay,
		oy,
		sy,
		cy,
		ly,
		uy,
		dy,
		fy,
		py,
		my,
		hy,
		gy,
		_y,
		vy,
		yy,
		by,
		xy,
		Sy,
		Cy,
		wy,
		Ty,
		Ey,
		Dy,
		Oy,
		ky,
		Ay,
		jy,
		My,
		Ny,
		Py,
		Fy,
		Iy,
		Ly,
		Ry,
		zy,
		vw
	]],
	["ldd", [lv]],
	["lddr", [_v]],
	["ldi", [av]],
	["ldir", [pv]],
	["neg", [G]],
	["nop", [Pe]],
	["or", [
		Qi,
		$i,
		ea,
		ta,
		na,
		ra,
		ia,
		aa,
		oa,
		sa,
		ca,
		la,
		ua,
		da,
		fa,
		pa,
		Ff,
		If,
		Lf,
		Rf,
		zf,
		Bf,
		Av,
		jv,
		Sb,
		Cb,
		wb,
		Tb,
		Eb,
		Db
	]],
	["otdr", [bv]],
	["otir", [gv]],
	["out", [
		Lu,
		Ru,
		i_,
		a_,
		p_,
		m_,
		x_,
		S_,
		k_,
		A_,
		L_,
		R_,
		U_,
		W_,
		Y_,
		X_,
		tv,
		nv
	]],
	["outd", [fv]],
	["outi", [cv]],
	["pop", [
		ja,
		Fu,
		Cg,
		Fg,
		Tv,
		fw
	]],
	["push", [
		Fa,
		Bu,
		Eg,
		Hg,
		kv,
		hw
	]],
	["res", [
		lc,
		uc,
		dc,
		fc,
		pc,
		mc,
		hc,
		gc,
		_c,
		vc,
		yc,
		bc,
		xc,
		Sc,
		Cc,
		wc,
		Tc,
		Ec,
		Dc,
		Oc,
		kc,
		Ac,
		jc,
		Mc,
		Nc,
		Pc,
		Fc,
		Ic,
		Lc,
		Rc,
		zc,
		Bc,
		Vc,
		Hc,
		Uc,
		Wc,
		Gc,
		Kc,
		qc,
		Jc,
		Yc,
		Xc,
		Zc,
		Qc,
		$c,
		el,
		tl,
		nl,
		rl,
		il,
		al,
		ol,
		sl,
		cl,
		ll,
		ul,
		dl,
		fl,
		pl,
		ml,
		hl,
		gl,
		_l,
		vl,
		rm,
		im,
		am,
		om,
		sm,
		cm,
		lm,
		um,
		dm,
		fm,
		pm,
		mm,
		hm,
		gm,
		_m,
		vm,
		ym,
		bm,
		xm,
		Sm,
		Cm,
		wm,
		Tm,
		Em,
		Dm,
		Om,
		km,
		Am,
		jm,
		Mm,
		Nm,
		Pm,
		Fm,
		Im,
		Lm,
		Rm,
		zm,
		Bm,
		Vm,
		Hm,
		Um,
		Wm,
		Gm,
		Km,
		qm,
		Jm,
		Ym,
		Xm,
		Zm,
		Qm,
		$m,
		eh,
		th,
		nh,
		rh,
		ih,
		ah,
		oh,
		sh,
		ch,
		lh,
		uh,
		dh,
		fh,
		Kx,
		qx,
		Jx,
		Yx,
		Xx,
		Zx,
		Qx,
		$x,
		eS,
		tS,
		nS,
		rS,
		iS,
		aS,
		oS,
		sS,
		cS,
		lS,
		uS,
		dS,
		fS,
		pS,
		mS,
		hS,
		gS,
		_S,
		vS,
		yS,
		bS,
		xS,
		SS,
		CS,
		wS,
		TS,
		ES,
		DS,
		OS,
		kS,
		AS,
		jS,
		MS,
		NS,
		PS,
		FS,
		IS,
		LS,
		RS,
		zS,
		BS,
		VS,
		HS,
		US,
		WS,
		GS,
		KS,
		qS,
		JS,
		YS,
		XS,
		ZS,
		QS,
		$S,
		eC,
		tC
	]],
	["ret", [
		Aa,
		za,
		Ba,
		Pu,
		Wu,
		Ng,
		Pg,
		Kg,
		qg,
		wv,
		Nv
	]],
	["reti", [__]],
	["retn", [c_]],
	["rl", [
		io,
		ao,
		oo,
		so,
		co,
		lo,
		uo,
		fo,
		lp,
		up,
		dp,
		fp,
		pp,
		mp,
		hp,
		gp,
		Xb,
		Zb,
		Qb,
		$b,
		ex,
		tx,
		nx,
		rx
	]],
	["rla", [it]],
	["rlc", [
		Ha,
		Ua,
		Wa,
		Ga,
		Ka,
		qa,
		Ja,
		Ya,
		qf,
		Jf,
		Yf,
		Xf,
		Zf,
		Qf,
		$f,
		ep,
		Pb,
		Fb,
		Ib,
		Lb,
		Rb,
		zb,
		Bb,
		Vb
	]],
	["rlca", [Ve]],
	["rld", [K_]],
	["rr", [
		po,
		mo,
		ho,
		go,
		_o,
		vo,
		yo,
		bo,
		_p,
		vp,
		yp,
		bp,
		xp,
		Sp,
		Cp,
		wp,
		ix,
		ax,
		ox,
		sx,
		cx,
		lx,
		ux,
		dx
	]],
	["rra", [ft]],
	["rrc", [
		Xa,
		Za,
		Qa,
		$a,
		eo,
		to,
		no,
		ro,
		tp,
		np,
		rp,
		ip,
		ap,
		op,
		sp,
		cp,
		Hb,
		Ub,
		Wb,
		Gb,
		Kb,
		qb,
		Jb,
		Yb
	]],
	["rrca", [Xe]],
	["rrd", [B_]],
	["rst", [
		Ra,
		Nu,
		Uu,
		Mg,
		Gg,
		Cv,
		Mv,
		xw
	]],
	["sbc", [
		ii,
		ai,
		oi,
		si,
		ci,
		li,
		ui,
		di,
		fi,
		pi,
		mi,
		hi,
		gi,
		_i,
		vi,
		yi,
		_f,
		vf,
		yf,
		bf,
		xf,
		Sf,
		Ag,
		jg,
		o_,
		C_,
		z_,
		Z_,
		ib,
		ab,
		ob,
		sb,
		cb,
		lb
	]],
	["scf", [It]],
	["set", [
		yl,
		bl,
		xl,
		Sl,
		Cl,
		wl,
		Tl,
		El,
		Dl,
		Ol,
		kl,
		Al,
		jl,
		Ml,
		Nl,
		Pl,
		Fl,
		Il,
		Ll,
		Rl,
		zl,
		Bl,
		Vl,
		Hl,
		Ul,
		Wl,
		Gl,
		Kl,
		ql,
		Jl,
		Yl,
		Xl,
		Zl,
		Ql,
		$l,
		eu,
		tu,
		nu,
		ru,
		iu,
		au,
		ou,
		su,
		cu,
		lu,
		uu,
		du,
		fu,
		pu,
		mu,
		hu,
		gu,
		_u,
		vu,
		yu,
		bu,
		xu,
		Su,
		Cu,
		wu,
		Tu,
		Eu,
		Du,
		Ou,
		ph,
		mh,
		hh,
		gh,
		_h,
		vh,
		yh,
		bh,
		xh,
		Sh,
		Ch,
		wh,
		Th,
		Eh,
		Dh,
		Oh,
		kh,
		Ah,
		jh,
		Mh,
		Nh,
		Ph,
		Fh,
		Ih,
		Lh,
		Rh,
		zh,
		Bh,
		Vh,
		Hh,
		Uh,
		Wh,
		Gh,
		Kh,
		qh,
		Jh,
		Yh,
		Xh,
		Zh,
		Qh,
		$h,
		eg,
		tg,
		ng,
		rg,
		ig,
		ag,
		og,
		sg,
		cg,
		lg,
		ug,
		dg,
		fg,
		pg,
		mg,
		hg,
		gg,
		_g,
		vg,
		yg,
		bg,
		xg,
		Sg,
		nC,
		rC,
		iC,
		aC,
		oC,
		sC,
		cC,
		lC,
		uC,
		dC,
		fC,
		pC,
		mC,
		hC,
		gC,
		_C,
		vC,
		yC,
		bC,
		xC,
		SC,
		CC,
		wC,
		TC,
		EC,
		DC,
		OC,
		kC,
		AC,
		jC,
		MC,
		NC,
		PC,
		FC,
		IC,
		LC,
		RC,
		zC,
		BC,
		VC,
		HC,
		UC,
		WC,
		GC,
		KC,
		qC,
		JC,
		YC,
		XC,
		ZC,
		QC,
		$C,
		ew,
		tw,
		nw,
		rw,
		iw,
		aw,
		ow,
		sw,
		cw,
		lw,
		uw,
		dw
	]],
	["sla", [
		xo,
		So,
		Co,
		wo,
		To,
		Eo,
		Do,
		Oo,
		Tp,
		Ep,
		Dp,
		Op,
		kp,
		Ap,
		jp,
		Mp,
		fx,
		px,
		mx,
		hx,
		gx,
		_x,
		vx,
		yx
	]],
	["sll", [
		Lo,
		Ro,
		zo,
		Bo,
		Vo,
		Ho,
		Uo,
		Wo,
		Vp,
		Hp,
		Up,
		Wp,
		Gp,
		Kp,
		qp,
		Jp,
		Ox,
		kx,
		Ax,
		jx,
		Mx,
		Nx,
		Px,
		Fx
	]],
	["sra", [
		ko,
		Ao,
		jo,
		Mo,
		No,
		Po,
		Fo,
		Io,
		Np,
		Pp,
		Fp,
		Ip,
		Lp,
		Rp,
		zp,
		Bp,
		bx,
		xx,
		Sx,
		Cx,
		wx,
		Tx,
		Ex,
		Dx
	]],
	["srl", [
		Go,
		Ko,
		qo,
		Jo,
		Yo,
		Xo,
		Zo,
		Qo,
		Yp,
		Xp,
		Zp,
		Qp,
		$p,
		em,
		tm,
		nm,
		Ix,
		Lx,
		Rx,
		zx,
		Bx,
		Vx,
		Hx,
		Ux
	]],
	["sub", [
		Hr,
		Ur,
		Wr,
		Gr,
		Kr,
		qr,
		Jr,
		Yr,
		Xr,
		Zr,
		Qr,
		$r,
		ei,
		ti,
		ni,
		ri,
		Vu,
		Hu,
		df,
		ff,
		pf,
		mf,
		hf,
		gf,
		Qy,
		$y,
		eb,
		tb,
		nb,
		rb
	]],
	["xor", [
		Ii,
		Li,
		Ri,
		zi,
		Bi,
		Vi,
		Hi,
		Ui,
		Wi,
		Gi,
		Ki,
		qi,
		Ji,
		Yi,
		Xi,
		Zi,
		kf,
		Af,
		jf,
		Mf,
		Nf,
		Pf,
		xv,
		Sv,
		gb,
		_b,
		vb,
		yb,
		bb,
		xb
	]]
]), Gk = /* @__PURE__ */ new Map([
	[0, Pe],
	[1, Fe],
	[2, Ie],
	[3, Le],
	[4, Re],
	[5, ze],
	[6, Be],
	[7, Ve],
	[8, He],
	[9, We],
	[10, Ge],
	[11, Ke],
	[12, qe],
	[13, Je],
	[14, Ye],
	[15, Xe],
	[16, Ze],
	[17, Qe],
	[18, $e],
	[19, et],
	[20, tt],
	[21, nt],
	[22, rt],
	[23, it],
	[24, at],
	[25, ot],
	[26, st],
	[27, ct],
	[28, lt],
	[29, ut],
	[30, dt],
	[31, ft],
	[32, pt],
	[33, mt],
	[34, ht],
	[35, gt],
	[36, _t],
	[37, vt],
	[38, yt],
	[39, bt],
	[40, xt],
	[41, St],
	[42, Ct],
	[43, wt],
	[44, Tt],
	[45, Et],
	[46, Dt],
	[47, Ot],
	[48, kt],
	[49, At],
	[50, jt],
	[51, Mt],
	[52, Nt],
	[53, Pt],
	[54, Ft],
	[55, It],
	[56, Lt],
	[57, Rt],
	[58, zt],
	[59, Bt],
	[60, Vt],
	[61, Ht],
	[62, Ut],
	[63, Wt],
	[64, Gt],
	[65, Kt],
	[66, qt],
	[67, Jt],
	[68, Yt],
	[69, Zt],
	[70, Qt],
	[71, $t],
	[72, en],
	[73, tn],
	[74, nn],
	[75, rn],
	[76, an],
	[77, on],
	[78, sn],
	[79, ln],
	[80, un],
	[81, fn],
	[82, pn],
	[83, mn],
	[84, hn],
	[85, _n],
	[86, vn],
	[87, yn],
	[88, bn],
	[89, xn],
	[90, Sn],
	[91, Cn],
	[92, wn],
	[93, Tn],
	[94, En],
	[95, Dn],
	[96, On],
	[97, An],
	[98, jn],
	[99, Nn],
	[100, Pn],
	[101, Fn],
	[102, In],
	[103, Ln],
	[104, Rn],
	[105, zn],
	[106, Bn],
	[107, Vn],
	[108, Hn],
	[109, Un],
	[110, Wn],
	[111, Gn],
	[112, Kn],
	[113, qn],
	[114, Yn],
	[115, Xn],
	[116, Qn],
	[117, $n],
	[118, er],
	[119, tr],
	[120, nr],
	[121, rr],
	[122, ir],
	[123, ar],
	[124, or],
	[125, sr],
	[126, cr],
	[127, lr],
	[128, ur],
	[129, fr],
	[130, mr],
	[131, gr],
	[132, vr],
	[133, br],
	[134, Sr],
	[135, wr],
	[136, Er],
	[137, Or],
	[138, Ar],
	[139, Mr],
	[140, Pr],
	[141, Ir],
	[142, Rr],
	[143, Br],
	[144, Hr],
	[145, Wr],
	[146, Kr],
	[147, Jr],
	[148, Xr],
	[149, Qr],
	[150, ei],
	[151, ni],
	[152, ii],
	[153, oi],
	[154, ci],
	[155, ui],
	[156, fi],
	[157, mi],
	[158, gi],
	[159, vi],
	[160, bi],
	[161, Si],
	[162, wi],
	[163, Ei],
	[164, Oi],
	[165, Ai],
	[166, Mi],
	[167, Pi],
	[168, Ii],
	[169, Ri],
	[170, Bi],
	[171, Hi],
	[172, Wi],
	[173, Ki],
	[174, Ji],
	[175, Xi],
	[176, Qi],
	[177, ea],
	[178, na],
	[179, ia],
	[180, oa],
	[181, ca],
	[182, ua],
	[183, fa],
	[184, ma],
	[185, ga],
	[186, va],
	[187, ba],
	[188, Sa],
	[189, wa],
	[190, Ea],
	[191, Oa],
	[192, Aa],
	[193, ja],
	[194, Ma],
	[195, Na],
	[196, Pa],
	[197, Fa],
	[198, Ia],
	[199, Ra],
	[200, za],
	[201, Ba],
	[202, Va],
	[203, /* @__PURE__ */ new Map([
		[0, Ha],
		[1, Ua],
		[2, Wa],
		[3, Ga],
		[4, Ka],
		[5, qa],
		[6, Ja],
		[7, Ya],
		[8, Xa],
		[9, Za],
		[10, Qa],
		[11, $a],
		[12, eo],
		[13, to],
		[14, no],
		[15, ro],
		[16, io],
		[17, ao],
		[18, oo],
		[19, so],
		[20, co],
		[21, lo],
		[22, uo],
		[23, fo],
		[24, po],
		[25, mo],
		[26, ho],
		[27, go],
		[28, _o],
		[29, vo],
		[30, yo],
		[31, bo],
		[32, xo],
		[33, So],
		[34, Co],
		[35, wo],
		[36, To],
		[37, Eo],
		[38, Do],
		[39, Oo],
		[40, ko],
		[41, Ao],
		[42, jo],
		[43, Mo],
		[44, No],
		[45, Po],
		[46, Fo],
		[47, Io],
		[48, Lo],
		[49, Ro],
		[50, zo],
		[51, Bo],
		[52, Vo],
		[53, Ho],
		[54, Uo],
		[55, Wo],
		[56, Go],
		[57, Ko],
		[58, qo],
		[59, Jo],
		[60, Yo],
		[61, Xo],
		[62, Zo],
		[63, Qo],
		[64, $o],
		[65, es],
		[66, ts],
		[67, ns],
		[68, rs],
		[69, is],
		[70, as],
		[71, os],
		[72, ss],
		[73, cs],
		[74, ls],
		[75, us],
		[76, ds],
		[77, fs],
		[78, ps],
		[79, ms],
		[80, hs],
		[81, gs],
		[82, _s],
		[83, vs],
		[84, ys],
		[85, bs],
		[86, xs],
		[87, Ss],
		[88, Cs],
		[89, ws],
		[90, Ts],
		[91, Es],
		[92, Ds],
		[93, Os],
		[94, ks],
		[95, As],
		[96, js],
		[97, Ms],
		[98, Ns],
		[99, Ps],
		[100, Fs],
		[101, Is],
		[102, Ls],
		[103, Rs],
		[104, zs],
		[105, Bs],
		[106, Vs],
		[107, Hs],
		[108, Us],
		[109, Ws],
		[110, Gs],
		[111, Ks],
		[112, qs],
		[113, Js],
		[114, Ys],
		[115, Xs],
		[116, Zs],
		[117, Qs],
		[118, $s],
		[119, ec],
		[120, tc],
		[121, nc],
		[122, rc],
		[123, ic],
		[124, ac],
		[125, oc],
		[126, sc],
		[127, cc],
		[128, lc],
		[129, uc],
		[130, dc],
		[131, fc],
		[132, pc],
		[133, mc],
		[134, hc],
		[135, gc],
		[136, _c],
		[137, vc],
		[138, yc],
		[139, bc],
		[140, xc],
		[141, Sc],
		[142, Cc],
		[143, wc],
		[144, Tc],
		[145, Ec],
		[146, Dc],
		[147, Oc],
		[148, kc],
		[149, Ac],
		[150, jc],
		[151, Mc],
		[152, Nc],
		[153, Pc],
		[154, Fc],
		[155, Ic],
		[156, Lc],
		[157, Rc],
		[158, zc],
		[159, Bc],
		[160, Vc],
		[161, Hc],
		[162, Uc],
		[163, Wc],
		[164, Gc],
		[165, Kc],
		[166, qc],
		[167, Jc],
		[168, Yc],
		[169, Xc],
		[170, Zc],
		[171, Qc],
		[172, $c],
		[173, el],
		[174, tl],
		[175, nl],
		[176, rl],
		[177, il],
		[178, al],
		[179, ol],
		[180, sl],
		[181, cl],
		[182, ll],
		[183, ul],
		[184, dl],
		[185, fl],
		[186, pl],
		[187, ml],
		[188, hl],
		[189, gl],
		[190, _l],
		[191, vl],
		[192, yl],
		[193, bl],
		[194, xl],
		[195, Sl],
		[196, Cl],
		[197, wl],
		[198, Tl],
		[199, El],
		[200, Dl],
		[201, Ol],
		[202, kl],
		[203, Al],
		[204, jl],
		[205, Ml],
		[206, Nl],
		[207, Pl],
		[208, Fl],
		[209, Il],
		[210, Ll],
		[211, Rl],
		[212, zl],
		[213, Bl],
		[214, Vl],
		[215, Hl],
		[216, Ul],
		[217, Wl],
		[218, Gl],
		[219, Kl],
		[220, ql],
		[221, Jl],
		[222, Yl],
		[223, Xl],
		[224, Zl],
		[225, Ql],
		[226, $l],
		[227, eu],
		[228, tu],
		[229, nu],
		[230, ru],
		[231, iu],
		[232, au],
		[233, ou],
		[234, su],
		[235, cu],
		[236, lu],
		[237, uu],
		[238, du],
		[239, fu],
		[240, pu],
		[241, mu],
		[242, hu],
		[243, gu],
		[244, _u],
		[245, vu],
		[246, yu],
		[247, bu],
		[248, xu],
		[249, Su],
		[250, Cu],
		[251, wu],
		[252, Tu],
		[253, Eu],
		[254, Du],
		[255, Ou]
	])],
	[204, ku],
	[205, Au],
	[206, ju],
	[207, Nu],
	[208, Pu],
	[209, Fu],
	[210, Iu],
	[211, Lu],
	[212, zu],
	[213, Bu],
	[214, Vu],
	[215, Uu],
	[216, Wu],
	[217, Gu],
	[218, Ku],
	[219, qu],
	[220, Yu],
	[221, /* @__PURE__ */ new Map([
		[4, Sw],
		[5, Cw],
		[6, ww],
		[9, Xu],
		[12, Tw],
		[13, Ew],
		[14, Dw],
		[20, Ow],
		[21, kw],
		[22, Aw],
		[25, Zu],
		[28, jw],
		[29, Mw],
		[30, Nw],
		[33, Qu],
		[34, $u],
		[35, ed],
		[36, td],
		[37, nd],
		[38, rd],
		[41, id],
		[42, ad],
		[43, od],
		[44, sd],
		[45, cd],
		[46, ld],
		[52, ud],
		[53, dd],
		[54, fd],
		[57, pd],
		[60, Pw],
		[61, Fw],
		[62, Iw],
		[64, Lw],
		[65, Rw],
		[66, zw],
		[67, Bw],
		[68, md],
		[69, hd],
		[70, gd],
		[71, Vw],
		[72, Hw],
		[73, Uw],
		[74, Ww],
		[75, Gw],
		[76, _d],
		[77, vd],
		[78, yd],
		[79, Kw],
		[80, qw],
		[81, Jw],
		[82, Yw],
		[83, Xw],
		[84, bd],
		[85, xd],
		[86, Sd],
		[87, Zw],
		[88, Qw],
		[89, $w],
		[90, eT],
		[91, tT],
		[92, Cd],
		[93, wd],
		[94, Td],
		[95, nT],
		[96, Ed],
		[97, Dd],
		[98, Od],
		[99, kd],
		[100, Ad],
		[101, jd],
		[102, Md],
		[103, Nd],
		[104, Pd],
		[105, Fd],
		[106, Id],
		[107, Ld],
		[108, Rd],
		[109, zd],
		[110, Bd],
		[111, Vd],
		[112, Hd],
		[113, Ud],
		[114, Wd],
		[115, Gd],
		[116, Kd],
		[117, qd],
		[119, Jd],
		[120, rT],
		[121, iT],
		[122, aT],
		[123, oT],
		[124, Yd],
		[125, Xd],
		[126, Zd],
		[127, sT],
		[128, cT],
		[129, lT],
		[130, uT],
		[131, dT],
		[132, Qd],
		[133, ef],
		[134, nf],
		[135, fT],
		[136, pT],
		[137, mT],
		[138, hT],
		[139, gT],
		[140, af],
		[141, sf],
		[142, lf],
		[143, _T],
		[144, vT],
		[145, yT],
		[146, bT],
		[147, xT],
		[148, df],
		[149, pf],
		[150, hf],
		[151, ST],
		[152, CT],
		[153, wT],
		[154, TT],
		[155, ET],
		[156, _f],
		[157, yf],
		[158, xf],
		[159, DT],
		[160, OT],
		[161, kT],
		[162, AT],
		[163, jT],
		[164, Cf],
		[165, Tf],
		[166, Df],
		[167, MT],
		[168, NT],
		[169, PT],
		[170, FT],
		[171, IT],
		[172, kf],
		[173, jf],
		[174, Nf],
		[175, LT],
		[176, RT],
		[177, zT],
		[178, BT],
		[179, VT],
		[180, Ff],
		[181, Lf],
		[182, zf],
		[183, HT],
		[184, UT],
		[185, WT],
		[186, GT],
		[187, KT],
		[188, Vf],
		[189, Uf],
		[190, Gf],
		[191, qT],
		[203, /* @__PURE__ */ new Map([
			[0, qf],
			[1, Jf],
			[2, Yf],
			[3, Xf],
			[4, Zf],
			[5, Qf],
			[6, $f],
			[7, ep],
			[8, tp],
			[9, np],
			[10, rp],
			[11, ip],
			[12, ap],
			[13, op],
			[14, sp],
			[15, cp],
			[16, lp],
			[17, up],
			[18, dp],
			[19, fp],
			[20, pp],
			[21, mp],
			[22, hp],
			[23, gp],
			[24, _p],
			[25, vp],
			[26, yp],
			[27, bp],
			[28, xp],
			[29, Sp],
			[30, Cp],
			[31, wp],
			[32, Tp],
			[33, Ep],
			[34, Dp],
			[35, Op],
			[36, kp],
			[37, Ap],
			[38, jp],
			[39, Mp],
			[40, Np],
			[41, Pp],
			[42, Fp],
			[43, Ip],
			[44, Lp],
			[45, Rp],
			[46, zp],
			[47, Bp],
			[48, Vp],
			[49, Hp],
			[50, Up],
			[51, Wp],
			[52, Gp],
			[53, Kp],
			[54, qp],
			[55, Jp],
			[56, Yp],
			[57, Xp],
			[58, Zp],
			[59, Qp],
			[60, $p],
			[61, em],
			[62, tm],
			[63, nm],
			[64, JT],
			[65, YT],
			[66, XT],
			[67, ZT],
			[68, QT],
			[69, $T],
			[70, L],
			[71, eE],
			[72, tE],
			[73, nE],
			[74, rE],
			[75, iE],
			[76, aE],
			[77, oE],
			[78, R],
			[79, sE],
			[80, cE],
			[81, lE],
			[82, uE],
			[83, dE],
			[84, fE],
			[85, pE],
			[86, z],
			[87, mE],
			[88, hE],
			[89, gE],
			[90, _E],
			[91, vE],
			[92, yE],
			[93, bE],
			[94, B],
			[95, xE],
			[96, SE],
			[97, CE],
			[98, wE],
			[99, TE],
			[100, EE],
			[101, DE],
			[102, V],
			[103, OE],
			[104, kE],
			[105, AE],
			[106, jE],
			[107, ME],
			[108, NE],
			[109, PE],
			[110, H],
			[111, FE],
			[112, IE],
			[113, LE],
			[114, RE],
			[115, zE],
			[116, BE],
			[117, VE],
			[118, U],
			[119, HE],
			[120, UE],
			[121, WE],
			[122, GE],
			[123, KE],
			[124, qE],
			[125, JE],
			[126, W],
			[127, YE],
			[128, rm],
			[129, im],
			[130, am],
			[131, om],
			[132, sm],
			[133, cm],
			[134, lm],
			[135, um],
			[136, dm],
			[137, fm],
			[138, pm],
			[139, mm],
			[140, hm],
			[141, gm],
			[142, _m],
			[143, vm],
			[144, ym],
			[145, bm],
			[146, xm],
			[147, Sm],
			[148, Cm],
			[149, wm],
			[150, Tm],
			[151, Em],
			[152, Dm],
			[153, Om],
			[154, km],
			[155, Am],
			[156, jm],
			[157, Mm],
			[158, Nm],
			[159, Pm],
			[160, Fm],
			[161, Im],
			[162, Lm],
			[163, Rm],
			[164, zm],
			[165, Bm],
			[166, Vm],
			[167, Hm],
			[168, Um],
			[169, Wm],
			[170, Gm],
			[171, Km],
			[172, qm],
			[173, Jm],
			[174, Ym],
			[175, Xm],
			[176, Zm],
			[177, Qm],
			[178, $m],
			[179, eh],
			[180, th],
			[181, nh],
			[182, rh],
			[183, ih],
			[184, ah],
			[185, oh],
			[186, sh],
			[187, ch],
			[188, lh],
			[189, uh],
			[190, dh],
			[191, fh],
			[192, ph],
			[193, mh],
			[194, hh],
			[195, gh],
			[196, _h],
			[197, vh],
			[198, yh],
			[199, bh],
			[200, xh],
			[201, Sh],
			[202, Ch],
			[203, wh],
			[204, Th],
			[205, Eh],
			[206, Dh],
			[207, Oh],
			[208, kh],
			[209, Ah],
			[210, jh],
			[211, Mh],
			[212, Nh],
			[213, Ph],
			[214, Fh],
			[215, Ih],
			[216, Lh],
			[217, Rh],
			[218, zh],
			[219, Bh],
			[220, Vh],
			[221, Hh],
			[222, Uh],
			[223, Wh],
			[224, Gh],
			[225, Kh],
			[226, qh],
			[227, Jh],
			[228, Yh],
			[229, Xh],
			[230, Zh],
			[231, Qh],
			[232, $h],
			[233, eg],
			[234, tg],
			[235, ng],
			[236, rg],
			[237, ig],
			[238, ag],
			[239, og],
			[240, sg],
			[241, cg],
			[242, lg],
			[243, ug],
			[244, dg],
			[245, fg],
			[246, pg],
			[247, mg],
			[248, hg],
			[249, gg],
			[250, _g],
			[251, vg],
			[252, yg],
			[253, bg],
			[254, xg],
			[255, Sg]
		])],
		[225, Cg],
		[227, wg],
		[229, Eg],
		[233, Dg],
		[249, kg]
	])],
	[222, Ag],
	[223, Mg],
	[224, Ng],
	[225, Fg],
	[226, Ig],
	[227, Rg],
	[228, Bg],
	[229, Hg],
	[230, Ug],
	[231, Gg],
	[232, Kg],
	[233, Jg],
	[234, Xg],
	[235, Qg],
	[236, e_],
	[237, /* @__PURE__ */ new Map([
		[64, n_],
		[65, i_],
		[66, o_],
		[67, s_],
		[68, G],
		[69, c_],
		[70, l_],
		[71, u_],
		[72, d_],
		[73, p_],
		[74, h_],
		[75, g_],
		[76, XE],
		[77, __],
		[78, ZE],
		[79, v_],
		[80, y_],
		[81, x_],
		[82, C_],
		[83, w_],
		[84, QE],
		[85, $E],
		[86, T_],
		[87, E_],
		[88, D_],
		[89, k_],
		[90, j_],
		[91, M_],
		[92, eD],
		[93, tD],
		[94, N_],
		[95, P_],
		[96, F_],
		[97, L_],
		[98, z_],
		[99, nD],
		[100, rD],
		[101, iD],
		[102, aD],
		[103, B_],
		[104, V_],
		[105, U_],
		[106, G_],
		[107, oD],
		[108, sD],
		[109, cD],
		[110, lD],
		[111, K_],
		[112, q_],
		[113, Y_],
		[114, Z_],
		[115, Q_],
		[116, uD],
		[117, dD],
		[118, fD],
		[120, $_],
		[121, tv],
		[122, rv],
		[123, iv],
		[124, pD],
		[125, mD],
		[126, hD],
		[160, av],
		[161, ov],
		[162, sv],
		[163, cv],
		[168, lv],
		[169, uv],
		[170, dv],
		[171, fv],
		[176, pv],
		[177, mv],
		[178, hv],
		[179, gv],
		[184, _v],
		[185, vv],
		[186, yv],
		[187, bv]
	])],
	[238, xv],
	[239, Cv],
	[240, wv],
	[241, Tv],
	[242, Ev],
	[243, Dv],
	[244, Ov],
	[245, kv],
	[246, Av],
	[247, Mv],
	[248, Nv],
	[249, Pv],
	[250, Fv],
	[251, Iv],
	[252, Lv],
	[253, /* @__PURE__ */ new Map([
		[4, gD],
		[5, _D],
		[6, vD],
		[9, Rv],
		[12, yD],
		[13, bD],
		[14, xD],
		[20, SD],
		[21, CD],
		[22, wD],
		[25, zv],
		[28, TD],
		[29, ED],
		[30, DD],
		[33, Bv],
		[34, Vv],
		[35, Hv],
		[36, Uv],
		[37, Wv],
		[38, Gv],
		[41, Kv],
		[42, qv],
		[43, Jv],
		[44, Yv],
		[45, Xv],
		[46, Zv],
		[52, Qv],
		[53, $v],
		[54, ey],
		[57, ty],
		[60, OD],
		[61, kD],
		[62, AD],
		[64, jD],
		[65, MD],
		[66, ND],
		[67, PD],
		[68, ny],
		[69, ry],
		[70, iy],
		[71, FD],
		[72, ID],
		[73, LD],
		[74, RD],
		[75, zD],
		[76, ay],
		[77, oy],
		[78, sy],
		[79, BD],
		[80, VD],
		[81, HD],
		[82, UD],
		[83, WD],
		[84, cy],
		[85, ly],
		[86, uy],
		[87, GD],
		[88, KD],
		[89, qD],
		[90, JD],
		[91, YD],
		[92, dy],
		[93, fy],
		[94, py],
		[95, XD],
		[96, my],
		[97, hy],
		[98, gy],
		[99, _y],
		[100, vy],
		[101, yy],
		[102, by],
		[103, xy],
		[104, Sy],
		[105, Cy],
		[106, wy],
		[107, Ty],
		[108, Ey],
		[109, Dy],
		[110, Oy],
		[111, ky],
		[112, Ay],
		[113, jy],
		[114, My],
		[115, Ny],
		[116, Py],
		[117, Fy],
		[119, Iy],
		[120, ZD],
		[121, QD],
		[122, $D],
		[123, eO],
		[124, Ly],
		[125, Ry],
		[126, zy],
		[127, tO],
		[128, nO],
		[129, rO],
		[130, iO],
		[131, aO],
		[132, By],
		[133, Hy],
		[134, Wy],
		[135, oO],
		[136, sO],
		[137, cO],
		[138, lO],
		[139, uO],
		[140, Ky],
		[141, Jy],
		[142, Xy],
		[143, dO],
		[144, fO],
		[145, pO],
		[146, mO],
		[147, hO],
		[148, Qy],
		[149, eb],
		[150, nb],
		[151, gO],
		[152, _O],
		[153, vO],
		[154, yO],
		[155, bO],
		[156, ib],
		[157, ob],
		[158, cb],
		[159, xO],
		[160, SO],
		[161, CO],
		[162, wO],
		[163, TO],
		[164, ub],
		[165, fb],
		[166, mb],
		[167, EO],
		[168, DO],
		[169, OO],
		[170, kO],
		[171, AO],
		[172, gb],
		[173, vb],
		[174, bb],
		[175, jO],
		[176, MO],
		[177, NO],
		[178, PO],
		[179, FO],
		[180, Sb],
		[181, wb],
		[182, Eb],
		[183, IO],
		[184, LO],
		[185, RO],
		[186, zO],
		[187, BO],
		[188, Ob],
		[189, Ab],
		[190, Mb],
		[191, VO],
		[203, /* @__PURE__ */ new Map([
			[0, Pb],
			[1, Fb],
			[2, Ib],
			[3, Lb],
			[4, Rb],
			[5, zb],
			[6, Bb],
			[7, Vb],
			[8, Hb],
			[9, Ub],
			[10, Wb],
			[11, Gb],
			[12, Kb],
			[13, qb],
			[14, Jb],
			[15, Yb],
			[16, Xb],
			[17, Zb],
			[18, Qb],
			[19, $b],
			[20, ex],
			[21, tx],
			[22, nx],
			[23, rx],
			[24, ix],
			[25, ax],
			[26, ox],
			[27, sx],
			[28, cx],
			[29, lx],
			[30, ux],
			[31, dx],
			[32, fx],
			[33, px],
			[34, mx],
			[35, hx],
			[36, gx],
			[37, _x],
			[38, vx],
			[39, yx],
			[40, bx],
			[41, xx],
			[42, Sx],
			[43, Cx],
			[44, wx],
			[45, Tx],
			[46, Ex],
			[47, Dx],
			[48, Ox],
			[49, kx],
			[50, Ax],
			[51, jx],
			[52, Mx],
			[53, Nx],
			[54, Px],
			[55, Fx],
			[56, Ix],
			[57, Lx],
			[58, Rx],
			[59, zx],
			[60, Bx],
			[61, Vx],
			[62, Hx],
			[63, Ux],
			[64, HO],
			[65, UO],
			[66, WO],
			[67, GO],
			[68, KO],
			[69, qO],
			[70, K],
			[71, JO],
			[72, YO],
			[73, XO],
			[74, ZO],
			[75, QO],
			[76, $O],
			[77, ek],
			[78, q],
			[79, tk],
			[80, nk],
			[81, rk],
			[82, ik],
			[83, ak],
			[84, ok],
			[85, sk],
			[86, J],
			[87, ck],
			[88, lk],
			[89, uk],
			[90, dk],
			[91, fk],
			[92, pk],
			[93, mk],
			[94, Y],
			[95, hk],
			[96, gk],
			[97, _k],
			[98, vk],
			[99, yk],
			[100, bk],
			[101, xk],
			[102, X],
			[103, Sk],
			[104, Ck],
			[105, wk],
			[106, Tk],
			[107, Ek],
			[108, Dk],
			[109, Ok],
			[110, Z],
			[111, kk],
			[112, Ak],
			[113, jk],
			[114, Mk],
			[115, Nk],
			[116, Pk],
			[117, Fk],
			[118, Wx],
			[119, Ik],
			[120, Lk],
			[121, Rk],
			[122, zk],
			[123, Bk],
			[124, Vk],
			[125, Hk],
			[126, Gx],
			[127, Uk],
			[128, Kx],
			[129, qx],
			[130, Jx],
			[131, Yx],
			[132, Xx],
			[133, Zx],
			[134, Qx],
			[135, $x],
			[136, eS],
			[137, tS],
			[138, nS],
			[139, rS],
			[140, iS],
			[141, aS],
			[142, oS],
			[143, sS],
			[144, cS],
			[145, lS],
			[146, uS],
			[147, dS],
			[148, fS],
			[149, pS],
			[150, mS],
			[151, hS],
			[152, gS],
			[153, _S],
			[154, vS],
			[155, yS],
			[156, bS],
			[157, xS],
			[158, SS],
			[159, CS],
			[160, wS],
			[161, TS],
			[162, ES],
			[163, DS],
			[164, OS],
			[165, kS],
			[166, AS],
			[167, jS],
			[168, MS],
			[169, NS],
			[170, PS],
			[171, FS],
			[172, IS],
			[173, LS],
			[174, RS],
			[175, zS],
			[176, BS],
			[177, VS],
			[178, HS],
			[179, US],
			[180, WS],
			[181, GS],
			[182, KS],
			[183, qS],
			[184, JS],
			[185, YS],
			[186, XS],
			[187, ZS],
			[188, QS],
			[189, $S],
			[190, eC],
			[191, tC],
			[192, nC],
			[193, rC],
			[194, iC],
			[195, aC],
			[196, oC],
			[197, sC],
			[198, cC],
			[199, lC],
			[200, uC],
			[201, dC],
			[202, fC],
			[203, pC],
			[204, mC],
			[205, hC],
			[206, gC],
			[207, _C],
			[208, vC],
			[209, yC],
			[210, bC],
			[211, xC],
			[212, SC],
			[213, CC],
			[214, wC],
			[215, TC],
			[216, EC],
			[217, DC],
			[218, OC],
			[219, kC],
			[220, AC],
			[221, jC],
			[222, MC],
			[223, NC],
			[224, PC],
			[225, FC],
			[226, IC],
			[227, LC],
			[228, RC],
			[229, zC],
			[230, BC],
			[231, VC],
			[232, HC],
			[233, UC],
			[234, WC],
			[235, GC],
			[236, KC],
			[237, qC],
			[238, JC],
			[239, YC],
			[240, XC],
			[241, ZC],
			[242, QC],
			[243, $C],
			[244, ew],
			[245, tw],
			[246, nw],
			[247, rw],
			[248, iw],
			[249, aw],
			[250, ow],
			[251, sw],
			[252, cw],
			[253, lw],
			[254, uw],
			[255, dw]
		])],
		[225, fw],
		[227, pw],
		[229, hw],
		[233, gw],
		[249, vw]
	])],
	[254, yw],
	[255, xw]
]);
//#endregion
//#region ../z80-inst/src/Utils.ts
function Kk(e, t) {
	return (e === 221 || e === 253) && t === 203;
}
//#endregion
//#region ../z80-disasm/src/Instruction.ts
var qk = class {
	constructor(e, t, n, r, i, a) {
		this.additionalDataLength = 0, this.address = e, this.bin = t, this.mnemonic = n, this.params = r ?? [], this.args = i ?? [], this.isExecutable = a;
	}
	binText() {
		return this.bin.map(se).join(" ");
	}
	toText(e) {
		let t = e ? this.mnemonic.toUpperCase() : this.mnemonic, n = this.args.map((t) => !e || t.length > 0 && t[0] === "\"" ? t : t.toUpperCase());
		return (t + " " + n.join(",")).trim();
	}
	replaceArgVariable(e, t) {
		let n = this.args;
		for (let r = 0; r < n.length; r++) {
			let i = n[r], a;
			do {
				a = !1;
				let n = i.indexOf(e);
				n >= 0 && (i = i.substring(0, n) + t + i.substring(n + e.length), a = !0);
			} while (a);
			n[r] = i;
		}
	}
	continues() {
		return !(this.mnemonic === "ret" && this.args.length === 0 || this.mnemonic === "reti" || this.mnemonic === "retn" || (this.mnemonic === "jp" || this.mnemonic === "jr") && this.args.length === 1);
	}
	continuesAt() {
		return this.continues() ? this.nextAddress() : void 0;
	}
	nextAddress() {
		return this.address + this.bin.length + this.additionalDataLength;
	}
}, Jk = class e {
	constructor(e, t, n, r, i) {
		this.preambleLength = e, this.sourceAddress = t, this.destinationAddress = n, this.copyLength = r, this.jumpAddress = i;
	}
	static detect(t, n) {
		let r = 14, i = n;
		t[i] === 243 && (i += 1, r += 1);
		let a = t[i + 1] | t[i + 2] << 8, o = t[i + 4] | t[i + 5] << 8, s = t[i + 7] | t[i + 8] << 8, c = t[i + 12] | t[i + 13] << 8;
		if (t[i + 0] === 33 && t[i + 3] === 17 && t[i + 6] === 1 && t[i + 9] === 237 && t[i + 10] === 176 && t[i + 11] === 195 && c >= o && c < o + s) return new e(r, a, o, s, c);
	}
}, Yk = /* @__PURE__ */ function(e) {
	return e[e.C = 0] = "C", e[e.DOLLAR = 1] = "DOLLAR", e[e.H = 2] = "H", e;
}({}), Xk = "TARGET", Zk = 65536;
function Qk(e) {
	return e >= 32 && e < 127 && e !== 34;
}
function $k(e) {
	return Qk(e) || e === 10 || e === 13;
}
function eA(e) {
	return e === 0 || e === 3;
}
function tA(e, t, n) {
	let r = f(e, t);
	switch (n) {
		case 0:
			r = "0x" + r;
			break;
		case 1:
			r = "$" + r;
			break;
		case 2: {
			let e = r.charAt(0).toUpperCase();
			e >= "A" && e <= "F" && (r = "0" + r), r += "h";
			break;
		}
	}
	return r;
}
var nA = class {
	constructor() {
		this.memory = new Uint8Array(Zk), this.readMemory = (e) => this.memory[e], this.hasContent = new Uint8Array(Zk), this.isDecoded = new Uint8Array(Zk), this.instructions = Array(Zk), this.knownLabels = /* @__PURE__ */ new Map(), this.entryPoints = [], this.referencedAddresses = /* @__PURE__ */ new Set(), this.opcodeToAdditionDataLength = /* @__PURE__ */ new Map(), this.createLabels = !0, this.useKnownLabels = !0, this.hexFormat = 0, this.fullDisassembly = !1;
	}
	setCreateLabels(e) {
		this.createLabels = e;
	}
	setUseKnownLabels(e) {
		this.useKnownLabels = e;
	}
	setHexFormat(e) {
		this.hexFormat = e;
	}
	setFullDisassembly(e) {
		this.fullDisassembly = e;
	}
	addChunk(e, t) {
		for (let n = 0; n < e.length; n++) {
			let r = (t + n) % Zk;
			this.memory[r] = e[n], this.hasContent[r] = 1;
		}
	}
	addEntryPoint(e) {
		this.entryPoints.push(e);
	}
	addAdditionalDataLength(e, t) {
		this.opcodeToAdditionDataLength.set(e, t);
	}
	getLabelForAddress(e) {
		return this.useKnownLabels ? this.knownLabels.get(e) : void 0;
	}
	disassembleOne(e, t) {
		let n = [], r = () => {
			let r = t(e);
			return n.push(r), e = v(e), r;
		}, i = e, a, o = r(), s = Gk, c, l;
		for (; c === void 0;) {
			let t = s.get(o);
			if (t === void 0) {
				let e = n.map((e) => this.toHexByte(e));
				c = new qk(i, n, "defb", e, e, !1);
			} else if (t instanceof Map) s = t, n.length === 2 && Kk(n[0], n[1]) && (l = r()), o = r();
			else {
				let o = (t.params ?? []).slice();
				for (let n = 0; n < o.length; n++) {
					let i = o[n], s;
					do {
						s = !1;
						let n = i.indexOf("nnnn");
						if (n >= 0) {
							let e = r(), o = g(r(), e), c;
							t.mnemonic === "call" || t.mnemonic === "jp" ? (a = o, c = Xk) : (c = this.toHexWord(o), t.params !== void 0 && t.params.length === 2 && t.params[0] === "hl" && t.params[1] === "nnnn" && this.referencedAddresses.add(o)), i = i.substring(0, n) + c + i.substring(n + 4), s = !0;
						}
						if (n = i.indexOf("nn"), n === -1 && (n = i.indexOf("dd")), n >= 0) {
							let e = l ?? r();
							l = void 0, i = n > 0 && i[n - 1] === "+" && e & 128 ? i.substring(0, n - 1) + "-" + this.toHexByte(-e & 255) + i.substring(n + 2) : i.substring(0, n) + this.toHexByte(e) + i.substring(n + 2), s = !0;
						}
						if (n = i.indexOf("offset"), n >= 0) {
							let t = w(r());
							a = e + t, i = i.substring(0, n) + Xk + i.substring(n + 6), s = !0;
						}
					} while (s);
					o[n] = i;
				}
				c = new qk(i, n, t.mnemonic, t.params, o, !0), a !== void 0 && (c.jumpTarget = a), c.additionalDataLength = this.getAdditionalDataLength(c);
			}
		}
		return c;
	}
	makeDataInstruction(e) {
		let t = e;
		for (; t < Zk && t - e < 50 && this.hasContent[t] && !(t > e && this.isDecoded[t]) && !(t > e && this.referencedAddresses.has(t));) t += 1;
		let n = t, r, i;
		for (t = e; t < n; t++) {
			let e = this.memory[t];
			if ($k(e)) r === void 0 && (r = t), t - r >= 4 && (i = r);
			else if (eA(e) && i !== void 0) {
				t++;
				break;
			} else if (r !== void 0) {
				if (i !== void 0) break;
				r = void 0;
			}
		}
		let a = t, o = [], s;
		if (i === e) for (s = ".text", n = a, t = e; t < n; t++) {
			let e = this.memory[t];
			if (Qk(e)) {
				let t = String.fromCharCode(e);
				if (t === "\"" && (t = "\\\""), o.length > 0 && o[o.length - 1].startsWith("\"")) {
					let e = o[o.length - 1];
					o[o.length - 1] = e.substring(0, e.length - 1) + t + "\"";
				} else o.push("\"" + t + "\"");
			} else o.push(this.toHexByte(e));
		}
		else for (s = "defb", i !== void 0 && (n = i), t = e; t < n; t++) o.push(this.toHexByte(this.memory[t]));
		return new qk(e, Array.from(this.memory.slice(e, n)), s, o, o, !1);
	}
	addLabel(e, t) {
		this.knownLabels.set(e, t);
	}
	addLabels(e) {
		for (let { name: t, address: n } of e) this.addLabel(n, t);
	}
	haveLabel(e) {
		for (let t of this.knownLabels.values()) if (t === e) return !0;
		return !1;
	}
	addUniqueLabel(e, t) {
		for (let n = 1; n < 1e3; n++) {
			let r = t + (n === 1 ? "" : n);
			if (!this.haveLabel(r)) {
				this.addLabel(e, r);
				break;
			}
		}
	}
	disassembleTrace(e, t) {
		let n = this.disassembleOne(e, t);
		return this.replaceTargetAddress(n), n;
	}
	disassemble() {
		for (let e = 0; e < this.entryPoints.length; e++) {
			let t = this.entryPoints[e], n = Jk.detect(this.memory, t);
			if (n !== void 0) {
				let e = n.sourceAddress, t = e + n.copyLength;
				this.hasContent.fill(0, e, t), this.addChunk(this.memory.subarray(e, t), n.destinationAddress), this.addUniqueLabel(n.jumpAddress, "main"), this.addEntryPoint(n.jumpAddress);
			}
		}
		let e = /* @__PURE__ */ new Set(), t = (t) => {
			t !== void 0 && this.hasContent[t] && this.instructions[t] === void 0 && e.add(t);
		};
		if (this.entryPoints.length === 0) {
			for (let t = 0; t < Zk; t++) if (this.hasContent[t]) {
				e.add(t);
				break;
			}
			if (e.size === 0) throw Error("no binary content was specified");
		} else for (let t of this.entryPoints) e.add(t);
		if (this.fullDisassembly) for (let t = 0; t < this.hasContent.length; t++) this.hasContent[t] && (t === 0 || !this.hasContent[t - 1]) && e.add(t);
		for (; e.size > 0;) {
			let n = e.values().next().value;
			if (e.delete(n), this.isDecoded[n]) {
				console.warn("Warning: Address", p(n), "has already been decoded");
				continue;
			}
			let r = this.disassembleOne(n, this.readMemory);
			this.instructions[n] = r, this.isDecoded.fill(1, n, n + r.bin.length), r.jumpTarget !== void 0 && r.jumpTarget >= 15360 && r.jumpTarget < 16384 && console.warn("Warning: Instruction at", p(n), "is jumping to screen address", p(r.jumpTarget)), this.fullDisassembly || t(r.jumpTarget), t(this.fullDisassembly ? r.nextAddress() : r.continuesAt());
		}
		let n = /* @__PURE__ */ new Map(), r = [];
		for (let e = 0; e < Zk; e++) if (this.hasContent[e]) {
			let t = this.instructions[e];
			if (t === void 0 && (t = this.makeDataInstruction(e)), r.push(t), t.jumpTarget !== void 0) {
				let e = n.get(t.jumpTarget);
				e === void 0 && (e = [], n.set(t.jumpTarget, e)), e.push(t);
			}
			if (t.bin.length === 0) throw Error("Instruction at 0x" + p(e) + " has no content");
			e += t.bin.length - 1;
		}
		if (this.createLabels) {
			let e = 1;
			for (let t of r) {
				let r = this.useKnownLabels ? this.knownLabels.get(t.address) : void 0, i = n.get(t.address) ?? [];
				if (i.length !== 0 && r === void 0 && (r = "label" + e++), r !== void 0) {
					t.label = r;
					for (let e of i) e.replaceArgVariable(Xk, r);
				}
			}
		}
		for (let e of r) this.replaceTargetAddress(e);
		return r;
	}
	replaceTargetAddress(e) {
		if (e.jumpTarget !== void 0) {
			let t = this.useKnownLabels ? this.knownLabels.get(e.jumpTarget) : void 0;
			t === void 0 && (t = e.jumpTarget === e.address && this.useKnownLabels ? "$" : this.toHexWord(e.jumpTarget)), e.replaceArgVariable(Xk, t);
		}
	}
	getAdditionalDataLength(e) {
		return this.opcodeToAdditionDataLength.get(e.bin[0]) ?? 0;
	}
	toHexByte(e) {
		return tA(e, 2, this.hexFormat);
	}
	toHexWord(e) {
		return tA(e, 4, this.hexFormat);
	}
}, rA = 1, iA = " ".repeat(8), aA = " ".repeat(5), oA = {
	address: (e) => e,
	hexByte: (e) => e,
	asciiByte: (e) => e
};
function sA(e, t) {
	let n = [];
	for (let r of e) {
		let e = r >= 32 && r < 127 ? String.fromCharCode(r) : ".";
		n.push(t.asciiByte(e, r));
	}
	return n.join("");
}
function cA(e, t, n) {
	let { makeListing: r = !1, showBinary: i = !0, hexFormat: a = Yk.C, upperCase: o = !1, mainEntryPoint: s, dataComment: c = !1, hexByteCount: l = 3, styles: u = oA } = n;
	function ee(e) {
		return o ? e.toUpperCase() : e;
	}
	let d = [], te, ne = i ? l * 3 : 0, re = r ? aA + " ".repeat(ne) : "", ie = 0, ae = 0;
	for (let e of t) {
		let t = e.address, n = e.bin;
		t !== te && (d.length > 0 && d.push(""), d.push(re + iA + ee(".org " + tA(t, 4, a))), te = t), te += n.length, e.isExecutable ? ie++ : ae++, e.label !== void 0 && d.push(re + ee(e.label) + ":");
		let s = e.toText(o);
		if (c && (s = s.padEnd(32) + "; " + sA(n, u)), r) {
			if (i) {
				let r = 0;
				for (; r < n.length;) {
					let i = n.slice(r, Math.min(r + l, n.length)), a = i.map((e) => u.hexByte(se(e), e)).join(" "), o = i.length * 3 - rA;
					d.push(u.address(p(t)) + " " + a + " ".repeat(Math.max(ne - o, 0)) + (t === e.address ? iA + s : "")), t += i.length, r += i.length;
				}
			} else d.push(u.address(p(t)) + " " + iA + s);
		} else d.push(iA + s);
	}
	let oe = re + iA + "end";
	if (s !== void 0) {
		let t = e.getLabelForAddress(s) ?? tA(s, 4, a);
		oe += " " + t;
	}
	return d.push(ee(oe)), d;
}
//#endregion
//#region src/CallStack.ts
var lA = void 0;
function uA(e, t) {
	return lA === void 0 && (lA = new nA()), lA.disassembleTrace(t & 65535, (t) => e(t & 65535));
}
function dA(e) {
	return e === 205 || (e & 199) == 196;
}
function fA(e) {
	return (e & 199) == 199;
}
function pA(e) {
	return dA(e) || fA(e);
}
function mA(e, t) {
	let n = e(t) & 255;
	if (!pA(n)) return;
	let r = uA(e, t);
	switch (r.mnemonic) {
		case "call": return r.jumpTarget === void 0 ? void 0 : {
			targetAddress: r.jumpTarget,
			length: r.bin.length
		};
		case "rst": return {
			targetAddress: n & 56,
			length: r.bin.length
		};
		default: return;
	}
}
function hA(t) {
	let n = [], r = (e) => t.peek(e), i = t.z80.pushInstructionAddress, a = /* @__PURE__ */ new Map(), o = Math.min(t.stackTop, e), s = t.z80.regs.sp & 65535;
	for (; s + 2 <= o;) {
		let e = i[s], t;
		pA(r(e)) && (t = a.get(e), t === void 0 && !a.has(e) && (t = mA(r, e), a.set(e, t)));
		let o = r(s) | r(s + 1) << 8;
		t !== void 0 && o === (e + t.length & 65535) ? (n.push({
			callSiteAddress: e,
			targetAddress: t.targetAddress,
			returnAddress: o,
			stackAddress: s
		}), s += 2) : s += 1;
	}
	return n;
}
//#endregion
//#region src/Z80Machine.ts
var gA = /* @__PURE__ */ new Set([
	201,
	192,
	200,
	208,
	216,
	224,
	232,
	240,
	248
]), _A = /* @__PURE__ */ new Set([
	69,
	77,
	85,
	93,
	101,
	109,
	117,
	125
]), vA = /* @__PURE__ */ new Set([
	205,
	196,
	204,
	212,
	220,
	228,
	236,
	244,
	252
]), yA = /* @__PURE__ */ new Set([
	199,
	207,
	215,
	223,
	231,
	239,
	247,
	255
]), bA = 237, xA = class extends Error {
	constructor(e) {
		super("no input available on port 0x" + p(e)), this.port = e;
	}
};
function SA(t) {
	if (t === void 0) return;
	let n;
	for (let r of t) n === void 0 && (n = new Uint8Array(e)), n[r & 65535] = 1;
	return n;
}
var CA = /* @__PURE__ */ new Set([
	"af",
	"bc",
	"de",
	"hl",
	"afPrime",
	"bcPrime",
	"dePrime",
	"hlPrime",
	"ix",
	"iy",
	"sp",
	"pc",
	"memptr"
]), wA = class {
	getStackTop() {
		return this.stackRegionTop;
	}
	constructor(t) {
		this.tStateCount = 0, this.stopReason = void 0, this.pendingInputPort = void 0, this.historyBuffer = [], this.historyStart = 0, this.historyCount = 0, this.pendingRecord = void 0, this.pauseRequested = !1, this.executing = !1, this.pokeJournal = void 0, this.nextStepId = 1;
		let n = t?.memory;
		if (n !== void 0 && n.length !== 65536) throw Error("the machine's memory must be exactly 64 kB (" + e + " bytes), but it is " + n.length + " bytes");
		if (this.z80 = new ke(this), this.memory = n ?? /* @__PURE__ */ new Uint8Array(65536), this.stackTop = t?.initialSp ?? 65535, this.stackRegionTop = this.stackTop, this.onPortRead = t?.onPortRead, this.onPortWrite = t?.onPortWrite, this.onMemoryRead = t?.onMemoryRead, this.onDebugRead = t?.onDebugRead ?? t?.onMemoryRead, this.onMemoryWrite = t?.onMemoryWrite, this.exitOnReturn = t?.exitOnReturn ?? !1, this.historyCapacity = Math.max(0, t?.historySize ?? 0), !Number.isInteger(this.historyCapacity) || this.historyCapacity > 4294967295) throw RangeError("Invalid history size");
		this.z80.regs.sp = this.stackTop, this.stackRegionTop = this.stackTop;
	}
	readMemory(e) {
		if (e &= 65535, this.onMemoryRead !== void 0) {
			let t = this.onMemoryRead(e);
			if (t !== void 0) return t & 255;
		}
		return this.memory[e];
	}
	writeMemory(e, t) {
		e &= 65535, t &= 255, (this.onMemoryWrite === void 0 || this.onMemoryWrite(e, t) !== !0) && (this.pendingRecord !== void 0 && this.pendingRecord.memoryWrites.push({
			address: e,
			before: this.memory[e],
			value: t
		}), this.memory[e] = t);
	}
	contendMemory(e) {}
	readPort(e) {
		if (this.onPortRead !== void 0) {
			let t = this.onPortRead(e);
			if (t !== void 0) return t & 255;
			if (this.executing) throw new xA(e);
		}
		return 255;
	}
	writePort(e, t) {
		t &= 255, this.pendingRecord !== void 0 && this.pendingRecord.portWrites.push({
			port: e,
			value: t
		}), this.onPortWrite !== void 0 && this.onPortWrite(e, t);
	}
	contendPort(e) {}
	reset() {
		this.z80.reset(), this.z80.regs.sp = this.stackTop, this.stackRegionTop = this.stackTop, this.tStateCount = 0, this.clearStopState(), this.clearHistory();
	}
	loadBinary(e, t, n) {
		this.writeBytes(e, t), this.z80.regs.pc = (n ?? t) & 65535, this.clearStopState(), this.clearHistory();
	}
	loadAssembly(e) {
		if (e.hasErrors()) throw Error("cannot load an assembly that has errors");
		for (let t of e.asm.assembledLines) t.binary.length > 0 && this.writeBytes(t.binary, t.address);
		this.z80.regs.pc = e.entryPoint & 65535, this.clearStopState(), this.clearHistory();
	}
	step() {
		let e = this.terminalStopReason();
		return e === void 0 ? (this.executeInstruction(), this.pauseRequested = !1, this.stopReason) : e;
	}
	pause() {
		this.pauseRequested = !0;
	}
	run(e) {
		return this.runUntil(e, void 0);
	}
	stepOver(e) {
		let t = this.terminalStopReason();
		if (t !== void 0) return {
			reason: t,
			tStates: 0,
			instructions: 0
		};
		let n = this.z80.regs.pc, r = this.peek(n), i;
		if (vA.has(r)) i = 3;
		else if (yA.has(r)) i = 1;
		else return this.stepAsRunResult();
		let a = n + i & 65535, o = this.z80.regs.sp;
		return this.runUntil(e, () => this.z80.regs.pc === a && this.z80.regs.sp >= o);
	}
	stepOut(e) {
		let t = this.terminalStopReason();
		if (t !== void 0) return {
			reason: t,
			tStates: 0,
			instructions: 0
		};
		let n = hA(this);
		if (n.length === 0) return this.run(e);
		let r = n[0].stackAddress;
		return this.runUntil(e, () => this.z80.regs.sp > r);
	}
	isTerminated() {
		return this.terminalStopReason() !== void 0;
	}
	raiseInterrupt() {
		this.deliverInterrupt(!0);
	}
	raiseNmi() {
		this.deliverInterrupt(!1);
	}
	deliverInterrupt(e) {
		this.requireNoOpenPoke("deliver an interrupt");
		let t = (!e || this.z80.regs.iff1 !== 0) && this.historyCapacity > 0 ? this.z80.save() : void 0, n = this.z80.regs.sp;
		t !== void 0 && (this.pendingRecord = {
			kind: "instruction",
			stepId: 0,
			address: t.regs.pc,
			interrupt: e ? "maskable" : "nmi",
			stateBefore: t,
			tStateCountBefore: this.tStateCount,
			memoryWrites: [],
			portWrites: []
		});
		try {
			e ? this.z80.maskableInterrupt() : this.z80.nonMaskableInterrupt();
		} catch (e) {
			throw this.pendingRecord = void 0, e;
		}
		let r = this.pendingRecord;
		this.pendingRecord = void 0, r !== void 0 && this.addRecord(r), this.markInterruptPush(n), this.wakeUp();
	}
	markInterruptPush(e) {
		let t = this.z80.regs.sp;
		t !== e && (this.z80.pushInstructionAddress[t] = this.peek(t) | this.peek(t + 1) << 8);
	}
	save() {
		let e = new l(this.z80.save(), this.memory.slice(), this.tStateCount, this.stopReason, this.pendingInputPort, this.z80.pushInstructionAddress.slice(this.stackBottom(), this.stackTopOffset()));
		return e.stackRegionTop = this.stackRegionTop, e;
	}
	restore(e) {
		this.z80.restore(e.z80State), this.stackRegionTop = e.stackRegionTop ?? this.stackTop, this.memory.set(e.memory.subarray(0, this.memory.length)), this.tStateCount = e.tStateCount, this.stopReason = e.stopReason, this.pendingInputPort = e.pendingInputPort;
		let t = e.stackProvenance, n = this.stackBottom(), r = Math.min(t?.length ?? 0, this.z80.pushInstructionAddress.length - n);
		r > 0 && this.z80.pushInstructionAddress.set(t.subarray(0, r), n), this.clearHistory();
	}
	setRegisterValue(e, t) {
		if (!oe(e)) throw Error("unknown register \"" + e + "\" (the shadow registers are spelled afPrime, bcPrime, dePrime and hlPrime)");
		let n = this.z80.regs, r = CA.has(e) ? t & 65535 : t & 255, i = n.getValue(e);
		if (i === r) return;
		let a = this.pokeJournal;
		a !== void 0 && a.registerEntries.get(e) === void 0 && a.registerEntries.set(e, {
			name: e,
			old: i,
			order: a.nextOrder++
		}), n[e] = r;
	}
	writeMemoryBytes(e, t) {
		let n = this.pokeJournal;
		if (n === void 0) {
			this.writeBytes(t, e);
			return;
		}
		let r = e & 65535;
		for (let e = 0; e < t.length; e++) {
			let i = r + e & 65535, a = this.memory[i], o = t[e] & 255;
			n.memoryEntries.get(i) === void 0 && n.memoryEntries.set(i, {
				old: a,
				order: n.nextOrder++
			}), a !== o && (n.memoryWrites.push({
				address: i,
				before: a,
				value: o
			}), this.memory[i] = o);
		}
	}
	beginPoke() {
		if (this.pokeJournal !== void 0) throw Error("a poke is already open; call endPoke() before beginning another");
		if (this.executing || this.pendingRecord !== void 0) throw Error("cannot begin a poke while an instruction is executing");
		this.pokeJournal = {
			stateBefore: this.z80.save(),
			tStateCountBefore: this.tStateCount,
			memoryWrites: [],
			registerEntries: /* @__PURE__ */ new Map(),
			memoryEntries: /* @__PURE__ */ new Map(),
			nextOrder: 0
		};
	}
	endPoke() {
		let e = this.pokeJournal;
		if (e === void 0) throw Error("no poke is open; call beginPoke() first");
		this.pokeJournal = void 0;
		let t = [];
		for (let n of e.registerEntries.values()) {
			let e = this.z80.regs.getValue(n.name);
			e !== n.old && t.push({
				order: n.order,
				write: {
					type: "register",
					name: n.name,
					old: n.old,
					new: e
				}
			});
		}
		let n = Array.from(e.memoryEntries.keys()).sort((e, t) => e - t);
		for (let r = 0; r < n.length;) {
			let i = n[r], a = [], o = [], s = 2 ** 53 - 1, c = !1, l = r;
			for (; l < n.length && n[l] === i + (l - r);) {
				let t = e.memoryEntries.get(n[l]), r = this.memory[n[l]];
				a.push(t.old), o.push(r), s = Math.min(s, t.order), c ||= r !== t.old, l++;
			}
			r = l, c && t.push({
				order: s,
				write: {
					type: "memory",
					address: i,
					old: a,
					new: o
				}
			});
		}
		t.sort((e, t) => e.order - t.order);
		let r = t.map((e) => e.write);
		return r.length !== 0 && (this.addRecord({
			kind: "poke",
			stepId: 0,
			address: -1,
			stateBefore: e.stateBefore,
			tStateCountBefore: e.tStateCountBefore,
			memoryWrites: e.memoryWrites,
			portWrites: [],
			writes: r
		}), this.historyCapacity > 0);
	}
	canUndo() {
		return this.historyCount > 0;
	}
	undo() {
		this.requireNoOpenPoke("undo");
		let e = this.removeNewestRecord();
		if (e === void 0) return !1;
		this.z80.restore(e.stateBefore), this.tStateCount = e.tStateCountBefore, e.stackTopBefore !== void 0 && (this.stackRegionTop = e.stackTopBefore);
		let t = e.memoryWrites;
		for (let e = t.length - 1; e >= 0; e--) {
			let n = t[e];
			this.memory[n.address] = n.before;
		}
		return e.kind !== "poke" && this.clearStopState(), !0;
	}
	getHistory(e) {
		let t = this.historyBuffer.length, n = e === void 0 ? this.historyCount : Math.min(Math.max(0, e), this.historyCount), r = [];
		for (let e = this.historyCount - n; e < this.historyCount; e++) {
			let n = this.historyBuffer[(this.historyStart + e) % t];
			n !== void 0 && r.push(n);
		}
		return r;
	}
	peek(e) {
		if (e &= 65535, this.onDebugRead !== void 0) {
			let t = this.onDebugRead(e);
			if (t !== void 0) return t & 255;
		}
		return this.memory[e];
	}
	getCallStack() {
		return hA(this);
	}
	disassembleAt(e) {
		return uA((e) => this.peek(e), e & 65535);
	}
	runUntil(e, t) {
		let n = this.terminalStopReason();
		if (n !== void 0) return {
			reason: n,
			tStates: 0,
			instructions: 0
		};
		let r = e?.maxTStates, i = e?.maxInstructions, o = SA(e?.breakpoints), s = this.tStateCount, c = 0;
		for (this.pauseRequested = !1;;) {
			let e = this.tStateCount - s;
			if (i !== void 0 && c >= i) return this.stopRun(a.INSTRUCTIONS_EXHAUSTED, e, c);
			if (r !== void 0 && e >= r) return this.stopRun(a.T_STATES_EXHAUSTED, e, c);
			this.executeInstruction(), e = this.tStateCount - s;
			let n = this.stopReason;
			if (n === a.WAITING_FOR_INPUT || (c += 1, n !== void 0)) return {
				reason: n,
				tStates: e,
				instructions: c
			};
			if (t !== void 0 && t()) return this.stopRun(a.STEP_COMPLETE, e, c);
			if (o !== void 0 && o[this.z80.regs.pc] !== 0) return this.stopRun(a.BREAKPOINT, e, c);
			if (this.pauseRequested) return this.pauseRequested = !1, this.stopRun(a.PAUSED, e, c);
		}
	}
	stepAsRunResult() {
		let e = this.tStateCount;
		this.executeInstruction();
		let t = this.stopReason, n = t === a.WAITING_FOR_INPUT ? 0 : 1;
		return this.stopRun(t ?? a.STEP_COMPLETE, this.tStateCount - e, n);
	}
	stopRun(e, t, n) {
		return this.stopReason = e, {
			reason: e,
			tStates: t,
			instructions: n
		};
	}
	executeInstruction() {
		this.requireNoOpenPoke("execute an instruction"), this.clearStopState();
		let e = this.historyCapacity > 0, t = e || this.onPortRead !== void 0 ? this.z80.save() : void 0, n = this.z80.regs.sp, r = this.tStateCount;
		e && t !== void 0 && (this.pendingRecord = {
			kind: "instruction",
			stepId: 0,
			address: this.z80.regs.pc,
			stateBefore: t,
			tStateCountBefore: r,
			stackTopBefore: this.stackRegionTop,
			memoryWrites: [],
			portWrites: []
		});
		let i = this.exitOnReturn && this.z80.regs.sp === this.stackTop && this.isReturnInstruction(this.z80.regs.pc);
		this.executing = !0;
		try {
			this.z80.step();
			let e = this.z80.regs.sp;
			(Math.abs(e - n) > 4096 || e > this.stackRegionTop) && (this.stackRegionTop = e);
		} catch (e) {
			if (this.pendingRecord = void 0, e instanceof xA && t !== void 0) {
				this.z80.restore(t), this.tStateCount = r, this.stopReason = a.WAITING_FOR_INPUT, this.pendingInputPort = e.port;
				return;
			}
			throw e;
		} finally {
			this.executing = !1;
		}
		let o = this.pendingRecord;
		o !== void 0 && (o.address = this.z80.instructionAddress, this.pendingRecord = void 0, this.addRecord(o)), this.z80.regs.halted === 0 ? i && this.z80.regs.sp === (this.stackTop + 2 & 65535) && (this.stopReason = a.RETURNED) : this.stopReason = this.z80.regs.iff1 === 0 ? a.HALTED : a.WAITING_FOR_INTERRUPT;
	}
	stackBottom() {
		return Math.min(Math.max(this.z80.regs.sp, 0), e);
	}
	stackTopOffset() {
		return Math.max(Math.min(this.stackTop, e), this.stackBottom());
	}
	isReturnInstruction(e) {
		let t = this.peek(e);
		return t === bA ? _A.has(this.peek(e + 1)) : gA.has(t);
	}
	wakeUp() {
		this.z80.regs.halted === 0 && (this.stopReason === a.WAITING_FOR_INTERRUPT || this.stopReason === a.HALTED) && this.clearStopState();
	}
	terminalStopReason() {
		let e = this.stopReason;
		return e !== void 0 && o(e) ? e : void 0;
	}
	requireNoOpenPoke(e) {
		if (this.pokeJournal !== void 0) throw Error("cannot " + e + " while a poke is open; call endPoke() first");
	}
	clearStopState() {
		this.stopReason = void 0, this.pendingInputPort = void 0;
	}
	writeBytes(e, t) {
		for (let n = 0; n < e.length; n++) this.memory[t + n & 65535] = e[n] & 255;
	}
	addRecord(e) {
		if (this.historyCapacity === 0) return;
		let t = this.historyBuffer.length;
		if (this.historyCount === t && t < this.historyCapacity) {
			let e = Array(Math.min(this.historyCapacity, t === 0 ? 64 : t * 2));
			for (let n = 0; n < this.historyCount; n++) e[n] = this.historyBuffer[(this.historyStart + n) % t];
			this.historyBuffer = e, this.historyStart = 0, t = e.length;
		}
		e.stepId = this.nextStepId++, this.historyBuffer[(this.historyStart + this.historyCount) % t] = e, this.historyCount < t ? this.historyCount += 1 : this.historyStart = (this.historyStart + 1) % t;
	}
	removeNewestRecord() {
		let e = this.historyBuffer.length;
		if (this.historyCount === 0 || e === 0) return;
		let t = (this.historyStart + this.historyCount - 1) % e, n = this.historyBuffer[t];
		return this.historyBuffer[t] = void 0, --this.historyCount, n;
	}
	clearHistory() {
		this.historyBuffer = [], this.historyStart = 0, this.historyCount = 0, this.pendingRecord = void 0, this.pokeJournal = void 0;
	}
}, TA = 47;
function EA(e) {
	if (e.length === 0) return ".";
	let t = e.charCodeAt(0) === TA, n = -1, r = !0;
	for (let t = e.length - 1; t > 0; --t) if (e.charCodeAt(t) === TA) {
		if (!r) {
			n = t;
			break;
		}
	} else r = !1;
	return n === -1 ? t ? "/" : "." : t && n === 1 ? "//" : e.slice(0, n);
}
function DA(...e) {
	let t = "";
	for (let n of e) n === "" || (n.startsWith("/") ? t = n : (t !== "" && !t.endsWith("/") && (t += "/"), t += n));
	return t;
}
function OA(e) {
	let t = e.lastIndexOf("/");
	return t >= 0 && (e = e.substring(t + 1)), t = e.lastIndexOf("."), t > 0 ? {
		name: e.substring(0, t),
		ext: e.substring(t)
	} : {
		name: e,
		ext: ""
	};
}
//#endregion
//#region ../z80-asm/src/AsmTokenizer.ts
var kA = /* @__PURE__ */ new Set([
	"z",
	"nz",
	"c",
	"nc",
	"po",
	"pe",
	"p",
	"m",
	"v",
	"nv"
]), AA = /* @__PURE__ */ function(e) {
	return e[e.ANYWHERE = 0] = "ANYWHERE", e[e.FIRST_COLUMN = 1] = "FIRST_COLUMN", e[e.NOT_FIRST_COLUMN = 2] = "NOT_FIRST_COLUMN", e;
}({}), jA = /^(?:<<|>>|<>|&&|==|!=|<=|>=|\|\||[-$~+*/^%!()&|?:,=<>#])/, MA = /^(?:af'|\.?[a-z_][a-z0-9_]*)/i, NA = /* @__PURE__ */ new Map();
function PA(e) {
	return e === " " || e === "	";
}
function FA(e, t) {
	return e >= "A" && e <= "Z" || e >= "a" && e <= "z" || e == "." || e == "_" || !t && e >= "0" && e <= "9";
}
function IA(e) {
	return kA.has(e.toLowerCase());
}
function LA(e, t) {
	for (; t < e.length && PA(e[t]);) t += 1;
	return t;
}
function Q(e, t) {
	let n = e >= "0" && e <= "9" ? e.charCodeAt(0) - 48 : e >= "A" && e <= "F" ? e.charCodeAt(0) - 65 + 10 : e >= "a" && e <= "f" ? e.charCodeAt(0) - 97 + 10 : void 0;
	return n === void 0 || n >= t ? void 0 : n;
}
function RA(e, t) {
	if (e[t] !== "\"" && e[t] !== "'") return;
	let n = e[t];
	t++;
	let r = [];
	for (; !(t >= e.length);) {
		if (e[t] === n) {
			if (t + 1 < e.length && e[t + 1] === n) t++;
			else break;
		}
		r.push(e[t]), t++;
	}
	let i = r.join("");
	return t++, {
		value: i,
		end: t,
		error: t <= e.length ? void 0 : "string is missing end quote"
	};
}
function zA(e) {
	let t = 0, n = 10;
	if (t < e.length && e[t] === "$") {
		if (t += 1, t === e.length || Q(e[t], 16) === void 0) return;
		n = 16;
	}
	if (n === 10 && Q(e[t], 10) !== void 0) {
		let r = t;
		for (; t < e.length && Q(e[t], 16) !== void 0;) t++;
		t < e.length && e[t].toUpperCase() === "H" && (n = 16), t = r;
	}
	if (n === 10) {
		let r = t;
		for (; t < e.length && Q(e[t], 8) !== void 0;) t++;
		t < e.length && e[t].toUpperCase() === "O" && (t === e.length || Q(e[t + 1], 8) === void 0) && (n = 8), t = r;
	}
	if (n === 10) {
		let r = t;
		for (; t < e.length && Q(e[t], 2) !== void 0;) t++;
		t < e.length && e[t].toUpperCase() === "B" && (t === e.length || Q(e[t + 1], 16) === void 0) && (n = 2), t = r;
	}
	n === 10 && t + 2 < e.length && e[t] === "0" && (e[t + 1].toLowerCase() == "x" ? (n = 16, t += 2) : e[t + 1].toLowerCase() == "o" ? (n = 8, t += 2) : e[t + 1].toLowerCase() == "b" && Q(e[t + 2], 2) !== void 0 && (n = 2, t += 2));
	let r = !1, i = 0;
	for (; t < e.length;) {
		let a = e[t], o = Q(a, n);
		if (o === void 0) break;
		i = i * n + o, r = !0, t++;
	}
	if (!r) return t === 0 ? void 0 : {
		value: i,
		end: t,
		error: "invalid number"
	};
	let a;
	if (t < e.length) {
		let r = e[t].toUpperCase();
		r === "H" ? n === 16 ? t++ : a = "found H at end of non-hex number: " + e.substring(0, t + 1) : r === "O" ? n === 8 ? t++ : a = "found O at end of non-octal number: " + e.substring(0, t + 1) : r === "B" ? n === 2 ? t++ : a = "found B at end of non-binary number: " + e.substring(0, t + 1) : r === "D" && (n === 10 ? t++ : a = "found D at end of non-decimal number: " + e.substring(0, t + 1));
	}
	return {
		value: i,
		end: t,
		error: a
	};
}
function BA(e, t) {
	if (e = e.substring(t), e === "") throw Error("cannot tokenize empty string");
	let n = zA(e);
	if (n !== void 0) return {
		tag: "number",
		begin: t,
		end: t + n.end,
		text: e.substring(0, n.end),
		value: n.value,
		error: n.error
	};
	let r = jA.exec(e);
	if (r !== null) return {
		tag: "symbol",
		begin: t,
		end: t + r[0].length,
		text: r[0],
		error: void 0
	};
	if (r = MA.exec(e), r !== null) return {
		tag: "identifier",
		begin: t,
		end: t + r[0].length,
		text: r[0],
		error: void 0
	};
	let i = RA(e, 0);
	return i === void 0 ? e[0] === ";" ? {
		tag: "comment",
		begin: t,
		end: t + e.length,
		text: e,
		value: e.substring(1).trim(),
		error: void 0
	} : {
		tag: "error",
		begin: t,
		end: t + 1,
		text: e[0],
		error: "invalid character \"" + e[0] + "\""
	} : {
		tag: "string",
		begin: t,
		end: t + i.end,
		text: e.substring(0, i.end),
		value: i.value,
		error: i.error
	};
}
function VA(e) {
	let t = NA.get(e);
	if (t !== void 0) return t;
	let n = [], r = 0;
	for (; r < e.length;) if (r = LA(e, r), r < e.length) {
		let t = BA(e, r);
		if (n.push(t), t.end <= r) throw Error("token did not advance: " + t);
		r = t.end;
	}
	return NA.set(e, n), n;
}
var HA = class {
	constructor(e) {
		this.tokenIndex = 0, this.line = e, this.tokens = VA(e);
	}
	getCurrentToken() {
		return this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex] : void 0;
	}
	getCurrentValidToken() {
		let e = this.getCurrentToken();
		return e === void 0 || e.error !== void 0 ? void 0 : {
			...e,
			error: void 0
		};
	}
	getCurrentColumn() {
		return this.getCurrentToken()?.begin ?? -1;
	}
	skipToEndOfLine() {
		this.tokenIndex = this.tokens.length;
	}
	readToEndOfLine() {
		let e = this.getCurrentToken(), t = e === void 0 ? "" : this.line.substring(e.begin);
		return this.skipToEndOfLine(), t;
	}
	isEndOfLine() {
		return this.tokenIndex === this.tokens.length || this.tokens[this.tokenIndex].tag === "comment";
	}
	ensureEndOfLine() {
		for (; this.tokenIndex < this.tokens.length && this.tokens[this.tokenIndex].tag === "comment";) this.tokenIndex += 1;
		return this.getCurrentToken();
	}
	found(e) {
		return this.foundToken(e) !== void 0;
	}
	foundToken(e) {
		let t = this.matchesToken(e);
		if (t !== void 0) return this.tokenIndex += 1, t;
	}
	foundAnyOf(e) {
		for (let t of e) if (this.found(t)) return t;
	}
	matches(e) {
		return this.matchesToken(e) !== void 0;
	}
	matchesToken(e) {
		let t = this.getCurrentValidToken();
		return t !== void 0 && t.text.toLowerCase() === e ? t : void 0;
	}
	readIdentifier(e, t = 0) {
		let n = this.getCurrentValidToken();
		if (n === void 0 || n.tag !== "identifier") return;
		switch (t) {
			case 0: break;
			case 1:
				if (n.begin !== 0) return;
				break;
			case 2:
				if (n.begin === 0) return;
				break;
			default: throw Error("unknown position requirement " + t);
		}
		let r = n.text, i = r.toLowerCase();
		if (e || !ie(i) && !ae(i) && !IA(i)) return this.tokenIndex += 1, {
			name: i,
			column: n.begin,
			originalSpelling: r
		};
	}
	readString() {
		let e = this.getCurrentValidToken();
		if (e !== void 0 && e.tag === "string") return this.tokenIndex += 1, e.value;
	}
	readCharConstant() {
		let e = this.getCurrentValidToken();
		if (e !== void 0 && e.tag === "string") {
			if (e.value.length !== 1) throw Error("invalid character constant");
			return this.tokenIndex += 1, e.value.charCodeAt(0);
		}
	}
	readMacroArgs() {
		let e = [];
		if (this.tokenIndex >= this.tokens.length) return e;
		let t = this.tokens[this.tokenIndex].begin, n = this.line;
		for (; t < n.length && n[t] != ";";) {
			let r, i = RA(n, t);
			if (i !== void 0) {
				let { end: e, error: a } = i;
				if (a !== void 0) throw Error(a);
				r = n.substring(t, e), t = e;
			} else if (n[t] === "<") {
				t += 1;
				let e = t;
				for (; t < n.length && n[t] !== ">";) t += 1;
				if (t === n.length) throw Error("Missing > after < in macro argument");
				r = n.substring(e, t), t += 1;
			} else {
				let e = t;
				for (; t < n.length && n[t] !== "," && n[t] !== ";";) t++;
				r = n.substring(e, t).trim();
			}
			if (e.push(r), t = LA(n, t), t < n.length && n[t] === "," && (t += 1, t = LA(n, t), t === n.length || n[t] === ";")) throw Error("missing macro argument after comma");
		}
		for (; this.tokenIndex < this.tokens.length && this.tokens[this.tokenIndex].begin < t;) this.tokenIndex += 1;
		return e;
	}
	readNumericConstant(e) {
		let t = this.getCurrentValidToken();
		if (t !== void 0) {
			if (t.tag === "number") return this.tokenIndex += 1, t.value;
			if (t.tag === "symbol" && t.text === "$") return this.tokenIndex += 1, e;
		}
	}
}, UA = /* @__PURE__ */ new Set([".title"]), WA = /* @__PURE__ */ new Set(["error"]), GA = /* @__PURE__ */ new Set([
	"defb",
	"db",
	".db",
	".byte",
	"defm",
	"dm",
	".dm",
	".text",
	".ascii",
	".asciz"
]), KA = /* @__PURE__ */ new Set([
	"defw",
	"dw",
	".dw",
	".word"
]), qA = /* @__PURE__ */ new Set([".long"]), JA = /* @__PURE__ */ new Set([
	"equ",
	".equ",
	"defl",
	"="
]), YA = /* @__PURE__ */ new Set([
	"org",
	".org",
	".loc"
]), XA = /* @__PURE__ */ new Set(["align", ".align"]), ZA = /* @__PURE__ */ new Set([
	"defs",
	"ds",
	".ds",
	".block",
	".blkb",
	"data",
	"dc"
]), QA = /* @__PURE__ */ new Set(["macro", ".macro"]), $A = /* @__PURE__ */ new Set(["endm", ".endm"]), ej = /* @__PURE__ */ new Set(["if", "cond"]), tj = /* @__PURE__ */ new Set(["else"]), nj = /* @__PURE__ */ new Set(["endif", "endc"]), rj = /* @__PURE__ */ new Set(["end"]), ij = /* @__PURE__ */ new Set([
	".s",
	".ass",
	".asm"
]), aj = [
	"!",
	"#",
	"$",
	"%",
	"&",
	".",
	":",
	"?",
	"@",
	"\\",
	"^",
	"_",
	"|",
	"~"
];
function oj() {
	return [
		{
			directives: UA,
			description: "Set the title of the program, as a string."
		},
		{
			directives: WA,
			description: "Force an error."
		},
		{
			directives: GA,
			description: "Define a sequence of bytes, text, or strings."
		},
		{
			directives: KA,
			description: "Define a sequence of 16-bit words."
		},
		{
			directives: qA,
			description: "Define a sequence of 32-bit longs."
		},
		{
			directives: JA,
			description: "Assign a value to a symbol."
		},
		{
			directives: YA,
			description: "Specify address of next instruction."
		},
		{
			directives: XA,
			description: "Add fill bytes until address is multiple of specified value."
		},
		{
			directives: ZA,
			description: "Fill memory with repeated bytes."
		},
		{
			directives: QA,
			description: "Start a macro definition."
		},
		{
			directives: $A,
			description: "End a macro definition."
		},
		{
			directives: ej,
			description: "If conditional."
		},
		{
			directives: tj,
			description: "Else conditional."
		},
		{
			directives: nj,
			description: "End of if conditional."
		},
		{
			directives: rj,
			description: "End of file, optionally followed by entry address or label."
		},
		{
			directives: /* @__PURE__ */ new Set(["#target"]),
			description: "Specify whether targeting bin or rom."
		},
		{
			directives: /* @__PURE__ */ new Set(["#code"]),
			description: "Start a new code segment."
		},
		{
			directives: /* @__PURE__ */ new Set(["#include"]),
			description: "Include an assembly file or library directory."
		},
		{
			directives: /* @__PURE__ */ new Set(["#local"]),
			description: "Start a local scope."
		},
		{
			directives: /* @__PURE__ */ new Set(["#endlocal"]),
			description: "End a local scope."
		},
		{
			directives: /* @__PURE__ */ new Set(["#insert"]),
			description: "Insert a binary file."
		}
	];
}
var sj = class {
	constructor(e, t, n, r) {
		this.symbol = e, this.assembledLine = t, this.column = n, this.index = r;
	}
	matches(e) {
		return e >= this.column && e <= this.column + this.symbol.name.length;
	}
	equals(e) {
		return e !== void 0 && this.symbol === e.symbol && this.assembledLine === e.assembledLine && this.column === e.column;
	}
}, cj = /* @__PURE__ */ function(e) {
	return e[e.UNKNOWN = 0] = "UNKNOWN", e[e.CONSTANT = 1] = "CONSTANT", e[e.CODE = 2] = "CODE", e[e.BYTE = 3] = "BYTE", e[e.WORD = 4] = "WORD", e[e.ARRAY = 5] = "ARRAY", e;
}({}), lj = class {
	constructor(e, t, n) {
		this.size = 0, this.type = 0, this.definitions = [], this.references = [], this.changesValue = !1, this.name = e, this.originalSpelling = t, this.value = n;
	}
}, uj = class {
	constructor(e, t) {
		this.beginLineNumber = 0, this.endLineNumber = 0, this.childFiles = [], this.lineNumbers = [], this.pathname = e, this.parentFileInfo = t, this.depth = t === void 0 ? 0 : t.depth + 1, t !== void 0 && t.childFiles.push(this);
	}
}, dj = class {
	constructor(e, t) {
		this.line = e, this.value = t;
	}
}, fj = class {
	constructor(e, t, n) {
		this.listingLineNumber = 0, this.address = 0, this.binary = [], this.alignment = 1, this.symbolsDefined = [], this.symbolsReferenced = [], this.expandedTo = [], this.rolledUpBinary = [], this.mnemonicColumn = void 0, this.insideInsert = !1, this.fileInfo = e, this.lineNumber = t, this.line = n;
	}
	set nextAddress(e) {
		this.specifiedNextAddress = e;
	}
	get nextAddress() {
		return this.specifiedNextAddress ?? this.endAddress();
	}
	endAddress() {
		return this.address + this.binary.length;
	}
	isData() {
		return this.binary.length > 0 && this.variant === void 0;
	}
	equals(e) {
		if (this.address !== e.address) return !1;
		let t = this.binary, n = e.binary;
		if (t.length !== n.length) return !1;
		for (let e = 0; e < t.length; e++) if (t[e] !== n[e]) return !1;
		return !0;
	}
}, pj = class {
	constructor(e, t) {
		this.fileInfo = e, this.assembledLines = t;
	}
}, mj = class {
	constructor(e, t, n, r, i, a, o) {
		this.name = e, this.tag = t, this.params = n, this.labels = r, this.macroListingLineNumber = i, this.endmListingLineNumber = a, this.lines = o;
	}
}, hj = class {
	constructor(e) {
		this.symbols = /* @__PURE__ */ new Map(), this.parent = e;
	}
	get(e, t) {
		let n = this.symbols.get(e);
		return n === void 0 && t && this.parent !== void 0 && (n = this.parent.get(e, t)), n;
	}
	set(e) {
		this.symbols.set(e.name, e);
	}
	remove(e) {
		this.symbols.delete(e);
	}
}, gj = class {
	constructor(e, t, n, r) {
		this.variant = e, this.tokens = t, this.expression = n, this.isCommand = r;
	}
	dump(e = "") {
		this.variant !== void 0 && console.log(e, this.variant.mnemonic + " " + this.variant.tokens.join(""));
		for (let [t, n] of this.tokens.entries()) console.log(e, "[" + t + "]"), n.dump(e + "    ");
		if (this.expression instanceof Map) for (let [t, n] of this.expression.entries()) console.log(e, "[" + t + "]"), n.dump(e + "    ");
		else if (this.expression !== void 0) {
			let { expr: t, trieNode: n } = this.expression;
			console.log(e, "[" + t + "]"), n.dump(e + "    ");
		}
	}
};
function _j(e, t) {
	let n, r = /* @__PURE__ */ new Map();
	for (let i of e) if (i.aliasOf === void 0) {
		if (t >= i.tokens.length) {
			if (n !== void 0) throw Error("same sequence of tokens leads to different trie node: " + je(n));
			n = i;
		} else {
			let e = i.tokens[t];
			e === "+" && i.tokens[t + 1] === "dd" && (e = "dd");
			let n = r.get(e);
			n === void 0 && (n = [], r.set(e, n)), n.push(i);
		}
	}
	let i = /* @__PURE__ */ new Map(), a;
	for (let [e, n] of r.entries()) {
		let r = _j(n, t + (e === "dd" ? 2 : 1));
		if (Ae(e)) {
			if (a !== void 0) throw Error("can only have one expression trie node");
			a = {
				expr: e,
				trieNode: r
			};
		} else if (Q(e[0], 10) !== void 0) {
			let t = parseInt(e, 10);
			if (a === void 0) a = /* @__PURE__ */ new Map();
			else if (!(a instanceof Map)) throw Error("can only have one expression trie node");
			a.set(t, r);
		} else i.set(e, r);
	}
	return new gj(n, i, a, !1);
}
var vj;
function yj() {
	if (vj === void 0) {
		let e = /* @__PURE__ */ new Map();
		for (let [t, n] of Wk.entries()) {
			let r = _j(n, 0);
			e.set(t, r);
		}
		vj = new gj(void 0, e, void 0, !0);
	}
	return vj;
}
var bj = class {
	constructor(e) {
		this.scopes = [new hj(void 0)], this.assembledLines = [], this.dirCache = /* @__PURE__ */ new Map(), this.macros = /* @__PURE__ */ new Map(), this.entryPoint = void 0, this.symbols = [], this.fileSystem = e;
	}
	addKnownLabel({ name: e, address: t }) {
		let n = new lj(e.toLowerCase(), e, t);
		n.definitions.push(new sj(n, void 0, 0, n.definitions.length)), this.scopes[0].set(n);
	}
	addConstant(e, t) {
		let n = new lj(e.toLowerCase(), e, t);
		n.type = 1, n.definitions.push(new sj(n, void 0, 0, n.definitions.length)), this.scopes[0].set(n);
	}
	addKnownLabels(e) {
		for (let t of e) this.addKnownLabel(t);
	}
	assembleFile(e) {
		let t = this.loadSourceFile(e, void 0);
		if (t === void 0) return;
		this.assembledLines = t.assembledLines.slice(), new xj(this, 1).run(), new xj(this, 2).run();
		for (let e = 0; e < this.assembledLines.length; e++) this.assembledLines[e].fileInfo.lineNumbers.push(e);
		let n = (e) => {
			if (e.lineNumbers.length === 0) throw Error("File info for \"" + e.pathname + "\" has no lines");
			e.beginLineNumber = e.lineNumbers[0], e.endLineNumber = e.lineNumbers[e.lineNumbers.length - 1] + 1;
			for (let t of e.childFiles) n(t), e.beginLineNumber = Math.min(e.beginLineNumber, t.beginLineNumber), e.endLineNumber = Math.max(e.endLineNumber, t.endLineNumber);
		};
		n(t.fileInfo);
		for (let e of this.assembledLines) e.binary.length > 0 && e.kind === void 0 && (e.kind = e.variant ? "code" : "data");
		for (let e of this.scopes) for (let t of e.symbols.values()) {
			this.symbols.push(t);
			for (let e of t.definitions) e.assembledLine !== void 0 && e.assembledLine.symbolsDefined.push(e);
			for (let e of t.references) e.assembledLine !== void 0 && e.assembledLine.symbolsReferenced.push(e);
		}
		for (let e of this.assembledLines) {
			let t = e;
			for (; t.expandedFrom !== void 0;) t = t.expandedFrom;
			t.rolledUpBinary.push(...e.binary), t.rolledUpError === void 0 && (t.rolledUpError = e.error);
		}
		this.symbols.sort((e, t) => e.value - t.value);
		let r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
		for (let e of this.assembledLines) {
			let t = e.isData() ? i : r;
			for (let n = 0; n < e.binary.length; n++) t.add(e.address + n);
		}
		for (let e = 0; e < this.symbols.length; e++) {
			let t = this.symbols[e];
			if (t.type === 0) {
				if (r.has(t.value)) t.type = 2;
				else {
					let n;
					switch (n = e + 1 < this.symbols.length ? this.symbols[e + 1].value : Math.max(...this.assembledLines.map((e) => e.endAddress())), t.size = n - t.value, t.size) {
						case 0:
							t.type = 0;
							break;
						case 1:
							t.type = 3;
							break;
						case 2:
							t.type = 4;
							break;
						default: t.type = 5;
					}
				}
			}
		}
		return t;
	}
	loadSourceFile(e, t) {
		let n = this.fileSystem.readTextFile(e);
		if (n === void 0) return;
		let r = new uj(e, t), i = [];
		for (let e = 0; e < n.length; e++) i.push(new fj(r, e, n[e]));
		return new pj(r, i);
	}
	readDir(e) {
		let t = this.dirCache.get(e);
		if (t === void 0) {
			if (t = this.fileSystem.readDirectory(e), t === void 0) return;
			this.dirCache.set(e, t);
		}
		return t;
	}
	getEntryPoint() {
		let e = this.entryPoint, t = !1;
		if (e === void 0) {
			for (let t of this.assembledLines) if (t.binary.length > 0) {
				e = t.address;
				break;
			}
			t = !0;
		}
		return {
			entryPoint: e,
			guessed: t
		};
	}
}, xj = class {
	constructor(e, t) {
		this.scopeCount = 1, this.target = "bin", this.listingLineNumber = 0, this.libraryIncludeCount = 0, this.sawEnd = !1, this.conditionals = [], this.labelCounter = 1, this.inserting = !1, this.asm = e, this.passNumber = t, this.currentScope = this.asm.scopes[0];
	}
	run() {
		let e = 0;
		for (this.listingLineNumber = 0;;) {
			let t = this.getNextLine();
			if (t === void 0) break;
			new Sj(this, t).assemble(), t.error !== void 0 && e++;
		}
		if (this.currentScope !== this.asm.scopes[0]) {
			let e = this.asm.assembledLines;
			e.length > 0 && e[e.length - 1].error === void 0 && (e[e.length - 1].error = "missing #endlocal");
		}
		for (let e of this.conditionals) e.line.error = "missing endif for if";
		if (this.inserting) {
			let e = this.asm.assembledLines;
			e.length > 0 && e[e.length - 1].error === void 0 && (e[e.length - 1].error = "missing #endinsert");
		}
		return e;
	}
	getNextLine() {
		if (this.listingLineNumber < 0 || this.listingLineNumber >= this.asm.assembledLines.length) return;
		let e = this.listingLineNumber++, t = this.asm.assembledLines[e];
		return t.listingLineNumber = e, t.address = e === 0 ? 0 : this.asm.assembledLines[e - 1].nextAddress, t;
	}
	setListingLineNumber(e) {
		if (e < this.listingLineNumber) throw Error(`Can't go backward in listing (${e} < ${this.listingLineNumber})`);
		this.listingLineNumber = e;
	}
	insertLines(e) {
		this.asm.assembledLines.splice(this.listingLineNumber, 0, ...e);
	}
	globals() {
		return this.asm.scopes[0];
	}
	locals() {
		return this.currentScope;
	}
	enterScope() {
		return this.passNumber === 1 ? (this.currentScope = new hj(this.currentScope), this.asm.scopes.push(this.currentScope), this.scopeCount++) : this.currentScope = this.asm.scopes[this.scopeCount++], this.currentScope;
	}
	leaveScope() {
		let e = this.currentScope.parent;
		return e !== void 0 && (this.currentScope = e, !0);
	}
	isEnabled() {
		for (let e of this.conditionals) if (!e.value) return !1;
		return !0;
	}
}, Sj = class e {
	constructor(e, t) {
		this.pass = e, this.assembledLine = t, this.tokenizer = new HA(t.line);
	}
	assemble() {
		try {
			this.assembleOrThrow();
		} catch (e) {
			this.assembledLine.error === void 0 && (this.assembledLine.error = e.message);
		}
	}
	assembleOrThrow() {
		if (this.assembledLine.insideInsert = !1, this.pass.inserting && !this.assembledLine.line.startsWith("#endinsert")) {
			this.assembledLine.insideInsert = !0, this.assembledLine.binary.length = 0;
			let e = this.assembledLine.line;
			for (let t = 0; t < e.length; t++) this.assembledLine.binary.push(e.charCodeAt(t));
			this.assembledLine.binary.push(10);
			return;
		}
		let t = this.assembledLine.address;
		if (this.assembledLine.binary.length = 0, this.pass.sawEnd) return;
		let n = this.pass.isEnabled(), r, i = 0;
		if (n && this.tokenizer.found("#")) {
			this.parseDirective();
			return;
		}
		let a, o, s = !1, c = this.tokenizer.readIdentifier(!1, AA.FIRST_COLUMN);
		c !== void 0 && (a = c.name, o = c.originalSpelling, r = t, this.tokenizer.found(":") && this.tokenizer.found(":") && (s = !0), n || (a = void 0, r = void 0, o = void 0));
		let l, u = this.tokenizer.readIdentifier(!1, AA.NOT_FIRST_COLUMN);
		if (u !== void 0) l = u.name, this.assembledLine.mnemonicColumn = u.column;
		else {
			let e = this.tokenizer.getCurrentColumn();
			e > 0 && this.tokenizer.found("=") && (l = "=", this.assembledLine.mnemonicColumn = e);
		}
		if (l !== void 0) {
			if (ej.has(l)) {
				if (n) {
					let e = this.readExpression();
					this.pass.conditionals.push(new dj(this.assembledLine, e !== 0));
				} else this.tokenizer.skipToEndOfLine(), this.pass.conditionals.push(new dj(this.assembledLine, !1));
				this.ensureEndOfLine();
				return;
			}
			if (tj.has(l)) {
				let e = this.pass.conditionals.at(-1);
				if (e === void 0) {
					this.assembledLine.error = "else without if";
					return;
				}
				e.value = !e.value, this.ensureEndOfLine();
				return;
			}
			if (nj.has(l)) {
				if (this.pass.conditionals.length === 0) {
					this.assembledLine.error = "endif without if";
					return;
				}
				this.pass.conditionals.pop(), this.ensureEndOfLine();
				return;
			}
			if (!n) return;
			if (UA.has(l)) this.readString();
			else if (WA.has(l)) {
				this.assembledLine.error = this.tokenizer.readToEndOfLine();
				return;
			} else if (GA.has(l)) {
				for (;;) {
					let e = this.tokenizer.tokenIndex, t = this.readString();
					if (t !== void 0 && t.length === 1 && (this.tokenizer.tokenIndex = e, t = void 0), t === void 0) {
						if (this.assembledLine.error !== void 0) return;
						if (t = this.parsePredefinedName(), t === void 0) {
							let e = this.readExpression();
							this.assembledLine.binary.push(h(e));
						}
					}
					if (t !== void 0) for (let e = 0; e < t.length; e++) this.assembledLine.binary.push(t.charCodeAt(e));
					if (!this.tokenizer.found(",")) break;
				}
				l === ".asciz" && this.assembledLine.binary.push(0);
			} else if (KA.has(l)) for (;;) {
				let e = this.readExpression();
				if (this.assembledLine.binary.push(h(e)), this.assembledLine.binary.push(m(e)), !this.tokenizer.found(",")) break;
			}
			else if (qA.has(l)) for (;;) {
				let e = this.readExpression();
				if (this.assembledLine.binary.push(h(e)), this.assembledLine.binary.push(m(e)), this.assembledLine.binary.push(h(e >> 16)), this.assembledLine.binary.push(m(e >> 16)), !this.tokenizer.found(",")) break;
			}
			else if (JA.has(l)) {
				let e = this.readExpression();
				a === void 0 ? this.assembledLine.error = "must have label for constant" : (r = e, i = 1);
			} else if (YA.has(l)) this.assembledLine.nextAddress = this.readExpression();
			else if (XA.has(l)) {
				let e = this.readExpression();
				if (this.assembledLine.alignment = e, this.assembledLine.kind = "reserved", e <= 0) this.assembledLine.error = "alignment value expected";
				else {
					let n;
					if (this.tokenizer.found(",") && (n = this.readExpression()), n === void 0) this.assembledLine.nextAddress = t + (e - t % e) % e;
					else {
						n = h(n);
						let r = t;
						for (; r % e !== 0;) this.assembledLine.binary.push(n), r++;
					}
				}
			} else if (ZA.has(l)) {
				let e = this.readExpression();
				if (this.assembledLine.kind = "reserved", e === void 0) this.assembledLine.error = "length value expected";
				else if (e < 0) this.assembledLine.error = "length cannot be negative";
				else {
					let n;
					if (this.tokenizer.found(",")) {
						let e = this.readExpression();
						if (e === void 0) {
							this.assembledLine.error === void 0 && (this.assembledLine.error = "error in fill byte");
							return;
						}
						n = e;
					}
					if (n === void 0) this.assembledLine.nextAddress = t + e;
					else {
						n = h(n);
						for (let t = 0; t < e; t++) this.assembledLine.binary.push(n);
					}
				}
			} else if (QA.has(l)) {
				let t, n;
				if (a !== void 0) t = a, a = void 0, n = "&";
				else {
					if (t = this.tokenizer.readIdentifier(!0)?.name, t === void 0) {
						this.assembledLine.error = "must specify name of macro";
						return;
					}
					n = "\\";
				}
				t = t.toLowerCase();
				let r = this.pass.asm.macros.get(t);
				if (this.pass.passNumber > 1) {
					if (r === void 0) return;
					r.macroListingLineNumber === this.assembledLine.listingLineNumber && this.pass.setListingLineNumber(r.endmListingLineNumber + 1);
					return;
				}
				{
					if (r !== void 0) {
						this.assembledLine.error = "macro \"" + t + "\" already defined";
						return;
					}
					let i = [], a = [];
					if (!this.tokenizer.isEndOfLine()) {
						let e = this.tokenizer.foundAnyOf(aj) ?? n;
						e !== "?" && (n = e);
						do {
							if (e = this.tokenizer.foundAnyOf(aj) ?? n, e !== "?" && e !== n) {
								this.assembledLine.error = "Inconsistent tags in macro: " + n + " and " + e;
								return;
							}
							let t = this.tokenizer.readIdentifier(!0)?.name;
							if (t === void 0) {
								this.assembledLine.error = "expected macro parameter name";
								return;
							}
							e === "?" ? a.push(t) : i.push(t);
						} while (this.tokenizer.found(","));
						this.ensureEndOfLine();
					}
					let o = this.assembledLine.listingLineNumber, s, c = [];
					for (;;) {
						let t = this.pass.getNextLine();
						if (t === void 0) {
							this.assembledLine.error = "macro has no endm";
							return;
						}
						let n = new e(this.pass, t).tokenizer.readIdentifier(!1)?.name;
						if (n !== void 0 && $A.has(n)) {
							s = t.listingLineNumber;
							break;
						}
						c.push(t.line);
					}
					if (s === void 0) throw Error("endmListingLineNumber is undefined");
					this.pass.asm.macros.set(t, new mj(t, n, i, a, o, s, c));
					return;
				}
			} else if ($A.has(l)) {
				this.assembledLine.error = "endm outside of macro definition";
				return;
			} else if (rj.has(l)) {
				if (!this.tokenizer.isEndOfLine()) {
					let e = this.readExpression();
					if (e === void 0) {
						this.assembledLine.error === void 0 && (this.assembledLine.error = "invalid expression for entry point");
						return;
					}
					if (this.pass.asm.entryPoint !== void 0 && this.pass.asm.entryPoint !== e) {
						this.assembledLine.error === void 0 && (this.assembledLine.error = "changing entry point from 0x" + p(this.pass.asm.entryPoint) + " to 0x" + p(e));
						return;
					}
					this.pass.asm.entryPoint = e;
				}
				this.pass.sawEnd = !0;
			} else this.processOpCode(l);
		}
		if (this.ensureEndOfLine(), a !== void 0 && r !== void 0 && o !== void 0) {
			let e = s ? this.pass.globals() : this.pass.locals(), t = e.get(a);
			t === void 0 ? (t = new lj(a, o, r), i !== 0 && (t.type = i), e.set(t)) : (t.definitions.length > 0 && t.value !== r && (t.changesValue = !0), t.value = r), this.pass.passNumber === 1 && t.definitions.push(new sj(t, this.assembledLine, 0, t.definitions.length));
		}
	}
	parsePredefinedName() {
		let e = this.tokenizer.foundAnyOf([
			"__date__",
			"__time__",
			"__file__",
			"__line__"
		]);
		if (e === void 0) return;
		let t;
		switch (e) {
			case "__date__": {
				let e = /* @__PURE__ */ new Date();
				t = e.getFullYear() + "-" + (e.getMonth() + 1).toString().padStart(2, "0") + "-" + e.getDate().toString().padStart(2, "0");
				break;
			}
			case "__time__": {
				let e = /* @__PURE__ */ new Date();
				t = e.getHours().toString().padStart(2, "0") + ":" + e.getMinutes().toString().padStart(2, "0") + ":" + e.getSeconds().toString().padStart(2, "0");
				break;
			}
			case "__file__":
				t = this.assembledLine.fileInfo.pathname;
				break;
			case "__line__": t = (this.assembledLine.lineNumber ?? 0).toString();
		}
		if (t === void 0) throw Error("internal error getting predefined name " + e);
		return t;
	}
	ensureEndOfLine() {
		let e = this.tokenizer.ensureEndOfLine();
		e !== void 0 && this.assembledLine.error === void 0 && (this.assembledLine.error = "syntax error (\"" + e.text + "\")");
	}
	parseDirective() {
		let e = this.tokenizer.readIdentifier(!0)?.name;
		if (e === void 0 || e === "") {
			this.assembledLine.error = "must specify directive after #";
			return;
		}
		switch (e) {
			case "target":
				let t = this.tokenizer.readIdentifier(!1)?.name;
				if (t === "bin" || t === "rom") this.pass.target = t;
				else {
					t === void 0 ? this.assembledLine.error = "must specify target" : this.assembledLine.error = "unknown target " + t;
					return;
				}
				break;
			case "code":
				if (this.tokenizer.readIdentifier(!0)?.name === void 0) this.assembledLine.error = "segment name expected";
				else if (this.tokenizer.found(",")) {
					if (!this.tokenizer.found("*")) {
						let e = this.readExpression();
						e === void 0 ? this.assembledLine.error = "start address expected" : this.assembledLine.nextAddress = e;
					}
					this.tokenizer.found(",") && this.readExpression() === void 0 && (this.assembledLine.error = "length expected");
				}
				break;
			case "include": {
				let e = this.tokenizer.readIdentifier(!1)?.name;
				if (e === "library") {
					let e = this.readString();
					if (e === void 0) this.assembledLine.error = "missing library directory";
					else if (this.pass.passNumber === 1) {
						let t = DA(EA(this.assembledLine.fileInfo.pathname), e), n = this.pass.asm.readDir(t);
						if (n === void 0) {
							this.assembledLine.error = "can't read directory \"" + t + "\"";
							return;
						}
						let r = [];
						for (let t of n) {
							let n = OA(t);
							if (ij.has(n.ext)) {
								let i = this.pass.globals().get(n.name);
								if (i !== void 0 && i.definitions.length === 0) {
									let n = DA(e, t);
									r.push(new fj(this.assembledLine.fileInfo, void 0, "#include \"" + n + "\"")), this.pass.libraryIncludeCount++;
								}
							}
						}
						this.pass.insertLines(r);
					}
				} else if (e !== void 0) this.assembledLine.error = "unknown identifier " + e;
				else {
					let e = this.readString();
					if (e === void 0) this.assembledLine.error = "missing included filename";
					else if (this.pass.passNumber === 1) {
						let t = DA(EA(this.assembledLine.fileInfo.pathname), e), n = this.pass.asm.loadSourceFile(t, this.assembledLine.fileInfo);
						n === void 0 ? this.assembledLine.error = "cannot read file " + t : this.pass.insertLines(n.assembledLines);
					}
				}
				break;
			}
			case "local":
				this.pass.enterScope();
				break;
			case "endlocal":
				let n = this.pass.locals();
				if (n.parent === void 0) this.assembledLine.error = "#endlocal without #local";
				else {
					for (let [e, t] of n.symbols) if (t.references.length > 0 && t.definitions.length === 0) {
						n.remove(e);
						let r = n.parent.get(e);
						if (r === void 0) n.parent.set(t);
						else for (let e = 0; e < t.references.length; e++) {
							let n = t.references[e];
							r.references.push(new sj(r, n.assembledLine, n.column, r.references.length));
						}
					}
					this.pass.leaveScope();
				}
				break;
			case "insert": {
				if (this.tokenizer.isEndOfLine()) {
					this.pass.inserting = !0;
					break;
				}
				let e = this.readString();
				if (e === void 0) {
					this.assembledLine.error === void 0 && (this.assembledLine.error = "must specify pathname of file to insert");
					return;
				}
				let t = DA(EA(this.assembledLine.fileInfo.pathname), e), n = this.pass.asm.fileSystem.readBinaryFile(t);
				if (n === void 0) {
					this.assembledLine.error = "file \"" + t + "\" not found";
					return;
				}
				this.assembledLine.binary.push(...n);
				break;
			}
			case "endinsert":
				this.pass.inserting ? this.pass.inserting = !1 : this.assembledLine.error = "#endinsert without #insert";
				break;
			default: this.assembledLine.error = "unknown directive #" + e;
		}
		this.ensureEndOfLine();
	}
	processOpCode(e) {
		let t = this.pass.asm.macros.get(e);
		if (t !== void 0) {
			if (this.pass.passNumber > 1) {
				if (this.assembledLine.listingLineNumber > t.endmListingLineNumber) {
					this.tokenizer.skipToEndOfLine();
					return;
				}
			} else {
				let e;
				try {
					e = this.tokenizer.readMacroArgs();
				} catch (e) {
					this.assembledLine.error = e.message;
					return;
				}
				if (e.length < t.params.length) {
					this.assembledLine.error = "macro missing \"" + t.params[e.length] + "\" argument";
					return;
				}
				if (e.length > t.params.length) {
					this.assembledLine.error = "macro got too many arguments (" + e.length + " instead of " + t.params.length + ")";
					return;
				}
				let n = [];
				for (let e of t.labels) n.push("tmp" + this.pass.labelCounter++);
				let r = t.lines.map((r) => {
					let i = new fj(this.assembledLine.fileInfo, void 0, this.performMacroSubstitutions(r, t, e, n));
					return i.expandedFrom = this.assembledLine, this.assembledLine.expandedTo.push(i), i;
				});
				this.pass.insertLines(r);
				return;
			}
		}
		let n = yj().tokens.get(e);
		if (n === void 0) {
			this.assembledLine.error = "unknown mnemonic \"" + e + "\"", this.tokenizer.matches(":") && (this.assembledLine.error += " (if it's a label, unindent it)");
			return;
		}
		let r = n, i = /* @__PURE__ */ new Map();
		for (;;) {
			let t = this.tokenizer.getCurrentValidToken();
			if (t === void 0 || t.tag === "comment") {
				if (r.variant !== void 0) {
					this.assembledLine.binary = [];
					for (let e of r.variant.opcodes) if (typeof e == "number") this.assembledLine.binary.push(e);
					else {
						let t = i.get(e);
						if (t === void 0) throw Error("did not find arg " + e);
						switch (e) {
							case "nn":
							case "dd":
							case "offset":
								this.assembledLine.binary.push(h(t));
								break;
							case "nnnn": this.assembledLine.binary.push(h(t)), this.assembledLine.binary.push(m(t));
						}
					}
					this.assembledLine.variant = r.variant;
					return;
				}
				this.assembledLine.error = "no variant found for " + e;
				return;
			}
			{
				let n = r.tokens.get(t.text.toLowerCase());
				if (n !== void 0) r = n, this.tokenizer.tokenIndex += 1;
				else if (r.expression === void 0) {
					this.assembledLine.error = "no variant found for " + e;
					return;
				} else if (r.expression instanceof Map) {
					let t = this.readExpressionUpdateError(), n = r.expression.get(t);
					if (n !== void 0) r = n;
					else {
						this.assembledLine.error = t + " is not a valid value for " + e;
						return;
					}
				} else {
					if (i.has(r.expression.expr)) throw Error("multiple expressions for arg " + r.expression.expr);
					let n;
					if (r.expression.expr === "dd") {
						if (t.text === ")") n = 0;
						else if (t.text === "+" || t.text === "-") n = this.readExpressionUpdateError();
						else {
							this.assembledLine.error = "invalid expression for +dd offset";
							return;
						}
					} else n = this.readExpressionUpdateError();
					if (r.expression.expr === "offset") {
						let t = n - this.assembledLine.address - this.assembledLine.binary.length - 2;
						if (this.pass.passNumber > 1 && (t < -128 || t > 127)) {
							let r = t < -128 ? -128 - t : t - 127;
							this.assembledLine.error === void 0 && (this.assembledLine.error = "destination is too far by " + r + " byte" + (r === 1 ? "" : "s") + " for relative jump", e === "jr" && (this.assembledLine.error += "; use jp")), n = 0;
						} else n = t;
					}
					i.set(r.expression.expr, n), r = r.expression.trieNode;
				}
			}
		}
	}
	performMacroSubstitutions(e, t, n, r) {
		let i = [], a = 0;
		for (; a < e.length;) {
			let o = e.charAt(a);
			if (o === t.tag || o === "?") {
				let s = a + 1, c = s;
				for (; c < e.length && FA(e.charAt(c), c === s);) c++;
				let l = e.substring(s, c), u = o === "?" ? t.labels : t.params, ee = o === "?" ? r : n, d = u.indexOf(l);
				d >= 0 ? (i.push(ee[d]), a = c) : (i.push(o), a++);
			} else i.push(o), a++;
		}
		return i.join("");
	}
	readString() {
		try {
			return this.tokenizer.readString();
		} catch (e) {
			this.assembledLine.error = e.message;
			return;
		}
	}
	readExpressionUpdateError() {
		try {
			return this.readExpression();
		} catch (e) {
			return this.assembledLine.error === void 0 && (this.assembledLine.error = e.message), 0;
		}
	}
	readExpression() {
		return this.readTernary();
	}
	readTernary() {
		let e = this.readLogicalOr();
		if (this.tokenizer.found("?")) {
			let t = this.readTernary();
			if (!this.tokenizer.found(":")) throw Error("ternary expression is missing colon");
			let n = this.readTernary();
			return e ? t : n;
		}
		return e;
	}
	readLogicalOr() {
		let e = this.readLogicalAnd();
		for (; this.tokenizer.foundAnyOf(["||"]);) {
			let t = this.readLogicalAnd();
			e ||= t;
		}
		return e;
	}
	readLogicalAnd() {
		let e = this.readBitwiseOr();
		for (; this.tokenizer.foundAnyOf(["&&"]);) {
			let t = this.readBitwiseOr();
			e &&= t;
		}
		return e;
	}
	readBitwiseOr() {
		let e = this.readBitwiseXor();
		for (; this.tokenizer.foundAnyOf(["|", "or"]);) {
			let t = this.readBitwiseXor();
			e |= t;
		}
		return e;
	}
	readBitwiseXor() {
		let e = this.readBitwiseAnd();
		for (; this.tokenizer.foundAnyOf(["^", "xor"]);) {
			let t = this.readBitwiseAnd();
			e ^= t;
		}
		return e;
	}
	readBitwiseAnd() {
		let e = this.readEquality();
		for (; this.tokenizer.foundAnyOf(["&", "and"]);) {
			let t = this.readEquality();
			e &= t;
		}
		return e;
	}
	readEquality() {
		let e = 0, t;
		for (;;) {
			let n = this.readInequality();
			switch (t) {
				case "==":
					e = +(e == n);
					break;
				case "!=":
					e = e == n ? 0 : 1;
					break;
				case void 0: e = n;
			}
			if (this.tokenizer.foundAnyOf([
				"==",
				"=",
				"eq"
			])) t = "==";
			else if (this.tokenizer.foundAnyOf([
				"!=",
				"<>",
				"ne"
			])) t = "!=";
			else break;
		}
		return e;
	}
	readInequality() {
		let e = 0, t;
		for (;;) {
			let n = this.readShift();
			switch (t) {
				case "<":
					e = +(e < n);
					break;
				case "<=":
					e = +(e <= n);
					break;
				case ">":
					e = +(e > n);
					break;
				case ">=":
					e = +(e >= n);
					break;
				case void 0: e = n;
			}
			if (this.tokenizer.foundAnyOf(["<", "lt"])) t = "<";
			else if (this.tokenizer.foundAnyOf(["<=", "le"])) t = "<=";
			else if (this.tokenizer.foundAnyOf([">", "gt"])) t = ">";
			else if (this.tokenizer.foundAnyOf([">=", "ge"])) t = ">=";
			else break;
		}
		return e;
	}
	readShift() {
		let e = 0, t;
		for (;;) {
			let n = this.readSum();
			if (t === "<<" ? e <<= n : t === ">>" ? e >>= n : e = n, this.tokenizer.foundAnyOf(["<<", "shl"])) t = "<<";
			else if (this.tokenizer.foundAnyOf([">>", "shr"])) t = ">>";
			else break;
		}
		return e;
	}
	readSum() {
		let e = 0, t = 1;
		for (;;) {
			let n = this.readProduct();
			if (e += t * n, this.tokenizer.found("+")) t = 1;
			else if (this.tokenizer.found("-")) t = -1;
			else break;
		}
		return e;
	}
	readProduct() {
		let e = 1, t = "*";
		for (;;) {
			let n = this.readMonadic();
			switch (t) {
				case "*":
					e *= n;
					break;
				case "/":
					e = Math.trunc(e / n);
					break;
				case "%": e %= n;
			}
			if (this.tokenizer.found("*")) t = "*";
			else if (this.tokenizer.found("/")) t = "/";
			else if (this.tokenizer.foundAnyOf(["%", "mod"])) t = "%";
			else break;
		}
		return e;
	}
	readMonadic() {
		let e = this.tokenizer.foundAnyOf([
			"+",
			"-",
			"~",
			"!",
			"low",
			"lo",
			"high",
			"hi"
		]);
		if (e !== void 0) {
			let t = this.readMonadic();
			switch (e) {
				case "+":
				default: return t;
				case "-": return -t;
				case "~": return ~t;
				case "!": return +!t;
				case "low":
				case "lo": return h(t);
				case "high":
				case "hi": return m(t);
			}
		} else return this.readAtom();
	}
	readAtom() {
		if (this.tokenizer.found("(")) {
			let e = this.readExpression();
			if (!this.tokenizer.found(")")) throw Error("missing close parenthesis");
			return e;
		}
		let e = this.tokenizer.readIdentifier(!1);
		if (e !== void 0) {
			let { name: t, column: n, originalSpelling: r } = e, i = this.pass.locals().get(t, this.pass.passNumber !== 1);
			if (i === void 0) {
				if (this.pass.passNumber === 1) i = new lj(t, r, 0), this.pass.locals().set(i);
				else throw Error("Identifier " + t + " was not defined in pass 1");
			}
			if (this.pass.passNumber === 1) {
				let e = new sj(i, this.assembledLine, n, i.references.length);
				i.references.push(e);
			} else if (i.definitions.length === 0) throw Error("unknown identifier \"" + t + "\"");
			else if (i.definitions.length > 1 && i.changesValue && i.definitions[0].assembledLine !== void 0 && i.definitions[0].assembledLine.listingLineNumber >= this.assembledLine.listingLineNumber) throw Error("label \"" + t + "\" not yet defined here");
			return this.pass.passNumber === 1 && i.definitions.length === 0 ? this.pass.locals().parent?.get(t, !0)?.value ?? 0 : i.value;
		}
		let t = this.tokenizer.readCharConstant();
		if (t !== void 0) return t;
		let n = this.tokenizer.readNumericConstant(this.assembledLine.address);
		if (n !== void 0) return n;
		let r = this.tokenizer.getCurrentToken();
		throw Error(r === void 0 ? "syntax error at end of line" : "syntax error (\"" + r.text + "\")");
	}
};
//#endregion
//#region src/Paths.ts
function $(e) {
	let t = e.startsWith("/"), n = [];
	for (let t of e.split("/")) t === "" || t === "." || (t === ".." && n.length > 0 && n[n.length - 1] !== ".." ? n.pop() : n.push(t));
	return (t ? "/" : "") + n.join("/");
}
function Cj(e) {
	let t = e.lastIndexOf("/");
	return t < 0 ? "" : e.substring(0, t);
}
//#endregion
//#region src/Assemble.ts
var wj = "cannot read file ", Tj = new TextEncoder(), Ej = new TextDecoder(), Dj = class {
	constructor(e) {
		this.files = /* @__PURE__ */ new Map();
		for (let t of Object.keys(e)) this.files.set($(t), e[t]);
	}
	readTextFile(e) {
		let t = this.files.get($(e));
		if (t !== void 0) return (typeof t == "string" ? t : Ej.decode(t)).split(/\r\n|\r|\n/);
	}
	readBinaryFile(e) {
		let t = this.files.get($(e));
		if (t !== void 0) return typeof t == "string" ? Tj.encode(t) : t;
	}
	readDirectory(e) {
		let t = $(e), n = [];
		for (let e of this.files.keys()) Cj(e) === t && n.push(e.substring(t === "" ? 0 : t.length + 1));
		return n.length === 0 ? void 0 : n.sort();
	}
}, Oj = class extends bj {
	constructor(...e) {
		super(...e), this.refusedIncludes = /* @__PURE__ */ new Map();
	}
	loadSourceFile(e, t) {
		if (t !== void 0) {
			let n = $(e);
			for (let r = t; r !== void 0; r = r.parentFileInfo) if ($(r.pathname) === n) {
				this.refusedIncludes.set(e, "include cycle: " + n);
				return;
			}
			if (t.depth >= 32) {
				this.refusedIncludes.set(e, "includes nested more than 32 deep");
				return;
			}
		}
		return super.loadSourceFile(e, t);
	}
	explainError(e) {
		if (e.startsWith(wj)) {
			let t = this.refusedIncludes.get(e.substring(17));
			if (t !== void 0) return t;
		}
		return e;
	}
}, kj = class {
	constructor(e, t, n, r) {
		this.asm = e, this.sourceFile = t, this.diagnostics = n, this.entryPoint = r;
	}
	hasErrors() {
		return this.diagnostics.length > 0;
	}
	segments() {
		let e = this.asm.assembledLines.filter((e) => e.binary.length > 0).sort((e, t) => e.address - t.address), t = [], n = 0, r = [], i = () => {
			r.length > 0 && (t.push({
				address: n,
				bytes: Uint8Array.from(r)
			}), r = []);
		};
		for (let t of e) {
			(r.length === 0 || t.address !== n + r.length) && (i(), n = t.address);
			for (let e of t.binary) r.push(e);
		}
		return i(), t;
	}
};
function Aj(e, t) {
	if (t !== void 0) return t;
	let n = Object.keys(e);
	if (n.indexOf("main.asm") >= 0) return r;
	if (n.length === 1) return n[0];
	throw n.length === 0 ? Error("no source files were provided to assemble") : Error("must specify entryPathname: there's no \"" + r + "\" among the source files (" + n.join(", ") + ")");
}
function jj(e, t) {
	let n = typeof e == "string" ? { [r]: e } : e, i = Aj(n, t?.entryPathname), a = new Oj(new Dj(n));
	t?.knownLabels !== void 0 && a.addKnownLabels(t.knownLabels);
	let o = a.assembleFile(i), s = [];
	if (o === void 0) s.push({
		pathname: $(i),
		lineNumber: void 0,
		message: "cannot read file " + i
	});
	else for (let e of a.assembledLines) e.error !== void 0 && s.push({
		pathname: $(e.fileInfo.pathname),
		lineNumber: e.lineNumber,
		message: a.explainError(e.error)
	});
	let c = a.entryPoint;
	if (c === void 0) {
		let e, t;
		for (let n of a.assembledLines) n.binary.length !== 0 && ((t === void 0 || n.address < t) && (t = n.address), !n.isData() && (e === void 0 || n.address < e) && (e = n.address));
		c = e ?? t;
	}
	return new kj(a, o, s, c ?? 0);
}
function Mj(e, t) {
	return jj(e, t).diagnostics;
}
//#endregion
//#region src/SourceMap.ts
function Nj(e, t) {
	return $(e) + ":" + t;
}
var Pj = class {
	constructor(t) {
		this.addressByLocation = /* @__PURE__ */ new Map(), this.result = t, this.entryPathname = $(t.sourceFile?.fileInfo.pathname ?? "main.asm"), this.locationByAddress = Array(e);
		for (let e of t.asm.assembledLines) {
			if (e.binary.length === 0 || e.lineNumber === void 0) continue;
			let t = {
				pathname: $(e.fileInfo.pathname),
				lineNumber: e.lineNumber
			};
			for (let n = 0; n < e.binary.length; n++) this.locationByAddress[e.address + n & 65535] = t;
			let n = Nj(t.pathname, t.lineNumber);
			this.addressByLocation.has(n) || this.addressByLocation.set(n, e.address);
		}
		this.addressSymbols = t.asm.symbols.filter((e) => e.definitions.length > 0 && e.type !== cj.CONSTANT).sort((e, t) => e.value - t.value);
	}
	addressToLocation(e) {
		if (!(e < 0 || e >= 65536)) return this.locationByAddress[e];
	}
	locationToAddress(e, t) {
		return this.addressByLocation.get(Nj(t ?? this.entryPathname, e));
	}
	symbolAt(e) {
		let t, n = 0, r = this.addressSymbols.length - 1;
		for (; n <= r;) {
			let i = n + r >> 1;
			this.addressSymbols[i].value <= e ? (t = this.addressSymbols[i], n = i + 1) : r = i - 1;
		}
		return t;
	}
	namedCallStack(e) {
		return e.getCallStack().map((e) => ({
			...e,
			name: this.symbolAt(e.targetAddress)?.originalSpelling
		}));
	}
};
//#endregion
export { bj as Asm, HA as AsmTokenizer, gj as AsmTrieNode, fj as AssembledLine, kj as AssemblyResult, r as DEFAULT_ENTRY_PATHNAME, t as DEFAULT_INITIAL_SP, n as DEFAULT_PORT_READ_VALUE, nA as Disasm, uj as FileInfo, T as Flag, Yk as HexFormat, Dj as InMemoryFileSystem, qk as Instruction, i as MAX_INCLUDE_DEPTH, e as MEMORY_SIZE, s as POKE_RECORD_ADDRESS, de as RegisterSet, pj as SourceFile, Pj as SourceMap, a as StopReason, sj as SymbolAppearance, lj as SymbolInfo, cj as SymbolType, ke as Z80, wA as Z80Machine, l as Z80MachineState, Oe as Z80State, pe as Z80_KNOWN_LABELS, S as add16, x as add8, jj as assemble, ue as assertNever, Mj as check, b as dec16, y as dec8, uA as disassembleInstructionAt, oj as getAsmDirectiveDocs, yj as getAsmInstructionTrie, m as hi, v as inc16, _ as inc8, cA as instructionsToText, ae as isByteReg, Kk as isDataThirdByte, Ae as isOpcodeTemplateOperand, c as isPokeRecord, oe as isRegisterSetField, o as isTerminalStopReason, ie as isWordReg, h as lo, Wk as mnemonicMap, Gk as opcodeMap, Ne as opcodeVariantToOpcodeString, je as opcodeVariantToString, hA as reconstructCallStack, fe as registerSetFields, w as signedByte, C as sub16, le as sub8, f as toHex, se as toHexByte, ce as toHexLong, p as toHexWord, g as word };

//# sourceMappingURL=index.js.map